{
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.add": "Add",
  "common.remove": "Remove",
  "common.edit": "Edit",
  "common.more_actions": "More actions",
  "common.confirm": "Confirm",
  "common.search": "Search",
  "common.select_placeholder": "Select…",
  "common.no_results": "No matches",
  "common.keep_typing_to_narrow": "{{count}} more — keep typing to narrow",
  "common.search_placeholder": "Search…",
  "common.drop_files_hint": "Drag and drop files here, or choose them below",
  "common.items": "items",
  "common.saving": "Saving…",
  "common.deleting": "Deleting…",
  "common.something_went_wrong": "Something went wrong.",
  "common.updating_to_latest_version": "Updating to the latest version…",
  "common.reload": "Reload",
  "common.error_body": "An unexpected error occurred. Your data is safe — reloading the page usually resolves it.",
  "common.chunk_update_body": "A newer version of the app was just released. This page will refresh automatically in a moment.",
  "common.back_to_dashboard": "Back to dashboard",
  "common.reference": "Reference",
  "common.copy": "Copy",
  "common.record_not_found": "This record could not be found.",
  "common.review_form_fields": "Please review the form fields and try again.",
  "common.nothing_here_yet": "Nothing here yet.",
  "common.language": "Language",
  "common.theme_light": "Switch to light mode",
  "common.theme_dark": "Switch to dark mode",
  "common.all": "All",
  "common.previous": "Previous",
  "common.open_profile": "Open profile",
  "common.next": "Next",
  "common.item_of_total": "{{index}} of {{total}}",
  "common.pagination_page_of": "Showing page {{current}} of {{total}}",
  "common.pagination_page_of_with_items": "Showing page {{current}} of {{total}} — {{count}} {{label}}",
  "common.rows_per_page": "Rows per page",
  "common.go_to_page": "Go to page {{page}}",
  "common.pick_date": "Pick a date",
  "common.pick_datetime": "Pick a date and time",
  "common.time": "Time",
  "common.clear": "Clear",
  "common.published": "Published",
  "common.draft": "Draft",
  "common.drafts": "Drafts",
  "common.status": "Status",
  "common.active": "Active",
  "common.closed": "Closed",
  "common.coming_soon": "Coming soon",
  "common.sst_private": "Private to SST",
  "common.period_label": "When",
  "common.period.all": "All",
  "common.period.active": "All active",
  "common.period.yesterday": "Yesterday",
  "common.period.today": "Today",
  "common.period.tomorrow": "Tomorrow",
  "common.period.this-week": "This week",
  "common.period.next-week": "Next week",
  "common.period.expired": "Expired",
  "common.title": "Title",
  "common.date": "Date",
  "common.from": "From",
  "common.to": "To",
  "common.actions": "Actions",
  "common.category": "Category",
  "common.views": "Views",
  "common.manage_categories": "Manage Categories",
  "common.publish": "Publish",
  "common.unpublish": "Unpublish",
  "common.unpublish_tooltip": "Hide from public site (back to draft)",
  "common.approve": "Approve",
  "common.reject": "Reject",
  "common.approving": "Approving…",
  "common.rejecting": "Rejecting…",
  "common.message_optional": "Message (optional)",
  "common.staff": "Staff",
  "common.record": "Record",
  "common.all_fields_required": "All fields are required.",
  "common.select_student": "Select student",
  "common.student": "Student",
  "common.reason": "Reason",
  "common.submitted_by": "Submitted by",
  "common.action": "Action",
  "common.this_student": "this student",
  "common.update_failed": "Failed to update",
  "common.search_by_student": "Search by student name…",
  "common.yes": "Yes",
  "common.no": "No",
  "common.loading": "Loading…",
  "common.download": "Download",
  "common.back": "Back",
  "shell.staff_portal": "Staff portal",
  "shell.sign_out": "Sign out",
  "role.admin": "Admin",
  "role.teacher": "Teacher",
  "role.student": "Student",
  "role.employee": "Employee",
  "role.parent": "Parent",
  "nav.sparky": "Sparky learning",
  "nav.dashboard": "Dashboard",
  "nav.open_menu": "Open menu",
  "nav.news": "News",
  "nav.school_calendar": "School Calendar",
  "nav.thai_events": "Thai Events",
  "nav.announcements": "Announcements",
  "nav.communications": "Communications",
  "nav.statistics": "Statistics",
  "nav.teachers": "Teachers",
  "nav.weekly_menus": "Weekly Menus",
  "nav.contact_inquiries": "Contact Inquiries",
  "nav.tour_requests": "Tour Requests",
  "nav.inquiries": "Inquiries",
  "nav.sand_dollars_award": "Award",
  "nav.all_awards": "All Awards",
  "nav.sand_dollars_stats": "Stats",
  "nav.sand_dollars_records": "Awards & stats",
  "nav.sand_dollars_config": "Configuration",
  "nav.house_points": "House Points",
  "nav.my_leaves": "My Leaves",
  "nav.leave_requests": "Leave Requests",
  "nav.immigration_compliance": "Immigration Compliance",
  "nav.my_it_tickets": "My IT Tickets",
  "nav.it_board": "IT Board",
  "nav.it_archive": "IT Archive",
  "nav.it_assets": "IT assets",
  "nav.my_bookings": "My Bookings",
  "nav.all_bookings": "All Bookings",
  "nav.tablet_pool": "Tablet Pool",
  "nav.student_directory": "Student Directory",
  "nav.student_absences": "Student Absences",
  "nav.arrivals_dismissals": "Arrivals & Dismissals",
  "nav.sst": "SST",
  "nav.students": "Students",
  "nav.credential_export": "Student Export",
  "nav.report_cards": "Report Cards",
  "nav.parents": "Parents",
  "nav.period_attendance": "Period Attendance",
  "nav.attendance": "Daily Attendance",
  "nav.checkout": "Checkout",
  "nav.attendance_report": "Attendance Report",
  "nav.attendance_calendar": "School Days",
  "nav.sessions": "Sessions",
  "nav.users": "Users",
  "nav.timetable": "Timetable",
  "nav.timetable_view": "Timetable View",
  "nav.timetable_setup": "Timetable Setup",
  "nav.temperature": "Temperature",
  "nav.infirmary_log": "Infirmary Log",
  "nav.medical_settings": "Medical Settings",
  "nav.import": "Import",
  "nav.school_years": "School Years",
  "nav.settings": "Settings",
  "nav.audit_log": "Audit Log",
  "nav.integration": "Integrations",
  "nav.door_log": "Door Access Log",
  "nav.cafeteria": "Cafeteria",
  "nav.shop": "Shop",
  "nav.shop_pos": "Shop Till",
  "nav.shop_inventory": "Inventory",
  "nav.shop_reports": "Reports",
  "nav.section.website": "Website",
  "nav.section.admissions": "Admissions",
  "nav.section.sand_dollars": "Sand Dollars",
  "nav.section.hr": "HR",
  "nav.section.it_support": "IT Support",
  "nav.section.bookings": "Bookings",
  "nav.section.student": "Student",
  "nav.section.administration": "Administration",
  "nav.section.cafeteria": "Cafeteria",
  "nav.section.shop": "Shop",
  "nav.section.medical": "Medical",
  "nav.section.config": "Config",
  "dashboard.subtitle": "Overview of what needs your attention",
  "dashboard.no_widgets": "No dashboard widgets are available for your account yet.",
  "dashboard.for_you.title": "For you",
  "dashboard.for_you.group.assigned": "Assigned to you",
  "dashboard.for_you.group.teaching": "Teaching",
  "dashboard.for_you.group.queue": "To review",
  "dashboard.for_you.all_caught_up": "You're all caught up",
  "dashboard.for_you.failed_to_load": "Could not load your to-do list.",
  "dashboard.for_you.oldest": "Oldest {{ago}}",
  "dashboard.for_you.due": "Due {{when}}",
  "dashboard.for_you.was_due": "Overdue, was due {{when}}",
  "dashboard.for_you.register_partial": "partly marked",
  "dashboard.for_you.today.title": "Today",
  "dashboard.for_you.today.birthdays": "Birthdays: {{names}}",
  "dashboard.for_you.today.colleague_out": "Out today: {{names}}",
  "dashboard.for_you.today.document_due_today": "{{doc}}: due today",
  "dashboard.for_you.today.document_days_left_one": "{{doc}}: {{count}} day left",
  "dashboard.for_you.today.document_days_left_other": "{{doc}}: {{count}} days left",
  "dashboard.for_you.today.document_days_overdue_one": "{{doc}}: {{count}} day overdue",
  "dashboard.for_you.today.document_days_overdue_other": "{{doc}}: {{count}} days overdue",
  "dashboard.for_you.kind.it-assigned_one": "{{count}} IT ticket assigned to you",
  "dashboard.for_you.kind.it-assigned_other": "{{count}} IT tickets assigned to you",
  "dashboard.for_you.kind.it-unassigned_one": "{{count}} IT ticket waiting for someone",
  "dashboard.for_you.kind.it-unassigned_other": "{{count}} IT tickets waiting for someone",
  "dashboard.for_you.kind.mss-days-to-mark_one": "{{count}} MSS day to mark",
  "dashboard.for_you.kind.mss-days-to-mark_other": "{{count}} MSS days to mark",
  "dashboard.for_you.kind.mss-decision-unseen_one": "{{count}} MSS decision on your proposals",
  "dashboard.for_you.kind.mss-decision-unseen_other": "{{count}} MSS decisions on your proposals",
  "dashboard.for_you.kind.mss-proposed_one": "{{count}} MSS proposal awaiting your decision",
  "dashboard.for_you.kind.mss-proposed_other": "{{count}} MSS proposals awaiting your decision",
  "dashboard.for_you.kind.edp-proposal-returned_one": "{{count}} EDP proposal returned to you",
  "dashboard.for_you.kind.edp-proposal-returned_other": "{{count}} EDP proposals returned to you",
  "dashboard.for_you.kind.incident-unread_one": "{{count}} unread incident message",
  "dashboard.for_you.kind.incident-unread_other": "{{count}} unread incident messages",
  "dashboard.for_you.kind.suspension-unread_one": "{{count}} unread suspension message",
  "dashboard.for_you.kind.suspension-unread_other": "{{count}} unread suspension messages",
  "dashboard.for_you.kind.register-missing_one": "{{count}} lesson register to complete",
  "dashboard.for_you.kind.register-missing_other": "{{count}} lesson registers to complete",
  "dashboard.for_you.kind.edp-register-missing_one": "{{count}} EDP register to complete",
  "dashboard.for_you.kind.edp-register-missing_other": "{{count}} EDP registers to complete",
  "dashboard.for_you.kind.report-card-outstanding_one": "{{count}} report-card entry to finish",
  "dashboard.for_you.kind.report-card-outstanding_other": "{{count}} report-card entries to finish",
  "dashboard.for_you.kind.newsletter-slot-missing_one": "{{count}} newsletter piece to write",
  "dashboard.for_you.kind.newsletter-slot-missing_other": "{{count}} newsletter pieces to write",
  "dashboard.for_you.kind.sparky-attention-open_one": "{{count}} Sparky follow-up open",
  "dashboard.for_you.kind.sparky-attention-open_other": "{{count}} Sparky follow-ups open",
  "dashboard.for_you.kind.sparky-lesson-running_one": "{{count}} Sparky lesson still running",
  "dashboard.for_you.kind.sparky-lesson-running_other": "{{count}} Sparky lessons still running",
  "dashboard.for_you.kind.sparky-lesson-draft_one": "{{count}} prepared Sparky lesson not started",
  "dashboard.for_you.kind.sparky-lesson-draft_other": "{{count}} prepared Sparky lessons not started",
  "dashboard.for_you.kind.leave-pending_one": "{{count}} leave request to review",
  "dashboard.for_you.kind.leave-pending_other": "{{count}} leave requests to review",
  "dashboard.for_you.kind.allergy-change-pending_one": "{{count}} allergy change to review",
  "dashboard.for_you.kind.allergy-change-pending_other": "{{count}} allergy changes to review",
  "dashboard.for_you.kind.contact-inquiry-new_one": "{{count}} new contact inquiry",
  "dashboard.for_you.kind.contact-inquiry-new_other": "{{count}} new contact inquiries",
  "dashboard.for_you.kind.tour-request-new_one": "{{count}} new tour request",
  "dashboard.for_you.kind.tour-request-new_other": "{{count}} new tour requests",
  "dashboard.for_you.kind.trial-ending_one": "{{count}} trial ending or overdue",
  "dashboard.for_you.kind.trial-ending_other": "{{count}} trials ending or overdue",
  "dashboard.for_you.kind.edp-proposal-submitted_one": "{{count}} EDP proposal to review",
  "dashboard.for_you.kind.edp-proposal-submitted_other": "{{count}} EDP proposals to review",
  "dashboard.for_you.kind.edp-payment-declared_one": "{{count}} EDP payment to confirm",
  "dashboard.for_you.kind.edp-payment-declared_other": "{{count}} EDP payments to confirm",
  "dashboard.for_you.kind.tuition-payment-declared_one": "{{count}} tuition payment to confirm",
  "dashboard.for_you.kind.tuition-payment-declared_other": "{{count}} tuition payments to confirm",
  "dashboard.for_you.kind.receipt-copy-requested_one": "{{count}} receipt copy requested",
  "dashboard.for_you.kind.receipt-copy-requested_other": "{{count}} receipt copies requested",
  "dashboard.for_you.kind.parent-profile-change_one": "{{count}} parent profile change to review",
  "dashboard.for_you.kind.parent-profile-change_other": "{{count}} parent profile changes to review",
  "dashboard.for_you.kind.teacher-profile-change_one": "{{count}} teacher profile change to review",
  "dashboard.for_you.kind.teacher-profile-change_other": "{{count}} teacher profile changes to review",
  "dashboard.failed_to_load": "Failed to load.",
  "dashboard.view_all": "View all",
  "dashboard.empty_default": "Nothing to show.",
  "dashboard.out_now": "Out now",
  "dashboard.widget.staff_leave": "Staff Leave",
  "dashboard.widget.staff_leave_empty": "No pending or active leave.",
  "dashboard.widget.staff_out": "Staff Out",
  "dashboard.widget.staff_out_today_label": "out today",
  "dashboard.widget.staff_out_week_label": "out this week",
  "dashboard.widget.student_absences": "Student Absences",
  "dashboard.widget.student_absences_empty": "Nobody is away.",
  "dashboard.widget.arrivals_dismissals": "Arrivals & Dismissals",
  "dashboard.widget.arrivals_dismissals_empty": "No arrivals or dismissals.",
  "dashboard.widget.lesson_excusals": "Lesson Excusals",
  "dashboard.widget.lesson_excusals_empty": "No lesson excusals.",
  "dashboard.widget.missing_today_label": "missing a lesson today",
  "dashboard.widget.excusals_upcoming_label": "lessons to be missed",
  "dashboard.widget.missing_today_upcoming_label": "missing a lesson today · {{count}} coming up",
  "dashboard.widget.missing_today_badge": "Today",
  "dashboard.widget.lunch_detention": "MSS",
  "dashboard.widget.lunch_detention_count_label": "need your attention",
  "dashboard.widget.lunch_detention_queue_title": "Awaiting decision",
  "dashboard.widget.lunch_detention_room_title": "Today's room",
  "dashboard.widget.lunch_detention_decisions_title": "Decisions on your proposals",
  "dashboard.widget.contact_inquiries": "Contact Inquiries",
  "dashboard.widget.contact_inquiries_empty": "No inquiries yet.",
  "dashboard.widget.tour_requests": "Tour Requests",
  "dashboard.widget.tour_requests_empty": "No tour requests yet.",
  "dashboard.widget.upcoming_events": "Upcoming Events",
  "dashboard.widget.upcoming_events_count_label": "in the next 7 days",
  "dashboard.widget.upcoming_events_empty": "No upcoming events.",
  "dashboard.widget.door_agent": "Door & Agent",
  "dashboard.widget.agent_unreachable_count_label": "unreachable",
  "dashboard.widget.agent_online": "Agent online",
  "dashboard.widget.agent_offline": "Agent offline",
  "dashboard.widget.agent_last_seen": "last seen {{time}}",
  "dashboard.widget.door_agent_no_devices": "No door devices.",
  "dashboard.widget.bell_status": "Bell",
  "dashboard.widget.bell_active": "Active",
  "dashboard.widget.bell_silent": "Silent today",
  "dashboard.widget.bell_off": "Off",
  "dashboard.widget.bell_next": "Next bell {{time}}",
  "dashboard.widget.bell_no_more_today": "No more bells today",
  "dashboard.widget.bell_reason_disabled": "Disabled in Bell settings",
  "dashboard.widget.bell_reason_no_active_year": "No active school year",
  "dashboard.widget.bell_reason_not_school_day": "Not a school day today",
  "dashboard.widget.bell_reason_no_schedule": "No schedule today",
  "dashboard.widget.bell_audio_error": "Sound card not detected",
  "dashboard.widget.bell_audio_error_detail": "The bell schedule can't ring until this is fixed — see the Integration page.",
  "dashboard.widget.bell_schedule_warning": "Schedule problem",
  "dashboard.widget.news": "News",
  "dashboard.widget.allergy_changes": "Allergy & Dietary Changes",
  "dashboard.widget.allergy_changes_empty": "No allergy or dietary changes are waiting for review.",
  "dashboard.widget.news_empty": "No news articles yet.",
  "dashboard.widget.out_now_count_label": "out now",
  "dashboard.widget.absences_upcoming_label": "away later this week",
  "dashboard.widget.out_now_upcoming_label": "out now · {{count}} coming up",
  "dashboard.widget.out_now_pending_label": "out now · {{count}} pending",
  "dashboard.widget.pending_count_label": "pending",
  "dashboard.widget.pending_out_now_label": "pending · {{count}} out now",
  "dashboard.widget.more_count": "+{{count}} more",
  "dashboard.widget.new_count_label": "new",
  "dashboard.widget.open_count_label": "open",
  "dashboard.widget.published_articles": "published articles",
  "dashboard.widget.student_attendance": "Student Attendance",
  "dashboard.widget.staff_attendance": "Staff Attendance",
  "dashboard.widget.on_campus": "On Campus Now",
  "dashboard.widget.on_campus_label": "on campus",
  "dashboard.widget.att_present": "Present",
  "dashboard.widget.att_late": "Late",
  "dashboard.widget.att_absent": "Absent",
  "dashboard.widget.att_suspended": "Suspended",
  "dashboard.widget.att_unmarked": "Unmarked",
  "dashboard.widget.att_checked_in": "Checked in",
  "dashboard.widget.on_campus_students": "Students",
  "dashboard.widget.on_campus_staff": "Staff",
  "dashboard.widget.attendance_no_school": "No school today.",
  "dashboard.widget.immigration_compliance": "Immigration Compliance",
  "dashboard.widget.immigration_compliance_empty": "Nothing due soon.",
  "dashboard.widget.immigration_compliance_count_label": "due soon or overdue",
  "dashboard.widget.it_support": "IT Support",
  "dashboard.widget.it_support_empty": "You haven't reported any IT problems yet.",
  "dashboard.widget.it_support_none_active": "Nothing open right now.",
  "dashboard.widget.it_queue": "IT Ticket Queue",
  "dashboard.widget.it_queue_empty": "No IT tickets right now.",
  "doc_type.visa": "Visa",
  "doc_type.workPermit": "Work Permit",
  "doc_type.ninetyDayReport": "90-Day Report",
  "dashboard.overdue": "overdue",
  "immigration_compliance.list_title": "Immigration Compliance",
  "immigration_compliance.list_subtitle": "Track visa, work permit, and 90-day report deadlines for staff and students.",
  "immigration_compliance.filter_all": "All",
  "immigration_compliance.filter_staff": "Staff",
  "immigration_compliance.filter_students": "Students",
  "immigration_compliance.col_name": "Name",
  "immigration_compliance.col_visa": "Visa Expiry",
  "immigration_compliance.col_work_permit": "Work Permit Expiry",
  "immigration_compliance.col_ninety_day": "90-Day Report Due",
  "immigration_compliance.not_set": "Not set",
  "immigration_compliance.list_empty": "No one is currently tracked.",
  "immigration_compliance.add_person_placeholder": "Add a person to track…",
  "immigration_compliance.add_person_action": "Add person",
  "immigration_compliance.add_person_title": "Add a person to track",
  "immigration_compliance.add_person_description": "Choose who to track. Their record opens next, blank, for the dates you know.",
  "immigration_compliance.add_person_who": "Who",
  "immigration_compliance.add_person_staff_all_tracked": "Everyone on staff is already tracked.",
  "immigration_compliance.add_person_students_all_tracked": "Every student is already tracked.",
  "immigration_compliance.settings_action": "Warning thresholds",
  "immigration_compliance.settings_title": "Warning thresholds",
  "immigration_compliance.settings_subtitle": "How many days before a deadline the dashboard and the digest start warning.",
  "immigration_compliance.settings_breadcrumb": "Settings",
  "immigration_compliance.settings_back": "Back to the list",
  "immigration_compliance.settings_saved": "Thresholds saved.",
  "immigration_compliance.edit_title": "Edit compliance record — {{name}}",
  "immigration_compliance.requires_tracking_label": "Requires tracking",
  "immigration_compliance.visa_expiry_label": "Visa expiry date",
  "immigration_compliance.work_permit_expiry_label": "Work permit expiry date",
  "immigration_compliance.work_permit_not_applicable": "Not applicable for students",
  "immigration_compliance.ninety_day_due_label": "90-day report due date",
  "immigration_compliance.save": "Save",
  "immigration_compliance.saving": "Saving…",
  "immigration_compliance.error_save_failed": "Failed to save compliance record",
  "immigration_compliance.visa_warn_days_label": "Warn N days before visa expiry",
  "immigration_compliance.work_permit_warn_days_label": "Warn N days before work permit expiry",
  "immigration_compliance.ninety_day_warn_days_label": "Warn N days before 90-day report due",
  "immigration_compliance.error_warn_days_number": "Enter a whole number of days",
  "modules.teachers": "Teachers",
  "modules.calendar": "School Calendar",
  "modules.thai-events": "Thai Events",
  "modules.weekly-menus": "Weekly Menus",
  "modules.contact-inquiries": "Contact Inquiries",
  "modules.tour-requests": "Tour Requests",
  "modules.leave-requests": "Leave Requests (HR)",
  "modules.immigration-compliance": "Immigration Compliance (HR)",
  "modules.sand-dollars-config": "Sand Dollar Config",
  "modules.student-management": "Student Management",
  "modules.student-credentials": "Student Login Credentials",
  "modules.student-management.description": "Full record management: edit student profiles, incidents, health records, and photos. Directory browsing works for any staff member without this.",
  "modules.student-credentials.description": "Export and reveal student login credentials (passwords, WiFi, Google Classroom, etc.). Grantable to teachers as well as admins.",
  "modules.parents": "Parents",
  "modules.sst": "Student Support Team (SST)",
  "modules.medical": "Medical / Nurse",
  "modules.school-years": "School Years",
  "modules.statistics": "Statistics",
  "modules.users": "User & Permission Management",
  "modules.settings": "Site Settings",
  "modules.audit-log": "Audit Log",
  "modules.timetable": "Timetable",
  "modules.cafeteria": "Cafeteria",
  "modules.shop": "School Shop",
  "modules.announcements": "Announcements",
  "modules.communications": "Communications",
  "modules.it-support": "IT Support",
  "modules.bookings": "Bookings",
  "modules.edp": "Extended Day Program (EDP)",
  "modules.report-cards": "Report Cards",
  "modules.conferences": "PTC",
  "modules.billing": "Tuition billing",
  "modules.sparky": "Sparky learning",
  "auth.welcome_back": "Welcome back",
  "auth.subtitle": "Sign in to access the RISP admin dashboard.",
  "auth.sign_in": "Sign in",
  "auth.signing_in": "Signing in...",
  "auth.card_description": "Use your school Google account or email + password.",
  "auth.or": "or",
  "auth.email": "Email",
  "auth.email_placeholder": "you@risphuket.ac.th",
  "auth.password": "Password",
  "auth.password_placeholder": "Enter your password",
  "auth.error_invalid_email": "Enter a valid email",
  "auth.error_email_required": "Email is required",
  "auth.error_password_required": "Password is required",
  "auth.error_fill_required": "Please enter email and password.",
  "auth.error_google_sign_in": "We couldn't sign you in.",
  "auth.error_google_unavailable": "Google sign-in couldn't load. Check your connection or use email + password below.",
  "auth.error_login_failed": "Login failed",
  "auth.error_not_staff": "This account isn't authorised for the admin portal — it isn't a school staff account.",
  "auth.risp_administration": "RISP Administration",
  "auth.hero_heading": "Every part of the school day, in one place.",
  "auth.hero_feature_operations": "Attendance, timetables & daily rosters",
  "auth.hero_feature_cafeteria": "Cafeteria POS, wallets & meal reports",
  "auth.hero_feature_rewards": "Sand-dollar rewards & house standings",
  "auth.hero_feature_community": "News, calendar & family communication",
  "auth.authorized_staff_only": "Authorized staff only.",
  "users.title": "Users",
  "users.subtitle": "Manage staff who can sign into the admin.",
  "users.import": "Import",
  "users.add_user": "Add user",
  "users.edit_user": "Edit user",
  "users.search_placeholder": "Search by name, email, or nickname…",
  "users.search_aria": "Search users by name, email, or nickname",
  "users.status_all": "All status",
  "users.status_active": "Active",
  "users.status_disabled": "Disabled",
  "users.item_label": "users",
  "users.empty": "No users found.",
  "users.help_note": "Add staff one at a time here, or bulk-import many from Excel via <strong>Import</strong>. Staff only need an email if they'll log in.",
  "users.photo": "Photo",
  "users.last_login": "Last login",
  "users.last_login_never": "Never",
  "users.email": "Email",
  "users.name": "Name",
  "users.role": "Role",
  "users.status": "Status",
  "users.linked": "Linked",
  "users.linked_google": "Google",
  "users.created": "Created",
  "users.resend_onboarding": "Resend onboarding",
  "users.onboarding_sent": "Onboarding email sent",
  "users.onboarding_error": "Failed to send onboarding email",
  "users.cannot_change_self": "You cannot change your own role or permissions.",
  "users.full_name": "Full name",
  "users.nickname": "Nickname (optional)",
  "users.person_id": "Person ID (optional)",
  "users.passport_or_thai_id": "Passport / Thai ID Number",
  "users.vacation_days": "Vacation days per year",
  "users.vacation_days_hint": "Paid vacation days this staff member gets each academic year. Leave at 0 if their contract has no vacation — they will not be able to request vacation leave.",
  "users.error_vacation_days_range": "Enter a whole number of days between 0 and 365",
  "users.field_photo": "Profile photo (square)",
  "users.select_role_placeholder": "Select a role",
  "users.password_optional": "Password (optional)",
  "users.password_hint": "Password (leave empty for Google sign-in; required for non-Workspace emails)",
  "users.modules": "Modules",
  "users.additional_permissions": "Additional Permissions",
  "users.send_invitation": "Send invitation email",
  "users.send_invitation_hint": "Emails workspace (school-domain) staff a link to sign in. Uncheck to add them silently.",
  "users.pos_operator": "POS operator (till account)",
  "users.pos_operator_hint": "This account only runs the till for the modules ticked below — no student data, no management pages.",
  "users.pos_operator_badge": "POS operator",
  "users.error_invalid_email": "Enter a valid email address.",
  "users.error_email_required": "Email is required.",
  "users.error_role_required": "Role is required.",
  "users.error_full_name_short": "Full name is too short.",
  "users.error_full_name_required": "Full name is required.",
  "users.error_save_failed": "Failed to save user",
  "users.placeholder_email": "user@risphuket.ac.th",
  "users.placeholder_full_name": "Jane Doe",
  "users.placeholder_nickname": "Jane",
  "users.placeholder_person_id": "T-001",
  "news.title": "News",
  "news.subtitle": "Manage website news and featured stories",
  "news.add": "Add News",
  "news.error": "Failed to load news articles.",
  "news.empty": "No news articles found. Create your first one!",
  "news.empty_draft": "No draft news articles found.",
  "news.empty_published": "No published news articles found.",
  "news.summary": "Showing {{filtered}} of {{total}} articles",
  "news.featured": "Featured",
  "news.publish_tooltip": "Publish article",
  "news.publish_dialog.title": "Publish article",
  "news.publish_dialog.now_label": "Publish now",
  "news.publish_dialog.now_hint": "Goes live on the website immediately.",
  "news.publish_dialog.schedule_label": "Schedule for later",
  "news.publish_dialog.schedule_hint": "Stays a draft until the date you choose.",
  "news.publish_dialog.date_label": "Publish at (goes live within 5 minutes)",
  "news.publish_dialog.date_required": "Choose a date and time",
  "news.publish_dialog.date_past": "Choose a time in the future",
  "news.publish_dialog.confirm_schedule": "Schedule",
  "news.publish_dialog.clear_schedule": "Clear schedule",
  "news.preview_tooltip": "Preview",
  "news.scheduled_for": "Scheduled for {{date}}",
  "news.edit_info_tooltip": "Edit info",
  "news.edit_content_tooltip": "Edit content",
  "news.delete_title": "Delete News Article",
  "news.delete_description": "Are you sure you want to delete this news article? This action cannot be undone.",
  "news.edit_content": "Edit Content",
  "news.edit_subtitle": "Edit article content",
  "news.back_to_news": "Back to News",
  "news.load_error": "Failed to load news article",
  "news.content_label": "Content",
  "news.save_error": "Failed to save content. Please try again.",
  "news.save_content": "Save Content",
  "thai_events.title": "Thai Events",
  "thai_events.subtitle": "Manage Thai national holiday banners",
  "thai_events.add_event": "Add Event",
  "thai_events.error": "Failed to load thai events.",
  "thai_events.empty": "No thai events yet. Click \"Add Event\" to create one.",
  "thai_events.empty_filtered": "No Thai events match the current filter.",
  "thai_events.enabled": "Enabled",
  "thai_events.disabled": "Disabled",
  "thai_events.summary": "Showing {{filtered}} of {{total}} Thai events",
  "thai_events.col_days_after": "Days After",
  "thai_events.image": "Image",
  "thai_events.same_day_only": "Same day only",
  "thai_events.day_after": "day after",
  "thai_events.days_after": "days after",
  "thai_events.no_image": "No image",
  "thai_events.enable_tooltip": "Enable event",
  "thai_events.enable": "Enable",
  "thai_events.delete_title": "Delete Thai Event",
  "thai_events.delete_description": "This will permanently remove the event. The banner will no longer appear.",
  "announcements.title": "Announcements",
  "announcements.subtitle": "Manage the site-wide announcement banner",
  "announcements.add_announcement": "Add Announcement",
  "announcements.error": "Failed to load announcements.",
  "announcements.empty": "No announcements yet. Click \"Add Announcement\" to create one.",
  "announcements.empty_filtered": "No announcements match the current filter.",
  "announcements.active": "Active",
  "announcements.inactive": "Inactive",
  "announcements.summary": "Showing {{filtered}} of {{total}} announcements",
  "announcements.message": "Message",
  "announcements.type": "Type",
  "announcements.window": "Window",
  "announcements.urgent": "Urgent",
  "announcements.info": "Info",
  "announcements.activate": "Activate",
  "announcements.activate_tooltip": "Show this announcement on the site",
  "announcements.deactivate": "Deactivate",
  "announcements.deactivate_tooltip": "Hide this announcement from the site",
  "announcements.delete_title": "Delete Announcement",
  "announcements.delete_description": "This will permanently remove the announcement. If it is currently active, the banner will no longer appear.",
  "newsletter.my_entries_card_title": "My entries",
  "newsletter.my_entries_title": "My Newsletter Entries",
  "newsletter.issue_title": "Newsletter Issue",
  "newsletter.week_of": "Week of {{start}} – {{end}}",
  "newsletter.issue_selector_label": "Issue",
  "newsletter.issue_status_draft": "Draft",
  "newsletter.issue_status_published": "Published",
  "newsletter.no_open_issue": "There is no open newsletter issue this week yet.",
  "newsletter.from_timetable": "From your timetable",
  "newsletter.not_from_timetable": "Not from your timetable",
  "newsletter.not_from_timetable_hint": "Entries you added yourself, and ones for a grade or subject that has since moved to someone else. If one is no longer yours to write, open it and delete it.",
  "newsletter.no_timetable_slots": "No grades or subjects from your timetable this week.",
  "newsletter.added_by_you": "Added by you",
  "newsletter.add_another": "Add another grade / subject",
  "newsletter.status_write": "Write",
  "newsletter.status_edit": "Edit",
  "newsletter.status_view": "View",
  "newsletter.skip_slot": "Skip this week",
  "newsletter.skipped": "Skipped this week",
  "newsletter.undo_skip": "Undo",
  "newsletter.new_entry_title": "New Newsletter Entry",
  "newsletter.edit_entry_title": "Edit Newsletter Entry",
  "newsletter.title_field": "Title",
  "newsletter.grade_field": "Grade",
  "newsletter.grade_placeholder": "Select a grade",
  "newsletter.subject_field": "Subject",
  "newsletter.subject_placeholder": "Select a subject",
  "newsletter.body": "Entry content",
  "newsletter.save_draft": "Save draft",
  "newsletter.submit_entry": "Submit",
  "newsletter.error_title_required": "Title is required",
  "newsletter.error_grade_required": "Grade is required",
  "newsletter.error_save_failed": "Failed to save the entry.",
  "newsletter.error_submit_failed": "Failed to submit the entry.",
  "newsletter.copy_from_label": "Copy from…",
  "newsletter.copy_from_placeholder": "Choose one of your entries to copy from",
  "newsletter.copy_confirm_title": "Replace this entry's content?",
  "newsletter.copy_confirm_description": "This will overwrite what you've written here with the copied entry. The title is left untouched.",
  "newsletter.copy_confirm_action": "Replace",
  "newsletter.new_front_page_title": "New Front Page",
  "newsletter.edit_front_page_title": "Edit Front Page",
  "newsletter.front_pages": "Front pages",
  "newsletter.add_front_page": "Add page",
  "newsletter.no_front_pages": "No front pages yet.",
  "newsletter.status_submitted": "Submitted",
  "newsletter.status_draft": "Draft",
  "newsletter.reorder_aria": "Reorder \"{{title}}\"",
  "newsletter.grade_entries": "Grade entries",
  "newsletter.no_grade_entries": "No grade entries yet.",
  "newsletter.submitted_count": "{{count}} submitted",
  "newsletter.draft_count": "{{count}} draft",
  "newsletter.outstanding_title": "Outstanding",
  "newsletter.outstanding_none": "Everyone is caught up.",
  "newsletter.outstanding_count": "{{count}} teachers still owe entries",
  "newsletter.missing_count": "{{count}} missing",
  "newsletter.preview_action": "Preview",
  "newsletter.publish_action": "Publish",
  "newsletter.publish_confirm_title": "Publish this issue?",
  "newsletter.publish_confirm_outstanding": "{{count}} teachers still have work outstanding. Publish anyway?",
  "newsletter.publish_confirm_ready": "This makes the issue readable by families. You can send it separately once you're ready.",
  "newsletter.published_badge": "Published {{date}}",
  "newsletter.unpublish_action": "Unpublish",
  "newsletter.unpublish_locked_tooltip": "This issue was already sent to families — unpublishing would break the links they received.",
  "newsletter.unpublish_confirm_title": "Unpublish this issue?",
  "newsletter.unpublish_confirm_description": "The issue will no longer be readable by families until it is published again.",
  "newsletter.send_to_families": "Send to families",
  "newsletter.send_started": "Sending started {{date}} to {{count}} families",
  "newsletter.send_preview_title": "Send to Families",
  "newsletter.recipient_count": "Recipients",
  "newsletter.batch_count": "Batches",
  "newsletter.email_subject": "Subject",
  "newsletter.email_preview": "Preview",
  "newsletter.email_body_intro": "This week's newsletter is now available.",
  "newsletter.send_now": "Send now ({{count}})",
  "newsletter.error_send_failed": "Failed to send the newsletter.",
  "newsletter.delete_front_page_title": "Delete Front Page",
  "newsletter.delete_front_page_description": "This will permanently remove \"{{title}}\" from the issue.",
  "newsletter.no_issue_admin": "There is no newsletter issue yet.",
  "newsletter.create_issue": "Create issue",
  "newsletter.create_issue_title": "New Newsletter Issue",
  "newsletter.school_year_field": "School year",
  "newsletter.school_year_placeholder": "Select a school year",
  "newsletter.week_start_field": "Week start",
  "newsletter.week_end_field": "Week end",
  "newsletter.error_school_year_required": "School year is required",
  "newsletter.error_week_start_required": "Week start is required",
  "newsletter.error_week_end_required": "Week end is required",
  "newsletter.error_create_issue_failed": "Failed to create the issue.",
  "newsletter.auto_publish_label": "Publish automatically",
  "newsletter.auto_publish_hint": "The issue goes live at the time below, even if some entries are still missing.",
  "newsletter.schedule_time_label": "Publish at",
  "newsletter.schedule_time_required": "Choose when the issue should publish.",
  "newsletter.schedule_time_past": "The publish time must be in the future.",
  "newsletter.auto_send_label": "Email families when it publishes",
  "newsletter.auto_send_hint": "Sends the newsletter email to every parent at the same time. It can only be sent once.",
  "newsletter.schedule_action": "Schedule",
  "newsletter.scheduled_publish_only": "Publishes {{date}}",
  "newsletter.scheduled_with_send": "Publishes and emails {{date}}",
  "newsletter.schedule_modal_title": "Publishing schedule",
  "newsletter.error_schedule_failed": "Failed to save the schedule.",
  "newsletter.stats_title": "Readership",
  "newsletter.stats_empty": "No reads recorded yet",
  "newsletter.stats_reach": "Reach",
  "newsletter.stats_reach_detail": "{{readers}} of {{notified}} emailed parents opened it",
  "newsletter.stats_unique_readers": "Unique readers",
  "newsletter.stats_unique_readers_detail": "{{parents}} of these are parents",
  "newsletter.stats_views": "Views",
  "newsletter.stats_average_time": "Avg. reading time",
  "newsletter.stats_by_grade": "By grade",
  "newsletter.stats_col_readers": "Readers",
  "newsletter.stats_col_views": "Views",
  "newsletter.stats_col_average": "Avg.",
  "events.breadcrumb": "Events",
  "events.title": "Website Events",
  "events.subtitle": "Manage public events and registrations",
  "events.add_event": "Add Event",
  "events.error": "Failed to load events. Please try again.",
  "events.empty": "No events found. Create your first one!",
  "events.empty_filtered": "No events match the current filter.",
  "events.summary": "Showing {{filtered}} of {{total}} events",
  "events.location": "Location",
  "events.registration_required": "Registration required",
  "events.delete_title": "Delete Event",
  "events.delete_description": "Are you sure you want to delete this event? This action cannot be undone.",
  "weekly_menus.title": "Weekly Menus",
  "weekly_menus.subtitle": "Manage the weekly lunch plan shown to families on the website.",
  "weekly_menus.add_week": "Add Week",
  "weekly_menus.error": "Failed to load weekly menus.",
  "weekly_menus.empty": "No weekly menus yet. Click \"Add Week\" to create one.",
  "weekly_menus.empty_filtered": "No weekly menus match the current filter.",
  "weekly_menus.summary": "Showing {{filtered}} of {{total}} weekly menus",
  "weekly_menus.week": "Week",
  "weekly_menus.days": "Days",
  "weekly_menus.school_day": "school day",
  "weekly_menus.school_days": "school days",
  "weekly_menus.holiday": "holiday",
  "weekly_menus.holidays": "holidays",
  "weekly_menus.delete_title": "Delete Weekly Menu",
  "weekly_menus.delete_description": "This will permanently remove the menu. Families will no longer see it on the website.",
  "tour_requests.title": "Tour Requests",
  "tour_requests.subtitle": "Visit requests submitted through the admissions form.",
  "tour_requests.error": "Failed to load tour requests.",
  "tour_requests.empty": "No tour requests found.",
  "tour_requests.name": "Name",
  "tour_requests.email": "Email",
  "tour_requests.children_column": "Children",
  "tour_requests.received": "Received",
  "tour_requests.child": "child",
  "tour_requests.children_word": "children",
  "contact_inquiries.title": "Contact Inquiries",
  "contact_inquiries.subtitle": "Messages submitted through the contact form.",
  "contact_inquiries.error": "Failed to load contact inquiries.",
  "contact_inquiries.empty": "No inquiries found.",
  "contact_inquiries.name": "Name",
  "contact_inquiries.email": "Email",
  "contact_inquiries.subject": "Subject",
  "contact_inquiries.received": "Received",
  "image.default_label": "Image",
  "image.replace": "Replace",
  "image.remove": "Remove",
  "image.upload": "Upload {{label}}",
  "image.formats_hint": "PNG, JPG or WebP — max 10 MB",
  "image.aspect_hint": "Recommended ratio {{ratio}}",
  "image.crop_title": "Crop Image",
  "image.zoom": "Zoom",
  "image.uploading": "Uploading…",
  "image.crop_and_upload": "Crop & Upload",
  "image.crop_apply": "Apply",
  "image.crop_failed": "Crop failed",
  "image.upload_failed": "Upload failed",
  "student_combobox.all_students": "All students",
  "student_combobox.search_placeholder": "Search students…",
  "student_combobox.no_students_found": "No students found.",
  "student_combobox.clear_student": "Clear student",
  "staff_combobox.search_placeholder": "Search staff…",
  "staff_combobox.no_staff_found": "No staff found.",
  "email_list.invalid_email": "Please enter a valid email address.",
  "email_list.already_in_list": "This address is already in the list.",
  "email_list.no_recipients": "No recipients yet.",
  "email_list.remove_email": "Remove {{email}}",
  "editor.content_placeholder": "Write your article content...",
  "editor.quote_placeholder": "Quote",
  "editor.author_placeholder": "Author",
  "editor.loading": "Loading editor...",
  "enum.incident_type.biting_ey": "Biting (EY)",
  "enum.incident_type.hitting_ey": "Hitting (EY)",
  "enum.incident_type.pushing_ey": "Pushing (EY)",
  "enum.incident_type.throwing_objects": "Throwing objects",
  "enum.incident_type.verbal_aggression": "Verbal Aggression",
  "enum.incident_type.targeted_harm": "Targeted harmful behavior towards an individual",
  "enum.incident_type.inappropriate_language": "Inappropriate language, gestures, or written representations",
  "enum.incident_type.property_damage": "Property related damage",
  "enum.incident_type.leaving_supervised_areas": "Leaving supervised areas",
  "enum.incident_type.emotional_dysregulation": "Emotional dysregulation",
  "enum.incident_type.accident": "Accident",
  "enum.incident_type.peer_conflict": "Peer conflict",
  "enum.incident_type.other": "Other",
  "enum.incident_severity.low": "Low",
  "enum.incident_severity.medium": "Medium",
  "enum.incident_severity.high": "High",
  "enum.incident_status.open": "Open",
  "enum.incident_status.investigating": "Investigating",
  "enum.incident_status.closed": "Closed",
  "enum.incident_student_role.initiated": "Initiated / caused harm",
  "enum.incident_student_role.affected": "Affected / harmed",
  "enum.incident_student_role.witness": "Witness",
  "enum.incident_student_role.unclear": "Involved — unclear",
  "enum.support_note_visibility.staff": "Shared with teachers",
  "enum.support_note_visibility.sst_only": "SST only",
  "enum.incident_outcome.no_further_action": "No further action",
  "enum.incident_outcome.monitoring": "Monitoring",
  "enum.incident_outcome.parents_informed": "Parents informed",
  "enum.incident_outcome.behaviour_support_plan": "Behaviour support plan",
  "enum.incident_outcome.referred_to_counsellor": "Referred to counsellor",
  "enum.incident_outcome.disciplinary_action": "Disciplinary action",
  "enum.incident_outcome.other": "Other",
  "enum.checkout_unavailable_reason.absent": "Absent today",
  "enum.checkout_unavailable_reason.excused": "Excused today",
  "enum.checkout_unavailable_reason.early_dismissal": "Already has an early dismissal today",
  "enum.checkout_unavailable_reason.collected": "Already collected today",
  "enum.checkout_unavailable_reason.edp": "In an EDP placement",
  "enum.checkout_unavailable_reason.suspended": "Suspended today",
  "checkout.subtitle": "Call students to the door and hand them over to their families.",
  "checkout.tab_door": "Door",
  "checkout.tab_room": "Waiting room",
  "checkout.tab_all": "Everyone",
  "checkout.tab_switch_label": "Checkout view",
  "checkout.door_is_office_only": "This is the front office's screen. You can look, but calling and checking off students happens at the door.",
  "checkout.edp_until": "In EDP until {{time}}",
  "checkout.edp_back": "Back from EDP",
  "checkout.edp_skip_action": "Not going to EDP today",
  "checkout.edp_skipped": "Not going to EDP today: {{reason}}",
  "checkout.edp_skipped_by": "recorded by {{name}}",
  "checkout.edp_skip_undo": "Going to EDP after all",
  "checkout.edp_skip_title": "Not going to EDP today",
  "checkout.edp_skip_description": "{{name}} will be treated as going home this afternoon. The EDP teacher sees the reason on the afternoon roster.",
  "checkout.edp_skip_reason_label": "Reason the parent gave",
  "checkout.edp_skip_reason_required": "Write the reason the parent gave.",
  "checkout.edp_skip_reason_max": "Keep the reason to at most 200 characters.",
  "checkout.edp_skip_confirm": "Record",
  "checkout.edp_skip_recorded": "Recorded. {{name}} can be called now.",
  "checkout.edp_skip_removed": "{{name}} is going to EDP after all.",
  "checkout.going_home_alone_badge": "Going home alone",
  "checkout_door.search_title": "Find a family",
  "checkout_door.search_placeholder": "Search by student name or nickname…",
  "checkout_door.search_hint": "Keep typing to search",
  "checkout_door.search_no_results": "No matches",
  "checkout_door.no_guardian_heading": "No guardian on file",
  "checkout_door.already_called": "Already called",
  "checkout_door.call_button": "Call",
  "checkout_door.call_all_button": "Call all",
  "checkout_door.call_failed": "Could not reach the classroom — the call did not go through. Try again.",
  "checkout_door.call_no_grade": "This student has no grade on file, so no classroom can be told. Fix the student record first.",
  "checkout_door.waiting_title": "Waiting",
  "checkout_door.waiting_empty": "Nobody is waiting to be collected.",
  "checkout_door.status_on_way": "On the way",
  "checkout_door.collected_button": "Collected",
  "checkout_door.collect_failed": "Could not record the handover. Try again.",
  "checkout_door.cancel_button": "Cancel",
  "checkout_door.cancel_failed": "Could not cancel the call. Try again.",
  "checkout_door.collected_at": "Collected at {{time}}",
  "checkout_door.undo_collected_button": "Undo",
  "checkout_door.undo_failed": "Could not undo the handover. Try again.",
  "checkout_door.left_alone_button": "Left on their own",
  "checkout_alone.title": "Going home alone",
  "checkout_alone.send_home_button": "Send home",
  "checkout_alone.parent_coming_button": "Parent coming",
  "checkout_alone.parent_coming_heading": "Parent coming today ({{count}})",
  "checkout_alone.undo_button": "Undo",
  "checkout_alone.keep_failed": "Could not record that a parent is coming. Try again.",
  "checkout_alone.undo_failed": "Could not undo. Try again.",
  "checkout_waiting_room.title": "Now collecting",
  "checkout_waiting_room.filter_label": "Grades shown",
  "checkout_waiting_room.filter_my_homeroom": "My homeroom",
  "checkout_waiting_room.empty": "No one is waiting to be collected.",
  "checkout_waiting_room.on_way_button": "On the way",
  "checkout_waiting_room.edp_strip_title": "Staying for EDP",
  "checkout_waiting_room.edp_strip_count": "{{count}} staying",
  "checkout_waiting_room.edp_strip_empty": "Nobody from these grades stays for EDP today.",
  "checkout_waiting_room.edp_strip_show": "Show",
  "checkout_waiting_room.edp_strip_hide": "Hide",
  "enum.it_ticket_location.classroom": "Classroom",
  "enum.it_ticket_location.library": "Library",
  "enum.it_ticket_location.admin_office": "Admin Office",
  "enum.it_ticket_location.staff_office": "Staff office",
  "enum.it_ticket_location.meeting_room": "Meeting Room",
  "enum.it_ticket_location.not_applicable": "No location applicable",
  "enum.it_ticket_location.other": "Other",
  "enum.it_ticket_device.laptop": "Laptop",
  "enum.it_ticket_device.projector_smartboard": "Projector / Smart Board",
  "enum.it_ticket_device.tv": "TV",
  "enum.it_ticket_device.wifi_network": "WIFI / Network",
  "enum.it_ticket_device.google_classroom": "Google Classroom",
  "enum.it_ticket_device.student_laptop": "Student Laptop",
  "enum.it_ticket_device.student_tablet": "Student Tablet",
  "enum.it_ticket_device.hmh": "HMH",
  "enum.it_ticket_device.mcgraw_hill": "McGraw Hill",
  "enum.it_ticket_device.risp_platform": "RISP Platform",
  "enum.it_ticket_device.other_software": "Other software",
  "enum.it_ticket_device.other": "Other",
  "enum.it_ticket_priority.low": "Low",
  "enum.it_ticket_priority.medium": "Medium",
  "enum.it_ticket_priority.high": "High",
  "enum.it_ticket_status.open": "Open",
  "enum.it_ticket_status.in_progress": "In progress",
  "enum.it_ticket_status.waiting_on_requester": "Waiting on requester",
  "enum.it_ticket_status.resolved": "Resolved",
  "enum.leave_type.personal": "Personal Leave",
  "enum.leave_type.vacation": "Vacation",
  "enum.leave_type.sick": "Sick Leave",
  "enum.leave_type.professional_development": "Professional Development",
  "enum.leave_portion.full_day": "Full day",
  "enum.leave_portion.morning_half": "Half day (morning)",
  "enum.leave_portion.afternoon_half": "Half day (afternoon)",
  "enum.status.pending": "Pending",
  "enum.status.approved": "Approved",
  "enum.status.rejected": "Rejected",
  "enum.student_absence_type.sick": "Sick",
  "enum.student_absence_type.family": "Family",
  "enum.student_absence_type.travel": "Travel",
  "enum.student_absence_type.medical": "Medical",
  "enum.student_absence_type.other": "Other",
  "enum.relationship.mother": "Mother",
  "enum.relationship.father": "Father",
  "enum.relationship.guardian": "Guardian",
  "enum.relationship.grandmother": "Grandmother",
  "enum.relationship.grandfather": "Grandfather",
  "enum.relationship.stepmother": "Stepmother",
  "enum.relationship.stepfather": "Stepfather",
  "enum.relationship.aunt": "Aunt",
  "enum.relationship.uncle": "Uncle",
  "enum.relationship.other": "Other",
  "enum.language.en": "English",
  "enum.language.th": "Thai",
  "enum.language.zh": "Chinese",
  "enum.tour_status.new": "New",
  "enum.tour_status.confirmed": "Confirmed",
  "enum.tour_status.completed": "Completed",
  "enum.tour_status.cancelled": "Cancelled",
  "enum.inquiry_status.new": "New",
  "enum.inquiry_status.in_progress": "In Progress",
  "enum.inquiry_status.resolved": "Resolved",
  "enum.sex.male": "Male",
  "enum.sex.female": "Female",
  "enum.booking_resource_type.room": "Room",
  "enum.booking_resource_type.tablet": "Tablets",
  "import.subtitle": "Add students or staff from an Excel template, or load MAP scores exported from NWEA.",
  "import.tabs_label": "What to import",
  "import.tab_map": "MAP results",
  "import.step_template_title": "Download the template",
  "import.step_template_body_students": "Fill in one row per student and keep the column headings as they are.",
  "import.step_template_body_staff": "Fill in one row per staff member and keep the column headings as they are.",
  "import.step_upload_title": "Upload the filled template",
  "import.file_label": "Filled template (.xlsx)",
  "import.step_review_title": "Check and confirm",
  "import.step_review_waiting": "You will see every row before anything is saved. People already in RISP are skipped, never overwritten.",
  "import.choose_another_file": "Choose another file",
  "import.students": "Students",
  "import.staff": "Staff",
  "import.download_template": "Download template",
  "import.download_failed": "Download failed",
  "import.analysing": "Analysing file…",
  "import.preview_failed": "Preview failed.",
  "import.preview_help_note": "<strong>Nothing is saved yet.</strong> Review the rows, then press Confirm. <strong>Add</strong> = new people who'll be created. <strong>Skip</strong> = already in the system (matched by email or ID) — left untouched. <strong>Error</strong> = something's wrong in that row (see the message); fix it in your file and upload again.",
  "import.chip_add": "✅ {{count}} to add",
  "import.chip_skip": "⏭️ {{count}} to skip",
  "import.chip_error": "⚠️ {{count}} errors",
  "import.col_row": "Row",
  "import.col_full_name": "Full name",
  "import.col_notes": "Notes / Reason",
  "import.no_rows": "No rows to display.",
  "import.commit_failed": "Commit failed.",
  "import.send_invitations": "Send invitation emails to the new staff",
  "import.importing": "Importing…",
  "import.confirm_import": "Confirm import",
  "import.result_help_note": "Done. Skipped and errored rows were not created — fix any errors in your Excel file and import again to add them.",
  "import.summary": "Created {{created}} · Skipped {{skipped}}",
  "import.invited": "Invitations sent to {{count}} staff.",
  "import.errors_count": "Errors ({{count}}):",
  "import.row_error": "Row {{row}}: {{message}}",
  "import.import_another": "Import another",
  "import.disposition_skip": "Skip",
  "import.disposition_error": "Error",
  "school_years.tabs_label": "School year sections",
  "school_years.tab_years": "School years",
  "school_years.tab_edp_rounds": "EDP rounds",
  "school_years.tab_school_days": "School days",
  "school_years.tab_sessions": "Sessions",
  "inquiries.tabs_label": "Inquiry sections",
  "inquiries.tab_contact": "Contact inquiries",
  "inquiries.tab_tours": "Tour requests",
  "school_years.default_name": "School Year {{startYear}}-{{endYear}}",
  "school_years.subtitle": "Shared school-year windows for Sand Dollars and future school features.",
  "school_years.new_school_year": "New School Year",
  "school_years.active_year_label": "Active year:",
  "school_years.empty": "No school years yet. Create one before using year-scoped features.",
  "school_years.col_code": "Code",
  "school_years.col_name": "Name",
  "school_years.col_start_date": "Start Date",
  "school_years.col_end_date": "End Date",
  "school_years.promote_title": "Promote all students up a grade?",
  "school_years.promote_description": "Every active student moves up one grade level for this year. Grade 12 students are left as-is. This can only be done once per year.",
  "school_years.promote_label": "Promote",
  "school_years.promoted_already": "Students were already promoted for this year",
  "school_years.promoted_success": "Promoted {{count}} students",
  "school_years.promote_failed": "Failed to promote students",
  "school_years.error_code_required": "Code is required.",
  "school_years.error_name_required": "Name is required.",
  "school_years.error_start_date_required": "Start date is required.",
  "school_years.error_end_date_required": "End date is required.",
  "school_years.status_planned": "Planned",
  "school_years.status_active": "Active",
  "school_years.status_archived": "Archived",
  "school_years.status_locked": "Locked",
  "school_years.edit_title": "Edit school year",
  "school_years.new_title": "New school year",
  "school_years.field_start_date": "Start date",
  "school_years.field_end_date": "End date",
  "settings.subtitle": "Manage site-wide configuration without requiring a new build.",
  "settings.load_error": "Failed to load settings.",
  "settings.empty": "No settings available.",
  "settings.label.mourning_mode": "Mourning Mode",
  "settings.label.tour_request_recipients": "Tour Request Recipients",
  "settings.label.contact_inquiry_recipients": "Contact Inquiry Recipients",
  "settings.label.leave_request_staff_recipients": "Leave Request Recipients (Staff)",
  "settings.label.leave_request_student_recipients": "Leave Request Recipients (Students)",
  "settings.label.student_absence_recipients": "Student Absence Recipients",
  "settings.label.early_dismissal_recipients": "Early Dismissal Recipients",
  "settings.label.early_dismissal_reminder_recipients": "Early Dismissal Reminder Recipients",
  "settings.label.early_dismissal_reminder_lead_minutes": "Early Dismissal Reminder Lead Time",
  "settings.label.late_arrival_recipients": "Late arrival recipients",
  "settings.label.fever_alert_recipients": "Fever Alert Recipients",
  "settings.label.allergy_change_request_recipients": "Allergy/dietary change requests",
  "settings.label.immigration_compliance_recipients": "Immigration Compliance Recipients",
  "settings.label.it_support_recipients": "IT Support Recipients",
  "settings.label.it_archive_after_days": "Archive resolved tickets after (days)",
  "settings.desc.mourning_mode": "Applies a grayscale filter to the entire site.",
  "settings.desc.tour_request_recipients": "Staff emails that receive a notification when a new tour request is submitted.",
  "settings.desc.contact_inquiry_recipients": "Staff emails that receive a notification when a new contact form is submitted.",
  "settings.desc.leave_request_staff_recipients": "Staff emails CC'd on every staff leave of absence submission, approval, and rejection.",
  "settings.desc.leave_request_student_recipients": "Staff emails CC'd on every student leave of absence submission, approval, and rejection.",
  "settings.desc.student_absence_recipients": "Staff emails that receive a notification when a parent reports a student absence.",
  "settings.desc.early_dismissal_recipients": "Staff emails that receive a notification when a parent files an early dismissal.",
  "settings.desc.early_dismissal_reminder_recipients": "Staff emails reminded shortly before each pick-up, so somebody fetches the student for the gate.",
  "settings.desc.early_dismissal_reminder_lead_minutes": "How many minutes before a pick-up that reminder goes out.",
  "settings.desc.late_arrival_recipients": "Told when a family files a late arrival.",
  "settings.desc.fever_alert_recipients": "Staff who receive an email when a child's temperature is recorded at or above 37.5 °C.",
  "settings.desc.allergy_change_request_recipients": "Who is emailed when a parent proposes an allergy or dietary change for review.",
  "settings.desc.immigration_compliance_recipients": "HR emails that receive the daily digest of visa, work permit, and 90-day report deadlines approaching or overdue.",
  "settings.desc.it_support_recipients": "IT staff emails that receive a notification when a new IT ticket is submitted.",
  "settings.desc.it_archive_after_days": "Resolved tickets move to the archive this many days after resolution.",
  "audit_log.subtitle": "Every change made through the admin, who made it, and when.",
  "audit_log.error": "Failed to load the audit log.",
  "audit_log.empty": "No audit entries found.",
  "audit_log.actor_email_label": "Actor email",
  "audit_log.search_email_placeholder": "Search email…",
  "audit_log.action_placeholder": "e.g. users.",
  "audit_log.from_label": "From",
  "audit_log.from_placeholder": "From…",
  "audit_log.to_label": "To",
  "audit_log.to_placeholder": "To…",
  "audit_log.page_summary": "Page {{page}} of {{totalPages}} ({{total}} entries)",
  "audit_log.col_when": "When",
  "audit_log.col_actor": "Actor",
  "audit_log.col_action": "Action",
  "audit_log.col_target": "Target",
  "audit_log.no_payload": "No payload",
  "audit_log.medical_payload_restricted": "Clinical details are retained. Medical access is required to view them.",
  "calendar.subtitle": "Academic dates, holidays, and key milestones",
  "calendar.add_entry": "Add Calendar Entry",
  "calendar.error": "Failed to load calendar entries. Please try again.",
  "calendar.empty_no_entries": "No calendar entries yet",
  "calendar.empty_filtered": "No calendar entries match the current filters.",
  "calendar.summary": "Showing {{filtered}} of {{total}} entries",
  "calendar.summary_with_year": "Showing {{filtered}} of {{total}} entries in {{code}}",
  "calendar.school_year_label": "School Year",
  "calendar.select_school_year_placeholder": "Select school year",
  "calendar.active_suffix": "(Active)",
  "calendar.all_categories": "All categories",
  "calendar.col_audience": "Audience",
  "calendar.all_day": "All day",
  "calendar.publish_tooltip": "Publish event",
  "calendar.delete_title": "Delete Calendar Entry",
  "calendar.delete_description": "Are you sure you want to delete this calendar entry? This action cannot be undone.",
  "calendar.feed_description": "Share this URL with families so they can sync the currently active school year automatically.",
  "calendar.copy_feed_link": "Copy feed link",
  "calendar.feed_link_copied": "Feed link copied",
  "calendar.view_label": "View",
  "calendar.view_list": "List",
  "calendar.view_month": "Month",
  "calendar.month_label": "Month",
  "calendar.previous_month": "Previous month",
  "calendar.next_month": "Next month",
  "leave.list_title": "Leave requests",
  "leave.list_subtitle": "Review and decide on staff leave of absence requests.",
  "leave.new_on_behalf": "New on behalf",
  "leave.search_placeholder": "Search by requester name or email…",
  "leave.search_aria": "Search leave requests by requester email",
  "leave.type_label": "Type",
  "leave.list_empty": "No requests match these filters.",
  "leave.col_requester": "Requester",
  "leave.col_dates": "Dates",
  "leave.col_days": "Days",
  "leave.col_action": "Action",
  "leave.open": "Open",
  "leave.new_on_behalf_title": "New leave request on behalf",
  "leave.my_title": "My leaves",
  "leave.my_subtitle": "Submit and track your leave of absence requests.",
  "leave.new_request": "New request",
  "leave.your_entitlement": "Your entitlement",
  "leave.history": "History",
  "leave.no_requests": "No leave requests yet.",
  "leave.days_one": "{{count}} day",
  "leave.days_other": "{{count}} days",
  "leave.reviewer_message": "Reviewer message:",
  "leave.new_request_title": "New leave request",
  "leave.detail_title": "Leave request — {{name}}",
  "leave.loading": "Loading…",
  "leave.detail_breadcrumb": "Detail",
  "leave.back": "Back",
  "leave.request_section": "Request",
  "leave.days_counted": "Days counted",
  "leave.submitted": "Submitted",
  "leave.reviewed": "Reviewed",
  "leave.reason": "Reason",
  "leave.requester_entitlement_title": "{{name}}'s leave",
  "leave.entitlement_default_title": "Entitlement",
  "leave.left": "left",
  "leave.days_used": "days used",
  "leave.over_allowance": "Over the {{limit}}-day allowance",
  "leave.staff_member_label": "Staff member",
  "leave.staff_member_placeholder": "Select the staff member this is for",
  "leave.on_behalf_hint": "Filing on behalf — the staff member will receive a confirmation email and can review the request from their My Leaves page.",
  "leave.error_no_requester": "Please select the staff member this request is for.",
  "leave.error_type_required": "Type is required",
  "leave.error_start_date_required": "Start date is required",
  "leave.error_end_date_required": "End date is required",
  "leave.error_end_date_after_start": "End date must be on or after start date",
  "leave.error_reason_required": "Reason is required",
  "leave.error_submit_failed": "Failed to submit leave request",
  "leave.days_remaining": "{{remaining}} of {{limit}} days remaining this year",
  "leave.days_pending_suffix": " ({{pending}} pending)",
  "leave.start_date_label": "Start date",
  "leave.end_date_label": "End date",
  "leave.duration_label": "Duration",
  "leave.half_day_hint": "Half-day options apply only to single-day requests.",
  "leave.submit_on_behalf": "Submit on behalf",
  "leave.submit_request": "Submit request",
  "leave.save_changes": "Save changes",
  "leave.edit_request": "Edit request",
  "leave.edit_request_title": "Edit request",
  "leave.submitting": "Submitting…",
  "leave.decision_title": "Decision",
  "leave.decided_by": "By {{name}} · {{date}}",
  "leave.message_to_requester": "Message to the requester",
  "leave.message_placeholder": "Optional — this is included in the approval / rejection email.",
  "leave.reject": "Reject",
  "leave.approve": "Approve",
  "leave.error_decision_failed": "Failed to update decision",
  "leave.internal_notes_title": "Internal notes",
  "leave.internal_notes_hint": "Only visible to admins.",
  "leave.no_notes": "No notes yet.",
  "leave.unknown_author": "Unknown",
  "leave.note_placeholder": "Add a note for other reviewers…",
  "leave.add_note": "Add note",
  "leave.adding_note": "Adding…",
  "leave.error_note_empty": "Note cannot be empty",
  "leave.error_note_add_failed": "Failed to add note",
  "leave.error_note_delete_failed": "Failed to delete note",
  "arrivals_dismissals.title": "Arrivals & dismissals",
  "arrivals_dismissals.subtitle": "Late arrivals and early pick-ups families have filed and the office recorded. Nothing here waits to be approved.",
  "arrivals_dismissals.kind.arrival": "Arrives",
  "arrivals_dismissals.kind.dismissal": "Leaves",
  "arrivals_dismissals.type_label": "Type",
  "arrivals_dismissals.type.all": "All",
  "arrivals_dismissals.empty": "Nothing matches these filters.",
  "late_arrivals.record_button": "Record late arrival",
  "late_arrivals.dialog_title": "Record late arrival",
  "late_arrivals.arrives_at": "Arrives at",
  "late_arrivals.time_window": "Choose a time between 08:00 and 13:00.",
  "late_arrivals.toast_recorded": "Late arrival recorded",
  "late_arrivals.record_failed": "Could not record the late arrival",
  "late_arrivals.not_excused": "Not excused",
  "late_arrivals.excused": "Excused",
  "late_arrivals.excused_help": "Switch off when this should count as an ordinary late. Only admins can change it.",
  "late_arrivals.excused_failed": "Could not update whether this counts as excused",
  "late_arrivals.term_count_one": "{{count}} late arrival this school year ({{notExcused}} not excused)",
  "late_arrivals.term_count_other": "{{count}} late arrivals this school year ({{notExcused}} not excused)",
  "late_arrivals.detail_breadcrumb": "Late arrival",
  "late_arrivals.detail_title": "Late arrival — {{name}}",
  "late_arrivals.not_found": "This late arrival no longer exists.",
  "late_arrivals.deleted": "Late arrival deleted",
  "late_arrivals.delete_title": "Delete this late arrival?",
  "late_arrivals.delete_description": "The lessons it excused go back to unmarked.",
  "early_dismissals.record_button": "Record dismissal",
  "early_dismissals.dialog_title": "Record early dismissal",
  "early_dismissals.toast_recorded": "Early dismissal recorded",
  "early_dismissals.record_failed": "Failed to record early dismissal",
  "early_dismissals.deleted": "Early dismissal deleted.",
  "early_dismissals.delete_title": "Delete this early dismissal?",
  "early_dismissals.delete_description": "The pick-up disappears from the gate list and from the teacher’s day. Nobody is emailed about it — tell the family yourself if they filed it.",
  "student_absences.delete_title": "Delete this absence?",
  "student_absences.delete_description": "The excused marks for these days are removed and the days go back to having no attendance record. If a teacher had marked the student before this absence was entered, that mark cannot be brought back.",
  "student_absences.deleted": "Absence deleted.",
  "student_absences.title": "Student absences",
  "student_absences.subtitle": "Absences reported by parents, and ones recorded on their behalf.",
  "student_absences.record_button": "Record absence",
  "student_absences.search_aria": "Search student absences by student name",
  "student_absences.empty": "No absences match these filters.",
  "student_absences.type_label": "Type",
  "student_absences.col_dates": "Dates",
  "student_absences.dialog_title": "Record absence",
  "student_absences.edit_title": "Change absence",
  "student_absences.toast_updated": "Absence updated",
  "student_absences.end_before_start": "The last day cannot fall before the first day",
  "student_absences.toast_recorded": "Absence recorded",
  "student_absences.record_failed": "Failed to record absence",
  "student_absences.start_date_label": "Start date",
  "student_absences.end_date_label": "End date",
  "incidents.error_select_student": "Select a student",
  "incidents.error_date_required": "Date is required",
  "incidents.error_time_format": "Time must be HH:MM",
  "incidents.error_location_required": "Location is required",
  "incidents.error_type_other_required": "Please specify the incident type",
  "incidents.error_description_required": "Description is required",
  "incidents.action_taken_optional": "Action taken (optional)",
  "incidents.prevention_suggestion_optional": "Suggestion for prevention (optional)",
  "incidents.error_form_invalid": "Some details still need fixing — check the highlighted fields.",
  "incidents.attachment_upload_warning": "Incident saved, but attachments failed to upload: {{message}}",
  "incidents.unknown_error": "unknown error",
  "incidents.report_success": "Incident reported",
  "incidents.report_failed": "Failed to report incident",
  "incidents.report_incident": "Report incident",
  "incidents.report_description": "File an incident report about a student.",
  "incidents.field_location": "Location",
  "incidents.field_type": "Type of incident",
  "incidents.field_specify": "Specify",
  "incidents.add_student": "Add another student",
  "incidents.add_staff": "Add staff",
  "incidents.select_student": "Select student",
  "incidents.student_note_placeholder": "Note (optional)",
  "incidents.severity": "Severity",
  "incidents.field_medical": "Medical attention required",
  "incidents.field_description": "Detailed description",
  "incidents.action_taken": "Action taken",
  "incidents.prevention_suggestion": "Suggestion for prevention",
  "incidents.field_attachments": "Attachments (images or PDF, up to 6)",
  "incidents.remove": "Remove",
  "incidents.submit_report": "Submit report",
  "sst.tab_switch_label": "Filter by state",
  "sst.tab_incidents": "Incidents",
  "sst.tab_lunch_detention": "MSS",
  "sst.tab_lunch_detention_attention": "MSS runs awaiting action",
  "sst.tab_patterns": "Patterns",
  "sst.tab_tests": "Tests",
  "sst.patterns_subtitle": "Children whose last {{days}} school days show something worth a look.",
  "sst.patterns_empty": "No patterns in the last {{days}} school days.",
  "sst.patterns_filter_unsupervised": "Not yet supervised",
  "sst.patterns_filter_supervised": "Under supervision",
  "sst.patterns_filter_everyone": "Everyone",
  "sst.patterns_supervised_since": "Under SST supervision since {{date}}",
  "sst.patterns_not_supervised": "Not supervised",
  "sst.patterns_flag_late": "Late pattern",
  "sst.patterns_flag_attendance": "Attendance",
  "sst.patterns_flag_class": "Class attendance",
  "sst.patterns_flag_incidents": "Incidents",
  "sst.patterns_flag_recognition": "Recognition",
  "sst.patterns_strip_label": "{{days}} school days, oldest first",
  "sst.patterns_legend_title": "How to read the strip",
  "sst.patterns_legend_present": "Present",
  "sst.patterns_legend_late": "Late — taller means later",
  "sst.patterns_legend_late_unmeasured": "Late, arrival time not recorded",
  "sst.patterns_legend_absent": "Absent",
  "sst.patterns_legend_excused": "Excused",
  "sst.patterns_legend_suspended": "Suspended",
  "sst.patterns_legend_none": "Nothing recorded",
  "sst.patterns_legend_incident": "Incident that day",
  "sst.patterns_legend_mss": "MSS day",
  "sst.patterns_day_present": "Present",
  "sst.patterns_day_late": "Late by {{minutes}} min",
  "sst.patterns_day_late_unmeasured": "Late, arrival time not recorded",
  "sst.patterns_day_absent": "Absent",
  "sst.patterns_day_excused": "Excused",
  "sst.patterns_day_suspended": "Suspended",
  "sst.patterns_day_none": "Nothing recorded",
  "sst.patterns_day_incidents_one": "{{count}} incident",
  "sst.patterns_day_incidents_other": "{{count}} incidents",
  "sst.patterns_day_mss": "MSS day",
  "sst.patterns_attendance_line": "Attended {{rate}} of the {{days}} school days recorded this year.",
  "sst.patterns_attendance_none": "No attendance recorded yet this year.",
  "sst.patterns_attendance_compare": "Children in {{gradeName}} average {{average}}.",
  "sst.patterns_late_line": "Arrived after {{cutoff}} on {{count}} mornings in the last {{days}} school days.",
  "sst.patterns_late_figures": "{{minutes}} minutes late on average, {{lost}} minutes of lessons missed.",
  "sst.patterns_late_partial": "Only {{measured}} of those mornings had a recorded arrival time, so the figures cover those {{measured}}.",
  "sst.patterns_late_unmeasured": "None of those mornings had a recorded arrival time, so there is nothing to average.",
  "sst.patterns_class_line": "{{className}}: present for {{rate}} of the {{periods}} lessons recorded this year.",
  "sst.patterns_class_compare": "The rest of that class averages {{average}}.",
  "sst.patterns_incidents_line": "Named in {{count}} incidents within {{days}} days.",
  "sst.patterns_recognition_line_one": "{{count}} sand dollar in the last {{days}} school days.",
  "sst.patterns_recognition_line_other": "{{count}} sand dollars in the last {{days}} school days.",
  "sst.patterns_recognition_compare": "Children in {{gradeName}} average {{average}} a day.",
  "sst.patterns_threshold_late": "flagged from 5 mornings",
  "sst.patterns_threshold_attendance": "flagged below 80%",
  "sst.patterns_threshold_class": "flagged below 80%",
  "sst.patterns_threshold_incidents": "flagged from 3, or 2 within a week",
  "sst.patterns_threshold_recognition": "flagged below 5",
  "sst.patterns_flag_grades_low": "Low grades",
  "sst.patterns_flag_grades_dropping": "Grades dropping",
  "sst.patterns_threshold_grades_low": "flagged from 3 low marks, or any F",
  "sst.patterns_threshold_grades_dropping": "flagged from 2 subjects down",
  "sst.patterns_grades_low_line": "Low marks on the {{period}} report card:",
  "sst.patterns_grades_dropping_line": "Lower on the {{period}} report card than in {{previous}}:",
  "sst.patterns_open_student": "Open student",
  "sst.patterns_filter_any_flag": "Any pattern",
  "sst.suspensions.title": "Suspensions",
  "sst.suspensions.case": "Suspension",
  "sst.suspensions.badge": "Suspended",
  "sst.suspensions.tab_attention": "Unread teacher messages on suspensions",
  "sst.suspensions.subtitle_sst": "Every suspension, where it is served, and the work teachers send in.",
  "sst.suspensions.subtitle_teacher": "Suspensions of students you teach. Send work to the SST from each one.",
  "sst.suspensions.create_action": "New suspension",
  "sst.suspensions.search_aria": "Search suspensions by student",
  "sst.suspensions.filter_all": "All",
  "sst.suspensions.filter_active": "Active",
  "sst.suspensions.filter_upcoming": "Upcoming",
  "sst.suspensions.filter_past": "Past",
  "sst.suspensions.filter_cancelled": "Cancelled",
  "sst.suspensions.empty": "No suspensions to show.",
  "sst.suspensions.served_at_label": "Served",
  "sst.suspensions.served_at_school": "In school",
  "sst.suspensions.served_at_home": "At home",
  "sst.suspensions.supervisor_label": "Send work to",
  "sst.suspensions.supervisor_none": "Not set",
  "sst.suspensions.phase_upcoming": "Upcoming",
  "sst.suspensions.phase_active": "Active",
  "sst.suspensions.phase_ended": "Ended",
  "sst.suspensions.phase_cancelled": "Cancelled",
  "sst.suspensions.open_action": "Open suspension",
  "sst.suspensions.error_student_required": "Choose a student.",
  "sst.suspensions.error_start_required": "Choose a start date.",
  "sst.suspensions.error_end_required": "Choose an end date.",
  "sst.suspensions.error_end_before_start": "The end date cannot be before the start date.",
  "sst.suspensions.error_location_too_long": "Keep the location under {{max}} characters.",
  "sst.suspensions.error_reason_required": "Give a reason.",
  "sst.suspensions.error_reason_too_long": "Keep the reason under {{max}} characters.",
  "sst.suspensions.field_start_date": "First day",
  "sst.suspensions.field_end_date": "Last day",
  "sst.suspensions.location_label": "Where in school",
  "sst.suspensions.location_placeholder": "e.g. Mornings EY side, from lunch SST office",
  "sst.suspensions.supervisor_field_label": "Send work to (supervisor)",
  "sst.suspensions.edp_allowed_label": "EDP allowed",
  "sst.suspensions.edp_allowed_hint": "Off: the student misses EDP while suspended. On: EDP runs as normal.",
  "sst.suspensions.incident_label": "Incident",
  "sst.suspensions.incident_none": "No incident",
  "sst.suspensions.incident_open": "Open incident",
  "sst.suspensions.create_title": "New suspension",
  "sst.suspensions.create_description": "Every school day in the range is marked suspended in the register, every lesson and MSS. The student's teachers are told.",
  "sst.suspensions.create_submit": "Record suspension",
  "sst.suspensions.create_success": "Suspension recorded",
  "sst.suspensions.edit_title": "Edit suspension",
  "sst.suspensions.edit_description": "Change {{name}}'s suspension. New dates re-mark the register and MSS.",
  "sst.suspensions.edit_success": "Suspension updated",
  "sst.suspensions.cancel_title": "Cancel suspension",
  "sst.suspensions.cancel_description": "Cancel {{name}}'s suspension as recorded in error?",
  "sst.suspensions.cancel_marks_explained": "Every suspended mark it wrote is removed: days and lessons go back to unmarked, and absences, late arrivals and door taps apply again. Teachers' earlier marks are not restored. To end a suspension early, edit its last day instead.",
  "sst.suspensions.cancel_confirm": "Cancel suspension",
  "sst.suspensions.cancel_success": "Suspension cancelled",
  "sst.suspensions.cancel_action": "Cancel suspension",
  "sst.suspensions.outcome_label": "Day log",
  "sst.suspensions.outcome_pending": "Not recorded",
  "sst.suspensions.outcome_served": "Served",
  "sst.suspensions.outcome_not_served": "Not served",
  "sst.suspensions.outcome_absent": "Absent",
  "sst.suspensions.marked_by_at": "Recorded by {{name}} · {{date}}",
  "sst.suspensions.day_note_label": "What they worked on",
  "sst.suspensions.day_note_placeholder": "Work completed, behaviour, anything to follow up",
  "sst.suspensions.thread_file_too_big": "{{name}} is over 10 MB and was left out.",
  "sst.suspensions.thread_placeholder": "Write a message or attach work…",
  "sst.suspensions.thread_send": "Send",
  "sst.suspensions.thread_attach_label": "Attach files (images or PDF, up to 6)",
  "sst.suspensions.thread_remove_file": "Remove {{name}}",
  "sst.suspensions.thread_with": "Thread with {{name}}",
  "sst.suspensions.thread_hint_sst": "Only you, the rest of the SST and this teacher see this thread.",
  "sst.suspensions.thread_title_teacher": "Your thread with the SST",
  "sst.suspensions.thread_hint_teacher": "Send work and notes for this student. Only you and the SST see this thread.",
  "sst.suspensions.notes_title": "SST notes",
  "sst.suspensions.notes_hint": "Private to the SST. Teachers never see these.",
  "sst.suspensions.notes_placeholder": "Add a note for the SST…",
  "sst.suspensions.notes_send": "Add note",
  "sst.suspensions.teachers_back": "All teachers",
  "sst.suspensions.teachers_title": "Teachers",
  "sst.suspensions.teachers_empty": "No teachers found for this student.",
  "sst.suspensions.teacher_left": "No longer teaches this student",
  "sst.suspensions.teacher_no_messages": "No messages yet",
  "sst.suspensions.teacher_unread_one": "{{count}} unread message",
  "sst.suspensions.teacher_unread_other": "{{count}} unread messages",
  "sst.suspensions.send_work_to": "Send work to",
  "sst.suspensions.details_title": "Details",
  "sst.suspensions.created_label": "Recorded",
  "sst.suspensions.created_by": "{{name}} · {{date}}",
  "sst.suspensions.cancelled_label": "Cancelled",
  "sst.suspensions.manage_title": "Manage",
  "sst.suspensions.tab_overview": "Overview",
  "sst.suspensions.tab_log": "Day log",
  "sst.suspensions.tab_notes": "SST notes",
  "sst.suspensions.tab_teachers": "Teachers",
  "sst.suspensions.tab_thread": "Send work",
  "sst.suspensions.attention_log_title_one": "{{count}} day to record",
  "sst.suspensions.attention_log_title_other": "{{count}} days to record",
  "sst.suspensions.attention_log_description": "Record whether the student served each past day in school, and what they worked on.",
  "sst.suspensions.attention_log_action": "Open day log",
  "sst.suspensions.workspace_tabs_label": "Suspension sections",
  "sst.suspensions.log_title": "Day log",
  "sst.suspensions.log_hint": "One row per school day served in school. Days still to come cannot be recorded yet.",
  "sst.suspensions.log_empty": "No school days to record.",
  "sst.suspensions.student_empty": "No suspensions on record.",
  "lunch_detentions.title": "MSS (Midday Support and Study)",
  "lunch_detentions.subtitle": "Review MSS runs and mark attendance for the ones you supervise.",
  "lunch_detentions.search_aria": "Search MSS runs by student name",
  "lunch_detentions.empty": "No MSS runs match these filters.",
  "lunch_detentions.awaiting_decision_title": "Awaiting decision",
  "lunch_detentions.proposed_by_name": "Proposed by {{name}}",
  "lunch_detentions.proposed_by_sst": "Created directly by SST",
  "lunch_detentions.col_supervisor": "Supervisor",
  "lunch_detentions.col_proposed_by": "Proposed by",
  "lunch_detentions.open_action": "Open",
  "lunch_detentions.supervisor_none": "Not yet assigned",
  "lunch_detentions.case": "MSS",
  "lunch_detentions.decided_by": "Decided by {{name}} on {{date}}",
  "lunch_detentions.decision_note_label": "Decision note",
  "lunch_detentions.days_title": "Days",
  "lunch_detentions.col_attendance": "Attendance",
  "lunch_detentions.col_marked_by": "Marked by",
  "lunch_detentions.col_note": "Note",
  "lunch_detentions.marked_by_at": "{{name}}, {{date}}",
  "lunch_detentions.note_placeholder": "Add a note about this MSS run…",
  "lunch_detentions.mark_disabled_hint": "Only the named supervisor or an SST member can mark days here, and only while the run is approved.",
  "lunch_detentions.manage_title": "Manage",
  "lunch_detentions.cancel_action": "Cancel run",
  "lunch_detentions.details_title": "Details",
  "attachments.remove_confirm_title": "Remove this file?",
  "attachments.remove_confirm_description": "{{name}} will be removed for everyone who can see this record.",
  "attachments.remove_action": "Remove",
  "attachments.removed": "{{name}} removed",
  "attachments.uploading_one": "Uploading {{count}} file…",
  "attachments.uploading_other": "Uploading {{count}} files…",
  "attachments.uploaded_one": "{{count}} file added",
  "attachments.uploaded_other": "{{count}} files added",
  "lunch_detentions.documents_title": "Documents",
  "lunch_detentions.documents_help": "Exercises or materials for this MSS",
  "lunch_detentions.documents_add": "Add documents — PDF, Word, Excel, PowerPoint or photos, up to 10 MB each",
  "lunch_detentions.documents_empty": "No documents yet.",
  "lunch_detentions.documents_added_by": "Added by {{name}} · {{date}}",
  "lunch_detentions.documents_added_on": "Added {{date}}",
  "lunch_detentions.documents_read_only_hint": "The people named on this MSS, the student's homeroom teacher and SST can add documents.",
  "lunch_detentions.documents_count_one": "{{count}} document",
  "lunch_detentions.documents_count_other": "{{count}} documents",
  "lunch_detentions.created_at_label": "Created",
  "lunch_detentions.proposed_by_label": "Proposed by",
  "lunch_detentions.supervisor_label": "Supervisor",
  "lunch_detentions.withdraw_action": "Withdraw",
  "lunch_detentions.withdraw_confirm_title": "Withdraw this proposal?",
  "lunch_detentions.withdraw_confirm_description": "The SST team will no longer see it awaiting a decision.",
  "lunch_detentions.withdraw_success": "Proposal withdrawn.",
  "lunch_detentions.confirm_no_show_title": "Mark as no-show?",
  "lunch_detentions.confirm_no_show_description": "{{name}} was in school on {{date}} but did not attend. This will be recorded as a no-show.",
  "lunch_detentions.confirm_no_show_action": "Mark no-show",
  "lunch_detentions.room.folded_in": "+{{count}} folded in",
  "lunch_detentions.room.days_left": "{{count}} left",
  "lunch_detentions.room.until": "until {{date}}",
  "lunch_detentions.room.note_placeholder": "Add a note…",
  "lunch_detentions.room.not_marked_title": "Not marked yet",
  "lunch_detentions.room.left_to_mark": "{{count}} left to mark",
  "lunch_detentions.room.session_title": "MSS room",
  "lunch_detentions.room.open_room": "Open today's room",
  "lunch_detentions.room.load_error": "Couldn't load the MSS room.",
  "lunch_detentions.decide_approve_title": "Approve MSS run",
  "lunch_detentions.decide_reject_title": "Reject MSS run",
  "lunch_detentions.decide_description": "{{name}}, {{dates}}",
  "lunch_detentions.decide_approve_success": "MSS run approved.",
  "lunch_detentions.decide_reject_success": "MSS run rejected.",
  "lunch_detentions.decision_note_hint": "Shown to the proposing teacher.",
  "lunch_detentions.supervisor_field_label": "Supervisor",
  "lunch_detentions.supervisor_none_option": "No supervisor yet",
  "lunch_detentions.edit_title": "Edit MSS run",
  "lunch_detentions.edit_description": "Days already marked are kept; only pending days adjust to the new range.",
  "lunch_detentions.field_start_date": "Start date",
  "lunch_detentions.field_end_date": "End date",
  "lunch_detentions.error_start_required": "Start date is required.",
  "lunch_detentions.error_end_required": "End date is required.",
  "lunch_detentions.error_end_before_start": "End date must be on or after the start date.",
  "lunch_detentions.edit_success": "MSS run updated.",
  "lunch_detentions.cancel_title": "Cancel this MSS run?",
  "lunch_detentions.cancel_description": "Days already marked for {{name}} stay on record; days still pending will no longer be tracked.",
  "lunch_detentions.cancel_confirm": "Cancel run",
  "lunch_detentions.cancel_success": "MSS run cancelled.",
  "lunch_detentions.propose_action": "New MSS run",
  "lunch_detentions.propose_dialog_title": "New MSS run",
  "lunch_detentions.propose_dialog_description_teacher": "This will be sent to the Student Support Team for approval.",
  "lunch_detentions.propose_dialog_description_sst": "This will be created and approved immediately.",
  "lunch_detentions.field_students": "Students",
  "lunch_detentions.error_select_student": "Select at least one student.",
  "lunch_detentions.error_too_many_students": "No more than {{max}} students at a time.",
  "lunch_detentions.error_reason_required": "Reason is required.",
  "lunch_detentions.clash_notice": "Already serving until {{date}}",
  "lunch_detentions.clash_notice_proposer_hint": "Send the request as usual — the SST team will add these days to the run already under way, or schedule them after it.",
  "lunch_detentions.clash_remove_student": "Leave them out of this request",
  "lunch_detentions.clash_create_must_resolve": "This is created already approved, so it cannot be settled later. For each student above, either add the days to the run under way — they stay on one run, in the lunch room once a day, marked once — or leave them out and handle them separately.",
  "lunch_detentions.clash_must_resolve": "Choose one, or change the dates so they no longer overlap — two runs covering one day put the student in the lunch room twice.",
  "lunch_detentions.request_count": "{{ordinal}} request this school year",
  "lunch_detentions.reschedule_after_clash_action": "Start after existing run ends",
  "lunch_detentions.reschedule_after_clash_hint": "Two runs, back to back. This becomes a separate run starting the day after the current one ends, with its own days, its own supervisor and its own marking — two sanctions on her record instead of one.",
  "lunch_detentions.extend_existing_action": "Add to the run they are already serving",
  "lunch_detentions.clash_same_days": "She serves the same number of days either way. The choice is whether that is one run or two.",
  "lunch_detentions.extend_existing_hint": "One run, made longer. The days this request asks for are added to the end of the run already under way, so she stays on a single run, appears in the lunch room once a day and is marked once. This request keeps its own reason and is linked to that run.",
  "lunch_detentions.extends_days_hint": "This request has no days of its own — it lengthened the run below, and the student is marked there.",
  "lunch_detentions.extends_link": "{{reason}} ({{dates}})",
  "lunch_detentions.extended_by_label": "Lengthened by",
  "lunch_detentions.propose_submit": "Propose",
  "lunch_detentions.create_submit": "Create",
  "lunch_detentions.propose_success": "MSS run proposed.",
  "lunch_detentions.create_success": "MSS run created.",
  "lunch_detentions.mode_label": "Approve now or send for review",
  "lunch_detentions.mode_approve": "Approve now",
  "lunch_detentions.mode_review": "Send for review",
  "lunch_detentions.review_success": "MSS run sent for review.",
  "lunch_detentions.from_incident_title": "Create an MSS run?",
  "lunch_detentions.from_incident_description": "This case was closed as disciplinary action. Create an MSS run for the student involved now?",
  "lunch_detentions.from_incident_confirm": "Create MSS run",
  "lunch_detentions.from_incident_skip": "Not now",
  "enum.lunch_detention_status.proposed": "Proposed",
  "enum.lunch_detention_status.approved": "Approved",
  "enum.lunch_detention_status.rejected": "Rejected",
  "enum.lunch_detention_status.withdrawn": "Withdrawn",
  "enum.lunch_detention_status.cancelled": "Cancelled",
  "enum.lunch_detention_phase.proposed": "Proposed",
  "enum.lunch_detention_phase.upcoming": "Upcoming",
  "enum.lunch_detention_phase.running": "Running",
  "enum.lunch_detention_phase.completed": "Completed",
  "enum.lunch_detention_phase.extension": "Added to another run",
  "enum.lunch_detention_phase.rejected": "Rejected",
  "enum.lunch_detention_phase.withdrawn": "Withdrawn",
  "enum.lunch_detention_phase.cancelled": "Cancelled",
  "enum.lunch_detention_attendance.pending": "Pending",
  "enum.lunch_detention_attendance.attended": "Attended",
  "enum.lunch_detention_attendance.absent": "Absent",
  "enum.lunch_detention_attendance.no_show": "No-show",
  "enum.lunch_detention_attendance.excused": "Excused",
  "enum.lunch_detention_attendance.suspended": "Suspended",
  "incidents.title": "Incidents",
  "incidents.subtitle_all": "Review incident reports filed by staff.",
  "incidents.subtitle_mine": "Incident reports you are involved in or oversee as a homeroom teacher.",
  "incidents.search_aria": "Search incidents by student names",
  "incidents.empty": "No incidents match these filters.",
  "incidents.col_medical": "Medical",
  "incidents.col_reporter": "Reporter",
  "incidents.type_label": "Type",
  "incidents.open_action": "Open",
  "incidents.unread_badge": "{{count}} unread updates",
  "incidents.new_badge": "New",
  "incidents.students_involved": "Students involved",
  "incidents.what_happened": "What happened",
  "incidents.schedule_students_count": "{{count}} students matched",
  "incidents.estimated_lesson": "Estimated lesson",
  "incidents.initial_response_title": "Initial response",
  "incidents.staff_involved": "Staff involved",
  "incidents.description_label": "Description",
  "incidents.attachments_label": "Attachments",
  "incidents.close": "Close",
  "incidents.severity_prefix": "Severity: {{severity}}",
  "incidents.medical_attention_badge": "Medical attention",
  "incidents.infirmary_title": "Infirmary",
  "incidents.infirmary_link_action": "Link a visit",
  "incidents.infirmary_unlink_action": "Unlink",
  "incidents.infirmary_open_requires_access": "Opening the full record requires Medical / Infirmary access.",
  "incidents.infirmary_none": "No infirmary visit is linked to this incident.",
  "incidents.infirmary_none_but_flagged": "This incident is marked as needing medical attention, but no infirmary visit is linked to it yet.",
  "incidents.infirmary_pick_hint": "Visits by the students on this incident on {{date}}.",
  "incidents.infirmary_pick_empty": "No unlinked infirmary visit was recorded for these students that day.",
  "incidents.no_attachments": "No attachments.",
  "incidents.download_failed": "Failed to download",
  "incidents.case": "Case",
  "incidents.the_report": "The report",
  "incidents.filed_by": "Filed by {{name}}",
  "incidents.legacy_note": "Imported from the previous system",
  "incidents.conversation": "Conversation",
  "incidents.message_placeholder": "Write a message…",
  "incidents.send_message": "Send message",
  "incidents.decision": "Decision",
  "incidents.outcome": "Outcome",
  "incidents.closed_by": "Closed by {{name}} on {{date}}",
  "incidents.no_decision_yet": "No decision has been recorded yet.",
  "incidents.reopen": "Reopen",
  "incidents.start_investigation": "Start investigation",
  "incidents.close_case": "Close case",
  "incidents.propose_lunch_detention": "Propose MSS",
  "incidents.no_lunch_detentions": "No MSS run has come out of this case yet.",
  "incidents.lunch_detentions_title": "MSS runs from this case",
  "incidents.close_case_description": "Record the outcome and the closing message that will be emailed to the staff involved.",
  "incidents.closing_message": "Closing message",
  "incidents.closing_message_hint": "This message is emailed to the staff involved in this case.",
  "incidents.sst_only_note": "SST-only note",
  "incidents.sst_only_note_hint": "Visible only to the Student Support Team. Not emailed, and not shown to the staff involved.",
  "incidents.sst_thread_title": "SST notes",
  "incidents.sst_thread_description": "A private working conversation for the Student Support Team.",
  "incidents.sst_thread_empty": "No messages yet. Only staff with SST access can see this thread.",
  "incidents.close_success": "Case closed",
  "incidents.error_outcome_required": "Select an outcome",
  "incidents.error_decision_required": "A closing message is required",
  "incidents.status_moved": "Status moved from {{from}} to {{to}}",
  "incidents.reporter": "Reporter",
  "incidents.edit_report": "Edit report",
  "incidents.edit_report_description": "Correct the details of this report. Students, staff and attachments are edited on the case page.",
  "incidents.update_success": "Report updated",
  "incidents.update_failed": "Failed to update report",
  "incidents.workspace_tabs_label": "Incident workspace",
  "case_management.next_action": "Next action",
  "case_management.items_needing_attention": "Items needing attention",
  "case_management.needs_attention": "Needs attention",
  "incidents.tab_overview": "Overview",
  "incidents.tab_risai": "RisAI",
  "incidents.tab_activity": "Activity",
  "incidents.tab_staff_conversation": "Staff conversation",
  "incidents.tab_sst": "SST notes",
  "incidents.tab_outcome": "Outcome",
  "incidents.tab_family": "Family communication",
  "incidents.attention_clarify_roles_title": "Clarify the students' roles",
  "incidents.attention_clarify_roles_description": "At least one student is still marked as involved but unclear. Confirm roles before the case progresses.",
  "incidents.attention_start_investigation_title": "Review this report",
  "incidents.attention_start_investigation_description": "Check the report and participants, then move it into investigation.",
  "incidents.attention_record_outcome_title": "Record the outcome",
  "incidents.attention_record_outcome_description": "The case is being investigated and is waiting for an SST decision.",
  "incidents.attention_waiting_for_sst_title": "Waiting for SST review",
  "incidents.attention_waiting_for_sst_description": "You can follow the case and add staff notes. SST owns the next decision.",
  "incidents.attention_complete_title": "Case complete",
  "incidents.attention_complete_description": "The outcome is recorded. The activity and conversations remain available as history.",
  "incidents.attention_action_clarify_roles": "Review participants",
  "incidents.attention_action_record_outcome": "Record outcome",
  "incidents.attention_warning_unclear_roles_title": "A student's role is still unclear",
  "incidents.attention_warning_unclear_roles_description": "Confirm who initiated, was affected or witnessed the incident.",
  "incidents.attention_warning_awaiting_outcome_title": "This case is awaiting an outcome",
  "incidents.attention_warning_awaiting_outcome_description": "Complete the SST review before closing the case.",
  "incidents.attention_warning_sst_follow_up_due_title": "SST follow-up may be due",
  "incidents.attention_warning_sst_follow_up_due_description": "A supervised student has no SST-only message on this case in the last seven days.",
  "incidents.schedule_estimate_title": "Estimated timetable context",
  "incidents.schedule_estimate_description": "Estimated from the incident date, time and each student's recorded timetable. The report remains the source of truth.",
  "incidents.schedule_estimate_unavailable": "No matching timetable period could be estimated from the recorded date and time.",
  "incidents.staff_conversation_title": "Staff conversation",
  "incidents.staff_conversation_description": "Visible to staff attached to this incident, relevant homeroom teachers and the SST.",
  "incidents.case_activity_title": "Case activity",
  "incidents.case_activity_description": "Status, participant and decision changes, ordered by time. Conversations have their own tabs.",
  "incidents.activity_report_created": "Incident report created",
  "incidents.related_history_title": "Related incident history",
  "incidents.related_history_description": "Previous incidents involving these students that you are permitted to see. Select a student to open the full filtered list.",
  "incidents.related_history_empty": "No previous visible incidents were found for these students.",
  "incidents.related_same_students_title_one": "{{count}} previous incident involved the same students",
  "incidents.related_same_students_title_other": "{{count}} previous incidents involved the same students",
  "incidents.related_same_students_description": "Two or more students from this case appeared together, which may help identify a repeated group pattern.",
  "incidents.related_same_students_badge": "Same students",
  "incidents.related_history_more_one": "{{count}} more related incident is available from the student filters above.",
  "incidents.related_history_more_other": "{{count}} more related incidents are available from the student filters above.",
  "incidents.infraction_tags_title": "Infraction tags",
  "incidents.infraction_tags_description": "Track recurring patterns without confusing a student's existing tags with tags created by this incident.",
  "incidents.infraction_tags_existing": "Tags already on the student",
  "incidents.infraction_tags_added": "Tags added by this incident",
  "incidents.risai_title": "RisAI assistance",
  "incidents.risai_description": "A reviewed assistant for summarising case information and preparing clear, family-safe drafts.",
  "incidents.risai_summary": "Summarise the case timeline",
  "incidents.risai_draft": "Prepare a message for review",
  "incidents.risai_case_assistant": "RisAI case assistant",
  "incidents.risai_callout_description": "Turn this report into a clear case brief, identify useful follow-ups and prepare a family-safe draft.",
  "incidents.risai_suggestions_title": "RisAI suggestions",
  "incidents.risai_suggestions_description": "A preview of the practical questions RisAI could surface from this case.",
  "incidents.risai_suggestion_roles": "Confirm each student's role using separate accounts where possible.",
  "incidents.risai_suggestion_outcome": "Compare the evidence and identify what is still missing before recording an outcome.",
  "incidents.risai_suggestion_medical": "Confirm whether infirmary follow-up occurred and should be linked to this case.",
  "incidents.risai_suggestion_support_plan": "Check whether this incident changes the student's existing SST support plan.",
  "incidents.risai_suggestion_facts": "Separate directly observed facts from assumptions or reported accounts.",
  "incidents.risai_suggestion_family": "Prepare a neutral family summary without exposing internal or SST-only information.",
  "incidents.risai_open_preview": "Explore RisAI",
  "incidents.risai_workspace_description": "RisAI will help staff review the information already in this case. It will suggest content, but staff remain responsible for every decision and message.",
  "incidents.risai_brief_title": "Case brief",
  "incidents.risai_brief_description": "Bring the report, timeline and recorded outcomes into one concise summary.",
  "incidents.risai_brief_action": "Generate case brief",
  "incidents.risai_follow_up_title": "Suggested follow-ups",
  "incidents.risai_follow_up_description": "Highlight missing facts and questions that may help staff complete the review.",
  "incidents.risai_follow_up_action": "Suggest follow-ups",
  "incidents.risai_family_draft_title": "Family-safe draft",
  "incidents.risai_family_draft_description": "Prepare a clear draft without exposing internal or SST-only information.",
  "incidents.risai_family_draft_action": "Prepare draft",
  "incidents.risai_human_control_title": "Private by design, reviewed by staff",
  "incidents.risai_human_control_description": "RisAI will respect the case's existing permissions. It will not send messages, change outcomes or reveal SST-only content, and every suggestion must be reviewed by an authorised staff member.",
  "incidents.family_communication_title": "Secure family communication",
  "incidents.family_communication_description": "Each student will have a separate private conversation with their linked parents. Internal incident and SST information will remain separate.",
  "incidents.family_owner_sst": "SST prepares and sends this student's family messages. The homeroom teacher can follow the conversation.",
  "incidents.family_owner_homeroom": "SST prepares and remains responsible for the message. The homeroom teacher sends it to the family.",
  "incidents.family_prepared_by": "Prepared by",
  "incidents.family_sent_by": "Sent by",
  "incidents.family_sst_team": "SST team",
  "incidents.family_homeroom_teacher": "Homeroom teacher",
  "incidents.family_flow_supervised": "SST is responsible for the message and sends it because the student is under SST supervision. The homeroom teacher can follow the conversation.",
  "incidents.family_flow_not_supervised": "SST remains responsible and prepares the message. The homeroom teacher sends it to the family from the platform.",
  "incidents.family_future_status_label": "Conversation status",
  "incidents.family_future_status_not_started": "Not started",
  "incidents.family_future_attention_hint": "When family contact is selected, this tab will remain marked for attention until the reviewed message has been sent.",
  "incidents.close_prefilled_hint": "This case was closed before. The previous outcome, closing message and SST-only note are filled in below — keep them or change them.",
  "support_notes.title": "Support notes",
  "support_notes.add": "Add note",
  "support_notes.placeholder": "Write a support note…",
  "support_notes.visibility": "Visibility",
  "support_notes.none": "No support notes recorded for this student.",
  "support_notes.error_body_required": "Note is required",
  "support_notes.banner_title": "SST observation: read before teaching",
  "support_notes.read_more": "Read full note",
  "support_notes.show_less": "Show less",
  "support_notes.view_all": "All SST observations ({{count}})",
  "support_notes.tag": "SST note",
  "support_notes.tag_aria": "Open the SST observation for {{name}}",
  "support_notes.class_button_one": "SST observations ({{count}} student)",
  "support_notes.class_button_other": "SST observations ({{count}} students)",
  "support_notes.class_page_title": "SST observations",
  "support_notes.class_page_subtitle": "What the Student Support Team has shared about students in this class.",
  "support_notes.class_page_none": "No student in this class has a shared SST observation.",
  "support_notes.earlier_notes": "Earlier observations ({{count}})",
  "support_notes.open_student": "Open student page",
  "support_notes.back_to_register": "Back to register",
  "it_tickets.new_title": "New IT ticket",
  "it_tickets.created": "Ticket submitted",
  "it_tickets.submit": "Submit ticket",
  "it_tickets.error_create_failed": "Failed to submit ticket",
  "it_tickets.field_location": "Location",
  "it_tickets.field_location_other": "Specify location",
  "it_tickets.field_device": "Type of device / software",
  "it_tickets.field_device_other": "Specify device or software",
  "it_tickets.field_description": "Description",
  "it_tickets.field_priority": "Priority",
  "it_tickets.field_needed_by": "Date needed by",
  "it_tickets.needed_by_hint": "Optional — leave blank if there is no deadline.",
  "it_tickets.field_attachments": "Attachments (images or PDF, up to 6)",
  "it_tickets.priority_hint_low": "Minor inconvenience, can wait.",
  "it_tickets.priority_hint_medium": "Affects daily tasks but has a workaround.",
  "it_tickets.priority_hint_high": "Urgent — prevents you from teaching or completing essential work.",
  "it_tickets.error_location_required": "Say where it is, so IT knows where to go.",
  "it_tickets.location_answered_hint": "A website is in no room, so there is nothing to answer here.",
  "it_tickets.error_location_other_required": "Please specify the location",
  "it_tickets.error_device_required": "Select at least one device or software",
  "it_tickets.error_device_other_required": "Please specify the device or software",
  "it_tickets.error_description_required": "Description is required",
  "it_tickets.attachment_upload_warning": "Ticket created, but the attachment failed to upload: {{message}}",
  "it_tickets.my_title": "My IT Tickets",
  "it_tickets.my_subtitle": "Track the IT problems you've reported and reply to IT.",
  "it_tickets.report_button": "Report an IT problem",
  "it_tickets.empty": "You haven't reported any IT problems yet.",
  "it_tickets.filter_status": "Filter by status",
  "it_tickets.empty_for_status": "No tickets with this status.",
  "it_tickets.detail_title": "IT ticket · {{requester}}",
  "it_tickets.details_section": "Ticket details",
  "it_tickets.col_requester": "Requester",
  "it_tickets.col_created": "Created",
  "it_tickets.col_resolved": "Resolved",
  "it_tickets.conversation_title": "Conversation",
  "it_tickets.comment_placeholder": "Write a reply…",
  "it_tickets.comment_send": "Send",
  "it_tickets.error_comment_failed": "Failed to post your reply",
  "it_tickets.status_moved": "Status moved from {{from}} to {{to}}",
  "it_tickets.change_status": "Change status",
  "it_tickets.status_note": "Note (optional)",
  "it_tickets.error_status_failed": "Failed to update status",
  "it_tickets.attachments": "Attachments",
  "it_tickets.add_attachment": "Add attachment",
  "it_tickets.new_reply": "New reply",
  "it_tickets.board_title": "IT Board",
  "it_tickets.board_subtitle": "Drag a ticket to a column to update its status.",
  "it_tickets.age_days_one": "{{count}} day old",
  "it_tickets.age_days_other": "{{count}} days old",
  "it_tickets.age_hours_one": "{{count}} hour old",
  "it_tickets.age_hours_other": "{{count}} hours old",
  "it_tickets.age_minutes_one": "{{count}} minute old",
  "it_tickets.age_minutes_other": "{{count}} minutes old",
  "it_tickets.due_on": "Due {{date}}",
  "it_tickets.overdue": "Overdue",
  "it_tickets.status_update_failed": "Failed to update ticket status",
  "it_tickets.view_archive": "View archive",
  "it_tickets.filter_priority": "Priority",
  "it_tickets.filter_device": "Device",
  "it_tickets.assignee": "Assignee",
  "it_tickets.assigned_to": "Assigned to",
  "it_tickets.assigned_to_name": "Assigned to {{name}}",
  "it_tickets.assignment_cleared": "Assignment removed",
  "it_tickets.unassigned": "Unassigned",
  "it_tickets.assignee_hint": "Only admins with IT support access can be assigned. They are emailed unless you assign it to yourself.",
  "it_tickets.error_assign_failed": "Could not change the assignee",
  "it_tickets.filter_search": "Search",
  "it_tickets.filter_from": "From",
  "it_tickets.filter_to": "To",
  "it_tickets.filter_location": "Location",
  "it_tickets.archive_title": "IT Ticket Archive",
  "it_tickets.archive_subtitle": "Resolved tickets and equipment/room trends over the selected period.",
  "it_tickets.archive_empty": "No tickets match this period and filters.",
  "it_tickets.stats_opened": "Opened",
  "it_tickets.stats_resolved": "Resolved",
  "it_tickets.stats_still_open": "Still open",
  "it_tickets.stats_overdue": "Overdue",
  "it_tickets.stats_avg_resolution": "Average resolution time",
  "it_tickets.stats_median_resolution": "Median resolution time",
  "it_tickets.stats_hours": "{{value}} hours",
  "it_tickets.stats_by_month": "Volume over time",
  "it_tickets.stats_by_device": "By device type",
  "it_tickets.stats_by_location": "By location",
  "it_tickets.stats_by_priority": "By priority",
  "it_tickets.stats_top_requesters": "Top requesters",
  "it_tickets.stats_no_resolutions": "No resolved tickets yet.",
  "it_tickets.stats_opened_legend": "Opened",
  "it_tickets.stats_resolved_legend": "Resolved",
  "it_tickets.archive_page_summary": "Page {{page}} of {{totalPages}} ({{total}} tickets)",
  "it_assets.title": "IT assets",
  "it_assets.subtitle": "Every school device: who has it, where it is and what state it is in",
  "it_assets.empty": "No assets match these filters",
  "it_assets.items": "assets",
  "it_assets.unassigned": "Unassigned",
  "it_assets.unknown_person": "Unknown person",
  "it_assets.needs_matching": "Needs matching",
  "it_assets.scan_button": "Scan",
  "it_assets.print_labels": "Print labels ({{count}})",
  "it_assets.print_all_labels": "Print all labels ({{count}})",
  "it_assets.bulk.button": "Bulk upload photos",
  "it_assets.bulk.title": "Bulk upload photos",
  "it_assets.bulk.help": "Name each photo after the asset's old asset ID or its asset tag, for example TAG-001.jpg. JPEG, PNG or WebP only (on iPhone choose Most Compatible). Files up to 25 MB.",
  "it_assets.bulk.files_label": "Photos",
  "it_assets.bulk.selected": "{{count}} files selected",
  "it_assets.bulk.upload": "Upload",
  "it_assets.bulk.uploading": "Uploading…",
  "it_assets.bulk.summary": "{{matched}} matched, {{unmatched}} unmatched, {{ambiguous}} ambiguous, {{failed}} failed",
  "it_assets.bulk.matched": "Matched",
  "it_assets.bulk.unmatched": "No matching asset",
  "it_assets.bulk.ambiguous": "Ambiguous (matches more than one asset, nothing changed)",
  "it_assets.bulk.ambiguous_row": "{{file}}: {{tags}}",
  "it_assets.bulk.failed": "Failed",
  "it_assets.bulk.failed_row": "{{file}}: {{reason}}",
  "it_assets.bulk.failed_reason.not_image": "Not an image file",
  "it_assets.bulk.failed_reason.too_large": "Larger than 25 MB",
  "it_assets.bulk.failed_reason.request_failed": "The upload failed, try again",
  "it_assets.bulk.failed_reason.unsupported_format": "Unsupported format, use JPEG, PNG or WebP",
  "it_assets.bulk.failed_reason.invalid_image": "The file is not a readable image",
  "it_assets.bulk.failed_reason.save_failed": "Could not save this image",
  "it_assets.labels.title": "Asset labels",
  "it_assets.labels.subtitle": "A4 sheet of 3 columns, 63.5 × 38.1 mm labels. Print at 100% scale.",
  "it_assets.labels.school": "Ruamrudee International School Phuket — IT",
  "it_assets.labels.none": "No assets selected. Choose assets on the list and press Print labels.",
  "it_assets.labels.none_matching": "No assets match these filters.",
  "it_assets.labels.load_failed": "Some assets could not be loaded and are not on the sheet: {{ids}}",
  "it_assets.labels.load_all_failed": "The assets could not be loaded. Go back to the list and try again.",
  "it_assets.bulk.progress": "Uploading… {{sent}}/{{total}}",
  "it_assets.select_all": "Select all assets on this page",
  "it_assets.select_asset": "Select {{tag}}",
  "it_assets.device_type.laptop": "Laptop",
  "it_assets.device_type.desktop": "Desktop",
  "it_assets.device_type.macbook": "MacBook",
  "it_assets.device_type.mac_mini": "Mac mini",
  "it_assets.device_type.imac": "iMac",
  "it_assets.device_type.tablet": "Tablet",
  "it_assets.device_type.ipad": "iPad",
  "it_assets.device_type.monitor": "Monitor",
  "it_assets.device_type.printer": "Printer",
  "it_assets.device_type.projector": "Projector",
  "it_assets.device_type.network": "Network device",
  "it_assets.device_type.server": "Server",
  "it_assets.device_type.phone": "Phone",
  "it_assets.device_type.other": "Other",
  "it_assets.status.in_use": "In use",
  "it_assets.status.available": "Available",
  "it_assets.status.repair": "Needs repair",
  "it_assets.status.storage": "In storage",
  "it_assets.status.retired": "Retired",
  "it_assets.status.lost": "Lost",
  "it_assets.department.it": "IT",
  "it_assets.department.staff": "Staff",
  "it_assets.department.teacher": "Teacher",
  "it_assets.department.student": "Student",
  "it_assets.department.ia_specialist": "IA / specialist",
  "it_assets.department.shared": "Public / shared device",
  "it_assets.department.other": "Other",
  "it_assets.credential_kind.product_key": "Product key",
  "it_assets.credential_kind.local": "Local account",
  "it_assets.credential_kind.admin": "Admin account",
  "it_assets.credential_kind.microsoft": "Microsoft account",
  "it_assets.credential_kind.email": "Email account",
  "it_assets.credential_kind.icloud": "iCloud account",
  "it_assets.credential_kind.other": "Other",
  "it_assets.stats.total": "Total",
  "it_assets.stats.in_use": "In use",
  "it_assets.stats.repair": "Needs repair",
  "it_assets.stats.unassigned": "Unassigned",
  "it_assets.stats.needs_matching": "Needs matching",
  "it_assets.stats.value": "Total value",
  "it_assets.filters.device_type": "Device type",
  "it_assets.filters.status": "Status",
  "it_assets.filters.department": "Department",
  "it_assets.filters.needs_matching": "Needs matching only",
  "it_assets.filters.all_types": "All types",
  "it_assets.filters.all_statuses": "All statuses",
  "it_assets.filters.all_departments": "All departments",
  "it_assets.filters.search": "Search assets",
  "it_assets.filters.search_placeholder": "Tag, serial, brand, model or person",
  "it_assets.columns.select": "Select",
  "it_assets.columns.photo": "Photo",
  "it_assets.columns.tag": "Tag",
  "it_assets.columns.type": "Type",
  "it_assets.columns.brand_model": "Brand and model",
  "it_assets.columns.serial": "Serial",
  "it_assets.columns.assigned": "Assigned to",
  "it_assets.columns.status": "Status",
  "it_assets.columns.updated": "Updated",
  "it_assets.scan.title": "Scan an asset",
  "it_assets.scan.description": "Point the camera at the asset's QR label, or type its tag.",
  "it_assets.scan.start": "Scan QR label",
  "it_assets.scan.stop": "Stop scanning",
  "it_assets.scan.unsupported": "This browser cannot scan QR codes. Type the tag instead.",
  "it_assets.scan.camera_error": "Could not access the camera",
  "it_assets.scan.manual_label": "Asset tag",
  "it_assets.scan.manual_placeholder": "e.g. RISP-0001",
  "it_assets.scan.lookup": "Find",
  "it_assets.scan.not_found": "No asset has the tag {{code}}.",
  "it_assets.scan.label_not_found": "This label's asset no longer exists ({{code}}).",
  "it_assets.scan.create_with_tag": "Create asset with tag {{code}}",
  "it_assets.add_button": "Add asset",
  "it_assets.print_label": "Print label",
  "it_assets.tabs.label": "Asset sections",
  "it_assets.tabs.details": "Details",
  "it_assets.tabs.credentials": "Credentials",
  "it_assets.tabs.history": "History",
  "it_assets.details.title": "Asset details",
  "it_assets.details.legacy_id": "Old asset ID",
  "it_assets.photo.title": "Photo",
  "it_assets.photo.upload": "Upload photo",
  "it_assets.photo.replace": "Replace photo",
  "it_assets.photo.uploaded": "Photo saved",
  "it_assets.photo.remove_title": "Remove this photo?",
  "it_assets.models.button": "Model photos",
  "it_assets.models.title": "Model photos",
  "it_assets.models.help": "One photo per brand and model. Every device of that model without a photo of its own shows it.",
  "it_assets.models.search_placeholder": "Search models",
  "it_assets.models.empty": "No models match",
  "it_assets.models.devices_one": "{{count}} device, {{own}} with its own photo",
  "it_assets.models.devices_other": "{{count}} devices, {{own}} with their own photo",
  "it_assets.models.unused": "No devices use this model any more",
  "it_assets.models.upload_for": "Upload a photo of {{model}}",
  "it_assets.models.saved": "Model photo saved",
  "it_assets.models.remove_title": "Remove the photo of {{model}}?",
  "it_assets.photo.model_photo": "Model photo — upload one to show this device's own photo instead",
  "it_assets.delete.title": "Delete {{tag}}?",
  "it_assets.delete.description": "The asset, its credentials and its history are deleted for good. To keep the record, change its status to Retired instead.",
  "it_assets.delete.done": "Asset deleted",
  "it_assets.form.create_title": "Add asset",
  "it_assets.form.edit_title": "Edit asset",
  "it_assets.form.asset_tag": "Asset tag",
  "it_assets.form.device_type": "Device type",
  "it_assets.form.device_type_other": "What kind of device?",
  "it_assets.form.brand": "Brand",
  "it_assets.form.model": "Model",
  "it_assets.form.serial_number": "Serial number",
  "it_assets.form.service_tag": "Service tag",
  "it_assets.form.libib_code": "Libib code",
  "it_assets.form.color": "Colour",
  "it_assets.form.department": "Department",
  "it_assets.form.no_department": "No department",
  "it_assets.form.department_other": "Which department?",
  "it_assets.form.purchase_date": "Purchase date",
  "it_assets.form.warranty_until": "Warranty until",
  "it_assets.form.cost_baht": "Cost (baht)",
  "it_assets.form.notes": "Notes",
  "it_assets.form.status": "Status",
  "it_assets.form.tag_required": "Enter the asset tag",
  "it_assets.form.tag_taken": "Another asset already has this tag",
  "it_assets.form.device_type_other_required": "Say what kind of device this is",
  "it_assets.form.department_other_required": "Say which department",
  "it_assets.form.cost_invalid": "Enter a cost of 0 or more",
  "it_assets.form.cost_too_large": "Enter a cost of at most 9,999,999,999.99 baht",
  "it_assets.form.too_long": "At most {{max}} characters",
  "it_assets.form.created": "Asset added",
  "it_assets.form.updated": "Asset saved",
  "it_assets.assign.button": "Assign",
  "it_assets.assign.title": "Assign asset",
  "it_assets.assign.description": "Choose who has it, where it is kept, or both.",
  "it_assets.assign.person": "Person",
  "it_assets.assign.person_search": "Search staff or students",
  "it_assets.assign.no_person": "No person",
  "it_assets.assign.room": "Room",
  "it_assets.assign.room_search": "Search rooms",
  "it_assets.assign.no_room": "No room",
  "it_assets.assign.no_match": "Nothing matches",
  "it_assets.assign.note": "Note",
  "it_assets.assign.return": "Return to IT",
  "it_assets.assign.saved": "Assignment saved",
  "it_assets.assign.returned": "Asset returned to IT",
  "it_assets.status_dialog.button": "Change status",
  "it_assets.status_dialog.title": "Change status",
  "it_assets.status_dialog.note": "Note",
  "it_assets.status_dialog.unchanged": "Choose a different status",
  "it_assets.status_dialog.saved": "Status changed",
  "it_assets.credentials.title": "Credentials",
  "it_assets.credentials.add": "Add credential",
  "it_assets.credentials.add_title": "Add credential",
  "it_assets.credentials.edit_title": "Edit credential",
  "it_assets.credentials.form_description": "Secrets are stored encrypted and shown only when revealed.",
  "it_assets.credentials.empty": "No credentials saved for this asset",
  "it_assets.credentials.kind": "Kind",
  "it_assets.credentials.label": "Label",
  "it_assets.credentials.username": "Username",
  "it_assets.credentials.hint": "Hint",
  "it_assets.credentials.secret": "Password or key",
  "it_assets.credentials.secret_keep": "Leave blank to keep",
  "it_assets.credentials.clear_secret": "Clear secret",
  "it_assets.credentials.actions": "Actions",
  "it_assets.credentials.reveal": "Reveal for 30 seconds",
  "it_assets.credentials.hide": "Hide",
  "it_assets.credentials.copy": "Copy",
  "it_assets.credentials.copied": "Copied to the clipboard",
  "it_assets.credentials.copy_failed": "Could not copy",
  "it_assets.credentials.reveal_failed": "Could not reveal the secret",
  "it_assets.credentials.saved": "Credential saved",
  "it_assets.credentials.deleted": "Credential deleted",
  "it_assets.credentials.delete_title": "Delete this credential?",
  "it_assets.credentials.delete_description": "The {{kind}} entry and its secret are deleted for good.",
  "it_assets.history.title": "History",
  "it_assets.history.empty": "Nothing recorded yet",
  "it_assets.history.created": "Asset added",
  "it_assets.history.assigned": "Assigned to {{to}}",
  "it_assets.history.returned": "Returned to IT",
  "it_assets.history.status_changed": "{{from}} → {{to}}",
  "it_assets.history.by": "by {{name}}",
  "bookings.my_title": "My Bookings",
  "bookings.my_subtitle": "Book the Computer Room or shared tablets for a lesson block.",
  "bookings.today_heading": "Today",
  "bookings.today_none": "No bookings today",
  "bookings.all_title": "All Bookings",
  "bookings.all_subtitle": "Every Computer Room and tablet booking, for delivery and usage tracking.",
  "bookings.tablet_pool_title": "Tablet Pool",
  "bookings.tablet_pool_subtitle": "Set how many tablets are available to book per lesson block.",
  "bookings.tablet_pool_saved": "Tablet pool updated",
  "bookings.new_button": "New booking",
  "bookings.new_title": "New Booking",
  "bookings.empty": "No bookings yet.",
  "bookings.filter_when": "Filter by date",
  "bookings.filter_upcoming": "Upcoming",
  "bookings.filter_past": "Past",
  "bookings.empty_for_filter": "No bookings in this period.",
  "bookings.submit": "Book",
  "bookings.created": "Booking created",
  "bookings.cancel_button": "Cancel",
  "bookings.cancel_title": "Cancel this booking?",
  "bookings.cancel_description": "This frees the room or tablets for that block for anyone else to book.",
  "bookings.cancelled": "Booking cancelled",
  "bookings.field_resource_type": "Resource",
  "bookings.field_date": "Date",
  "bookings.field_period": "Period",
  "bookings.field_time": "Time",
  "bookings.field_room": "Room",
  "bookings.field_delivery_room": "Delivery room",
  "bookings.field_class": "Class",
  "bookings.field_quantity": "Quantity",
  "bookings.field_note": "Note",
  "bookings.field_tablet_total": "Total tablets",
  "bookings.booked_by": "Booked by",
  "bookings.period_placeholder": "Select a period",
  "bookings.room_placeholder": "Select a room",
  "bookings.class_placeholder": "Select a class",
  "bookings.class_none": "No class",
  "bookings.summary_room": "{{room}}",
  "bookings.summary_tablet": "{{quantity}} tablets to {{room}}",
  "bookings.error_date_required": "Date is required",
  "bookings.error_period_required": "Period is required",
  "bookings.error_room_required": "Room is required",
  "bookings.error_quantity_number": "Quantity must be a number",
  "bookings.error_quantity_min": "Quantity must be at least 1",
  "bookings.error_quantity_required": "Quantity is required",
  "bookings.error_create_failed": "Could not create the booking",
  "bookings.error_tablet_total_number": "Must be a number",
  "bookings.status_free": "Free",
  "bookings.status_busy": "Busy",
  "bookings.reason_scheduled": "Scheduled class",
  "bookings.reason_booked": "Already booked",
  "bookings.tablets_remaining": "{{remaining}} of {{total}} tablets remaining",
  "bookings.filter_from": "From",
  "bookings.filter_to": "To",
  "parents.error_full_name_required": "Full name is required.",
  "parents.error_email_invalid": "Enter a valid email address.",
  "parents.error_email_required": "Email is required.",
  "parents.error_students_required": "Link at least one student.",
  "parents.toast_updated": "Parent updated",
  "parents.toast_created": "Parent created — invitation email sent",
  "parents.error_save_failed": "Failed to save parent",
  "parents.edit_title": "Edit parent",
  "parents.add_title": "Add parent",
  "parents.full_name": "Full name",
  "parents.email": "Email",
  "parents.email_placeholder": "parent@example.com",
  "parents.email_change_hint": "This is how the parent signs in. Changing it signs them out of any open session.",
  "parents.field_phone": "Phone (optional)",
  "parents.field_address": "Address (optional)",
  "parents.field_relationship": "Relationship (optional)",
  "parents.field_occupation": "Occupation (optional)",
  "parents.field_date_of_birth": "Date of birth (optional)",
  "parents.field_nationalities": "Nationalities (optional)",
  "parents.field_preferred_language": "Preferred communication language",
  "parents.field_person_id": "Person ID (optional)",
  "parents.linked_students": "Linked students",
  "parents.person_id_placeholder": "P-001",
  "parents.select_placeholder": "Select…",
  "parents.invite_resent": "Invitation re-sent",
  "parents.error_resend_invite": "Failed to resend invite",
  "parents.error_resend": "Failed to resend",
  "parents.toast_deactivated": "Parent deactivated",
  "parents.toast_activated": "Parent activated",
  "parents.title": "Parents",
  "parents.subtitle": "Manage parent accounts and their linked children.",
  "parents.empty": "No parents yet.",
  "parents.search_placeholder": "Search by parent, child, or email…",
  "parents.search_aria": "Search parents",
  "parents.filter_account_all": "All accounts",
  "parents.filter_grade_all": "All grades",
  "parents.item_label": "parents",
  "parents.empty_filtered": "No parents match this search.",
  "parents.confirm_deactivate_title": "Deactivate this parent?",
  "parents.confirm_deactivate_description": "{{name}} will not be able to sign in to the parent portal until you activate them again.",
  "parents.confirm_resend_title": "Send the invite again?",
  "parents.confirm_resend_description": "{{name}} will get a new setup email at {{email}}, and their previous link will stop working.",
  "parents.col_name": "Name",
  "parents.col_phone": "Phone",
  "parents.col_children": "Children",
  "parents.col_account": "Account",
  "parents.col_active": "Active",
  "parents.col_language": "Language",
  "parents.deactivate": "Deactivate",
  "parents.activate": "Activate",
  "parents.account_active": "Active",
  "parents.account_invited": "Invited",
  "parents.resend_invite": "Resend invite",
  "parents.status_active": "Active",
  "parents.status_inactive": "Inactive",
  "parents.details_section": "Details",
  "parents.phone": "Phone",
  "parents.relationship": "Relationship",
  "parents.address": "Address",
  "parents.created_label": "Created",
  "parents.no_students_linked": "No students linked.",
  "parents.search_students_placeholder": "Search students…",
  "parents.no_students_found": "No students found.",
  "parents.tab_list": "Parents",
  "parents.tab_changes": "Recent changes",
  "parents.changes_empty": "No changes to review yet.",
  "parents.mark_all_reviewed": "Mark all reviewed",
  "parents.mark_reviewed": "Reviewed",
  "parents.reviewed_by": "Reviewed by {{name}}",
  "parents.reviewed": "Reviewed",
  "parents.show_reviewed": "Show reviewed",
  "parents.change_field_fullName": "Full name",
  "parents.change_field_phone": "Phone",
  "parents.change_field_address": "Address",
  "parents.change_field_occupation": "Occupation",
  "parents.change_field_dateOfBirth": "Date of birth",
  "parents.change_field_nationalities": "Nationalities",
  "parents.change_field_email": "Email",
  "parents.occupation": "Occupation",
  "parents.date_of_birth": "Date of birth",
  "parents.nationalities": "Nationalities",
  "nationalities.label": "Nationalities",
  "nationalities.search_placeholder": "Search nationalities…",
  "nationalities.none_found": "No nationalities found.",
  "nationalities.represented": "Nationalities represented",
  "nationalities.top_chart_title": "Top nationalities",
  "nationalities.by_grade_title": "Distinct nationalities by grade",
  "nationalities.footnote_count_each": "People with dual nationality are counted toward each nationality.",
  "teachers.reorder_aria": "Reorder {{name}}",
  "teachers.reorder_hint": "Drag teachers up or down to change their display order. Changes save automatically.",
  "teachers.col_teacher": "Teacher",
  "teachers.col_leadership": "Leadership",
  "teachers.uncategorised": "Uncategorised",
  "teachers.senior": "Senior",
  "teachers.divisional": "Divisional",
  "teachers.publish_tooltip": "Publish teacher",
  "teachers.title": "Teachers",
  "teachers.subtitle": "{{total}} total · {{published}} published",
  "teachers.done_reordering": "Done Reordering",
  "teachers.reorder": "Reorder",
  "teachers.add": "Add Teacher",
  "teachers.empty": "No teachers yet. Create the first one!",
  "teachers.delete_title": "Delete Teacher",
  "teachers.delete_description": "Are you sure you want to delete this teacher? This action cannot be undone.",
  "teachers.tab_list": "Teachers",
  "teachers.tab_review": "Profile review",
  "teachers.review_empty": "No profiles are waiting for review.",
  "teachers.review_new": "New profile",
  "teachers.review_edit": "Edit",
  "teachers.review_submitted": "Submitted {{date}}",
  "teachers.review_current_value": "Currently: {{value}}",
  "teachers.review_preview": "Website preview",
  "teachers.review_approve": "Approve",
  "teachers.review_reject": "Reject",
  "teachers.review_reject_note": "Tell them what to change",
  "teachers.review_reject_note_required": "A short note is required so they know what to fix.",
  "teachers.review_approved_hint": "Approved. Publish it from the Teachers tab when you have set the category and order.",
  "teachers.pending_badge": "Pending review",
  "teachers.col_title": "Job title",
  "teachers.col_bio": "Bio",
  "teachers.col_qualifications": "Qualifications",
  "teachers.col_certifications": "Certifications",
  "staff.status_active": "active",
  "staff.status_inactive": "inactive",
  "staff.public_profile": "Public website profile",
  "staff.no_profile": "No public profile linked to this account.",
  "staff.no_profile_hint": "Create one from the <link>Teachers page</link> and link this user via the \"Linked sign-in account\" field.",
  "staff.leave_history": "Leave history",
  "staff.no_leave_requests": "No leave requests submitted yet.",
  "staff.leaves_section": "Leaves",
  "staff.my_leaves_hint": "Manage and review your own leave requests on the <link>My Leaves</link> page.",
  "staff.immigration_compliance_section": "Immigration compliance",
  "staff.immigration_compliance_empty": "Not currently tracked.",
  "staff.it_assets": "Assigned equipment",
  "staff.it_no_assets": "No equipment assigned.",
  "staff.it_tickets": "IT tickets raised",
  "staff.it_no_tickets": "No IT tickets raised.",
  "staff.personal_details": "Personal details",
  "staff.date_of_birth": "Date of birth",
  "staff.phone": "Phone",
  "staff.address": "Address",
  "staff.door_id": "Door ID",
  "staff.out_today": "Out today",
  "staff.last_login": "Last login",
  "staff.work_title": "Work",
  "staff.work_homeroom": "Homeroom",
  "staff.work_assisting": "Assists in",
  "staff.work_default_room": "Default room",
  "staff.work_aide_for": "1:1 aide for",
  "staff.timetable_title": "Weekly timetable",
  "staff.detail_tabs_label": "Staff record sections",
  "staff.tab_overview": "Overview",
  "staff.tab_timetable": "Timetable",
  "staff.tab_hr": "HR",
  "staff.tab_attendance": "Attendance",
  "staff.tab_it": "IT",
  "staff.tab_wallet": "Wallet",
  "staff.profile_show_bio": "Show bio",
  "staff.profile_hide_bio": "Hide bio",
  "profile.title": "My profile",
  "profile.subtitle": "Your own details and what the school shows about you",
  "profile.identity_section": "Identity",
  "profile.identity_managed_hint": "Your full name and email address are managed by the school. Contact an administrator to change them.",
  "profile.basic_section": "Basic information",
  "profile.photo_label": "Profile photo (square)",
  "profile.photo_hint": "Used for your avatar across the staff platform.",
  "profile.nickname_placeholder": "What colleagues call you",
  "profile.saved": "Saved",
  "profile.save_failed": "Could not save your profile",
  "profile.immigration_section": "Immigration compliance",
  "profile.immigration_empty": "Not currently tracked.",
  "profile.public_section": "Public website profile",
  "profile.public_hint": "This is what visitors see on the school website. Changes are reviewed by an administrator before they go live.",
  "profile.public_status_pending": "Waiting for review since {{date}}",
  "profile.public_status_rejected": "Changes not approved: {{note}}",
  "profile.public_status_live": "Live on the website",
  "profile.public_status_draft": "Not published yet",
  "profile.public_photo_label": "Website photo (square)",
  "profile.public_role_label": "Job title",
  "profile.public_bio_label": "Bio",
  "profile.public_qualifications_label": "Qualifications (one per line)",
  "profile.public_certifications_label": "Certifications (one per line)",
  "profile.public_submit": "Submit for review",
  "profile.public_role_required": "A job title is required",
  "statistics.title": "Statistics",
  "statistics.subtitle": "Visitor analytics and content page-view statistics.",
  "statistics.tab_visitors": "Visitors",
  "statistics.tab_content": "Content",
  "statistics.tab_diversity": "Diversity",
  "statistics.tab_students": "Students",
  "statistics.students_total": "Active students",
  "statistics.students_no_parents": "Students with no linked parent",
  "statistics.students_parents_never": "Students whose parents never logged in",
  "statistics.students_missing_logins": "Students missing logins",
  "statistics.students_footnote": "From Grade 1, every student needs a Google email plus HMH, IXL, locker and Wi-Fi logins; Grades 1–5 also need McGraw Hill. Click a card to see who is affected.",
  "statistics.period_7d": "7 days",
  "statistics.period_30d": "30 days",
  "statistics.period_90d": "90 days",
  "statistics.tab_news": "News",
  "statistics.tab_pages": "Pages",
  "statistics.section_news": "News Articles",
  "statistics.section_pages": "Site Pages",
  "statistics.no_views": "No {{label}} views recorded for this period.",
  "statistics.views_over_time": "Views over time",
  "statistics.total_views": "Total views",
  "statistics.avg_per_day": "Avg / day",
  "statistics.peak_day": "Peak day",
  "statistics.top_10": "Top 10 most viewed",
  "statistics.new": "New",
  "statistics.returning": "Returning",
  "statistics.include_internal": "Include internal traffic",
  "statistics.unique_visitors": "Unique visitors",
  "statistics.pageviews": "Pageviews",
  "statistics.sessions": "Sessions",
  "statistics.unique_visitors_over_time": "Unique visitors over time",
  "statistics.new_vs_returning": "New vs Returning",
  "statistics.devices": "Devices",
  "statistics.traffic_sources": "Traffic sources",
  "statistics.no_data_period": "No data for this period.",
  "statistics.admissions_funnel": "Admissions funnel",
  "statistics.form_abandonment": "Form abandonment",
  "statistics.no_form_activity": "No form activity for this period.",
  "statistics.submitted_ratio": "{{submits}}/{{starts}} submitted",
  "statistics.abandoned_pct": "{{pct}}% abandoned",
  "statistics.top_locations": "Top locations",
  "statistics.view_countries": "Countries",
  "statistics.view_cities": "Cities",
  "statistics.unknown_country": "Unknown",
  "statistics.n_visitors": "{{count}} visitors",
  "statistics.map_alt": "World map showing visitors from {{count}} countries",
  "statistics.col_country": "Country",
  "statistics.col_region": "Region",
  "statistics.col_city": "City",
  "statistics.col_visitors": "Visitors",
  "statistics.downloads": "Downloads",
  "statistics.no_downloads": "No downloads for this period.",
  "statistics.col_file": "File",
  "statistics.col_unique": "Unique",
  "statistics.col_total": "Total",
  "common.print": "Print",
  "common.export_csv": "Export CSV",
  "common.export_excel": "Export Excel",
  "medical.error_select_student": "Select a student",
  "medical.error_date_required": "Date is required",
  "medical.error_time_format": "Time must be HH:MM",
  "medical.error_visit_type_required": "Visit type is required",
  "medical.toast_visit_updated": "Visit updated",
  "medical.toast_visit_recorded": "Visit recorded",
  "medical.photo_upload_warning": "Visit saved, but photos failed to upload: {{message}}",
  "medical.unknown_error": "unknown error",
  "medical.error_save_visit": "Failed to save visit",
  "medical.edit_visit": "Edit visit",
  "medical.record_visit": "Record visit",
  "medical.record_visit_description": "Log an infirmary visit for a student.",
  "medical.field_visit_date": "Visit date",
  "medical.field_visit_time": "Visit time",
  "medical.field_visit_type": "Visit type",
  "medical.field_place": "Place (optional)",
  "medical.field_notes": "Notes (optional)",
  "medical.field_tags": "Tags (optional)",
  "medical.field_existing_photos": "Existing photos",
  "medical.field_add_photos": "Add photos (optional)",
  "medical.select_type_placeholder": "Select type…",
  "medical.place_placeholder": "Infirmary, Classroom…",
  "medical.photo_tag_aria": "Photo tag",
  "medical.photo_tag_before": "Before",
  "medical.photo_tag_after": "After",
  "medical.photo_tag_other": "Other",
  "medical.retag_photo_aria": "Change this photo’s tag",
  "medical.share_section_title": "Share with family",
  "medical.share_will_email": "Not shared yet. Sharing emails the family a link to the portal — the message itself carries no details.",
  "medical.shared_on": "Shared with the family on {{when}}. Updating will not email them again.",
  "medical.family_note_label": "Note for the family",
  "medical.family_note_help": "Parents see this instead of the clinical notes.",
  "medical.copy_notes_to_family": "Copy from notes",
  "medical.family_photos_label": "Photos the family may see",
  "medical.family_photos_count": "{{count}} of {{total}} photos shared",
  "medical.share_with_family": "Share with family",
  "medical.update_share": "Update what is shared",
  "medical.unshare": "Stop sharing",
  "medical.share_sent": "Shared. The family has been emailed.",
  "medical.share_updated": "Updated what the family can see.",
  "medical.share_withdrawn": "No longer shared with the family.",
  "medical.files_selected_one": "{{count}} file selected",
  "medical.files_selected_other": "{{count}} files selected",
  "medical.delete_photo_title": "Delete photo",
  "medical.delete_photo_description": "Delete \"{{name}}\"? This cannot be undone.",
  "medical.move_visit_remove_photos_title": "Move visit and remove its photos?",
  "medical.move_visit_remove_photos_description_one": "This visit has {{count}} photo of the student it was logged against. Moving it to another student deletes that photo. This cannot be undone.",
  "medical.move_visit_remove_photos_description_other": "This visit has {{count}} photos of the student it was logged against. Moving it to another student deletes those photos. This cannot be undone.",
  "medical.move_visit_remove_photos_confirm": "Remove photos and move visit",
  "medical.delete_photo_aria": "Delete {{name}}",
  "medical.daily_log_title": "Infirmary Daily Log",
  "medical.daily_log_subtitle": "Record and review infirmary visits over any date range.",
  "medical.add_visit": "Add visit",
  "medical.search_student_placeholder": "Search student name…",
  "medical.search_student_aria": "Search student name",
  "medical.all_types": "All types",
  "medical.all_tags": "All tags",
  "medical.visit_count_one": "{{count}} visit",
  "medical.visit_count_other": "{{count}} visits",
  "medical.col_name": "Name",
  "medical.col_class": "Class",
  "medical.col_type": "Type",
  "medical.col_place": "Place",
  "medical.col_notes": "Notes",
  "medical.col_tags": "Tags",
  "medical.col_parent": "Family",
  "medical.family_sees_this": "The family can see this visit — shared on {{when}}",
  "medical.family_not_shared": "Not shared with the family",
  "medical.col_photos": "Photos",
  "medical.csv_col_parent_notified": "Shared with family",
  "medical.no_visits": "No visits recorded for this date.",
  "medical.delete_visit_title": "Delete visit for {{name}}?",
  "medical.delete_visit_description": "This will permanently remove the visit record and any attached photos.",
  "medical.item_label": "visits",
  "medical.visit_detail_title": "Infirmary visit",
  "medical.visit_section_title": "The visit",
  "medical.student_section_title": "Student",
  "medical.record_section_title": "Record",
  "medical.visit_history_title": "Other visits ({{count}})",
  "medical.no_other_visits": "This is the only visit on record for this student.",
  "medical.no_photos": "No photos attached to this visit.",
  "medical.add_photos": "Add photos",
  "medical.open_profile": "Open profile",
  "medical.open_visit": "Open visit",
  "medical.recorded_by": "Recorded by",
  "medical.early_dismissal": "Early dismissal",
  "common.created": "Created",
  "common.updated": "Last edited",
  "medical.print_title": "Infirmary daily log",
  "medical.error_label_required": "Label is required.",
  "medical.error_sort_order_number": "Sort order must be a number",
  "medical.col_tag": "Tag",
  "medical.col_visit_type": "Visit Type",
  "medical.col_sort": "Sort",
  "medical.active": "Active",
  "medical.inactive": "Inactive",
  "medical.tags_empty": "No tags yet. Add one to get started.",
  "medical.visit_types_empty": "No visit types yet. Add one to get started.",
  "medical.edit_tag": "Edit tag",
  "medical.new_tag": "New tag",
  "medical.edit_visit_type": "Edit visit type",
  "medical.new_visit_type": "New visit type",
  "medical.field_label": "Label",
  "medical.field_color": "Color",
  "medical.field_sort_order": "Sort order",
  "medical.tag_placeholder": "Allergy",
  "medical.visit_type_placeholder": "Sick visit",
  "medical.delete_tag_title": "Delete tag \"{{label}}\"?",
  "medical.delete_tag_description": "This will permanently remove the tag. Existing visits using it may be affected.",
  "medical.delete_visit_type_title": "Delete visit type \"{{label}}\"?",
  "medical.delete_visit_type_description": "This will permanently remove the visit type. Existing visits using it may be affected.",
  "medical.tab_visit_types": "Visit Types",
  "medical.tab_tags": "Tags",
  "medical.new_visit_type_cta": "New Visit Type",
  "medical.new_tag_cta": "New Tag",
  "medical.settings_subtitle": "Visit types and tags for the nurse module.",
  "temperature.error_invalid": "Please enter a valid temperature",
  "temperature.toast_reading_recorded": "Reading recorded for {{name}}",
  "temperature.error_save_failed": "Failed to save reading",
  "temperature.toast_reading_updated": "Reading updated",
  "temperature.error_update_failed": "Failed to update reading",
  "temperature.error_delete_failed": "Failed to delete reading",
  "temperature.error_export_failed": "Failed to export temperature data",
  "temperature.add_title": "Add Temperature Reading",
  "temperature.edit_title": "Edit Temperature Reading",
  "temperature.recording_for": "Recording for <bold>{{name}}</bold>",
  "temperature.field_temperature": "Temperature (°C)",
  "temperature.field_note": "Note (optional)",
  "temperature.note_placeholder": "e.g. complained of headache",
  "temperature.export_title": "Export Temperature CSV",
  "temperature.export_description": "Export readings across a date range and one or more classes.",
  "temperature.from_label": "From",
  "temperature.to_label": "To",
  "temperature.error_from_after_to": "\"From\" date must be on or before \"To\" date.",
  "temperature.classes_label": "Classes",
  "temperature.select_all": "Select all",
  "temperature.no_tracking_classes": "No temperature-tracking classes.",
  "temperature.download_csv": "Download CSV",
  "temperature.exporting": "Exporting…",
  "temperature.col_class": "Class",
  "temperature.col_grade": "Grade",
  "temperature.col_readings": "Readings",
  "temperature.edit_reading_aria": "Edit reading",
  "temperature.delete_reading_aria": "Delete reading",
  "temperature.no_readings": "No readings",
  "temperature.add_reading": "Add reading",
  "temperature.no_students_enrolled": "No students enrolled in this class.",
  "temperature.print_title": "Temperature sheet",
  "temperature.subtitle": "Track daily temperature readings by class.",
  "temperature.select_year_placeholder": "Select year…",
  "temperature.no_classes_enabled": "No classes enabled",
  "temperature.select_class_placeholder": "Select class…",
  "temperature.help_note": "Record each child's temperature through the day. Readings at or above 37.5 °C are flagged and alert staff.",
  "temperature.select_prompt": "Select a class and date to view or record temperatures.",
  "temperature.loading_roster": "Loading roster…",
  "temperature.load_roster_failed": "Failed to load roster. Please try again.",
  "students.subtitle": "Manage students, photos, and Google sign-in emails.",
  "students.item_label": "students",
  "students.new_student": "New Student",
  "students.search_placeholder": "Search by name or nickname…",
  "students.search_aria": "Search students by name or nickname",
  "students.house_label": "House",
  "students.all_houses": "All houses",
  "students.all_grades": "All grades",
  "students.filter_active_only": "Active only",
  "students.filter_inactive_only": "Inactive only",
  "students.status.label": "Status",
  "students.status.card_title": "Enrolment",
  "students.status.enrolled": "Enrolled",
  "students.status.trial": "Trial",
  "students.status.admitted": "Admitted",
  "students.status.left": "Left",
  "students.status.arriving": "Arriving",
  "students.status.trial_until": "Trial until {{date}}",
  "students.status.arriving_starts": "Arriving · starts {{date}}",
  "students.status.filter_enrolled": "Enrolled",
  "students.status.filter_trial": "On trial",
  "students.status.filter_trial-ending": "Trial ending",
  "students.status.filter_admitted": "Arriving",
  "students.status.filter_left": "Left",
  "students.status.create_hint_enrolled": "In class from today.",
  "students.status.create_hint_trial": "In class for the trial dates, and the family can log in. Needs a grade.",
  "students.status.create_hint_admitted": "Accepted and starting later. The family can log in now; the child joins class lists on the start date. Needs a grade.",
  "students.status.readonly_hint": "Change it with Extend, Enrol or Left on the student's row or page.",
  "students.status.explain_enrolled": "In class, on registers and in school records.",
  "students.status.explain_trial": "In class and on registers with a Trial badge, but not in report cards, MAP or audits. If nobody acts, the trial runs on one school day at a time.",
  "students.status.explain_admitted": "Not in class yet. Teachers see the child under Arriving, and the child is enrolled automatically on the start date.",
  "students.status.explain_left": "No longer at school. Parent logins stay on only while a brother or sister is still at school.",
  "students.status.mark_left": "Mark as left",
  "students.status.left_confirm_title": "Mark {{name}} as left?",
  "students.status.left_confirm_description": "The child leaves class lists and registers today. Their records stay, and draft invoices are not touched: void them in Tuition if needed.",
  "students.trial.extend": "Extend trial",
  "students.trial.extend_title": "Extend {{name}}'s trial",
  "students.trial.extend_submit": "Extend trial",
  "students.trial.currently_until": "The trial currently ends on {{date}}.",
  "students.trial.start_date": "Trial starts",
  "students.trial.end_date": "Trial ends",
  "students.trial.start_required": "Choose the day the trial starts.",
  "students.trial.end_required": "Choose the day the trial ends.",
  "students.trial.end_before_start": "The trial cannot end before it starts.",
  "students.enrol.action": "Enrol",
  "students.enrol.title": "Enrol {{name}}",
  "students.enrol.description": "Today enrols the child now. A later date records them as Arriving until then.",
  "students.enrol.start_date": "Start date",
  "students.enrol.start_date_required": "Choose the start date.",
  "students.enrol.grade": "Grade",
  "students.enrol.create_draft": "Create a draft invoice",
  "students.enrol.create_draft_hint": "The semester draft for this child, with a discount for the school days already gone. It stays a draft until you issue it in Tuition.",
  "students.enrol.prepaid_hint": "Has the family already paid in advance? Set the prepaid semesters so later bulk billing does not bill them again.",
  "students.enrol.prepaid_link": "Open the prepaid setting",
  "students.enrol.submit": "Enrol",
  "students.enrol.done_enrolled": "Enrolled. The child is in class from today.",
  "students.enrol.done_admitted": "Admitted. The child joins class on the start date.",
  "students.enrol.draft_created": "Draft invoice created.",
  "students.enrol.open_draft": "Open the draft",
  "students.enrol.draft_skipped": "No draft was made: the start date is outside this year's semesters.",
  "students.enrol.draft_failed": "The enrolment is saved, but the draft invoice could not be created.",
  "students.arriving.change_start": "Change start date",
  "students.arriving.change_start_title": "Change {{name}}'s start date",
  "students.arriving.change_start_hint": "The child joins class lists on this date. A date that has already come enrols them now.",
  "students.arriving.section_title": "Arriving ({{count}})",
  "students.arriving.section_hint": "Admitted children and trials that start later this year. They are not on registers yet.",
  "students.arriving.starts_col": "Starts",
  "students.empty": "No students found.",
  "students.tab_list": "Students",
  "students.tab_audit": "Audit",
  "students.detail_tabs_label": "Student record sections",
  "students.detail_tab_overview": "Overview",
  "students.detail_tab_family_logins": "Family & logins",
  "students.detail_tab_attendance": "Attendance",
  "students.detail_tab_timetable": "Timetable",
  "students.timetable_title": "Weekly timetable",
  "students.timetable_empty": "No timetable has been published for this child yet.",
  "students.timetable_special_dates": "Not on a fixed day",
  "students.edp_this_round_label": "EDP this round",
  "students.edp_none_this_round": "None this round",
  "students.detail_tab_wellbeing": "Wellbeing",
  "students.detail_tab_sst": "SST",
  "students.detail_tab_rewards": "Rewards",
  "students.detail_tab_wallet": "Wallet",
  "students.sst_tabs_label": "Student Support Team record",
  "students.sst_tab_supervision": "Supervision",
  "students.sst_tab_incidents": "Incidents",
  "students.sst_tab_notes": "SST notes",
  "students.sst_tab_lunch_detentions": "MSS",
  "students.sst_supervision_title": "SST supervision",
  "students.sst_supervision_badge": "SST supervision",
  "students.sst_supervision_since": "Under SST supervision since {{date}}",
  "students.sst_supervision_active": "Under SST supervision",
  "students.sst_supervision_inactive": "This student is not currently under SST supervision.",
  "students.sst_supervision_history": "Supervision history",
  "students.sst_supervision_no_history": "No SST supervision has been recorded for this student.",
  "students.sst_supervision_active_period": "Current supervision period",
  "students.sst_supervision_closed_period": "Previous supervision period",
  "students.sst_supervision_started_by": "Started by {{name}} on {{date}}",
  "students.sst_supervision_ended_by": "Ended by {{name}} on {{date}}",
  "students.sst_supervision_start_action": "Start SST supervision",
  "students.sst_supervision_end_action": "End supervision",
  "students.sst_supervision_reason_label": "Reason for starting supervision",
  "students.sst_supervision_reason_placeholder": "Explain why SST supervision is being started…",
  "students.sst_supervision_end_note_label": "Closing note (optional)",
  "students.sst_supervision_end_note_placeholder": "Record why supervision is ending or any follow-up…",
  "students.sst_supervision_history_hint": "This action is permanent in the supervision history.",
  "students.sst_supervision_start_confirm": "Start supervision",
  "students.sst_supervision_end_confirm": "End supervision",
  "students.sst_supervision_started": "SST supervision started",
  "students.sst_supervision_ended": "SST supervision ended",
  "students.audit_title": "Student audit",
  "students.audit_subtitle": "Students missing parents or logins, and parents who never signed in.",
  "students.audit_filter_any_issue": "Any issue",
  "students.audit_filter_no_parents": "No parents",
  "students.audit_filter_parents_never": "Parents never logged in",
  "students.audit_filter_missing_logins": "Missing logins",
  "students.audit_filter_all": "All students",
  "students.audit_col_parents": "Parents",
  "students.audit_col_parent_login": "Parent login",
  "students.audit_no_parents_badge": "None linked",
  "students.audit_parent_logged_in": "Logged in",
  "students.audit_parent_never_logged_in": "Never logged in",
  "students.audit_col_google": "Google",
  "students.audit_col_hmh": "HMH",
  "students.audit_col_mcgrawhill": "McGraw Hill",
  "students.audit_col_boddle": "Boddle",
  "students.audit_col_wifi": "Wi-Fi",
  "students.audit_col_ixl": "IXL",
  "students.audit_col_locker": "Locker",
  "students.audit_not_required": "Not required before Grade 1",
  "students.audit_empty": "No students match this view.",
  "students.help_note": "Add students one at a time with <strong>Add student</strong>, or bring in many at once from Excel via <strong>Import</strong>.",
  "students.google_email_label": "Google email",
  "students.link_button": "Link",
  "students.google_email_dialog_title": "Google sign-in email — {{name}}",
  "students.school_google_email_label": "School Google email",
  "students.google_email_placeholder": "firstname.lastname@risphuket.ac.th",
  "students.error_invalid_email": "Please enter a valid email address",
  "students.google_email_hint": "The student will be able to sign in to the public site with this email.",
  "students.unlink": "Unlink",
  "students.delete_title": "Archive student \"{{name}}\"?",
  "students.delete_description": "The student will become inactive and disappear from current rosters. Their history will be preserved.",
  "students.back_to_students": "Back to students",
  "students.details_title": "Student details",
  "students.nickname_label": "Nickname",
  "students.date_of_birth_label": "Date of birth",
  "students.sex_label": "Sex",
  "students.personal_id_label": "Personal ID",
  "students.no_house": "No house",
  "students.no_google_email": "No Google email linked",
  "students.photo_download": "Download photo",
  "students.photo_downloading": "Downloading…",
  "students.award_button": "Award this student",
  "students.stat_total": "Total sand dollars",
  "students.stat_this_month": "This month",
  "students.stat_top_value": "Top value",
  "students.stat_top_awarder": "Top awarder",
  "students.award_count_one": "{{count}} award",
  "students.award_count_other": "{{count}} awards",
  "students.monthly_history": "Monthly history",
  "students.by_value": "By value",
  "students.no_awards_yet": "No awards yet.",
  "students.unknown": "Unknown",
  "students.growth_title": "Growth",
  "students.add_measurement": "Add measurement",
  "students.who_info_p1": "Percentiles use the <strong>WHO Child Growth Standards</strong> (2006, ages 0–5) and <strong>WHO Growth Reference</strong> (2007, ages 5–19).",
  "students.who_info_p2": "<strong>Height-for-age</strong> and <strong>BMI-for-age</strong> are shown for all ages; <strong>weight-for-age</strong> only up to age 10 (WHO does not define it beyond 10 — BMI-for-age is the recommended indicator for older children).",
  "students.who_info_p3": "A percentile is computed from the child's age & sex via the WHO LMS method (z-score → percentile). It shows how the child compares to the WHO reference population — e.g. 75th percentile means taller/heavier than 75% of children that age.",
  "students.who_info_p4": "Requires the student's <strong>date of birth</strong> and <strong>sex</strong>; otherwise percentiles show '—'.",
  "students.col_weight": "Weight",
  "students.col_height": "Height",
  "students.col_weight_kg": "Weight (kg)",
  "students.col_height_cm": "Height (cm)",
  "students.growth_print_title": "Growth history",
  "students.delete_measurement_title": "Delete measurement",
  "students.delete_measurement_description": "Delete the measurement from {{date}}? This cannot be undone.",
  "students.recent_awards_title": "Recent awards",
  "students.total_suffix": "{{count}} total",
  "students.awarded_by": "by {{name}}",
  "students.staff_fallback": "staff",
  "students.view_all_awards": "View all awards for this student",
  "students.edit_title": "Edit student",
  "students.new_title": "New student",
  "students.google_email_invalid": "Google email is not valid",
  "students.fullname_placeholder": "John Doe",
  "students.nickname_placeholder": "Johnny",
  "students.nickname_hint": "If set, the nickname is shown across the system instead of the full name.",
  "students.date_of_birth_field": "Date of birth (optional)",
  "students.sex_field": "Sex (optional)",
  "students.not_specified": "Not specified",
  "students.person_id_placeholder": "S-001",
  "students.door_id_field": "Door ID (optional)",
  "students.door_id_field_hint": "Short number for the door panel when the Person ID has too many digits. Cards enrolled under it open the door as this student.",
  "students.door_id_invalid": "Door ID can contain digits only",
  "students.google_email_field": "Google email (optional)",
  "students.google_email_field_hint": "If set, the student can sign in to the public site with this Google account.",
  "students.grade_level_field": "Grade level",
  "students.edp_free_places_field": "Free EDP places",
  "students.edp_free_places_hint": "EDP courses this child pays nothing for. Each is worth the round's standard course price. Most children have none.",
  "students.edp_free_places_invalid": "Enter a whole number of 0 or more.",
  "students.house_field": "House (optional)",
  "students.photo_alt": "Student photo",
  "students.infirmary_title": "Infirmary visits",
  "students.no_infirmary_visits": "No infirmary visits yet.",
  "students.delete_visit_title": "Delete visit",
  "students.delete_visit_description": "Delete the infirmary visit from {{date}}? This cannot be undone.",
  "students.parents_title": "Parents / guardians",
  "students.new_parent": "New parent",
  "students.no_parents_linked": "No parents linked yet.",
  "students.parent_search_placeholder": "Link an existing parent — search name or email…",
  "students.no_matching_parents": "No matching unlinked parents.",
  "students.toast_parent_linked": "Parent linked",
  "students.error_link_failed": "Failed to link",
  "students.unlink_parent_title": "Unlink parent?",
  "students.unlink_parent_description": "{{name}} will no longer be linked to this student. You can re-link them at any time.",
  "students.toast_parent_unlinked": "Parent unlinked",
  "students.error_unlink_failed": "Failed to unlink",
  "students.no_temp_readings": "No temperature readings recorded.",
  "students.temp_col_temp_c": "Temp (°C)",
  "students.temp_col_temp": "Temp",
  "students.temp_col_taken_by": "Taken by",
  "students.temp_col_note": "Note",
  "students.temperature_print_title": "Temperature history",
  "students.edit_measurement_title": "Edit measurement",
  "students.measurement_save_failed": "Failed to save",
  "students.no_incidents": "No incidents recorded for this student.",
  "students.incidents_visible_title": "Incidents visible to you",
  "students.no_visible_incidents": "No incidents are available to you for this student.",
  "students.no_lunch_detentions": "No MSS runs recorded for this student.",
  "students.no_measurements_yet": "No measurements yet.",
  "students.error_date_required": "Date is required.",
  "students.error_weight_number": "Weight must be a number",
  "students.error_height_number": "Height must be a number",
  "students.allergies_section": "Allergies & dietary",
  "students.allergy_badge": "Severe allergy",
  "students.allergy_card.print": "Printable allergy card",
  "students.allergy_card.severe_banner": "Severe allergy",
  "students.allergy_card.allergens_heading": "Allergens",
  "students.allergy_card.dietary_heading": "Dietary note",
  "students.allergy_card.no_allergens": "No allergens recorded.",
  "students.allergy_severe_suffix": "severe",
  "students.no_dietary_info": "No allergies or dietary notes on file.",
  "students.dietary_note": "Dietary note",
  "students.allergies_label": "Allergies",
  "students.aides.badge": "1:1: {{name}}",
  "students.aides.label": "1:1",
  "students.aides.off.full_day": "Off today",
  "students.aides.off.morning_half": "Off this morning",
  "students.aides.off.afternoon_half": "Off this afternoon",
  "students.aides.role": "1:1 aide",
  "students.aides.section_title": "1:1 support",
  "students.aides.none": "No 1:1 assigned",
  "students.aides.edit_title": "1:1 support",
  "students.aides.edit_description": "Staff who support this student one-to-one. They can see this student's full record, incidents and logins.",
  "students.aides.saved": "1:1 support saved",
  "students.add_allergy": "Add allergy",
  "students.allergy_item_placeholder": "e.g. Peanuts",
  "students.severe": "Severe",
  "students.media_consent_section": "Social media consent",
  "students.social_consent_label": "Social media consent",
  "students.social_note": "Note",
  "students.may_leave_alone_badge": "May leave alone",
  "students.leave_alone_section": "Going home alone",
  "students.leave_alone_label": "May leave alone",
  "students.leave_alone_hint": "Only with a signed form from the parents.",
  "students.leave_alone_note": "Note",
  "students.social_ok": "OK to share",
  "students.social_no": "Do NOT share",
  "students.credentials_section_title": "Digital account logins",
  "students.credential_add_button": "Add login",
  "students.credential_empty": "No login details on file yet.",
  "students.credential_col_platform": "Platform",
  "students.credential_col_username": "Username",
  "students.credential_col_password": "Password",
  "students.credential_col_login_url": "Login URL",
  "students.credential_col_notes": "Notes",
  "students.credential_open_login": "Open login page",
  "students.credential_toggle_reveal": "Show/hide password",
  "students.credential_copy_password": "Copy password",
  "common.password_large_type": "Show password in large type",
  "common.password_large_type_hint": "Numbers are blue and symbols are red. The small number under each character is its position.",
  "students.credential_toast_copied": "Password copied to clipboard",
  "students.credential_error_copy": "Couldn't copy to clipboard",
  "students.credential_error_reveal": "Couldn't reveal password",
  "students.credential_delete_title": "Delete login",
  "students.credential_delete_description": "Delete the \"{{name}}\" login for this student? This cannot be undone.",
  "students.credential_print_title": "Digital Account Logins",
  "students.credential_add_title": "Add login",
  "students.credential_edit_title": "Edit login",
  "students.credential_field_platform": "Platform",
  "students.credential_field_custom_label": "Platform name",
  "students.credential_error_custom_label_required": "Enter a name for this platform.",
  "students.credential_field_username": "Username / email",
  "students.credential_field_password": "Password",
  "students.credential_field_notes": "Notes (parents can see this)",
  "students.credential_platform_other": "Other",
  "students.credential_toast_added": "Login added",
  "students.credential_toast_updated": "Login updated",
  "students.credential_error_save": "Couldn't save this login",
  "credential_export.title": "Student Export",
  "credential_export.subtitle": "Generate a printable sheet or CSV of student details. Login credentials are one optional section among several.",
  "credential_export.label_grade": "Grade",
  "credential_export.layout_heading": "Sheet layout",
  "credential_export.split_by_grade": "A separate sheet per grade",
  "credential_export.split_by_grade_hint": "One worksheet per grade in Excel, and each grade starts its own page when printed.",
  "credential_export.as_cards": "Print as login cards",
  "credential_export.as_cards_hint": "One card per student, two across an A4 page, to cut out and hand out. The first student field is the card's heading.",
  "credential_export.card_username": "Username",
  "credential_export.card_password": "Password",
  "credential_export.no_grade": "No grade",
  "credential_export.reorder_column_aria": "Move the {{column}} column",
  "credential_export.fields_heading": "Student fields",
  "credential_export.platforms_heading": "Login platforms",
  "credential_export.field.fullName": "Full name",
  "credential_export.field.firstName": "First name",
  "credential_export.field.lastName": "Last name",
  "credential_export.field.nickname": "Nickname",
  "credential_export.field.personId": "Student ID",
  "credential_export.field.risPersonId": "RIS Phuket ID",
  "credential_export.field.gradeLevel": "Grade",
  "credential_export.field.sex": "Sex",
  "credential_export.field.dateOfBirth": "Date of birth",
  "credential_export.field.house": "House",
  "credential_export.field.passportOrThaiId": "Passport / Thai ID",
  "credential_export.field.email": "Email",
  "credential_export.field.parents": "Parent contacts",
  "credential_export.platform.google": "Gmail / Google",
  "credential_export.platform.ixl": "IXL",
  "credential_export.platform.locker": "Locker",
  "credential_export.platform.hmh": "HMH",
  "credential_export.platform.mcgrawhill": "McGraw Hill",
  "credential_export.platform.boddle": "Boddle",
  "credential_export.platform.kidsaz": "Kids A-Z",
  "credential_export.platform.epic": "Epic",
  "credential_export.platform.wifi": "School WiFi",
  "credential_export.platform.other": "Other",
  "credential_export.password_warning": "This sheet contains passwords — handle and destroy carefully.",
  "credential_export.generate": "Generate",
  "credential_export.generating": "Generating…",
  "credential_export.empty": "No students found for this selection.",
  "credential_export.empty_hint": "Pick a grade and at least one field or platform, then press Generate.",
  "sand_dollars.award_title": "Award Sand Dollars",
  "sand_dollars.award_subtitle": "Pick students, choose a value, and submit.",
  "sand_dollars.no_house_yet": "{{name}} — no house yet",
  "sand_dollars.remove_student_aria": "Remove {{name}}",
  "sand_dollars.search_placeholder": "Search by name or nickname…",
  "sand_dollars.reset_filters": "Reset filters",
  "sand_dollars.select_all_count": "Select all {{count}}",
  "sand_dollars.deselect_all": "Deselect all",
  "sand_dollars.select_all_grade": "Select all {{grade}}",
  "sand_dollars.student_count_one": "{{count}} student",
  "sand_dollars.student_count_other": "{{count}} students",
  "sand_dollars.selected_count": "{{count}} selected",
  "sand_dollars.no_students_match": "No students match these filters.",
  "sand_dollars.value_label": "Value",
  "sand_dollars.no_categories_prompt": "Create award categories first.",
  "sand_dollars.awarding": "Awarding…",
  "sand_dollars.award_count_one": "Award {{count}} sand dollar",
  "sand_dollars.award_count_other": "Award {{count}} sand dollars",
  "sand_dollars.note_placeholder": "Optional private note (visible only to you)",
  "sand_dollars.toast_awarded_count_one": "Awarded {{count}} sand dollar",
  "sand_dollars.toast_awarded_count_other": "Awarded {{count}} sand dollars",
  "sand_dollars.toast_value_label": "Value: {{name}}",
  "sand_dollars.toast_award_failed": "Failed to award sand dollars",
  "sand_dollars.all_awards_title": "All Sand Dollar Awards",
  "sand_dollars.all_awards_subtitle": "Browse, filter, and (admin only) remove awards.",
  "sand_dollars.no_awards_match": "No awards match these filters.",
  "sand_dollars.from_placeholder": "From",
  "sand_dollars.to_placeholder": "To",
  "sand_dollars.my_awards_only": "My awards only",
  "sand_dollars.item_label": "awards",
  "sand_dollars.teacher_col": "Teacher",
  "sand_dollars.auto_award.attendance_weekly": "by completing a full week on time ({{period}})",
  "sand_dollars.auto_award.attendance_monthly": "by completing a full month on time ({{period}})",
  "sand_dollars.auto_award.attendance_weekly_name": "Weekly perfect attendance",
  "sand_dollars.auto_award.attendance_monthly_name": "Monthly perfect attendance",
  "sand_dollars.auto_award.filter_automatic": "Automatic",
  "sand_dollars.auto_award.attendance_weekly_hint": "One sand dollar for a child present, on time and tapped in at the door every school day of the week. Given each Friday morning.",
  "sand_dollars.auto_award.attendance_monthly_hint": "One sand dollar for a whole month without a single absence or late arrival. Given on the first of the following month, on top of that month's weekly awards.",
  "sand_dollars.auto_award.min_school_days": "Minimum school days in the period",
  "sand_dollars.auto_award.min_school_days_hint": "A shorter period — a week broken by holidays — is skipped for everyone.",
  "sand_dollars.auto_award.error_category_required": "Choose a category before switching this on",
  "sand_dollars.auto_award.error_min_days_number": "Enter a whole number of days",
  "sand_dollars.auto_award.run_label": "Re-run for a date in the period",
  "sand_dollars.auto_award.run_cta": "Run",
  "sand_dollars.auto_award.run_result": "{{awarded}} sand dollar(s) given for {{periodKey}}",
  "sand_dollars.auto_award.run_skipped": "Nothing given: {{reason}}",
  "sand_dollars.auto_award.skip_reason_disabled": "the rule is switched off",
  "sand_dollars.auto_award.skip_reason_no_category": "no category is chosen",
  "sand_dollars.auto_award.skip_reason_too_few_school_days": "the period has fewer school days than required",
  "sand_dollars.auto_award.skip_reason_year_not_writable": "the school year is closed to changes",
  "sand_dollars.select_category": "Select a category",
  "sand_dollars.private_note_col": "Private Note",
  "sand_dollars.delete_award_title": "Delete this award?",
  "sand_dollars.delete_award_description": "The student's total will decrease by 1. This cannot be undone.",
  "sand_dollars.stats_title": "Sand Dollar Statistics",
  "sand_dollars.stats_subtitle": "Programme health, per-grade rates, houses, leaderboards and staff activity.",
  "sand_dollars.celebration_label": "Celebration",
  "sand_dollars.no_celebration_option": "No celebration (use period)",
  "sand_dollars.scoped_to_celebration": "All stats scoped to this celebration’s period.",
  "sand_dollars.houses_totals_for": "Houses — totals for {{title}}",
  "sand_dollars.houses_totals_year": "Houses — totals this school year",
  "sand_dollars.unknown_house": "Unknown",
  "sand_dollars.no_awards_yet": "No awards yet.",
  "sand_dollars.house_race_title": "House race over time (per month)",
  "sand_dollars.not_enough_data": "Not enough data yet.",
  "sand_dollars.leaderboard_title": "Leaderboard",
  "sand_dollars.period_today": "Today",
  "sand_dollars.period_week": "This week",
  "sand_dollars.period_month": "This month",
  "sand_dollars.period_year": "This school year",
  "sand_dollars.period_all": "All time",
  "sand_dollars.scope_overall": "Overall",
  "sand_dollars.scope_house": "By house",
  "sand_dollars.scope_grade": "By grade",
  "sand_dollars.no_awards_scope": "No awards yet for this scope.",
  "sand_dollars.tab_celebrations": "Celebrations",
  "sand_dollars.tab_attendance_awards": "Attendance awards",
  "sand_dollars.standings_fallback": "Standings",
  "sand_dollars.overall_top3": "Overall Top 3",
  "sand_dollars.by_house": "By House",
  "sand_dollars.by_grade": "By Grade",
  "sand_dollars.schoolwide_top_scorers": "School-wide top scorers",
  "sand_dollars.no_awards_period": "No awards in this period.",
  "sand_dollars.tab_houses": "Houses",
  "houses.tab": "Houses",
  "houses.search_placeholder": "Find a student or staff member…",
  "houses.student_count_one": "{{count}} student",
  "houses.student_count_other": "{{count}} students",
  "houses.leaders": "House leaders",
  "houses.captains": "Captains · Grade 5",
  "houses.council": "House council · Grades 6–9",
  "houses.members": "Members · Grades 1–4",
  "houses.none_yet": "No one yet",
  "houses.no_houses": "No houses have been set up yet.",
  "houses.edit_leaders": "Edit leaders",
  "houses.edit_leaders_for": "Edit {{house}} leaders",
  "houses.edit_leaders_title": "{{house}} leaders",
  "houses.leaders_label": "House leaders",
  "houses.move_to": "Move {{name}} to another house",
  "houses.no_house": "No house",
  "houses.unplaced_title": "Not in a house yet",
  "houses.grade_not_set": "Grade not set",
  "houses.everyone_placed": "Every student is in a house.",
  "houses.currently_in": "Now in {{house}}",
  "houses.move_failed": "Couldn't change the house",
  "sand_dollars.tab_categories": "Categories",
  "sand_dollars.new_house_cta": "New House",
  "sand_dollars.new_category_cta": "New Category",
  "sand_dollars.new_celebration_cta": "New Celebration",
  "sand_dollars.config_subtitle": "Houses, award categories, and celebration periods.",
  "sand_dollars.error_title_required": "Title is required.",
  "sand_dollars.error_period_start_required": "Start date is required.",
  "sand_dollars.error_period_end_required": "End date is required.",
  "sand_dollars.period_col": "Period",
  "sand_dollars.status_archived": "Archived",
  "sand_dollars.no_celebrations_yet": "No celebrations yet. Create one for the current month.",
  "sand_dollars.edit_celebration": "Edit celebration",
  "sand_dollars.new_celebration": "New celebration",
  "sand_dollars.field_period_start": "Period start",
  "sand_dollars.field_period_end": "Period end",
  "sand_dollars.field_notes": "Notes (optional)",
  "sand_dollars.field_end_time": "End time on the last day (optional)",
  "sand_dollars.field_end_time_hint": "Awards entered after this time stop counting, so the results are ready for the celebration.",
  "sand_dollars.field_minimum_dollars": "Minimum Sand Dollars (optional)",
  "sand_dollars.field_minimum_dollars_hint": "Children with at least this many in the period receive a prize.",
  "sand_dollars.error_minimum_dollars": "Enter a whole number from 1 to 999, or leave it empty.",
  "sand_dollars.minimum_heading_one": "Minimum {{count}} Sand Dollar",
  "sand_dollars.minimum_heading_other": "Minimum {{count}} Sand Dollars",
  "sand_dollars.minimum_reached_one": "Reached the minimum ({{count}} child)",
  "sand_dollars.minimum_reached_other": "Reached the minimum ({{count}} children)",
  "sand_dollars.minimum_not_reached_one": "Did not reach it ({{count}} child)",
  "sand_dollars.minimum_not_reached_other": "Did not reach it ({{count}} children)",
  "sand_dollars.minimum_reached_status": "Reached",
  "sand_dollars.minimum_not_reached_status": "Not reached",
  "sand_dollars.celebration_col_house": "House",
  "sand_dollars.celebration_col_dollars": "Sand Dollars",
  "sand_dollars.delete_celebration_title": "Delete celebration \"{{title}}\"?",
  "sand_dollars.delete_celebration_description": "Standings are computed from awards on demand, so deletion only removes the celebration record itself.",
  "sand_dollars.error_name_required": "Name is required.",
  "sand_dollars.error_sort_order_number": "Sort order must be a number",
  "sand_dollars.icon_col": "Icon",
  "sand_dollars.sort_col": "Sort",
  "sand_dollars.categories_empty": "No categories yet. Add the values you want to celebrate.",
  "sand_dollars.edit_category": "Edit category",
  "sand_dollars.new_category": "New category",
  "sand_dollars.field_name": "Name",
  "sand_dollars.name_placeholder_category": "Responsibility",
  "sand_dollars.field_icon": "Icon (optional)",
  "sand_dollars.delete_category_title": "Delete category \"{{name}}\"?",
  "sand_dollars.delete_category_description": "Awards already linked to this category will block deletion.",
  "sand_dollars.houses_empty": "No houses yet. Create the four houses to get started.",
  "sand_dollars.edit_house": "Edit house",
  "sand_dollars.new_house": "New house",
  "sand_dollars.house_name_placeholder": "Dolphin",
  "sand_dollars.delete_house_title": "Delete house \"{{name}}\"?",
  "sand_dollars.delete_house_description": "Students assigned to this house will block deletion. Move them first.",
  "house_points.title": "House Points",
  "house_points.subtitle": "Manual point adjustments for each house.",
  "house_points.empty": "No adjustments yet.",
  "house_points.item_label": "adjustments",
  "house_points.adjust": "Adjust {{house}}",
  "house_points.new_title": "Adjust {{house}}",
  "house_points.edit_title": "Edit adjustment",
  "house_points.amount": "Amount (+ or −)",
  "house_points.category": "Category",
  "house_points.category_placeholder": "Select a category",
  "house_points.note": "Note",
  "house_points.house": "House",
  "house_points.admin": "By",
  "house_points.delete_title": "Delete this adjustment?",
  "house_points.delete_description": "This will remove the adjustment and update the house's total.",
  "house_points.error_amount_number": "Amount must be a number",
  "house_points.error_amount_integer": "Amount must be a whole number",
  "house_points.error_amount_nonzero": "Amount cannot be zero",
  "house_points.error_amount_required": "Amount is required",
  "house_points.error_category_required": "Category is required",
  "house_points.error_date_required": "Date is required",
  "house_points.breakdown": "{{students}} from students, {{adjustments}} adjustments",
  "common.name": "Name",
  "common.code": "Code",
  "common.sort": "Sort",
  "common.error_name_required": "Name is required.",
  "common.weekday_short.mon": "Mon",
  "common.weekday_short.tue": "Tue",
  "common.weekday_short.wed": "Wed",
  "common.weekday_short.thu": "Thu",
  "common.weekday_short.fri": "Fri",
  "common.weekday_short.sat": "Sat",
  "timetable.edp_tile_label": "EDP",
  "common.weekday_full.mon": "Monday",
  "common.weekday_full.tue": "Tuesday",
  "common.weekday_full.wed": "Wednesday",
  "common.weekday_full.thu": "Thursday",
  "common.weekday_full.fri": "Friday",
  "common.kind_lesson": "Lesson",
  "common.kind_break": "Break",
  "common.kind_activity": "Activity",
  "common.close": "Close",
  "common.dismiss_note": "Hide this note",
  "common.navigation_menu": "Navigation menu",
  "icon_picker.no_icon": "No icon",
  "icon_picker.none": "None",
  "color_picker.use_color": "Use colour {{color}}",
  "color_picker.custom_color": "Custom colour",
  "timetable.col_slots": "Slots",
  "timetable.slot_count_one": "{{count}} slot",
  "timetable.slot_count_other": "{{count}} slots",
  "timetable.special_schedules_empty": "No special schedules yet. Add one to get started.",
  "timetable.new_special_schedule": "New special schedule",
  "timetable.short_day_placeholder": "Short Day",
  "timetable.start_from_normal_schedule_label": "Start from the normal schedule",
  "timetable.start_from_normal_schedule_desc": "Seeds one slot per active period from the Bell Schedule tab, so you only need to adjust times.",
  "timetable.edit_special_schedule_named": "Edit \"{{name}}\"",
  "timetable.edit_special_schedule": "Edit special schedule",
  "timetable.duplicate_default_schedule_button": "Duplicate default schedule",
  "timetable.col_start": "Start",
  "timetable.col_end": "End",
  "timetable.col_kind": "Kind",
  "timetable.midday_swap_role": "Midday swap role",
  "timetable.period_weekdays": "Runs on",
  "timetable.period_weekdays_hint": "The days of the week this period exists. Untick a day and it disappears from the timetable grid and from that day’s bells.",
  "timetable.error_weekdays_required": "Choose at least one day.",
  "timetable.midday_lunch": "Midday lunch",
  "timetable.midday_lesson": "Midday lesson",
  "timetable.col_linked_period": "Linked period",
  "timetable.col_remove": "Remove",
  "timetable.no_linked_period": "— None (free/activity) —",
  "timetable.period_placeholder": "Period 1",
  "timetable.remove_slot_aria": "Remove slot",
  "timetable.slots_empty": "No slots yet. Add a slot or duplicate the default schedule.",
  "timetable.add_slot_button": "Add slot",
  "timetable.duplicate_confirm_title": "Duplicate the normal schedule?",
  "timetable.duplicate_confirm_description": "This replaces the current slot list below with one slot per active period. Save to keep it.",
  "timetable.duplicate_confirm_label": "Duplicate",
  "timetable.delete_special_schedule_title": "Delete special schedule \"{{name}}\"?",
  "timetable.delete_special_schedule_description": "This will permanently remove the schedule and its slots.",
  "timetable.error_start_time_required": "Start time is required.",
  "timetable.error_end_time_required": "End time is required.",
  "timetable.col_period": "Period",
  "timetable.field_start_time": "Start time",
  "timetable.field_end_time": "End time",
  "timetable.edit_period": "Edit period",
  "timetable.new_period": "New period",
  "timetable.delete_period_title": "Delete period \"{{name}}\"?",
  "timetable.delete_period_description": "This will permanently remove the period.",
  "timetable.periods_empty": "No periods yet. Add periods to get started.",
  "timetable.col_grade": "Grade",
  "timetable.col_homeroom_teacher": "Homeroom Teacher",
  "timetable.badge_per_period": "Per-period",
  "timetable.badge_temperature": "Temperature",
  "timetable.ensure_one_class_per_grade_button": "Ensure one class per grade",
  "timetable.ensure_one_class_per_grade_tooltip": "Creates one class for each grade that has active students, for the selected year. Safe to run again — it won't duplicate.",
  "timetable.select_school_year_placeholder": "Select school year",
  "timetable.class_name_placeholder": "Grade 6A",
  "timetable.field_grade_level": "Grade level",
  "timetable.select_grade_placeholder": "Select grade",
  "timetable.field_homeroom_teacher": "Homeroom teacher",
  "timetable.field_assistant_teachers": "Assistant teachers",
  "timetable.assistant_teachers_hint": "Assistants can read the class's report cards (Early Years and Grade 1+) but cannot change them.",
  "timetable.assistant_teachers_placeholder": "Search staff…",
  "timetable.assistant_teachers_empty": "No matching staff",
  "timetable.field_homeroom_room": "Homeroom room",
  "timetable.none_placeholder": "— None —",
  "timetable.field_per_period_attendance": "Per-period attendance",
  "timetable.per_period_attendance_tooltip": "When on, teachers mark attendance for this class every period (in 'My Classes Today'), not just once a day. Turn on for classes where students move between teachers (usually secondary); leave off for younger years.",
  "timetable.lunch_group": "Lunch group",
  "timetable.lunch_none": "None",
  "timetable.lunch_first": "First lunch (11:35)",
  "timetable.lunch_second": "Second lunch (12:25)",
  "timetable.field_temperature_tracking": "Temperature tracking",
  "timetable.temperature_tracking_tooltip": "When on, this class will appear in the temperature check workflow so staff can record students' temperatures.",
  "timetable.edit_class": "Edit class",
  "timetable.new_class": "New class",
  "timetable.delete_class_title": "Delete class \"{{name}}\"?",
  "timetable.delete_class_description": "This will permanently remove the class. A class that already has attendance or other records cannot be deleted; deactivate it instead.",
  "timetable.classes_empty_with_year": "No classes yet. Add a class or click \"Ensure one class per grade\".",
  "timetable.classes_empty_no_year": "Select a school year to see classes.",
  "timetable.error_grade_level_required": "Grade level is required.",
  "timetable.col_subject": "Subject",
  "timetable.subject_name_placeholder": "Mathematics",
  "timetable.subject_code_placeholder": "MATH",
  "timetable.edit_subject": "Edit subject",
  "timetable.new_subject": "New subject",
  "timetable.delete_subject_title": "Delete subject \"{{name}}\"?",
  "timetable.delete_subject_description": "This will permanently remove the subject.",
  "timetable.subjects_empty": "No subjects yet. Add subjects to get started.",
  "timetable.room_name_placeholder": "Science Lab",
  "timetable.room_code_placeholder": "R-SCI",
  "timetable.edit_room": "Edit room",
  "timetable.new_room": "New room",
  "timetable.delete_room_title": "Delete room \"{{name}}\"?",
  "timetable.delete_room_description": "This will permanently remove the room.",
  "timetable.rooms_empty": "No rooms yet. Add rooms to get started.",
  "timetable.label_class": "Class",
  "timetable.label_teacher": "Teacher",
  "timetable.label_room": "Room",
  "timetable.label_bookable": "Bookable",
  "timetable.entity_word_class": "class",
  "timetable.entity_word_teacher": "teacher",
  "timetable.entity_word_room": "room",
  "timetable.entity_word_classes": "classes",
  "timetable.entity_word_teachers": "teachers",
  "timetable.entity_word_rooms": "rooms",
  "timetable.entity_fallback": "Entity",
  "timetable.field_assistants": "Assistants",
  "timetable.assistants_hint": "(usually 1–2)",
  "timetable.add_assistant_placeholder": "Add assistant…",
  "timetable.remove_assistant_aria": "Remove {{name}}",
  "timetable.conflict_teacher": "Teacher also assigned to {{className}} at this time",
  "timetable.conflict_room": "Room also booked by {{className}} at this time",
  "timetable.tab_classes": "Classes",
  "timetable.tab_rooms": "Rooms",
  "timetable.tab_subjects": "Subjects",
  "timetable.tab_bell_schedule": "Bell Schedule",
  "timetable.tab_special_schedules": "Special Schedules",
  "timetable.tab_teacher_rooms": "Teacher Rooms",
  "timetable.new_class_button": "New Class",
  "timetable.new_room_button": "New Room",
  "timetable.new_subject_button": "New Subject",
  "timetable.new_period_button": "New Period",
  "timetable.new_special_schedule_button": "New Special Schedule",
  "timetable.breadcrumb_setup": "Setup",
  "timetable.col_role": "Role",
  "timetable.col_default_room": "Default room",
  "timetable.teacher_rooms_empty": "No staff teachers yet.",
  "timetable.setup_subtitle": "Rooms, subjects and other timetable configuration.",
  "timetable.setup_help_note": "Set up the building blocks of the timetable: <strong>Classes</strong> (one per grade — use \"Ensure one class per grade\"), <strong>Subjects</strong>, <strong>Rooms</strong>, and the <strong>Bell Schedule</strong> (period times, shared by every class).",
  "timetable.grid_subtitle_default": "Select a class to view and edit its weekly timetable.",
  "timetable.grid_help_note": "Build each class's weekly schedule: pick a class, then click a lesson cell to set its <strong>subject, teacher and room</strong>. Break, lunch and homeroom rows span the whole week. For classes with <strong>per-period attendance</strong>, this schedule drives each teacher's lessons and roster.",
  "timetable.col_time": "Time",
  "timetable.lessons_per_week": "Lessons per week",
  "timetable.lessons_total": "{{count}} lessons in total",
  "timetable.no_periods_configured": "No periods configured. Add periods in Timetable Setup → Bell Schedule.",
  "timetable.no_lessons_scheduled": "No lessons scheduled.",
  "timetable.add_cell_label": "+ Add",
  "timetable.tbn": "TBN",
  "timetable.assistant_plus_name": "+ {{name}}",
  "timetable.assistant_plus_count": "+ {{count}} assistants",
  "timetable.field_school_year": "School Year",
  "timetable.select_year_placeholder": "Select year…",
  "timetable.field_view_by": "View by",
  "timetable.select_class_placeholder": "Select class…",
  "timetable.select_teacher_placeholder": "Select teacher…",
  "timetable.select_room_placeholder": "Select room…",
  "timetable.view_subtitle_default": "Select a school year and entity to view the timetable.",
  "timetable.view_select_prompt": "Select a school year and {{entity}} to view the timetable.",
  "timetable.print_all_button": "Print all {{entity}}",
  "timetable.view_help_note": "The same timetable shown three ways — switch <strong>View by</strong> Class, Teacher or Room. <strong>Print</strong> what you are looking at, or <strong>Print all</strong> to print every class, teacher or room at once. With the timetable permission you can also click a cell in the Class view to change it.",
  "attendance.status.present": "Present",
  "attendance.status.absent": "Absent",
  "attendance.status.late": "Late",
  "attendance.status.late_excused": "Late (excused)",
  "attendance.status.excused": "Excused",
  "attendance.status.suspended": "Suspended",
  "attendance.col_day_status": "Today",
  "attendance.status_unmarked": "Unmarked",
  "attendance.status_not_marked": "Not marked",
  "attendance.col_id": "ID",
  "attendance.col_grade_role": "Grade / Role",
  "attendance.col_mark": "Mark",
  "attendance.col_check_in": "Check-in",
  "attendance.col_check_out": "Check-out",
  "attendance.col_note": "Note",
  "attendance.auto_from_door": "Auto (door)",
  "attendance.last_seen": "Last seen {{time}}",
  "attendance.check_in_tooltip": "Check-in times fill in automatically from campus door swipes, marked with the “Auto (door)” badge. Type a time yourself to override it — that locks it in as a manual entry.",
  "attendance.check_out_tooltip": "Check-out fills in automatically too, but only in the afternoon and only after about an hour passes with no further door activity, so a quick trip out isn't mistaken for leaving for the day. Until then, “Last seen” shows the person's latest door swipe — not a confirmed departure. Type a time yourself to override it — that locks it in as a manual entry.",
  "attendance.subtitle": "Mark daily attendance for students and staff.",
  "attendance.non_school_day_banner": "<strong>{{date}}</strong> is not a school day. Attendance cannot be marked.",
  "attendance.unmarked_count": "{{count}} unmarked",
  "common.view_all": "View all",
  "students.attendance_title": "Attendance",
  "students.attendance_summary": "{{present}} present · {{absent}} absent · {{late}} late over {{days}} school days",
  "students.attendance_empty": "No attendance recorded in this period.",
  "students.attendance_load_more": "Show an earlier week",
  "attendance.all_periods": "All periods",
  "attendance.no_lesson": "No lesson",
  "attendance.marked_label": "Marked",
  "attendance.unmarked_tooltip_title": "Not marked yet",
  "common.and_n_more": "and {{count}} more",
  "attendance.label_role": "Role",
  "attendance.role_students": "Students",
  "attendance.label_grade": "Grade",
  "attendance.search_by_name_placeholder": "Search by name…",
  "attendance.daily_help_note": "Mark daily attendance. On <strong>“Staff only”</strong> days students don't appear; on a <strong>Winter/Summer session</strong> date, only the enrolled people appear.",
  "attendance.error_mark_failed": "Failed to mark attendance",
  "attendance.toast_marked_as": "{{name}} marked as {{status}}",
  "attendance.toast_saved_for": "Saved for {{name}}",
  "attendance.error_save_failed": "Failed to save",
  "attendance.error_temp_failed": "Failed to record temperature",
  "attendance.note_placeholder": "Add note…",
  "attendance.marked_by": "by {{name}}",
  "attendance.temp_placeholder": "°C",
  "attendance.empty_no_roster": "No roster entries found.",
  "attendance.empty_select_date": "Select a date to load attendance.",
  "attendance.sessions_title": "Attendance Sessions",
  "attendance.sessions_subtitle": "Manage winter and summer school sessions. Creating a session marks its weekdays open in the attendance calendar.",
  "attendance.error_school_year_required": "School year is required.",
  "attendance.error_kind_required": "Kind is required.",
  "attendance.kind_summer": "Summer",
  "attendance.kind_winter": "Winter",
  "attendance.session_edit_title": "Edit Session",
  "attendance.new_session": "New Session",
  "attendance.toast_session_updated": "Session updated",
  "attendance.toast_session_created": "Session created",
  "attendance.error_session_save_failed": "Failed to save session",
  "attendance.label_school_year": "School Year",
  "attendance.label_kind": "Kind",
  "attendance.select_kind_placeholder": "Select kind",
  "attendance.session_name_placeholder": "e.g. Summer School 2027",
  "attendance.col_start_date": "Start Date",
  "attendance.col_end_date": "End Date",
  "attendance.status_active": "Active",
  "attendance.status_inactive": "Inactive",
  "attendance.save_changes": "Save Changes",
  "attendance.create_session": "Create Session",
  "attendance.sessions_help_note": "<strong>Sessions</strong> are for special programs that run outside the normal school year — Winter School and Summer School. On a session's dates, attendance is tracked <strong>only for the enrolled</strong> students and staff. The regular school year needs no session.",
  "attendance.tooltip_manage_enrollments": "Manage enrollments",
  "attendance.tooltip_edit_session": "Edit session",
  "attendance.tooltip_delete_session": "Delete session",
  "attendance.empty_sessions": "No sessions found for this school year.",
  "attendance.delete_session_title": "Delete Session",
  "attendance.delete_session_description": "Are you sure you want to delete \"{{name}}\"? This cannot be undone.",
  "attendance.toast_session_deleted": "Session deleted",
  "attendance.error_delete_session_failed": "Failed to delete session",
  "attendance.toast_exception_saved": "Exception saved",
  "attendance.error_exception_save_failed": "Failed to save exception",
  "attendance.add_exception_heading": "Add / Update Exception",
  "attendance.add_exception": "Add exception",
  "attendance.calendar_kind_open": "Open",
  "attendance.calendar_kind_closed": "Closed",
  "attendance.label_audience": "Audience",
  "attendance.audience_tooltip": "Who attends this day: All = students + staff; Staff only = staff (no students); Students only = students.",
  "attendance.select_audience_placeholder": "Select audience",
  "attendance.audience_staff_only": "Staff only",
  "attendance.audience_students_only": "Students only",
  "attendance.label_special_schedule": "Special schedule",
  "attendance.special_schedule_tooltip": "Assign a bell-schedule variant to this date, e.g. a shortened exam-day or assembly schedule.",
  "attendance.select_schedule_placeholder": "Select schedule",
  "attendance.none_option": "— None —",
  "attendance.label_optional": "Label (optional)",
  "attendance.label_placeholder_example": "e.g. Public holiday, Sports Day",
  "attendance.save_exception": "Save Exception",
  "attendance.toast_exception_removed": "Exception removed",
  "attendance.error_exception_remove_failed": "Failed to remove exception",
  "attendance.col_date_iso": "Date (ISO)",
  "attendance.col_scope": "Scope",
  "attendance.col_label": "Label",
  "attendance.tooltip_remove_exception": "Remove exception",
  "attendance.confirm_remove_exception_description": "Remove the calendar exception on {{date}}? The day returns to the normal schedule.",
  "attendance.school_calendar_subtitle": "Override default weekday/weekend behaviour. Add an <strong>open</strong> exception to make a weekend day a school day, or a <strong>closed</strong> exception to mark a weekday as a non-school day (e.g. public holidays).",
  "attendance.school_calendar_help_note": "Set exceptions to the normal Mon–Fri schedule. <strong>Closed</strong> = a holiday (no attendance for anyone). <strong>Open + “Staff only”</strong> = an in-service / teacher-prep day: staff check in, but students don't appear (e.g. the weeks before students start). <strong>Open + “All”</strong> is a normal school day.",
  "attendance.label_from": "From",
  "attendance.label_to": "To",
  "attendance.empty_calendar_exceptions": "No calendar exceptions in this date range.",
  "attendance.report_subtitle": "View the attendance matrix for a date range.",
  "attendance.export_xlsx": "Export .xlsx",
  "attendance.no_record": "No record",
  "attendance.empty_no_report_data": "No attendance data for this range.",
  "attendance.empty_select_range_report": "Select a date range to load report.",
  "attendance.daily_total": "Daily total",
  "attendance.search_student_placeholder": "Search student by name or nickname…",
  "attendance.no_matching_students": "No matching students found.",
  "attendance.all_students_enrolled": "All active students are already enrolled.",
  "attendance.toast_enrolled": "{{name}} enrolled",
  "attendance.error_already_enrolled": "Already enrolled",
  "attendance.error_enroll_failed": "Failed to enroll",
  "attendance.search_staff_placeholder": "Search staff by name or email…",
  "attendance.no_matching_staff": "No matching staff found.",
  "attendance.all_staff_enrolled": "All staff are already enrolled.",
  "attendance.tooltip_remove_from_session": "Remove from session",
  "attendance.enrollments_title": "Enrollments — {{name}}",
  "attendance.enrollment_help_note": "Add the <strong>students and staff</strong> taking part in this session. Use the <strong>Students / Staff</strong> toggle to search each directory. Only enrolled people are tracked for attendance on the session's dates.",
  "attendance.enrolled_count": "Enrolled ({{count}})",
  "attendance.no_one_enrolled": "No one enrolled yet.",
  "attendance.toast_person_removed": "Person removed from session",
  "attendance.error_remove_failed": "Failed to remove",
  "attendance.toast_all_marked_present": "All students marked as present",
  "attendance.confirm_register": "Confirm today's register ({{count}})",
  "attendance.toast_register_confirmed": "{{count}} marked from today's register",
  "attendance.mark_all_present": "Mark all present",
  "attendance.marked_footer": "{{marked}} / {{total}} marked",
  "attendance.missed.lessons_one": "{{count}} lesson",
  "attendance.missed.lessons_other": "{{count}} lessons",
  "attendance.missed.teacher_one": "{{count}} marked absent",
  "attendance.missed.teacher_other": "{{count}} marked absent",
  "attendance.missed.reported_absence_one": "{{count}} reported absent",
  "attendance.missed.reported_absence_other": "{{count}} reported absent",
  "attendance.missed.late_arrival_one": "{{count}} arrived late",
  "attendance.missed.late_arrival_other": "{{count}} arrived late",
  "attendance.missed.lesson_excusal_one": "{{count}} excused from the lesson",
  "attendance.missed.lesson_excusal_other": "{{count}} excused from lessons",
  "attendance.missed.suspension_one": "{{count}} suspended",
  "attendance.missed.suspension_other": "{{count}} suspended",
  "attendance.missed.early_dismissal_one": "{{count}} left early",
  "attendance.missed.early_dismissal_other": "{{count}} left early",
  "attendance.mark_source.absence": "Reported absent",
  "attendance.mark_source.lateArrival": "Late arrival",
  "attendance.mark_source.earlyDismissal": "Early dismissal",
  "attendance.mark_source.lessonExcusal": "Lesson excusal",
  "attendance.mark_source.suspension": "Suspended",
  "attendance.history_title": "Attendance History",
  "attendance.history_subtitle": "Per-person attendance record for the selected range.",
  "attendance.rate_label": "Rate ({{days}} days)",
  "attendance.empty_no_records": "No records for this range.",
  "attendance.empty_select_range_history": "Select a date range to load history.",
  "attendance.marked_ratio": "{{marked}}/{{total}} marked",
  "attendance.my_classes_help_note": "Your scheduled classes for the day. Mark attendance per period; tap a status again to change it. Classes that take attendance once a day are listed for reference only.",
  "attendance.no_marking_needed": "No marking needed",
  "attendance.lesson_assistants_one": "Assistant:",
  "attendance.lesson_assistants_other": "Assistants:",
  "attendance.no_classes_title": "No classes scheduled for this day.",
  "attendance.no_classes_description": "{{date}} has no scheduled periods for your account, or is not a school day.",
  "attendance.my_classes_subtitle": "Mark per-period attendance for your classes.",
  "attendance.period_admin_subtitle": "View or correct any class's per-period attendance.",
  "attendance.label_period": "Period",
  "attendance.select_period_placeholder": "Select period…",
  "attendance.select_class_period_date": "Select a class, period, and date to view or mark attendance.",
  "directory.title": "Student Directory",
  "directory.subtitle": "Browse student profiles, allergies, and house — read-only.",
  "directory.search_placeholder": "Search students",
  "directory.search_aria": "Search students by name",
  "directory.empty": "No students found.",
  "directory.sand_dollars_col": "Sand Dollars",
  "directory.allergy_col": "Allergies",
  "directory.restriction_badge": "Dietary restriction",
  "directory.back": "Back to Student Directory",
  "directory.details_title": "Details",
  "directory.no_parents": "No parent records.",
  "directory.no_share": "Do NOT share on social media",
  "cafeteria.title": "Cafeteria",
  "cafeteria.subtitle": "Manage beverages, snacks, and their prices.",
  "cafeteria.tabs.label": "Cafeteria sections",
  "cafeteria.tabs.menu": "Menu",
  "cafeteria.tabs.sales": "Sales",
  "cafeteria.tabs.wallets": "Wallets",
  "cafeteria.tabs.reports": "Reports",
  "cafeteria.sales.title": "Cafeteria Sales",
  "cafeteria.sales.subtitle": "Every sale, paid by wallet or Thai QR. Refunds are possible on the day of the sale.",
  "cafeteria.sales.empty": "No sales for these filters.",
  "cafeteria.sales.walk_in": "Walk-in",
  "cafeteria.sales.filter_payment": "Paid by",
  "cafeteria.sales.all_payments": "All payments",
  "cafeteria.sales.wallet": "Wallet",
  "cafeteria.sales.thai_qr": "Thai QR",
  "cafeteria.sales.filter_refunds": "Refunds",
  "cafeteria.sales.any_refund": "All sales",
  "cafeteria.sales.with_refunds": "With refunds",
  "cafeteria.sales.search_placeholder": "Search name or sale number",
  "cafeteria.sales.search_aria": "Search sales",
  "cafeteria.sales.items_label": "sales",
  "cafeteria.sales.col_time": "Time",
  "cafeteria.sales.col_who": "Who",
  "cafeteria.sales.col_items": "Items",
  "cafeteria.sales.col_paid_by": "Paid by",
  "cafeteria.sales.col_total": "Total",
  "cafeteria.sales.col_cashier": "Cashier",
  "cafeteria.sales.refunded_amount": "{{amount}} refunded",
  "cafeteria.sales.refund": "Refund",
  "cafeteria.sales.detail_title": "Sale",
  "cafeteria.sales.refunds_title": "Refunds",
  "cafeteria.sales.no_refunds": "Nothing refunded.",
  "cafeteria.refund.title": "Refund",
  "cafeteria.refund.col_item": "Item",
  "cafeteria.refund.col_bought": "Bought",
  "cafeteria.refund.col_refunded": "Already refunded",
  "cafeteria.refund.col_refund_now": "Refund now",
  "cafeteria.refund.refund_now_aria": "Refund now: {{name}}",
  "cafeteria.refund.of_left": "of {{count}} left",
  "cafeteria.refund.comment": "Comment",
  "cafeteria.refund.comment_placeholder": "Why, and how the money went back (e.g. cash returned by Khun Ploy)",
  "cafeteria.refund.comment_required": "Write why, and how the money went back.",
  "cafeteria.refund.too_many": "Only {{left}} of {{name}} left to refund.",
  "cafeteria.refund.wallet_note": "{{amount}} goes back to {{name}}'s wallet.",
  "cafeteria.refund.thai_qr_note": "No money moves in the system. Write in the comment how it was returned.",
  "cafeteria.refund.submit": "Refund {{amount}}",
  "cafeteria.refund.done": "Refunded {{amount}}.",
  "cafeteria.refund.failed": "The refund did not go through.",
  "cafeteria.add": "Add Product",
  "cafeteria.empty": "No products yet. Add a category, then a product.",
  "cafeteria.col_product": "Product",
  "cafeteria.col_price": "Price",
  "cafeteria.active": "Active",
  "cafeteria.inactive": "Inactive",
  "cafeteria.delete_title": "Delete Product",
  "cafeteria.delete_description": "Are you sure you want to delete this product? This action cannot be undone.",
  "cafeteria.edit_product": "Edit Product",
  "cafeteria.price_label": "Price (฿)",
  "cafeteria.product_image": "Product image",
  "cafeteria.select_category": "Select a category",
  "cafeteria.no_categories": "No categories yet.",
  "cafeteria.new_category_label": "New category",
  "cafeteria.new_category_placeholder": "e.g. Beverage",
  "cafeteria.delete_category_failed": "Failed to delete category. Please try again.",
  "cafeteria.category_already_exists": "A category with this name already exists.",
  "cafeteria.wallet_title": "Cafeteria wallet",
  "cafeteria.balance_label": "Balance",
  "cafeteria.topup_form_title": "Add cash top-up",
  "cafeteria.topup_amount_label": "Amount (฿)",
  "cafeteria.topup_note_label": "Note",
  "cafeteria.topup_bonus_label": "Bonus / free credit (฿)",
  "cafeteria.topup_button": "Top up",
  "cafeteria.topup_success": "Wallet topped up",
  "cafeteria.topup_failed": "Failed to top up wallet",
  "cafeteria.transactions_title": "Transaction history",
  "cafeteria.no_transactions": "No transactions yet.",
  "cafeteria.show_qr_button": "Show QR",
  "cafeteria.show_qr_no_person_id": "No personId — cannot generate a QR",
  "cafeteria.qr_modal_title": "Cafeteria QR code",
  "cafeteria.qr_modal_description": "Scan this at the till, or type the ID manually.",
  "cafeteria.qr_generating": "Generating QR code…",
  "cafeteria.qr_failed": "Failed to generate QR code.",
  "nav.cafeteria_pos": "Cafeteria Till",
  "cafeteria.pos.title": "Cafeteria Till",
  "cafeteria.pos.subtitle": "Tap products to build the order, then charge the customer's wallet.",
  "cafeteria.pos.cart_title": "Cart",
  "cafeteria.pos.cart_empty": "Cart is empty. Tap a product to add it.",
  "cafeteria.pos.total_label": "Total",
  "cafeteria.pos.charge_button": "Charge",
  "cafeteria.pos.clear_cart": "Clear cart",
  "cafeteria.pos.no_products": "No products available.",
  "cafeteria.pos.checkout_success": "Charged {{total}} — new balance {{balance}}",
  "cafeteria.pos.checkout_failed": "Failed to charge wallet",
  "cafeteria.pos.identify_title": "Identify customer",
  "cafeteria.pos.identify_description": "Scan a QR code or enter the person ID.",
  "cafeteria.pos.person_id_label": "Person ID",
  "cafeteria.pos.person_id_placeholder": "Enter person ID",
  "cafeteria.pos.lookup_button": "Look up",
  "cafeteria.pos.scan_button": "Scan QR",
  "cafeteria.pos.stop_scan_button": "Stop scan",
  "cafeteria.pos.scan_unsupported": "Camera scan not supported here — enter the ID",
  "cafeteria.pos.camera_error": "Could not access the camera",
  "cafeteria.pos.person_not_found": "No account found for that ID",
  "cafeteria.pos.balance_label": "Balance",
  "cafeteria.pos.confirm_charge_button": "Confirm & charge",
  "cafeteria.pos.charging": "Charging…",
  "cafeteria.pos.charge_success_title": "Charge complete",
  "cafeteria.pos.charge_success_description": "New balance: {{balance}}",
  "cafeteria.pos.done_button": "Done",
  "cafeteria.pos.change_person_button": "Use a different ID",
  "cafeteria.pos.search_label": "Search by name or nickname",
  "cafeteria.pos.search_placeholder": "Type a name or nickname",
  "cafeteria.pos.search_hint": "Type at least 2 characters",
  "cafeteria.pos.search_no_results": "No matching people",
  "cafeteria.pos.payment_method_wallet": "Wallet",
  "cafeteria.pos.payment_method_thai_qr": "Thai QR (parent/visitor)",
  "cafeteria.pos.attribution_search_label": "Attribute to a parent, student or staff member (optional)",
  "cafeteria.pos.attribution_search_placeholder": "Type a name or nickname",
  "cafeteria.pos.attribution_anonymous_hint": "Leave blank to record this as an anonymous visitor.",
  "cafeteria.pos.payer_label_label": "Payer name (optional)",
  "cafeteria.pos.payer_label_placeholder": "e.g. walk-up visitor's name",
  "cafeteria.pos.record_thai_qr_button": "Record Thai-QR sale",
  "cafeteria.pos.thai_qr_checkout_success": "Recorded Thai-QR sale of {{total}}",
  "cafeteria.pos.thai_qr_success_title": "Thai-QR sale recorded",
  "cafeteria.pos.thai_qr_success_description": "Total: {{total}}. No wallet was charged.",
  "cafeteria.wallets.title": "Cafeteria Wallets",
  "cafeteria.wallets.subtitle": "Every wallet balance across the school, and the global transaction log.",
  "cafeteria.wallets.total_label": "Total credit held",
  "cafeteria.wallets.accounts_title": "Wallets",
  "cafeteria.wallets.account_count": "{{count}} wallets",
  "cafeteria.wallets.search_placeholder": "Search by name or person ID",
  "cafeteria.wallets.search_aria": "Search wallets",
  "cafeteria.wallets.col_name": "Name",
  "cafeteria.wallets.col_role": "Role",
  "cafeteria.wallets.col_person_id": "Person ID",
  "cafeteria.wallets.col_balance": "Balance",
  "cafeteria.wallets.empty": "No wallets found.",
  "cafeteria.wallets.transactions_title": "Transactions",
  "cafeteria.wallets.filter_all": "All",
  "cafeteria.wallets.filter_topups": "Top-ups",
  "cafeteria.wallets.filter_purchases": "Purchases",
  "cafeteria.wallets.col_user": "User",
  "cafeteria.wallets.col_type": "Type",
  "cafeteria.wallets.col_amount": "Amount",
  "cafeteria.wallets.col_note": "Details",
  "cafeteria.wallets.col_date": "Date",
  "cafeteria.wallets.transactions_empty": "No transactions found.",
  "cafeteria.wallets.type_topup": "Top-up",
  "cafeteria.wallets.type_purchase": "Purchase",
  "cafeteria.wallets.type_adjustment": "Adjustment",
  "cafeteria.wallets.type_refund": "Refund",
  "cafeteria.wallets.type_bonus": "Bonus",
  "cafeteria.reports.title": "Cafeteria Reports",
  "cafeteria.reports.subtitle": "Sales, customers and products for today, this week or this month, set against the period before.",
  "cafeteria.reports.card_net": "Net sales",
  "cafeteria.reports.net_breakdown": "Sales {{sales}} · refunds {{refunds}}",
  "cafeteria.reports.card_refunds": "Refunds",
  "cafeteria.reports.refunds_breakdown": "Wallet {{wallet}} · Thai QR {{thaiQr}}",
  "cafeteria.reports.col_refunds": "Refunds",
  "cafeteria.reports.col_net": "Net",
  "cafeteria.reports.col_refunded_qty": "Refunded",
  "cafeteria.reports.col_net_revenue": "Net revenue",
  "cafeteria.reports.card_wallet": "Wallet",
  "cafeteria.reports.card_thai_qr": "Thai-QR",
  "cafeteria.reports.card_orders": "Orders",
  "cafeteria.reports.card_avg_order": "Avg. order",
  "cafeteria.reports.card_items_sold": "Items sold",
  "cafeteria.reports.trend_vs_prev": "vs previous period",
  "cafeteria.reports.top_seller": "Top seller",
  "cafeteria.reports.split_hint": "Thai-QR is money received in the period; Wallet is pre-paid credit drawn down (already received earlier as a top-up).",
  "cafeteria.reports.period_day": "Day",
  "cafeteria.reports.period_week": "Week",
  "cafeteria.reports.period_month": "Month",
  "cafeteria.reports.from_label": "From",
  "cafeteria.reports.to_label": "To",
  "cafeteria.reports.sales_title": "Sales by period",
  "cafeteria.reports.sales_empty": "No sales in this period.",
  "cafeteria.reports.col_period": "Period",
  "cafeteria.reports.col_total": "Total",
  "cafeteria.reports.col_wallet": "Wallet",
  "cafeteria.reports.col_thai_qr": "Thai-QR",
  "cafeteria.reports.col_orders": "Orders",
  "cafeteria.reports.products_title": "Product breakdown",
  "cafeteria.reports.products_empty": "No product sales in this period.",
  "cafeteria.reports.col_product": "Product",
  "cafeteria.reports.col_qty": "Qty",
  "cafeteria.reports.col_revenue": "Revenue",
  "cafeteria.reports.totals_label": "Totals",
  "cafeteria.reports.preset_label": "Report range",
  "cafeteria.reports.preset_today": "Today",
  "cafeteria.reports.preset_week": "This week",
  "cafeteria.reports.preset_month": "This month",
  "cafeteria.reports.preset_custom": "Custom",
  "cafeteria.reports.export_pdf": "Export PDF",
  "cafeteria.reports.compared_with": "compared with {{range}}",
  "cafeteria.reports.compare_yesterday": "vs yesterday",
  "cafeteria.reports.compare_last_week": "vs last week",
  "cafeteria.reports.compare_last_month": "vs last month",
  "cafeteria.reports.compare_previous_day": "vs the day before",
  "cafeteria.reports.compare_previous_days": "vs previous {{count}} days",
  "cafeteria.reports.legend_yesterday": "Yesterday",
  "cafeteria.reports.legend_last_week": "Last week",
  "cafeteria.reports.legend_last_month": "Last month",
  "cafeteria.reports.legend_this_period": "This period",
  "cafeteria.reports.legend_previous_period": "Previous period",
  "cafeteria.reports.row_sales": "Sales",
  "cafeteria.reports.card_items_per_order": "Items per order",
  "cafeteria.reports.items_sold_hint": "{{count}} items sold",
  "cafeteria.reports.card_customers": "Customers",
  "cafeteria.reports.customers_hint": "{{count}} orders without a wallet",
  "cafeteria.reports.refund_rate_hint": "{{rate}} of sales · {{count}} orders",
  "cafeteria.reports.card_top_ups": "Wallet top-ups",
  "cafeteria.reports.top_ups_hint": "{{count}} top-ups recorded",
  "cafeteria.reports.payment_mix_title": "Payment mix",
  "cafeteria.reports.payment_mix_subtitle": "Net sales by how they were paid",
  "cafeteria.reports.orders_count": "{{count}} orders",
  "cafeteria.reports.customers_title": "Who buys",
  "cafeteria.reports.customers_subtitle": "Net sales by who the wallet belongs to",
  "cafeteria.reports.customer_student": "Students",
  "cafeteria.reports.customer_staff": "Staff",
  "cafeteria.reports.customer_parent": "Parents",
  "cafeteria.reports.customer_anonymous": "Unattributed",
  "cafeteria.reports.hours_title": "Busiest hours",
  "cafeteria.reports.hours_subtitle": "Net sales by hour of the day",
  "cafeteria.reports.hours_peak": "Peak at {{hour}} with {{amount}}",
  "cafeteria.reports.weekday_title": "Day of the week",
  "cafeteria.reports.weekday_subtitle": "Average net sales per day, Monday to Sunday",
  "cafeteria.reports.weekday_per_day": "Per day",
  "cafeteria.reports.top_products_title": "Top products",
  "cafeteria.reports.top_products_subtitle": "By net revenue, with each product's share of net sales",
  "cafeteria.reports.product_sold": "{{count}} sold",
  "cafeteria.reports.grades_title": "Sales by grade",
  "cafeteria.reports.grades_subtitle": "Student wallet purchases by the grade the child is in now",
  "cafeteria.reports.grade_orders": "{{orders}} orders · {{students}} students",
  "cafeteria.reports.col_share": "Share",
  "cafeteria.reports.chart_empty": "Nothing to show for this range.",
  "cafeteria.reports.no_data_title": "Nothing sold in this range",
  "cafeteria.reports.no_data_description": "Sales appear here as the till records them. Pick another range or come back later.",
  "cafeteria.reports.print_title": "Cafeteria sales report",
  "cafeteria.reports.print_period": "Period",
  "cafeteria.reports.print_compared": "Compared with",
  "cafeteria.reports.print_generated": "Generated {{date}}",
  "cafeteria.reports.print_orders": "{{count}} orders",
  "cafeteria.below_zero": "Below zero",
  "cafeteria.pos.balance_after_label": "Balance after this sale",
  "cafeteria.pos.over_limit": "This would take the wallet below {{limit}}. Please top up first.",
  "cafeteria.pos.overdraft_hint": "Can be charged down to {{limit}}.",
  "cafeteria.pos.unit_price": "{{price}} each",
  "cafeteria.pos.decrease_item": "One less {{name}}",
  "cafeteria.pos.increase_item": "One more {{name}}",
  "cafeteria.pos.remove_item": "Remove {{name}}",
  "cafeteria.wallets.account_filter_label": "Filter accounts",
  "cafeteria.settings.overdraft_title": "Overdraft limit",
  "cafeteria.settings.overdraft_description": "How far below zero a wallet may go at the till. When a wallet drops below ฿0, the parents (or the staff member) are emailed to top up, then reminded every 3 days.",
  "cafeteria.settings.overdraft_label": "Overdraft limit (baht)",
  "cafeteria.settings.overdraft_zero_hint": "Set 0 to never let a wallet go below ฿0.",
  "cafeteria.settings.overdraft_none": "Never below ฿0",
  "cafeteria.settings.overdraft_edit": "Change",
  "cafeteria.settings.overdraft_saved": "Overdraft limit saved",
  "cafeteria.settings.overdraft_save_failed": "Could not save the overdraft limit",
  "cafeteria.settings.overdraft_required": "Enter an amount in baht",
  "cafeteria.settings.overdraft_whole": "Use a whole number of baht",
  "cafeteria.settings.overdraft_min": "The limit cannot be negative",
  "cafeteria.settings.overdraft_max": "The limit can be at most {{max}}",
  "integration.subtitle": "Door-access devices, the entry bell, the agent API key, machine translation and RisAI.",
  "integration.tab_devices": "Devices",
  "integration.tab_bell": "Bell & Schedule",
  "integration.tab_agent": "Agent",
  "integration.tab_translation": "Translation",
  "integration.translation_title": "Machine translation",
  "integration.translation_description": "Lets the communications composer translate a message from English into Thai or Chinese using Google Cloud Translate. There is no other provider to choose.",
  "integration.translation_status_configured": "Configured",
  "integration.translation_status_not_configured": "Not configured",
  "integration.translation_key_stored": "A key is stored.",
  "integration.translation_key_not_stored": "No key is stored.",
  "integration.translation_last_updated": "Last updated",
  "integration.translation_api_key_label": "Google Cloud Translate API key",
  "integration.translation_key_placeholder_set": "Key stored — paste a new one to replace it",
  "integration.translation_key_placeholder_new": "Paste an API key",
  "integration.translation_clear_button": "Clear key",
  "integration.translation_clear_confirm_title": "Clear the translation API key?",
  "integration.translation_clear_confirm_description": "This also switches translation off. Messages can still be written in Thai and Chinese by hand.",
  "integration.translation_clear_confirm_label": "Clear key",
  "integration.translation_enable_label": "Enable machine translation",
  "integration.translation_toast_key_saved": "API key saved.",
  "integration.translation_toast_key_cleared": "API key cleared.",
  "integration.translation_billing_note": "Google bills per character translated. Pressing translate on a long message costs real money against whichever account owns this key — there is no spending cap here.",
  "integration.tab_risai": "RisAI",
  "integration.risai_title": "RisAI",
  "integration.risai_description": "The school's AI assistant. Names, contact details and identity numbers are replaced by temporary placeholders before anything is sent to OpenAI, and put back in the reply.",
  "integration.risai_status_configured": "Configured",
  "integration.risai_status_not_configured": "Not configured",
  "integration.risai_key_stored": "A key is stored.",
  "integration.risai_key_not_stored": "No key is stored.",
  "integration.risai_last_updated": "Last updated",
  "integration.risai_api_key_label": "OpenAI API key",
  "integration.risai_key_placeholder_set": "Key stored — paste a new one to replace it",
  "integration.risai_key_placeholder_new": "Paste an API key",
  "integration.risai_clear_button": "Clear key",
  "integration.risai_clear_confirm_title": "Clear the OpenAI API key?",
  "integration.risai_clear_confirm_description": "This also switches RisAI off. Nothing that uses it will work until a key is stored again.",
  "integration.risai_clear_confirm_label": "Clear key",
  "integration.risai_enable_label": "Enable RisAI",
  "integration.risai_toast_key_saved": "API key saved.",
  "integration.risai_toast_key_cleared": "API key cleared.",
  "integration.risai_toast_defaults_saved": "Defaults saved.",
  "integration.risai_defaults_title": "Defaults",
  "integration.risai_model_label": "Default model",
  "integration.risai_model_unpriced": "no price on file",
  "integration.risai_model_price": "{{input}} in / {{output}} out per 1M tokens",
  "integration.risai_budget_label": "Monthly budget (USD)",
  "integration.risai_budget_hint": "About {{thb}} THB at {{rate}} THB per USD. Set the same limit on the OpenAI project as a second guard.",
  "integration.risai_month_spend": "This month: {{spend}} USD of {{cap}} USD across {{count}} requests",
  "integration.risai_month_errors_one": "{{count}} call failed this month",
  "integration.risai_month_errors_other": "{{count}} calls failed this month",
  "integration.risai_billing_note": "Billed by OpenAI per token. Calls stop for the rest of the month once the budget is reached.",
  "integration.risai_save_defaults": "Save defaults",
  "integration.risai_error_budget_number": "Enter the budget as a number",
  "integration.risai_inspector_title": "Inspector",
  "integration.risai_inspector_description": "Paste any note or record. Redact only shows exactly what would leave the server and costs nothing. Send runs it through the model and shows the raw and restored replies.",
  "integration.risai_inspector_text_label": "Text",
  "integration.risai_inspector_subjects_label": "Subject IDs (optional, comma-separated)",
  "integration.risai_inspector_redact_button": "Redact only",
  "integration.risai_inspector_send_button": "Send",
  "integration.risai_inspector_found": "People replaced: {{people}} · contact details replaced: {{contacts}}",
  "integration.risai_inspector_panel_redacted": "What left the server",
  "integration.risai_inspector_panel_raw": "Raw reply",
  "integration.risai_inspector_panel_restored": "Restored reply",
  "integration.risai_inspector_panel_usage": "Usage",
  "integration.risai_inspector_usage": "{{model}} · {{input}} in ({{cached}} cached) / {{output}} out · {{cost}} USD",
  "integration.risai_inspector_unmatched_one": "{{count}} placeholder the model invented was left as is",
  "integration.risai_inspector_unmatched_other": "{{count}} placeholders the model invented were left as is",
  "integration.risai_inspector_send_disabled": "Store a key and enable RisAI to send.",
  "integration.doors_title": "Doors",
  "integration.doors_description": "Door-access devices the on-site agent polls for check-in events.",
  "integration.add_device_button": "Add Device",
  "integration.col_ip_address": "IP Address",
  "integration.open_device_web_ui": "Open device web interface",
  "integration.col_port": "Port",
  "integration.col_username": "Username",
  "integration.col_poll_interval": "Poll Interval",
  "integration.poll_interval_minutes": "{{count}} min",
  "integration.doors_empty": "No door devices configured yet.",
  "integration.new_device_title": "New Door Device",
  "integration.edit_device_title": "Edit Door Device",
  "integration.device_name_placeholder": "e.g. Main Gate",
  "integration.field_ip_address": "IP Address",
  "integration.field_port": "Port",
  "integration.field_username": "Username",
  "integration.field_password": "Password",
  "integration.password_placeholder_set": "•••• (set)",
  "integration.password_placeholder_new": "Enter a password",
  "integration.password_hint_edit": "Leave blank to keep the current password.",
  "integration.field_poll_interval": "Poll Interval (minutes)",
  "integration.field_enabled": "Enabled",
  "integration.error_ip_required": "IP address is required.",
  "integration.error_port_invalid": "Enter a valid port (1–65535).",
  "integration.error_username_required": "Username is required.",
  "integration.error_password_required": "Password is required.",
  "integration.error_poll_interval_invalid": "Enter a valid poll interval (1 or more minutes).",
  "integration.delete_device_title": "Delete \"{{name}}\"?",
  "integration.delete_device_description": "The agent will stop polling this device. This cannot be undone.",
  "integration.toast_device_created": "Door device added.",
  "integration.toast_device_updated": "Door device updated.",
  "integration.toast_device_deleted": "Door device deleted.",
  "integration.bell_title": "Bell",
  "integration.bell_description": "Controls the entry bell the agent rings at the configured periods.",
  "integration.field_bell_enabled": "Bell system (master on/off)",
  "integration.field_bell_enabled_help": "Rings the school bell on schedule. Turn off to silence it entirely — e.g. during a school event when the campus is open but no bell is wanted.",
  "integration.field_bell_volume": "Volume (0–100)",
  "integration.field_bell_sound": "Bell sound",
  "integration.bell_sound_preview": "Preview",
  "integration.bell_sound.classic_loop": "Classic loop",
  "integration.bell_sound.electric_ring": "Electric ring",
  "integration.bell_sound.school_1": "School bell 1",
  "integration.bell_sound.school_2": "School bell 2",
  "integration.bell_sound.school_3": "School bell 3",
  "integration.bell_sound.japanese": "Japanese school bell",
  "integration.bell_sound.german": "German high school bell",
  "integration.bell_sound.vintage": "Vintage interior bell",
  "integration.bell_sound.buzzer": "AC buzzer bell",
  "integration.bell_sound.long_ring": "Long ring",
  "integration.bell_sound.chime": "Chime",
  "integration.bell_sound.ris_nat_anthem": "RIS national anthem (short)",
  "integration.bell_sound.ris_song_short": "RIS school song (short)",
  "integration.bell_sound.suspense_bell": "Suspense bell",
  "integration.bell_sound.national_anthem": "Thai national anthem",
  "integration.bell_sound.ris_song_full": "RIS school song (full)",
  "integration.bell_sound.ac_bell": "AC bell",
  "integration.bell_sound.clock_bell_chimes": "Clock bell chimes",
  "integration.error_volume_range": "Volume must be between 0 and 100.",
  "integration.anthem_title": "Day-start anthem",
  "integration.anthem_description": "Plays the school anthem once each morning at a fixed time.",
  "integration.field_anthem_enabled": "Anthem Enabled",
  "integration.field_anthem_time": "Play time",
  "integration.field_anthem_sound": "Anthem sound",
  "integration.last_bell_title": "Special last bell",
  "integration.last_bell_description": "Rings once more with a distinct sound when the last period of the day ends.",
  "integration.field_last_bell_enabled": "Last Bell Enabled",
  "integration.field_last_bell_sound": "Last bell sound",
  "integration.break_warning_title": "Break warning",
  "integration.break_warning_description": "Warns before every break ends, lunch included, by ringing ahead of the next bell.",
  "integration.field_break_warning_enabled": "Break Warning Enabled",
  "integration.field_break_warning_offset": "Warn before break ends (minutes)",
  "integration.field_break_warning_sound": "Break warning sound",
  "integration.error_time_invalid": "Enter a valid time (HH:MM).",
  "integration.error_break_offset_invalid": "Enter a valid warning offset (0–30 minutes).",
  "integration.campus_checkin_title": "Attendance from door swipes",
  "integration.campus_checkin_description": "Controls how check-in and check-out times on the Attendance grid fill in automatically from door-swipe data, and when a first tap counts as late.",
  "integration.field_checkout_eager_hour": "Confirm check-out after",
  "integration.checkout_eager_hour_hint": "Check-out is only confirmed automatically from this time onward, so a morning-only errand is never mistaken for leaving for the day.",
  "integration.field_checkout_quiet_minutes": "Quiet period before check-out (minutes)",
  "integration.checkout_quiet_minutes_hint": "How long someone must go without a door swipe before their last swipe is treated as a confirmed check-out.",
  "integration.field_access_granted_minor_codes": "Access-granted door codes",
  "integration.access_granted_minor_codes_placeholder": "e.g. 1, 38, 75",
  "integration.access_granted_minor_codes_hint": "Comma-separated door event codes that count as a granted (successful) swipe. Denied or unknown-card events are ignored.",
  "integration.field_late_after_staff": "Staff are late after",
  "integration.field_late_after_students": "Students are late after",
  "integration.late_after_hint": "A first tap in this minute or earlier marks the day present; a later first tap marks it late. The office can change either mark afterwards. Whole minutes count, so 07:30:55 is still on time.",
  "integration.late_after_students_hint": "The same rule for students: 08:00:55 is still on time, 08:01 is late.",
  "integration.error_checkout_quiet_minutes_invalid": "Enter a valid quiet period (0–1440 minutes).",
  "integration.error_access_granted_minor_codes_invalid": "Enter door codes as comma-separated numbers (e.g. 1, 38, 75).",
  "integration.toast_settings_saved": "Settings saved.",
  "integration.api_key_title": "API Key",
  "integration.api_key_description": "The key the door/bell agent uses to authenticate with this server.",
  "integration.api_key_none": "No API key has been generated yet.",
  "integration.reveal_button": "Reveal",
  "integration.regenerate_button": "Regenerate",
  "integration.toast_key_copied": "API key copied to clipboard.",
  "integration.error_copy_failed": "Could not copy the API key.",
  "integration.regenerate_confirm_title": "Regenerate the API key?",
  "integration.regenerate_confirm_description": "The agent's current key will stop working immediately — it must be updated with the new key before it can reach this server again.",
  "integration.regenerate_confirm_label": "Regenerate",
  "integration.toast_key_regenerated": "API key regenerated.",
  "integration.agent_status_title": "Agent Status",
  "integration.agent_status_description": "Live status from the on-site agent: last check-in, bell schedule and device activity.",
  "integration.agent_status_no_events": "No events yet",
  "integration.agent_status_never": "Never",
  "integration.agent_status_no_devices": "No door devices configured.",
  "integration.agent_last_seen": "Agent last seen",
  "integration.agent_last_bell": "Last bell",
  "integration.agent_next_bell": "Next bell",
  "integration.agent_devices": "Devices",
  "integration.agent_ip": "Agent IP",
  "integration.agent_version": "Version",
  "integration.agent_access_hint": "Reach the Pi over SSH at one of the IPs above.",
  "integration.open_config_page": "Open config page (:8080)",
  "integration.agent_device_never_polled": "Never polled",
  "integration.agent_device_unreachable": "Unreachable",
  "integration.agent_device_ok": "OK",
  "integration.agent_device_disabled": "Disabled",
  "integration.agent_audio": "Audio device",
  "integration.agent_audio_ok": "OK",
  "integration.agent_audio_unavailable": "Not detected",
  "integration.agent_audio_never_reported": "Never reported",
  "integration.refresh_button": "Refresh",
  "integration.bell_kind_anthem": "Anthem",
  "integration.bell_kind_bell": "Bell",
  "integration.bell_kind_break_warning": "Break warning",
  "integration.bell_kind_last_bell": "Last bell",
  "integration.filter_device": "Device",
  "integration.log_subtitle": "Every check-in event reported by the door-access agent.",
  "integration.unmatched_title": "{{count}} swipes could not be matched to anybody ({{badges}} badges)",
  "integration.unmatched_help": "These people swiped in but no attendance was recorded, because the badge number the door panel sent does not match anyone on file. Register them, or correct the number at the panel.",
  "integration.unmatched_row_meta": "{{count}}x · last seen {{lastSeen}}",
  "integration.unmatched_show_all": "Show {{count}} more",
  "integration.inferred_link": "Inferred",
  "integration.inferred_link_help": "The door panel sent an ID that does not match this person’s ID on file. The name confirmed who it is, but the number should be fixed at the panel.",
  "integration.log_error": "Failed to load the door-access log.",
  "integration.log_empty": "No door-access events found.",
  "integration.log_page_summary": "Page {{page}} of {{totalPages}} ({{total}} events)",
  "integration.col_person": "Person",
  "integration.col_card": "Card",
  "integration.col_door": "Door",
  "integration.col_event_type": "Event Type",
  "integration.person_unknown": "Unknown",
  "integration.filter_person": "Person",
  "integration.person_search_placeholder": "Search name, card, or ID",
  "integration.filter_linked_only": "Linked users only",
  "integration.filter_user": "User",
  "integration.user_picker_placeholder": "Select a user",
  "integration.user_search_placeholder": "Search by name or email",
  "integration.user_search_hint": "Type at least 2 characters",
  "integration.user_search_no_results": "No matching users",
  "integration.user_picker_clear": "Clear selected user",
  "shop.title": "School Shop",
  "shop.subtitle": "Manage shop categories, products, and variants.",
  "shop.add": "Add Product",
  "shop.empty": "No products yet. Add a category, then a product.",
  "shop.col_product": "Product",
  "shop.col_variant": "Variant",
  "shop.col_price": "Price",
  "shop.col_sku": "SKU",
  "shop.col_stock": "Stock",
  "shop.col_min_qty": "Min. qty",
  "shop.col_avg_cost": "Avg. cost",
  "shop.active": "Active",
  "shop.inactive": "Inactive",
  "shop.delete_title": "Delete Product",
  "shop.delete_description": "Are you sure you want to delete this product? This action cannot be undone.",
  "shop.edit_product": "Edit Product",
  "shop.price_label": "Price (฿)",
  "shop.product_image": "Product image",
  "shop.select_category": "Select a category",
  "shop.no_categories": "No categories yet.",
  "shop.new_category_label": "New category",
  "shop.new_category_placeholder": "e.g. Stationery",
  "shop.category_already_exists": "A category with this name already exists.",
  "shop.delete_category_failed": "Failed to delete category. Please try again.",
  "shop.category_name_label": "Category name",
  "shop.edit_category": "Edit category",
  "shop.delete_product_failed": "Failed to delete product. Please try again.",
  "shop.add_variant": "Add Variant",
  "shop.edit_variant": "Edit Variant",
  "shop.variant_label": "Variant label",
  "shop.no_variants": "No variants yet. Add one below.",
  "shop.delete_variant_title": "Delete Variant",
  "shop.delete_variant_description": "Are you sure you want to delete this variant? This action cannot be undone.",
  "shop.delete_variant_failed": "Failed to delete variant. Please try again.",
  "shop.add_size_run": "Add Size Run",
  "shop.size_run_description": "Create several size variants at once, all at the same price.",
  "shop.size_labels_label": "Size labels",
  "shop.size_labels_placeholder": "One per line or comma-separated, e.g. S, M, L, XL",
  "shop.size_run_empty_labels": "Enter at least one size label",
  "shop.size_run_success": "{{count}} variant(s) created",
  "shop.size_run_failed": "{{count}} variant(s) failed to create",
  "shop.payment_status_paid": "Paid",
  "shop.payment_status_credit": "Credit",
  "shop.pos.title": "Shop Till",
  "shop.pos.subtitle": "Tap products to build the order, then record the sale.",
  "shop.pos.cart_title": "Cart",
  "shop.pos.cart_empty": "Cart is empty. Tap a product to add it.",
  "shop.pos.total_label": "Total",
  "shop.pos.charge_button": "Record sale",
  "shop.pos.clear_cart": "Clear cart",
  "shop.pos.no_products": "No products available.",
  "shop.pos.checkout_success": "Sale recorded — total {{total}}",
  "shop.pos.checkout_failed": "Failed to record sale",
  "shop.pos.out_of_stock": "Out of stock",
  "shop.pos.pick_variant_description": "Choose a size and quantity.",
  "shop.pos.stock_available": "{{count}} in stock",
  "shop.pos.add_to_cart": "Add to cart",
  "shop.pos.buyer_type_label": "Buyer type",
  "shop.pos.buyer_type_student": "Student",
  "shop.pos.buyer_type_staff": "Staff",
  "shop.pos.buyer_type_parent": "Parent",
  "shop.pos.buyer_type_visitor": "Visitor",
  "shop.pos.buyer_name_label": "Buyer name",
  "shop.pos.buyer_name_placeholder": "e.g. walk-up visitor's name",
  "shop.pos.buyer_search_label": "Search by name or nickname",
  "shop.pos.buyer_search_placeholder": "Type a name or nickname",
  "shop.pos.buyer_search_hint": "Type at least 2 characters",
  "shop.pos.buyer_no_results": "No matching people",
  "shop.pos.payment_status_label": "Payment status",
  "shop.pos.confirm_title": "Confirm sale",
  "shop.pos.confirm_description": "Choose the buyer and payment status, then confirm.",
  "shop.pos.confirm_charge_button": "Confirm & record sale",
  "shop.pos.recording": "Recording…",
  "shop.pos.sale_success_title": "Sale recorded",
  "shop.pos.sale_success_description": "Total {{total}} · Gross profit {{grossProfit}}",
  "shop.pos.done_button": "Done",
  "shop.inventory.title": "Shop Inventory",
  "shop.inventory.subtitle": "Stock on hand, minimum levels, and inventory value.",
  "shop.inventory.col_status": "Status",
  "shop.inventory.col_value": "Inventory value",
  "shop.inventory.status_ok": "OK",
  "shop.inventory.status_low": "Low",
  "shop.inventory.status_out": "Out of stock",
  "shop.inventory.receive_stock": "Receive stock",
  "shop.inventory.adjust_stock": "Adjust",
  "shop.inventory.qty_label": "Quantity",
  "shop.inventory.unit_cost_label": "Unit cost (฿)",
  "shop.inventory.note_label": "Note",
  "shop.inventory.receive_button": "Receive",
  "shop.inventory.adjust_button": "Adjust",
  "shop.inventory.receive_success": "Stock received",
  "shop.inventory.receive_failed": "Failed to receive stock",
  "shop.inventory.adjust_success": "Stock adjusted",
  "shop.inventory.adjust_failed": "Failed to adjust stock",
  "shop.inventory.movements_title": "Stock movements",
  "shop.inventory.movements_empty": "No stock movements yet.",
  "shop.inventory.summary_total_value": "Total inventory value",
  "shop.inventory.summary_out_of_stock": "Out of stock",
  "shop.inventory.summary_low_stock": "Low stock",
  "shop.inventory.select_variant_label": "Variant",
  "shop.inventory.select_variant_placeholder": "Select a variant",
  "shop.inventory.variant_required": "Please select a variant",
  "shop.inventory.qty_required": "Quantity is required",
  "shop.inventory.qty_positive": "Quantity must be greater than 0",
  "shop.inventory.qty_nonzero": "Quantity cannot be zero",
  "shop.inventory.unit_cost_required": "Unit cost is required",
  "shop.inventory.unit_cost_negative": "Unit cost cannot be negative",
  "shop.inventory.history_button": "History",
  "shop.inventory.movements_col_type": "Type",
  "shop.inventory.movements_col_qty": "Quantity",
  "shop.inventory.movements_col_unit_cost": "Unit cost",
  "shop.inventory.movements_col_note": "Note",
  "shop.inventory.movements_col_date": "Date",
  "shop.inventory.movement_type_stock_in": "Stock received",
  "shop.inventory.movement_type_sale": "Sale",
  "shop.inventory.movement_type_adjustment": "Adjustment",
  "shop.reports.title": "Shop Reports",
  "shop.reports.subtitle": "Sales, profit, and outstanding credit overview.",
  "shop.reports.monthly_title": "Monthly sales",
  "shop.reports.yearly_title": "Yearly sales",
  "shop.reports.top_sellers_title": "Top sellers",
  "shop.reports.debtors_title": "Outstanding credit",
  "shop.reports.col_month": "Month",
  "shop.reports.col_year": "Year",
  "shop.reports.col_total_amount": "Total sales",
  "shop.reports.col_total_cost": "Total cost",
  "shop.reports.col_gross_profit": "Gross profit",
  "shop.reports.col_qty_sold": "Qty sold",
  "shop.reports.col_revenue": "Revenue",
  "shop.reports.col_buyer": "Buyer",
  "shop.reports.col_outstanding": "Outstanding",
  "shop.reports.target_label": "Target",
  "shop.reports.set_target": "Set target",
  "shop.reports.target_amount_label": "Target amount (฿)",
  "shop.reports.settle_button": "Settle",
  "shop.reports.settle_success": "Sale settled",
  "shop.reports.settle_failed": "Failed to settle sale",
  "shop.reports.debtors_empty": "No outstanding credit.",
  "shop.reports.from_label": "From",
  "shop.reports.to_label": "To",
  "shop.reports.tab_monthly": "Monthly",
  "shop.reports.tab_yearly": "Yearly",
  "shop.reports.tab_top_sellers": "Top sellers",
  "shop.reports.tab_debtors": "Debtors",
  "shop.reports.year_label": "Year",
  "shop.reports.legend_actual": "Actual",
  "shop.reports.target_updated": "Target updated",
  "shop.reports.target_update_failed": "Failed to update target",
  "shop.reports.target_invalid": "Enter a valid target amount",
  "shop.reports.col_open_sales": "Open sales",
  "shop.reports.total_outstanding": "Total outstanding",
  "shop.reports.settle_confirm_title": "Settle sale",
  "shop.reports.settle_confirm_description": "Mark this credit sale as paid? This cannot be undone.",
  "shop.reports.top_sellers_empty": "No sales in this period.",
  "shop.reports.yearly_empty": "No sales yet.",
  "shop.reports.col_amount": "Amount",
  "shop.reports.col_sale_id": "Sale",
  "nav.allergy_change_requests": "Allergy Change Requests",
  "allergy_changes.title": "Allergy & Dietary Change Requests",
  "allergy_changes.subtitle": "Review allergy and dietary changes proposed by parents before they are applied to a student's record.",
  "allergy_changes.search_aria": "Search allergy change requests by student name",
  "allergy_changes.empty": "No allergy change requests match these filters.",
  "allergy_changes.col_submitted_at": "Submitted",
  "allergy_changes.col_document": "Document",
  "allergy_changes.document_attached_badge": "Document attached",
  "allergy_changes.document_required_badge": "Document required",
  "allergy_changes.review_action": "Review",
  "allergy_changes.no_allergies": "No allergies recorded.",
  "allergy_changes.no_dietary_note": "No dietary note.",
  "allergy_changes.review_title": "Review allergy change request",
  "allergy_changes.review_description": "Compare the current record with the change proposed for {{name}}. You can edit the values before approving.",
  "allergy_changes.current_label": "Current record",
  "allergy_changes.view_document": "View supporting document",
  "allergy_changes.proposed_label": "Proposed change",
  "allergy_changes.toast_approved": "Allergy change approved",
  "allergy_changes.toast_rejected": "Allergy change rejected",
  "presence.help_note": "Shows who currently has the admin app open. An idle open tab still counts as online, so this is not an attendance or timesheet record — it just answers whether someone is around right now.",
  "presence.title": "Online now",
  "presence.empty": "Nobody is connected right now",
  "presence.connected_since": "Connected {{duration}}",
  "presence.count_label": "online",
  "presence.online": "Online",
  "presence.offline": "Offline",
  "nav.my_profile": "My profile",
  "dashboard.widget.bell_remaining": "{{count}} more today, last at {{last}}",
  "nav.bell_schedule": "Bell schedule",
  "bell_schedule.subtitle": "Every bell the school will ring on a given day.",
  "bell_schedule.help_note": "Exactly what the bell controller will play, taken from the same schedule it reads. Step through days to check a variant or a short-period day before it happens.",
  "bell_schedule.previous_day": "Previous day",
  "bell_schedule.next_day": "Next day",
  "bell_schedule.today": "Today",
  "bell_schedule.next": "Next",
  "bell_schedule.regular_schedule": "Regular schedule",
  "bell_schedule.ring_count": "{{count}} rings",
  "bell_schedule.starts_group": "{{first}} · {{second}} (second lunch group)",
  "bell_schedule.kind_bell": "Period bell",
  "bell_schedule.kind_anthem": "Anthem",
  "bell_schedule.kind_break_warning": "Break warning",
  "bell_schedule.kind_last_bell": "Last bell",
  "bell_schedule.bells_off_warning": "Bells are switched off in Bell settings, so nothing will actually ring on this day.",
  "bell_schedule.empty_title": "No bells on {{date}}",
  "bell_schedule.empty_disabled": "Bells are switched off in Bell settings.",
  "bell_schedule.empty_no_active_year": "This date is outside the active school year.",
  "bell_schedule.empty_not_school_day": "This is not a school day.",
  "bell_schedule.empty_no_schedule": "No periods are scheduled for this day.",
  "bookings.grid_title": "Pick a period and room",
  "bookings.grid_legend": "Green cells are free — click one to select that period and room. Greyed cells show the class or person already using the room.",
  "bookings.grid_pick_date": "Choose a date to see what is free.",
  "bookings.grid_load_error": "Could not load availability for this date.",
  "bookings.grid_empty": "No bookable rooms or periods for this date.",
  "bookings.error_grid_pick_required": "Pick a free period and room from the grid.",
  "bookings.horizon_hint": "Up to {{days}} days ahead.",
  "settings.label.bookings_max_advance_days": "Booking window (days)",
  "settings.desc.bookings_max_advance_days": "How far ahead staff may book a room or tablets. Set to 0 for no limit.",
  "settings.label.newsletter_batch_size": "Newsletter batch size",
  "settings.desc.newsletter_batch_size": "Recipients per outgoing message. Capped at 100 regardless of this value (Gmail's SMTP limit).",
  "settings.label.newsletter_batch_delay_ms": "Newsletter inter-batch delay (ms)",
  "settings.desc.newsletter_batch_delay_ms": "Pause between batches while sending a newsletter issue.",
  "settings.label.newsletter_daily_allowance": "Newsletter daily recipient allowance",
  "settings.desc.newsletter_daily_allowance": "A send is refused before anything goes out if the recipient count exceeds this number.",
  "bookings.tablets_free_of_total": "{{remaining}} of {{total}} free",
  "bookings.tablets_all_out": "None left",
  "bookings.tablets_none_in_pool": "No tablets are registered in the pool yet.",
  "bookings.tablets_legend": "Showing blocks with at least {{wanted}} tablet(s) free. Change the quantity to see more.",
  "dashboard.widget.bookings_today_count_label": "today",
  "dashboard.widget.bookings_none_today": "No bookings today",
  "dashboard.widget.bookings_next_up": "Next up",
  "dashboard.widget.upcoming_bookings": "Room & tablet bookings",
  "dashboard.widget.upcoming_bookings_empty": "Nothing booked yet.",
  "dashboard.widget.bookings_tablets": "{{count}} tablets",
  "dashboard.widget.bookings_room": "Room",
  "settings.label.booking_recipients": "Booking notifications",
  "settings.desc.booking_recipients": "Who receives an email each time a room or tablets are booked.",
  "realtime.live": "Live",
  "realtime.reconnecting": "Reconnecting",
  "realtime.live_hint": "Connected — pages update as things change.",
  "realtime.offline_hint": "Not connected. Pages will update again once the connection returns.",
  "signature.title": "Email signature",
  "signature.help_note": "Fill in your details, copy the signature, then paste it into Gmail under Settings → General → Signature. Your details are not saved — the signature is built here and copied straight to your clipboard.",
  "signature.field_prefix": "Prefix",
  "signature.prefix_placeholder": "Dr",
  "signature.field_name": "Name",
  "signature.name_hint": "Managed by the school. Contact an administrator to change it. Add a prefix such as Dr if you use one.",
  "signature.field_title": "Job title",
  "signature.field_title_extra": "Job title (line {{n}})",
  "signature.title_placeholder": "Head of Mathematics",
  "signature.field_phone": "Phone",
  "signature.phone_hint": "Optional. Leave blank to omit the line entirely.",
  "signature.preview": "Preview",
  "signature.copy": "Copy signature",
  "signature.copied": "Signature copied — paste it into Gmail.",
  "signature.copied_html": "Signature HTML copied.",
  "signature.copy_failed": "Could not copy. Select the preview and copy it by hand.",
  "signature.field_title_line": "Job title line {{n}}",
  "signature.title_placeholder_extra": "Another title, e.g. Athletic Director",
  "signature.title_hint": "One line per title. Add a line for each role you hold; leave a line blank and it is left out.",
  "signature.add_title": "Add another title",
  "signature.remove_title": "Remove this title",
  "signature.howto_title": "Adding it to Gmail",
  "signature.subtitle": "Build your school email signature and paste it into Gmail.",
  "signature.client_gmail": "Gmail",
  "signature.client_outlook": "Outlook",
  "signature.client_apple": "Apple Mail",
  "signature.howto_gmail_1": "Click Copy signature above.",
  "signature.howto_gmail_2": "In Gmail, open Settings (the gear icon) → See all settings → General.",
  "signature.howto_gmail_3": "Scroll to Signature, then click Create new and give it a name — or pick the one you already use.",
  "signature.howto_gmail_4": "Click inside the signature box and paste (Ctrl+V, or Cmd+V on a Mac). The crest and layout come across with it.",
  "signature.howto_gmail_5": "Under Signature defaults, set it for new emails and for replies, then click Save changes at the bottom.",
  "signature.howto_gmail_note": "Paste on a computer — the Gmail mobile app cannot paste a formatted signature, but it uses the one saved here.",
  "signature.howto_outlook_1": "Click Copy signature above.",
  "signature.howto_outlook_2": "In Outlook on the web or new Outlook, open Settings (the gear icon) → Mail → Compose and reply.",
  "signature.howto_outlook_3": "Under Email signature, click New signature and give it a name.",
  "signature.howto_outlook_4": "Click inside the box and paste (Ctrl+V, or Cmd+V on a Mac).",
  "signature.howto_outlook_5": "Choose it for new messages and for replies and forwards, then click Save.",
  "signature.howto_outlook_note": "In classic Outlook for Windows the path is File → Options → Mail → Signatures instead; paste into the Edit signature box there.",
  "signature.howto_apple_1": "Click Copy signature above.",
  "signature.howto_apple_2": "In Mail, open Mail → Settings (Preferences on older macOS) → Signatures.",
  "signature.howto_apple_3": "Select your school account in the left column, then click + and name the signature.",
  "signature.howto_apple_4": "Untick “Always match my default message font”, click into the right-hand pane and paste (Cmd+V).",
  "signature.howto_apple_5": "Close Settings, then set it under Choose Signature for that account.",
  "signature.howto_apple_note": "Set it on a Mac — Mail on iPhone and iPad only keeps plain-text signatures.",
  "profile.tab_profile": "Profile",
  "profile.tab_public": "Website public profile",
  "profile.tab_signature": "Email signature",
  "profile.wallet_section": "Cafeteria wallet",
  "profile.wallet_balance_label": "current balance",
  "profile.wallet_empty": "No transactions yet.",
  "profile.notification_emails_title": "Notifications",
  "profile.notification_emails_label": "Email me notifications",
  "profile.notification_emails_hint": "Everything still arrives under the bell either way — switching this off stops only the emails. Account emails such as password resets are unaffected.",
  "nav.section.my_work": "My work",
  "nav.my_work.classes_today": "Classes & diary",
  "nav.my_work.newsletter": "Newsletter",
  "nav.my_work.bookings": "Bookings",
  "nav.my_work.leaves": "Leaves",
  "nav.my_work.it_tickets": "IT tickets",
  "nav.my_work.sst": "SST",
  "nav.section.attendance": "Attendance",
  "nav.section.people": "People",
  "dashboard.updated_ago": "Updated {{ago}}",
  "attendance.per_period_off_notice": "{{class}} takes attendance once a day, so there is nothing to mark per period. Turn on “Per-period attendance” for this class in Timetable → Setup → Classes to use this page.",
  "enum.tour_status.replied": "Replied",
  "credential_export.preparing": "Preparing…",
  "lesson_excusals.title": "Lesson excusals",
  "lesson_excusals.dialog_title": "Record lesson excusal",
  "lesson_excusals.record_button": "Record excusal",
  "lesson_excusals.day_label": "Day",
  "lesson_excusals.choose_lesson": "Choose a lesson",
  "lesson_excusals.no_lessons": "No excusable lessons on that day.",
  "lesson_excusals.lesson_required": "Choose the lesson.",
  "lesson_excusals.below_threshold": "already below the presence threshold in {{subject}}",
  "lesson_excusals.current_attendance": "presence in {{subject}}",
  "lesson_excusals.toast_recorded": "Lesson excusal recorded",
  "lesson_excusals.record_failed": "Failed to record lesson excusal",
  "dashboard.widget.out_today_label": "out today",
  "dashboard.widget.movements_today_label": "today",
  "attendance.leaves_at": "Leaves {{time}}",
  "teacher_day.nobody_out": "No one is out or leaving early on this day.",
  "teacher_day.students_out": "Students out",
  "teacher_day.leaves_at": "Leaves {{time}}",
  "teacher_day.misses_lesson": "Misses {{subject}} · {{period}}",
  "teacher_day.your_homeroom": "Your homeroom",
  "teacher_day.staff_out": "Staff out",
  "lesson_excusals.subtitle": "Lessons families have excused their child from, and ones recorded on their behalf.",
  "lesson_excusals.tab_full_day": "Full-day",
  "lesson_excusals.tab_lessons": "Lessons",
  "lesson_excusals.delete_title": "Delete this lesson excusal?",
  "lesson_excusals.delete_description": "The lesson goes back to having no attendance mark, and the family is not told. If a teacher had marked the student before the excusal was recorded, that mark cannot be brought back.",
  "lesson_excusals.tab_switch": "Absence type",
  "lesson_excusals.col_lesson": "Lesson",
  "lesson_excusals.col_attendance": "Attendance",
  "lesson_excusals.rate_at_request": "{{percent}}% when reported",
  "lesson_excusals.type.injury": "Injury",
  "lesson_excusals.type.illness": "Illness",
  "lesson_excusals.type.medical": "Medical",
  "lesson_excusals.type.religious": "Religious",
  "lesson_excusals.type.other": "Other",
  "subjects.parent_excusable": "Parents may request an excusal",
  "attendance.col_subject_rate": "{{subject}} attendance",
  "attendance.col_subject_rate_short": "Attendance",
  "attendance.tab_daily": "Daily",
  "attendance.tab_classes": "By class",
  "attendance.no_grade": "No grade",
  "attendance.tab_subjects": "By subject",
  "attendance.tab_audit": "Audit",
  "attendance.audit_title": "Attendance audit",
  "attendance.audit_subtitle": "Registers nobody finished: children with no attendance for the day, and lessons whose register was never taken or skipped someone.",
  "attendance.audit_view_daily": "Daily register",
  "attendance.audit_view_lessons": "Lesson registers",
  "attendance.audit_daily_empty": "Every child has attendance for every school day in this range.",
  "attendance.audit_lessons_empty": "Every lesson register in this range is complete.",
  "attendance.audit_col_period": "Period",
  "attendance.audit_col_class": "Class",
  "attendance.audit_col_subject": "Subject",
  "attendance.audit_col_teacher": "Teacher",
  "attendance.audit_col_register": "Register",
  "attendance.audit_state_missing": "Not taken",
  "attendance.audit_state_partial": "{{marked}} of {{expected}} marked",
  "attendance.audit_skipped": "Skipped: {{names}}",
  "attendance.audit_all_teachers": "All teachers",
  "attendance.audit_select": "Select",
  "attendance.audit_select_all": "Select all registers shown",
  "attendance.audit_select_register": "Select {{subject}}, {{period}} on {{date}}",
  "attendance.audit_fill_button": "Fill from daily attendance",
  "attendance.audit_fill_selected_one": "{{count}} register selected",
  "attendance.audit_fill_selected_other": "{{count}} registers selected",
  "attendance.audit_fill_title": "Fill registers from daily attendance",
  "attendance.audit_fill_description": "Only children with no mark are filled, from their daily attendance. Marks already on a register are never changed.",
  "attendance.audit_fill_loading": "Checking the registers…",
  "attendance.audit_fill_registers_one": "{{count}} register",
  "attendance.audit_fill_registers_other": "{{count}} registers",
  "attendance.audit_fill_present_one": "{{count}} present",
  "attendance.audit_fill_present_other": "{{count}} present",
  "attendance.audit_fill_late_one": "{{count}} late (arrived during the lesson)",
  "attendance.audit_fill_late_other": "{{count}} late (arrived during the lesson)",
  "attendance.audit_fill_absent_one": "{{count}} absent (arrived after the lesson)",
  "attendance.audit_fill_absent_other": "{{count}} absent (arrived after the lesson)",
  "attendance.audit_fill_excused_one": "{{count}} excused (early dismissal)",
  "attendance.audit_fill_excused_other": "{{count}} excused (early dismissal)",
  "attendance.audit_fill_nothing": "Nothing to fill: every child here already has a mark, or has no daily attendance yet.",
  "attendance.audit_fill_skipped_title": "No daily attendance — left empty",
  "attendance.audit_fill_skipped_hint": "Mark these children in the daily register first, then fill again.",
  "attendance.audit_fill_confirm": "Fill registers",
  "attendance.audit_fill_done_one": "Filled {{count}} register",
  "attendance.audit_fill_done_other": "Filled {{count}} registers",
  "attendance.audit_fill_failed": "Could not fill the registers",
  "attendance.subject_rates_title": "Attendance by Subject",
  "attendance.subject_rates_empty": "No lessons in your classes have been marked yet.",
  "attendance.subject_rates_filter_grade": "Grade",
  "attendance.subject_rates_filter_subject": "Subject",
  "settings.label.lesson_excusal_recipients": "Lesson Excusal Recipients",
  "settings.desc.lesson_excusal_recipients": "Staff emails that receive a notification when a parent submits a lesson excusal request.",
  "edp.approve.grade_levels_required": "Choose at least one grade.",
  "edp.approve.block_required": "Block is required.",
  "edp.approve.category_required": "Category is required.",
  "edp.approve.day_required": "Day is required.",
  "edp.approve.groups_share_a_teacher_slot": "Two groups with the same teacher cannot run in the same slot on the same day.",
  "edp.approve.description": "Confirm the final arrangement for this course. Anything that differs from the proposal is recorded as a modification.",
  "edp.approve.eligible_for_free_places": "Free places may be used",
  "edp.approve.eligible_for_free_places_hint": "Only some courses take free places. A family's credit is worth one base price each, spendable only on courses ticked here — anything left over is lost.",
  "edp.config.registration_closed": "Closed to new requests",
  "edp.config.registration_closed_hint": "Use this when a course is oversubscribed. It stays on the family’s week, marked full and no longer selectable. Every family that already asked for it keeps their request and their place in the queue — this only stops new ones.",
  "edp.schedule_tags.more": "+{{count}} more",
  "edp.approve.external_instructor": "Not a member of staff",
  "edp.approve.external_instructor_hint": "The name families will see. A course taught this way books nobody's afternoon.",
  "edp.approve.external_instructor_label": "Teacher's name",
  "edp.approve.external_instructor_required": "Give the teacher's name.",
  "edp.approve.instructor_required": "Instructor is required.",
  "edp.approve.max_below_min": "Maximum students cannot be less than the minimum.",
  "edp.approve.min_floor": "Minimum students must be at least 4, except for one-on-one classes.",
  "edp.approve.min_required": "Minimum students is required.",
  "edp.approve.number_required": "Enter a number.",
  "edp.approve.preview_none": "No changes from the proposal.",
  "edp.approve.preview_title": "What will change",
  "edp.approve.recorded": "Proposal approved.",
  "edp.approve.submit": "Approve",
  "edp.approve.title": "Approve proposal",
  "edp.approve.title_required": "Title is required.",
  "edp.decision.admin_notes": "Internal notes",
  "edp.decision.admin_notes_hint": "Visible to the office only — never shown to the proposing staff member.",
  "edp.decision.comment": "Comment",
  "edp.decision.comment_hint": "This comment is sent to the proposing staff member.",
  "edp.decision.comment_required": "A comment is required.",
  "edp.decision.recorded": "Decision recorded.",
  "edp.decision.request_changes_title": "Request changes",
  "edp.decision.waitlist_title": "Waitlist proposal",
  "edp.decision.reject_title": "Reject proposal",
  "edp.detail.action_approve": "Approve",
  "edp.detail.action_reject": "Not approve",
  "edp.detail.action_request_changes": "Request changes",
  "edp.detail.action_waitlist": "Waitlist",
  "edp.detail.actions_title": "Decision",
  "edp.detail.admin_notes": "Office notes",
  "edp.detail.approved_as_proposed": "Approved as proposed",
  "edp.detail.approved_with_modification": "Approved with modification",
  "edp.detail.as_submitted": "As submitted",
  "edp.detail.capacity_warning_title": "A maximum of {{max}} exceeds the standard for this grade band",
  "edp.detail.comment_error": "Could not post your comment. Try again.",
  "edp.detail.comment_placeholder": "Write a comment…",
  "edp.detail.comment_send": "Send",
  "edp.detail.conversation": "Conversation",
  "edp.detail.edit_and_resubmit": "Edit and resubmit",
  "edp.detail.field_additional_info": "Additional information",
  "edp.detail.field_additional_students_with_support": "Additional students who need support",
  "edp.detail.field_available_for_two_classes": "Available for two classes",
  "edp.detail.field_block": "Block",
  "edp.detail.field_capacity": "Capacity",
  "edp.detail.field_category": "Category",
  "edp.detail.field_day": "Day",
  "edp.detail.field_days_per_week": "Days per week",
  "edp.detail.field_description": "Description",
  "edp.detail.field_facility_other": "Facility (other)",
  "edp.detail.field_grade_levels": "Grades",
  "edp.detail.field_instructor": "Instructor",
  "edp.detail.field_materials": "Materials and equipment",
  "edp.detail.field_max_students": "Maximum students",
  "edp.detail.field_min_students": "Minimum students",
  "edp.detail.field_objectives": "Objectives",
  "edp.detail.field_outcome": "Course outcome",
  "edp.detail.field_preferred_facilities": "Preferred facilities",
  "edp.detail.field_purchase_details": "Purchase details",
  "edp.detail.field_purchase_required": "Purchase required",
  "edp.detail.field_room": "Room",
  "edp.detail.field_safety_details": "Safety details",
  "edp.detail.field_safety_required": "Safety requirements",
  "edp.detail.field_sessions": "Day & block",
  "edp.detail.field_title": "Title",
  "edp.detail.no_max": "No fixed maximum",
  "edp.detail.resubmit_button": "Resubmit",
  "edp.detail.resubmitted": "Proposal resubmitted.",
  "edp.detail.revision_history": "Revision history",
  "edp.detail.revision_history_toggle": "{{count}} versions",
  "edp.detail.revision_version": "Version {{version}}",
  "edp.detail.room_unassigned": "Unassigned",
  "edp.detail.withdraw_button": "Withdraw",
  "edp.detail.withdraw_confirm_action": "Withdraw proposal",
  "edp.detail.withdraw_confirm_body": "This proposal will be withdrawn and can no longer be approved. This cannot be undone.",
  "edp.detail.withdraw_confirm_title": "Withdraw this proposal?",
  "edp.detail.withdrawn": "Proposal withdrawn.",
  "edp.detail.tri_yes": "Yes",
  "edp.detail.tri_no": "No",
  "edp.detail.tri_maybe": "Maybe",
  "edp.detail.support_yes": "Yes",
  "edp.detail.support_no": "No",
  "edp.detail.support_na": "Not applicable",
  "edp.detail.support_possibly": "Possibly",
  "edp.detail.purchase_no": "No",
  "edp.detail.purchase_yes": "Yes",
  "edp.detail.purchase_possibly": "Possibly",
  "edp.detail.course_config_title": "Pricing & registration",
  "edp.detail.course_config_hint": "Families are only ever shown courses whose status is \"Open for registration\".",
  "edp.detail.course_price": "Price (THB, whole round)",
  "edp.detail.course_price_hint": "What a family pays for every lesson of this course, not a per-lesson rate.",
  "edp.detail.course_price_invalid": "Enter a whole number of 0 or more.",
  "edp.detail.course_status": "Registration status",
  "edp.detail.course_status_locked": "set automatically once seats are given out",
  "edp.detail.course_config_saved": "Course settings saved.",
  "edp.detail.families_will_see_heading": "Families will see this",
  "edp.detail.families_will_see_hint": "Parents choosing a course for their child will read this.",
  "edp.detail.office_only_heading": "For the office",
  "edp.detail.course_title": "Course title",
  "edp.detail.course_title_required": "Enter a course title.",
  "edp.detail.course_description": "Description",
  "edp.detail.course_description_required": "Enter a description.",
  "edp.detail.course_objectives": "Objectives",
  "edp.mine.empty": "You haven't proposed any EDP courses yet.",
  "edp.mine.empty_for_status": "No proposals match this filter.",
  "edp.mine.filter_status": "Status",
  "edp.mine.guide_link": "EDP guide and policy",
  "edp.mine.heading": "My EDP Proposals",
  "edp.mine.propose": "Propose a course",
  "edp.mine.subtitle": "Your submitted, in-review and decided EDP course proposals.",
  "edp.propose.add_another": "Add another course",
  "edp.propose.additional_info": "Additional information",
  "edp.propose.additional_students_with_support": "Can this course take additional students who need support?",
  "edp.propose.category": "Category",
  "edp.propose.confirm_accept": "I have read and accept all of the above.",
  "edp.propose.confirmation": "Confirmation",
  "edp.propose.course_n": "Course {{n}}",
  "edp.propose.description": "Description",
  "edp.propose.facility_other": "Describe the facility",
  "edp.propose.grade_levels": "Grades",
  "edp.propose.grade_levels_hint": "Tick every grade this course is open to. They do not have to be next to each other.",
  "edp.propose.one_on_one": "One-on-one or private course",
  "edp.propose.one_on_one_hint": "Taught individually rather than as a group, so the four-student minimum does not apply. Still choose the grades it is open to.",
  "edp.propose.heading": "Propose an EDP Course",
  "edp.propose.back_to_guide": "← EDP guide and policy",
  "edp.propose.identity_from_account": "Your name and role are taken from your account — no need to re-enter them.",
  "edp.propose.materials": "Materials and equipment",
  "edp.propose.max_hint": "Leave blank for no fixed maximum.",
  "edp.propose.max_students": "Maximum students",
  "edp.propose.maybe": "Maybe",
  "edp.propose.min_students": "Minimum students",
  "edp.propose.no_open_round": "There is no open proposal round right now. Check back once the office opens one.",
  "edp.propose.not_applicable": "Not applicable",
  "edp.propose.objectives": "Objectives",
  "edp.propose.outcome": "Course outcome",
  "edp.propose.position_department": "Position / Department",
  "edp.propose.possibly": "Possibly",
  "edp.propose.preferred_facilities": "Preferred facilities",
  "edp.propose.purchase_details": "Purchase details",
  "edp.propose.purchase_required": "Does this course require a purchase?",
  "edp.propose.round_window": "{{round}} · proposals close {{closes}}",
  "edp.propose.safety_details": "Safety details",
  "edp.propose.safety_required": "Does this course have specific safety requirements?",
  "edp.propose.submit": "Submit proposal",
  "edp.propose.submitted": "{{count}} course(s) submitted for review.",
  "edp.guide.eyebrow": "After-school co-curricular & extra-curricular program",
  "edp.guide.heading": "Everything you need for EDP, in one place",
  "edp.guide.intro": "EDP runs two 50-minute blocks after school, five grade bands, and a mix of academic and extra-curricular courses — all proposed by our own staff. This page explains how to propose a course, what is expected, and what happens after you submit.",
  "edp.guide.chip_block1": "15:40–16:30 · Block 1",
  "edp.guide.chip_transition": "16:30–16:40 · Transition",
  "edp.guide.chip_block2": "16:40–17:30 · Block 2",
  "edp.guide.chip_minimum": "4 students minimum to run",
  "edp.guide.chip_bands": "5 grade bands",
  "edp.guide.how_heading": "How to offer an EDP course",
  "edp.guide.step_design": "Design one course",
  "edp.guide.step_design_body": "Pick a grade band, a category (co-curricular or extra-curricular), and a 50-minute format that fits Block 1 or Block 2.",
  "edp.guide.step_propose": "Propose one or several",
  "edp.guide.step_propose_body": "Your name and role come from your account. Add as many courses as you would like to offer in the same submission — each one is reviewed on its own.",
  "edp.guide.step_review": "The office reviews it",
  "edp.guide.step_review_body": "Proposals are weighed against grade-band coverage, program balance, staffing, facilities, safety and expected enrolment.",
  "edp.guide.step_decision": "You get a decision",
  "edp.guide.step_decision_body": "The office approves it as proposed, approves it with changes, waitlists it, or does not approve it this round. The decision appears on your proposal, with a note of anything that changed from what you asked for.",
  "edp.guide.facts_heading": "Before you propose",
  "edp.guide.fact_load_label": "Load",
  "edp.guide.fact_load": "Max 2 classes per day",
  "edp.guide.fact_load_body": "One per block at most, subject to scheduling.",
  "edp.guide.fact_minimum_label": "Minimum",
  "edp.guide.fact_minimum": "4 students to run",
  "edp.guide.fact_minimum_body": "Except approved one-on-one or private arrangements.",
  "edp.guide.fact_format_label": "Format",
  "edp.guide.fact_format": "50 minutes, one block",
  "edp.guide.fact_format_body": "A course should not span continuously across both blocks.",
  "edp.guide.fact_compensation_label": "Compensation",
  "edp.guide.fact_compensation": "Handled by HR",
  "edp.guide.fact_compensation_body": "Separately from the proposal, per your employment arrangement.",
  "edp.guide.band_col": "Grade band",
  "edp.guide.band_max_col": "Standard max, one instructor",
  "edp.guide.band_no_max": "No fixed maximum",
  "edp.guide.band_footnote": "For Grades 4–9 there is no fixed number, but enrolment is still bounded by the activity, the room, equipment, safety and supervision. The office may set a lower maximum, or approve a larger class where extra staff are assigned.",
  "edp.guide.submit_heading": "Submit a course proposal",
  "edp.guide.submit_body": "You can propose several courses in one go. Submitting does not guarantee a course runs: the office builds the final schedule around grade-band coverage, variety, staffing and safety.",
  "edp.guide.submit_cta": "Propose a course",
  "edp.guide.submit_window": "{{round}} · proposals close {{closes}}",
  "edp.guide.submit_closed": "Proposals are not open at the moment. The office will open the next round before the term is scheduled.",
  "edp.guide.faq_heading": "Frequently asked questions",
  "edp.guide.faq_multiple_courses": "Can I propose more than one course?",
  "edp.guide.faq_multiple_courses_a": "Yes — add as many courses as you like in a single submission. Your staff details are entered once. Each course is recorded and reviewed independently, so the office can approve one, modify another, and decline a third.",
  "edp.guide.faq_two_classes": "Can I teach two EDP classes in one day?",
  "edp.guide.faq_two_classes_a": "Yes, up to two — one in Block 1 and one in Block 2 — subject to scheduling and approval. Treat them as two separate offerings rather than one continuous course.",
  "edp.guide.faq_who_decides": "Who decides the final room, day and block?",
  "edp.guide.faq_who_decides_a": "You propose preferences; the office confirms the final day, block, room and grade band based on overall scheduling needs. Anything that changed from your proposal is listed on it.",
  "edp.guide.faq_equipment": "What if my course needs to purchase equipment?",
  "edp.guide.faq_equipment_a": "Note it on the proposal with an estimated cost. All purchases need school approval before any commitment is made.",
  "edp.guide.faq_safety": "My course involves swimming, cooking or tools — what do I need to flag?",
  "edp.guide.faq_safety_a": "Describe any extra safety or supervision needs on the proposal — water safety, food preparation, specialised tools, outdoor activity — so the office can plan appropriate staffing.",
  "edp.guide.policy_heading": "The full policy",
  "edp.guide.policy_english_only": "The EDP Staff Policy & Procedures is maintained by the school in English and reproduced here in full.",
  "edp.propose.title": "Course title",
  "edp.propose.families_will_see_heading": "Families will see this",
  "edp.propose.families_will_see_hint": "Parents choosing a course for their child will read this.",
  "edp.propose.office_only_heading": "For the office",
  "edp.propose.days_per_week_d1": "1 day",
  "edp.propose.days_per_week_d2": "2 days",
  "edp.propose.days_per_week_d3": "3 days",
  "edp.propose.days_per_week_d4": "4 days",
  "edp.propose.days_per_week_d5": "5 days",
  "edp.propose.days_per_week_flexible": "Flexible",
  "edp.queue.col_band": "Grade band",
  "edp.queue.col_capacity": "Capacity",
  "edp.queue.col_category": "Category",
  "edp.queue.col_proposer": "Proposer",
  "edp.queue.col_reference": "Reference",
  "edp.queue.col_status": "Status",
  "edp.queue.col_title": "Title",
  "edp.queue.empty": "No proposals match these filters.",
  "edp.queue.filter_grade": "Grade",
  "edp.queue.filter_block": "Block",
  "edp.queue.filter_category": "Category",
  "edp.queue.filter_day": "Day",
  "edp.queue.filter_round": "Round",
  "edp.queue.filter_search": "Search",
  "edp.queue.filter_status": "Status",
  "edp.queue.heading": "EDP Proposal Queue",
  "edp.queue.subtitle": "Review and decide on submitted EDP course proposals.",
  "edp.tabs_label": "EDP sections",
  "edp.tab_schedule": "Master schedule",
  "edp.tab_proposals": "Proposals",
  "edp.tab_registrations": "Registrations",
  "edp.schedule.heading": "EDP Master Schedule",
  "edp.schedule.subtitle": "The whole week for one round, one bar per course across the grades it serves.",
  "edp.schedule.filter_round": "Round",
  "edp.schedule.filter_grade": "Grade",
  "edp.schedule.filter_grade_all": "All grades",
  "edp.schedule.filter_day": "Day",
  "edp.schedule.filter_day_all": "All days",
  "edp.schedule.filter_block": "Slot",
  "edp.schedule.filter_block_all": "All slots",
  "edp.schedule.filter_category": "Category",
  "edp.schedule.filter_teacher": "Teacher",
  "edp.schedule.filter_teacher_all": "All teachers",
  "edp.schedule.count": "{{shown}} of {{total}} courses",
  "edp.schedule.gap_grade": "{{grade}} has nothing on {{days}}.",
  "edp.schedule.gaps_none_grade": "{{grade}} has something on every day shown.",
  "edp.schedule.empty_no_round": "No EDP round to draw a schedule for yet.",
  "edp.schedule.col_slot": "Slot",
  "edp.schedule.col_grades": "Grades",
  "edp.schedule.slot_empty": "Nothing on",
  "edp.schedule.seats": "{{enrolled}} of {{max}}",
  "edp.schedule.seats_no_max": "{{enrolled}} enrolled",
  "edp.schedule.gaps_title": "Days with nothing on",
  "edp.schedule.gap": "{{band}} has nothing on {{days}}.",
  "edp.schedule.gaps_none": "Every grade band has something on every weekday.",
  "edp.schedule.balance_title": "Co-curricular and extra-curricular",
  "edp.schedule.balance": "{{band}}: {{co}} co-curricular, {{extra}} extra-curricular.",
  "edp.schedule.over_max_title": "Above the standard maximum",
  "edp.schedule.over_max": "{{title}} takes up to {{max}}, above the standard {{standard}} for its youngest grade.",
  "edp.schedule.over_max_none": "No course takes more than the standard for its grades.",
  "edp.schedule.special_dates_title": "Not on a fixed day",
  "edp.schedule.special_dates_hint": "These courses meet on their own enumerated dates and hold no weekday slot.",
  "edp.schedule.special_date_closed_mark": "School closed",
  "edp.schedule.special_date_closed": "{{title}} meets on {{date}}, which is not a school day.",
  "edp.schedule.print.heading": "EDP weekly schedule — {{round}}",
  "edp.schedule.print.heading_grade": "EDP weekly schedule — {{round}} · {{grade}}",
  "edp.schedule.print.caption": "Filters: {{filters}} · Printed {{date}}",
  "edp.schedule.print.filters_none": "none",
  "edp.schedule.print.free_place_yes": "A free place may be spent on this course",
  "edp.schedule.print.free_place_no": "Full price — no free place",
  "edp.schedule.print.free_place_legend": "● a free place may be spent on it · ○ full price",
  "edp.schedule.print.free_places_none_here": "No free place applies to this year group, so none is marked.",
  "edp.schedule.print.meta": "{{courses}} courses · {{price}} base price · {{dates}} · {{sessions}} weekly sessions",
  "edp.schedule.print.category_legend": "{{co}} co-curricular · {{extra}} extra-curricular",
  "edp.timeline.system": "The system",
  "edp.timeline.submitted": "submitted the proposal",
  "edp.timeline.resubmitted": "resubmitted the proposal",
  "edp.detail.office_edit": "Correct this proposal",
  "edp.detail.office_edit_hint": "Saves your correction straight onto the proposal and keeps the teacher’s original in the history. Use \"Request changes\" instead when the teacher needs to decide something.",
  "edp.detail.office_edited": "Proposal corrected.",
  "edp.timeline.edited_by_office": "corrected by the office",
  "edp.timeline.changes_requested": "requested changes",
  "edp.timeline.approved": "approved the proposal",
  "edp.timeline.waitlisted": "waitlisted the proposal",
  "edp.timeline.rejected": "did not approve the proposal",
  "edp.timeline.withdrawn": "withdrew the proposal",
  "edp.timeline.comment": "commented",
  "edp.timeline.concern_raised": "raised a concern",
  "edp.timeline.email_sent": "sent an email",
  "edp.rounds.edit_title": "Edit round",
  "edp.rounds.empty": "No EDP rounds yet.",
  "edp.rounds.error_first_lesson_required": "First lesson date is required.",
  "edp.rounds.error_last_lesson_required": "Last lesson date is required.",
  "edp.rounds.error_lesson_date_order": "Last lesson date must be on or after the first lesson date.",
  "edp.rounds.error_name_required": "Name is required.",
  "edp.rounds.error_proposal_closes_required": "Proposal window close date is required.",
  "edp.rounds.error_proposal_opens_required": "Proposal window open date is required.",
  "edp.rounds.error_proposal_window_order": "Proposal window must close on or after it opens.",
  "edp.rounds.error_registration_window_order": "Registration window must close on or after it opens.",
  "edp.rounds.error_school_year_required": "School year is required.",
  "edp.rounds.field_first_lesson": "First lesson date",
  "edp.rounds.field_last_lesson": "Last lesson date",
  "edp.rounds.field_proposal_closes": "Proposal window closes",
  "edp.rounds.field_proposal_opens": "Proposal window opens",
  "edp.rounds.field_registration_closes": "Registration window closes",
  "edp.rounds.field_registration_opens": "Registration window opens",
  "edp.rounds.heading": "EDP Rounds",
  "edp.rounds.lesson_dates": "Lesson dates",
  "edp.rounds.name": "Name",
  "edp.rounds.new_round": "New round",
  "edp.rounds.new_title": "New round",
  "edp.rounds.proposal_count": "Proposals",
  "edp.rounds.proposal_window": "Proposal window",
  "edp.rounds.registration_window": "Registration window",
  "edp.rounds.school_year": "School year",
  "edp.rounds.subtitle": "Open a round to let staff submit EDP course proposals.",
  "edp.rounds.status_draft": "Draft",
  "edp.rounds.status_proposals_open": "Proposals open",
  "edp.rounds.status_in_review": "In review",
  "edp.rounds.status_closed": "Closed",
  "edp.rounds.field_base_price": "Standard course price (THB, whole round)",
  "edp.rounds.hint_base_price": "The total for every lesson of an ordinary course, not a per-lesson rate. Each of a child's free places is worth this much.",
  "edp.rounds.field_payments_enabled": "Families may pay for this round",
  "edp.rounds.hint_payments_enabled": "Off until you are ready. While it is off there is no payment page and no bank details anywhere on the parent portal — turn it on once places are settled and you know what you are collecting.",
  "edp.rounds.error_base_price_invalid": "Enter a whole number of 0 or more.",
  "nav.section.edp": "Extended Day Program",
  "nav.my_work.edp_proposals": "EDP proposals",
  "nav.edp": "EDP",
  "nav.edp_queue": "EDP Queue",
  "notifications.title": "Notifications",
  "notifications.empty": "All caught up",
  "notifications.pending_items": "Pending items",
  "notifications.mark_all_read": "Mark all read",
  "notifications.clear_all": "Clear all",
  "notifications.clear_all_confirm": "Delete all notifications? This cannot be undone.",
  "notifications.mark_unread": "Mark as unread",
  "notifications.load_more": "Show older",
  "notifications.view": "View",
  "notifications.item.it-tickets.created": "New IT ticket from {{name}}",
  "notifications.item.it-tickets.replied": "{{name}} replied to your IT ticket",
  "notifications.item.it-tickets.status-changed": "Your IT ticket's status changed",
  "notifications.item.it-tickets.commented": "{{name}} commented on an IT ticket",
  "notifications.item.it-tickets.assigned": "An IT ticket was assigned to you",
  "notifications.item.bookings.created": "New booking by {{name}}",
  "notifications.item.contact-inquiries.created": "New contact inquiry from {{name}}",
  "notifications.item.tour-requests.created": "New tour request from {{name}}",
  "notifications.item.tour-requests.scheduled": "Tour scheduled for {{name}}",
  "notifications.item.tour-requests.cancelled": "Tour cancelled for {{name}}",
  "notifications.item.leave-requests.submitted": "{{name}} requested leave",
  "notifications.item.leave-requests.approved": "Your leave request was approved",
  "notifications.item.leave-requests.rejected": "Your leave request was rejected",
  "notifications.item.leave-requests.edited": "{{name}} changed your leave request",
  "notifications.item.student-absences.filed": "{{student}} was reported absent",
  "notifications.item.student-absences.edited": "{{student}}'s absence was updated",
  "notifications.item.lesson-excusals.submitted": "Lesson excusal for {{student}}",
  "notifications.item.allergy-changes.submitted": "Allergy change requested for {{student}}",
  "notifications.item.early-dismissals.filed": "Early dismissal filed for {{student}}",
  "notifications.item.early-dismissals.teacher-digest": "{{count}} of your students leave early today",
  "notifications.item.late-arrivals.filed": "{{student}} will arrive late",
  "notifications.item.late-arrivals.teacher-digest": "{{count}} students arrive late in your lessons today",
  "notifications.item.fever.alert": "{{name}} has a high temperature: {{tempC}}°C",
  "notifications.item.sst-incidents.opened": "{{name}} opened an SST case",
  "notifications.item.sst-incidents.message": "{{name}} posted on an SST case",
  "notifications.item.sst-incidents.private-message": "New post on an SST-only thread",
  "notifications.item.sst-incidents.closed": "{{name}} closed an SST case",
  "notifications.item.lunch-detentions.proposed": "MSS proposed for {{student}}",
  "notifications.item.lunch-detentions.decided": "MSS for {{student}} was decided",
  "notifications.item.lunch-detentions.assigned": "MSS assigned for {{student}}",
  "notifications.item.lunch-detentions.cancelled": "MSS for {{student}} was cancelled",
  "notifications.item.suspensions.started": "A suspension was recorded for {{student}}",
  "notifications.item.suspensions.changed": "{{student}}'s suspension was updated",
  "notifications.item.students.trial-started": "{{name}} starts a trial in {{grade}} ({{from}} to {{to}})",
  "notifications.item.students.trial-extended": "{{name}}'s trial in {{grade}} now runs until {{to}}",
  "notifications.item.students.enrolled": "{{name}} is now enrolled in {{grade}}",
  "notifications.item.students.left": "{{name}} has left {{grade}}",
  "notifications.item.students.admitted": "{{name}} will start in {{grade}} on {{from}}",
  "notifications.item.students.arriving-soon": "{{name}} starts in {{grade}} on {{from}}",
  "notifications.item.support-notes.shared": "{{author}} shared an SST observation about {{student}}",
  "notifications.item.suspensions.cancelled": "{{student}}'s suspension was cancelled",
  "notifications.item.suspensions.message": "New message about {{student}}'s suspension",
  "notifications.item.edp.approved": "Your EDP proposal “{{course}}” was approved",
  "notifications.item.edp.rejected": "Your EDP proposal “{{course}}” was rejected",
  "edp.registrations.heading": "EDP Registrations",
  "edp.registrations.subtitle": "See how many families want each course, and hand out the places.",
  "edp.registrations.empty": "No registrations yet.",
  "edp.registrations.empty_no_round": "There is no EDP round to place children into yet.",
  "edp.registrations.col_course": "Course",
  "edp.registrations.col_schedule": "Day & block",
  "edp.registrations.col_grade_levels": "Grades",
  "edp.registrations.col_demand": "Demand / capacity",
  "edp.registrations.col_confirmed": "Confirmed",
  "edp.registrations.col_status": "Status",
  "edp.registrations.filter_round": "Round",
  "edp.registrations.send_outcomes": "Send outcome emails",
  "edp.registrations.send_outcomes_confirm_title": "Send the outcome emails?",
  "edp.registrations.send_outcomes_confirm_description": "Every family whose choices are settled will get an email telling them the outcome. This cannot be undone.",
  "edp.registrations.send_outcomes_confirm_action": "Send",
  "edp.registrations.send_outcomes_sending": "Sending…",
  "edp.registrations.send_outcomes_result": "Sending to {{queued}} families. They go out over the next few minutes.",
  "edp.registrations.send_outcomes_result_skipped": "Sending to {{queued}} families. {{skipped}} skipped — listed above.",
  "edp.registrations.send_outcomes_result_none": "Everyone in this round has already been written to.",
  "edp.registrations.send_outcomes_result_none_skipped": "Nobody new to write to. {{skipped}} skipped — listed above.",
  "edp.registrations.skipped_title": "Not written to",
  "edp.registrations.skipped_unnamed": "A child with no name on file",
  "edp.registrations.skipped_reason_pending_choices": "their choices are not settled yet",
  "edp.registrations.skipped_reason_no_guardian": "no guardian on file",
  "edp.registrations.skipped_reason_no_child_name": "no name on file",
  "edp.tab_students": "Students",
  "edp.students.heading": "EDP Students",
  "edp.students.subtitle": "Every child in the round: what they are doing, and what it costs.",
  "edp.students.search_placeholder": "Search by name",
  "edp.students.empty": "Nobody has registered for this round yet.",
  "edp.students.empty_no_round": "There is no EDP round to look at yet.",
  "edp.students.filter_round": "Round",
  "edp.students.filter_grade": "Grade",
  "edp.students.filter_grade_all": "All grades",
  "edp.students.filter_all": "Everyone",
  "edp.students.filter_with_seat": "Has a place",
  "edp.students.filter_no_seat": "No place yet",
  "edp.students.filter_not_registered": "Not registered",
  "edp.students.never_registered": "Not registered",
  "edp.students.summary": "{{children}} children · {{registered}} registered · {{seated}} with a place · {{payable}} owed",
  "edp.students.col_child": "Child",
  "edp.students.col_grade": "Grade",
  "edp.students.col_doing": "What they are doing",
  "edp.students.col_asked_for": "Asked for",
  "edp.students.nothing_asked_for": "Added by the office",
  "edp.students.no_request_sent": "No request sent",
  "edp.students.slot_rank": "{{rank}} for this afternoon",
  "edp.students.col_free_places": "Free places",
  "edp.students.col_total": "Total",
  "edp.students.col_discount": "Discount",
  "edp.students.col_payable": "Payable",
  "edp.students.no_seat_yet": "Registered — no place yet",
  "edp.students.not_registered": "added by the office",
  "edp.students.free_places_used": "{{used}} of {{granted}} used",
  "edp.students.export": "Export CSV",
  "edp.students.csv_free_places": "Free places granted",
  "edp.students.csv_free_places_used": "Free places used",
  "edp.placement.heading": "Course placement",
  "edp.placement.applicants_title": "Applicants",
  "edp.placement.empty": "No one has applied for this course yet.",
  "edp.placement.col_name": "Name",
  "edp.placement.col_grade": "Grade",
  "edp.placement.col_choice": "Choice",
  "edp.placement.col_submitted": "Applied",
  "edp.placement.col_status": "Status",
  "edp.placement.col_actions": "Actions",
  "edp.placement.outside_grade_levels": "Not in a grade this course is open to.",
  "edp.placement.choice_rank": "{{rank}} choice for this afternoon",
  "edp.placement.choice_no_slot": "Meets on set dates — no afternoon to rank against",
  "edp.placement.choice_seat_only": "Added by the office — no choice on file",
  "edp.placement.also_this_afternoon": "Also asked for this afternoon:",
  "edp.placement.action_confirm": "Confirm",
  "edp.placement.action_offer": "Offer",
  "edp.placement.action_waitlist": "Waitlist",
  "edp.placement.action_withdraw": "Withdraw",
  "edp.placement.action_remove": "Remove",
  "edp.placement.remove_confirm_title": "Remove from this course?",
  "edp.placement.remove_confirm_description": "{{name}} loses their place on this course and the request behind it. This cannot be undone.",
  "edp.placement.remove_confirm_action": "Remove",
  "edp.placement.confirm_all": "Confirm all",
  "edp.placement.confirm_all_success": "{{confirmed}} confirmed.",
  "edp.placement.confirm_all_success_with_skipped": "{{confirmed}} confirmed, {{skipped}} skipped — already holding this afternoon on another course.",
  "edp.placement.oversubscribed_hint": "This course is oversubscribed — decide places one at a time instead of confirming everyone at once.",
  "edp.placement.add_student": "Add a student",
  "edp.placement.seat_status_none": "No seat yet",
  "edp.placement.manual_enrol_title": "Add a student",
  "edp.placement.manual_enrol_description": "Give a child a confirmed place directly — a late registration, a phone call, or a family with no portal access.",
  "edp.placement.manual_enrol_student_label": "Student",
  "edp.placement.manual_enrol_student_required": "Choose a student.",
  "edp.placement.manual_enrol_submit": "Add",
  "edp.placement.manual_enrol_success": "Student added to the course.",
  "edp.propose.confirm_no_guarantee": "I understand that submission of this proposal does not guarantee approval.",
  "edp.propose.confirm_school_may_adjust": "I understand that the school may adjust the proposed day, block, grade band, class size, or location.",
  "edp.propose.confirm_minimum_four": "I understand that an EDP class normally requires at least 4 students to operate, except for approved one-on-one/private arrangements.",
  "edp.propose.confirm_fifty_minutes": "I understand that each EDP block is 50 minutes.",
  "edp.propose.confirm_two_per_day": "I understand that staff may teach a maximum of two EDP classes per day.",
  "edp.propose.confirm_attendance": "I understand that approved EDP staff are responsible for attendance, student supervision, transition, and dismissal according to school procedures.",
  "edp.propose.confirm_hr_compensation": "I understand that compensation arrangements are handled separately by Human Resources according to the applicable employment arrangement.",
  "edp.propose.errors.title_required": "Give the course a title.",
  "edp.propose.errors.category_required": "Choose a category.",
  "edp.propose.errors.description_required": "Describe the course.",
  "edp.propose.errors.objectives_required": "List 2–4 objectives.",
  "edp.propose.errors.grade_levels_required": "Choose at least one grade.",
  "edp.propose.errors.answer_required": "Answer this question.",
  "edp.propose.errors.number_required": "Enter a number.",
  "edp.propose.errors.minimum_required": "Enter a minimum.",
  "edp.propose.errors.minimum_floor": "An EDP group class requires a minimum of 4 students.",
  "edp.propose.errors.maximum_below_minimum": "Maximum cannot be lower than minimum.",
  "edp.propose.errors.preferred_facilities_required": "Select at least one preferred location.",
  "edp.propose.errors.facility_other_required": "Describe the other location.",
  "edp.propose.errors.materials_required": "List materials, or write \"None\".",
  "edp.propose.errors.purchase_details_required": "Describe the items and estimated cost.",
  "edp.propose.errors.safety_details_required": "Describe the safety or supervision requirements.",
  "edp.propose.errors.position_department_required": "Enter your position or department.",
  "edp.propose.errors.confirmation_required": "You must accept the staff confirmation before submitting.",
  "edp.propose.errors.courses_required": "Add at least one course.",
  "editor.image_too_small": "That picture is small and will look blurry",
  "editor.image_from_url_unsupported": "That image cannot be added from a link",
  "editor.image_from_url_unsupported_hint": "Save the picture to your computer, then upload it here.",
  "editor.image_too_small_hint": "It is only {{width}}×{{height}} pixels. If you copied it out of a document, insert the original photo file instead — the detail cannot be recovered later.",
  "communications.title": "Communications",
  "communications.subtitle": "Write a message to families and send it to a chosen audience.",
  "communications.new_message": "New message",
  "communications.empty": "No messages yet.",
  "communications.empty_filtered": "No messages match this filter.",
  "communications.col_title": "Title",
  "communications.col_audience": "Audience",
  "communications.col_translated": "Translated",
  "communications.col_recipients": "Recipients",
  "communications.col_sent": "Sent",
  "communications.last_send_failed": "Last send failed: {{reason}}",
  "enum.communication_status.draft": "Draft",
  "enum.communication_status.scheduled": "Scheduled",
  "enum.communication_status.sending": "Sending",
  "enum.communication_status.sent": "Sent",
  "communications.new_title": "New Message",
  "communications.edit_title": "Edit Message",
  "communications.field_title": "Title",
  "communications.field_body": "Message",
  "communications.field_audience": "Audience",
  "communications.audience_all_parents": "All parents",
  "communications.audience_grades": "Choose grades",
  "communications.include_arriving": "Include arriving families",
  "communications.include_arriving_hint": "Also send to families whose child has been admitted but has not started yet. Parents whose children have all left never receive this message.",
  "communications.error_title_required": "Title is required",
  "communications.error_grades_required": "Choose at least one grade",
  "communications.error_save_failed": "Failed to save the message.",
  "communications.save_draft": "Save draft",
  "communications.saved": "Draft saved",
  "communications.recipient_preview": "This will be sent to {{count}} parents.",
  "communications.recipient_preview_loading": "Counting recipients…",
  "communications.send_now": "Send now",
  "communications.send_confirm_title": "Send this message now?",
  "communications.send_confirm_description": "This will send to {{count}} parents and cannot be undone.",
  "communications.send_confirm_action": "Send now ({{count}})",
  "communications.error_send_failed": "Failed to send the message.",
  "communications.send_success": "Message sent.",
  "communications.schedule": "Schedule",
  "communications.scheduled_for_label": "Send at",
  "communications.error_schedule_failed": "Failed to schedule the message.",
  "communications.schedule_success": "Message scheduled.",
  "communications.cancel_schedule": "Cancel schedule",
  "communications.cancel_schedule_success": "Schedule cancelled — back to draft.",
  "communications.error_cancel_schedule_failed": "Failed to cancel the schedule.",
  "communications.delete_draft": "Delete draft",
  "communications.delete_draft_confirm_title": "Delete this draft?",
  "communications.delete_draft_confirm_description": "This message will be permanently removed.",
  "communications.deleted": "Draft deleted",
  "communications.error_delete_failed": "Failed to delete the draft.",
  "communications.sent_at_summary": "Sent {{date}}",
  "communications.locked_notice": "This message has already been sent and can no longer be changed.",
  "communications.detail_funnel_title": "Engagement",
  "communications.funnel_recipients": "Recipients",
  "communications.funnel_sent": "Sent",
  "communications.funnel_failed": "Failed",
  "communications.funnel_clicked": "Clicked",
  "communications.funnel_read": "Read",
  "communications.recipients_title": "Recipients",
  "communications.col_parent": "Parent",
  "communications.col_email": "Email",
  "communications.col_language": "Language",
  "communications.col_sent_at": "Sent",
  "communications.col_clicked_at": "Clicked",
  "communications.col_read_at": "Read",
  "communications.col_failure_reason": "Failure reason",
  "communications.recipients_empty": "No recipients recorded.",
  "communications.field_language_versions": "Language versions",
  "communications.tab_translated": "Translated",
  "communications.error_english_required": "Add the English version before sending.",
  "communications.translate_from_english": "Translate from English",
  "communications.translation_billing_note": "Billed per character by Google.",
  "communications.translation_preview_title": "Review translation",
  "communications.translation_preview_description": "Machine-translated into {{language}}. Nothing is saved until you use it, and it stays fully editable afterwards.",
  "communications.translation_preview_use": "Use this translation",
  "communications.translation_loading": "Translating…",
  "communications.translation_error_rejected": "The configured key was rejected. Check it in Integration settings.",
  "communications.translation_error_quota": "Translation quota exceeded. Wait or raise the quota, then try again.",
  "communications.translation_error_unavailable": "The translation service is unavailable right now. Try again later.",
  "communications.translation_error_generic": "Could not translate this message. Try again.",
  "communications.translation_not_configured_title": "Translation not configured",
  "communications.translation_not_configured_description": "No translation provider is set up yet. An admin can add a Google Cloud Translate key in Integration settings — until then, Thai and Chinese versions can still be written or pasted by hand.",
  "communications.translation_not_configured_link": "Go to Integration settings",
  "settings.label.communications_send_delay_ms": "Communications send delay (ms)",
  "settings.desc.communications_send_delay_ms": "Pause between individual sends while dispatching a message.",
  "settings.label.communications_daily_allowance": "Communications daily recipient allowance",
  "settings.desc.communications_daily_allowance": "A send is refused before anything goes out if the recipient count exceeds this number.",
  "settings.label.cafeteria_overdraft_limit": "Cafeteria overdraft limit (baht)",
  "settings.desc.cafeteria_overdraft_limit": "How far below zero a cafeteria wallet may go. 0 means never below zero.",
  "checkout_roster.tally_still_here": "Still here",
  "checkout_roster.tally_gone_home": "Gone home",
  "checkout_roster.tally_not_in": "Not in today",
  "checkout_roster.filter_label": "Filter students",
  "checkout_roster.filter_all": "Everyone",
  "checkout_roster.filter_still_here": "Still here",
  "checkout_roster.filter_waiting": "Waiting",
  "checkout_roster.filter_gone_home": "Gone home",
  "checkout_roster.empty": "No students on the register today.",
  "checkout_roster.empty_filtered": "No students match this filter.",
  "checkout_roster.no_grade": "No grade on file",
  "checkout_roster.load_failed": "Could not load the register. Refresh to try again.",
  "enum.checkout_roster_state.in_class": "In class",
  "enum.checkout_roster_state.waiting": "Waiting",
  "enum.checkout_roster_state.on_way": "On the way",
  "enum.checkout_roster_state.collected": "Gone home",
  "enum.checkout_roster_state.absent": "Absent",
  "enum.checkout_roster_state.excused": "Excused",
  "enum.checkout_roster_state.early_dismissal": "Left early",
  "enum.checkout_roster_state.edp": "EDP",
  "enum.checkout_roster_state.suspended": "Suspended",
  "edp.detail.course_max_hint": "Leave blank for no fixed maximum.",
  "edp.detail.course_one_on_one_places_hint": "A one-on-one course takes one child, so it has one place.",
  "edp.sessions.add": "Add a day",
  "edp.sessions.remove": "Remove this day",
  "edp.sessions.label": "When it runs",
  "edp.sessions.hint": "One row per meeting. A course that runs twice a week has two — the same children attend both.",
  "edp.schedule_kind.label": "How this course meets",
  "edp.schedule_kind.weekly": "Every week",
  "edp.schedule_kind.special_dates": "On set dates",
  "edp.schedule_kind.special_dates_hint": "For a course the school fixes to particular dates rather than a weekday — each with its own start and end time, so it need not fit a block. Leave the room unassigned for an off-site course.",
  "edp.meetings.date": "Date",
  "edp.meetings.starts_at": "Starts",
  "edp.meetings.ends_at": "Ends",
  "edp.meetings.room": "Room",
  "edp.meetings.add": "Add a date",
  "edp.meetings.remove": "Remove this date",
  "edp.meetings.last_one_stays": "A course has to meet at least once. To give up its dates, make it a weekly course above.",
  "edp.meetings.errors.at_least_one": "Give this course at least one date, or make it a weekly course.",
  "edp.meetings.errors.date_required": "Every row needs a date.",
  "edp.meetings.errors.times_required": "Every date needs a start and an end time.",
  "edp.meetings.errors.end_after_start": "A meeting has to end after it starts.",
  "edp.meetings.errors.repeated_date": "This course already meets on that date.",
  "edp.afternoon.heading": "EDP Afternoon",
  "edp.afternoon.scope_label": "Scope",
  "edp.afternoon.scope_homeroom": "My Homeroom",
  "edp.afternoon.scope_class": "A Class",
  "edp.afternoon.scope_school": "Whole School",
  "edp.afternoon.class_label": "Class",
  "edp.afternoon.class_placeholder": "Choose a class",
  "edp.afternoon.pick_class": "Choose a class to see who is staying for EDP.",
  "edp.afternoon.no_homeroom": "You have no homeroom class this year, so there is nothing to show here.",
  "edp.afternoon.staying_heading": "Staying for EDP",
  "edp.afternoon.going_home_heading": "Going Home",
  "edp.afternoon.going_home_omitted": "At whole-school scope, only the children staying are listed — going home is everyone else.",
  "edp.afternoon.going_home_empty": "Everyone in this list is staying for EDP today.",
  "edp.afternoon.no_one_staying": "No one is staying for EDP today.",
  "edp.afternoon.room_unassigned": "No room assigned",
  "edp.afternoon.until": "Until {{time}}",
  "edp.afternoon.excused": "Not going today: {{reason}}",
  "edp.afternoon.excused_by": "recorded at the door by {{name}}",
  "edp.afternoon.tab_day": "By day",
  "edp.afternoon.tab_week": "By week",
  "edp.afternoon.tab_class": "By class",
  "edp.afternoon.week_col_student": "Student",
  "edp.afternoon.tabs_label": "EDP Afternoon views",
  "edp.week.subtitle": "Week of {{date}}",
  "edp.week.week_label": "Week",
  "edp.week.previous_week": "Previous week",
  "edp.week.next_week": "Next week",
  "edp.week.empty": "No EDP course meets this week.",
  "edp.week.col_student": "Student",
  "edp.week.instructor_unnamed": "No instructor named",
  "edp.week.marked_footer": "Marked",
  "edp.week.marked_count": "{{marked}} of {{total}} marked",
  "edp.week.upcoming": "Upcoming",
  "edp.week.order_label": "Order by",
  "edp.week.order_block": "Block",
  "edp.week.order_name": "Name",
  "edp.week.order_day": "Day",
  "edp.register.take_register": "Take the register",
  "edp.register.empty_roster": "Nobody holds a place in this course yet, so there is no one to mark.",
  "edp.register.col_note": "Note",
  "edp.register.col_marked_by": "Marked by",
  "edp.register.note_placeholder": "Add a note",
  "edp.register.mark_all_present": "Mark everyone present",
  "edp.register.marked_footer": "{{marked}} of {{total}} marked",
  "edp.register.nothing_to_save": "Mark at least one child before saving.",
  "edp.register.saved": "Register saved.",
  "edp.register.marked_by_at": "Marked by {{name}} · {{when}}",
  "edp.register.summary_title": "The term so far",
  "edp.register.summary_rate": "Attendance (present or late)",
  "edp.register.summary_no_rate": "No rate yet",
  "edp.register.summary_meetings": "Afternoons so far, of {{term}}",
  "edp.register.summary_unmarked": "Still unmarked",
  "edp.register.summary_unmarked_warning": "{{unmarked}} of {{meetings}} afternoons have not been marked, so this rate covers only the part of the register that is filled in.",
  "edp.register.summary_no_marks_yet": "No child on this register has been marked yet ({{unmarked}} of {{meetings}} afternoons unmarked), so there is no attendance rate to give.",
  "edp.register.summary_no_marks_from_roster": "No child on this register has been marked yet, so there is no attendance rate to give.",
  "edp.register.summary_all_marked": "Every afternoon held so far has been marked for every child.",
  "edp.register.summary_partly_marked": "{{partly}} of {{meetings}} afternoons have been started but not finished — some children on them carry no mark at all.",
  "edp.register.summary_off_schedule": "This course has changed days. These counts are worked out from the afternoons it meets on now, so they may include afternoons it never met on.",
  "edp.register.summary_none_held": "This course has not met yet, so there is nothing to add up.",
  "edp.register.summary_col_unmarked": "Not marked",
  "nav.edp_afternoon": "EDP Afternoon",
  "communications.message_title": "Message",
  "communications.edit_message": "Edit",
  "communications.sent_edit_warning": "Already emailed to {{count}} families.",
  "communications.sent_edit_warning_hint": "Edits change the message in the portal only. The email they already received cannot be changed, and who receives it can no longer change.",
  "edp.groups.add": "Run as another group",
  "edp.groups.remove": "Remove this group",
  "edp.groups.group_n": "Group {{n}}",
  "edp.groups.title": "Group name",
  "edp.groups.title_placeholder": "Same as the course",
  "edp.groups.same_teacher": "Same teacher",
  "edp.groups.same_maximum": "Same maximum",
  "edp.groups.hint": "A group is a separate set of children with its own register. Adding a day inside a group means the same children attend twice a week.",
  "edp.detail.add_group": "Run this again as another group",
  "edp.detail.add_group_hint": "For when more families want a place than the course has room for. A separate register, so the children in it are not the ones already enrolled.",
  "edp.detail.group_added": "Another group added.",
  "edp.propose.groups_hint": "Say when the course would run. Add a day for a course that meets twice a week with the same children; add another group to run the same course again for a different set of children.",
  "edp.propose.external_instructor": "Taught by someone else",
  "edp.propose.external_instructor_hint": "Leave blank if you are teaching it. Name a visiting or part-time teacher the school has no account for.",
  "edp.propose.errors.preferred_groups_required": "Say when the course would run.",
  "edp.propose.errors.group_needs_a_day": "A group must run on at least one day.",
  "edp.propose.errors.repeated_slot": "A group cannot run twice in the same slot on the same day.",
  "edp.propose.errors.groups_share_a_slot": "Two groups of one course cannot run in the same slot on the same day.",
  "edp.propose.errors.slot_not_on_that_day": "That slot does not exist on that day.",
  "edp.groups.grades": "Grades for this group",
  "edp.groups.grades_hint": "Leave every box clear to open the group to all of the course’s grades.",
  "edp.queue.col_requested": "Requested",
  "edp.detail.field_requested_sessions": "Requested",
  "edp.detail.field_groups": "Groups",
  "sand_dollars.stats_tabs_label": "Sand dollar statistics sections",
  "sand_dollars.records_tabs_label": "Sand dollar awards and statistics",
  "sand_dollars.tab_overview": "Overview",
  "sand_dollars.tab_grades": "Grades",
  "sand_dollars.tab_staff": "Staff",
  "sand_dollars.unknown": "Unknown",
  "sand_dollars.stat_awards": "Awards",
  "sand_dollars.stat_over_school_days_one": "over {{count}} school day",
  "sand_dollars.stat_over_school_days_other": "over {{count}} school days",
  "sand_dollars.stat_per_student_per_day": "Per student per day",
  "sand_dollars.stat_per_day_hint": "{{value}} a day school-wide",
  "sand_dollars.stat_coverage": "Students recognised",
  "sand_dollars.stat_coverage_hint": "{{awarded}} of {{total}} hold at least one",
  "sand_dollars.stat_staff_awarding": "Staff awarding",
  "sand_dollars.stat_median_hint": "Median {{value}} per student",
  "sand_dollars.trend_title": "Awards over time",
  "sand_dollars.weekday_title": "Which day of the week",
  "sand_dollars.spread_title": "How recognition is spread",
  "sand_dollars.spread_subtitle": "Students grouped by how many sand dollars they hold. The red bar is the children nobody has recognised yet.",
  "sand_dollars.spread_students": "Students",
  "sand_dollars.categories_title": "Which values are recognised",
  "sand_dollars.grades_chart_title": "Per student per school day, by grade",
  "sand_dollars.grades_chart_subtitle": "The dashed line is the school average, {{value}} per student per school day.",
  "sand_dollars.grades_table_title": "Grades in full",
  "sand_dollars.col_grade": "Grade",
  "sand_dollars.col_students": "Students",
  "sand_dollars.col_awards": "Awards",
  "sand_dollars.col_per_day": "Per student/day",
  "sand_dollars.col_per_week": "Per student/week",
  "sand_dollars.col_coverage": "Recognised",
  "sand_dollars.houses_not_assigned_yet": "No house totals yet — houses are assigned around October.",
  "sand_dollars.staff_awarding_title": "Who is awarding",
  "sand_dollars.staff_reach": "{{students}} students · {{rate}} a school day",
  "sand_dollars.staff_silent_title": "Awarded nothing",
  "sand_dollars.staff_silent_subtitle": "Active admins and teachers with no awards in this window.",
  "sand_dollars.staff_silent_none": "Everyone has awarded at least once.",
  "sand_dollars.tab_class_list": "Class list",
  "sand_dollars.class_list_title": "Every student, with what they hold",
  "sand_dollars.class_list_empty": "No students to show for this window.",
  "sand_dollars.summary_students": "Students",
  "sand_dollars.summary_awards": "Awards",
  "sand_dollars.summary_median": "Median per student",
  "sand_dollars.summary_recognised": "Recognised",
  "sand_dollars.col_awards_total": "Awards",
  "sand_dollars.col_vs_grade": "Vs grade",
  "sand_dollars.col_rank_in_grade": "Rank in grade",
  "sand_dollars.col_awarders": "Awarders",
  "sand_dollars.col_top_value": "Top value",
  "sand_dollars.col_top_awarder": "Top awarder",
  "sand_dollars.col_last_awarded": "Last awarded",
  "sand_dollars.rank_of": "{{rank}} of {{size}}",
  "sand_dollars.school_days_ago_one": "{{count}} school day ago",
  "sand_dollars.school_days_ago_other": "{{count}} school days ago",
  "sand_dollars.never_awarded": "Never",
  "sand_dollars.class_list_all_values": "All values",
  "sand_dollars.class_list_category_hint": "Filters by each child's most frequent value",
  "sand_dollars.class_list_below_label": "Awards below",
  "sand_dollars.class_list_showing": "Showing {{shown}} of {{total}}",
  "students.rate_per_day": "Per school day",
  "students.rate_per_week": "Per school week",
  "students.rate_per_month": "Per school month",
  "students.rate_vs_grade": "Vs their grade",
  "students.rate_window_hint": "{{awards}} awards over {{days}} school days",
  "students.rate_per_week_hint": "Five school days",
  "students.rate_per_month_hint": "Twenty school days",
  "students.rate_vs_grade_hint": "Grade averages {{average}} per school day · last awarded {{last}}",
  "students.rate_last_never": "never",
  "students.rate_last_days_one": "{{count}} school day ago",
  "students.rate_last_days_other": "{{count}} school days ago",
  "lunch_detentions.thread_title": "Staff conversation",
  "lunch_detentions.private_thread_title": "SST notes",
  "lunch_detentions.staff_thread_hint": "Visible to the proposer, supervisor, relevant homeroom teacher and SST.",
  "lunch_detentions.activity_title": "MSS activity",
  "lunch_detentions.activity_hint": "Decisions, extensions and attendance changes, ordered by time.",
  "lunch_detentions.workspace_tabs_label": "MSS workspace",
  "lunch_detentions.tab_overview": "Overview",
  "lunch_detentions.tab_attendance": "Attendance",
  "lunch_detentions.tab_activity": "Activity",
  "lunch_detentions.tab_staff_conversation": "Staff conversation",
  "lunch_detentions.tab_sst": "SST notes",
  "lunch_detentions.tab_family": "Family contact?",
  "lunch_detentions.attention_review_request_title": "Review the MSS request",
  "lunch_detentions.attention_review_request_description": "SST needs to approve or reject this proposed run.",
  "lunch_detentions.attention_waiting_for_decision_title": "Waiting for an SST decision",
  "lunch_detentions.attention_waiting_for_decision_description": "You can follow this request; SST owns the approval decision.",
  "lunch_detentions.attention_assign_supervisor_title": "Assign a supervisor",
  "lunch_detentions.attention_assign_supervisor_description": "This approved run has nobody assigned to supervise and record attendance.",
  "lunch_detentions.attention_record_attendance_title": "Complete the attendance record",
  "lunch_detentions.attention_record_attendance_description": "One or more MSS days still need an attendance outcome.",
  "lunch_detentions.attention_view_main_run_title": "Continue in the main run",
  "lunch_detentions.attention_view_main_run_description": "This request was folded into another run, where attendance and progress are recorded.",
  "lunch_detentions.attention_upcoming_title": "Run is ready",
  "lunch_detentions.attention_upcoming_description": "The run has not started yet. Attendance will be recorded on its scheduled days.",
  "lunch_detentions.attention_complete_title": "No open action",
  "lunch_detentions.attention_complete_description": "This run is complete or no longer active. Its history remains available.",
  "lunch_detentions.attention_action_review": "Review request",
  "lunch_detentions.attention_action_assign": "Assign supervisor",
  "lunch_detentions.attention_action_attendance": "Open attendance",
  "lunch_detentions.attention_action_view_main": "View main run",
  "lunch_detentions.attention_warning_overdue_attendance_title_one": "{{count}} MSS day is overdue",
  "lunch_detentions.attention_warning_overdue_attendance_title_other": "{{count}} MSS days are overdue",
  "lunch_detentions.attention_warning_overdue_attendance_description": "The scheduled date has passed but no attendance outcome was recorded.",
  "lunch_detentions.attention_warning_missing_supervisor_title": "No supervisor is assigned",
  "lunch_detentions.attention_warning_missing_supervisor_description": "Assign ownership so somebody is clearly responsible for attendance.",
  "lunch_detentions.request_count_label": "Requests this school year",
  "lunch_detentions.family_communication_description": "A secure family conversation for this MSS run will live here, separate from staff and SST notes.",
  "lunch_detentions.family_question_title": "Does the family need to be contacted?",
  "lunch_detentions.family_question_description": "Family communication is optional for each MSS run. Record the decision before opening a conversation.",
  "lunch_detentions.family_decision_label": "Current decision",
  "lunch_detentions.family_decision_pending": "Not decided",
  "lunch_detentions.family_yes_title": "Yes, contact the family",
  "lunch_detentions.family_yes_description": "Open a secure conversation linked to this MSS run.",
  "lunch_detentions.family_no_title": "No message needed",
  "lunch_detentions.family_no_description": "Record that this MSS run does not require family contact.",
  "lunch_detentions.family_question_hint": "This decision and any future conversation will remain separate from staff and SST notes.",
  "lunch_detentions.family_future_attention_hint": "In the completed feature, choosing family contact will mark this tab until the message has been sent.",
  "lunch_detentions.progress_label": "Progress",
  "lunch_detentions.progress_recorded": "{{recorded}} of {{total}} days recorded",
  "lunch_detentions.progress_remaining_one": "{{count}} day remaining",
  "lunch_detentions.progress_remaining_other": "{{count}} days remaining",
  "lunch_detentions.progress_aria": "{{recorded}} of {{total}} MSS days recorded",
  "lunch_detentions.private_thread_hint": "Only holders of the SST module can read this. The proposing teacher and the supervisor cannot.",
  "lunch_detentions.private_note_placeholder": "Add a note only the SST can read…",
  "lunch_detentions.note_send": "Add note",
  "lunch_detentions.timeline_decision": "Decided: {{detail}}",
  "lunch_detentions.timeline_extension": "Extended by a later request ({{detail}})",
  "lunch_detentions.timeline_attendance": "Marked {{detail}}",
  "edp.tab_payments": "Payments",
  "edp.tab_cancellations": "Cancellations",
  "edp.cancellations.heading": "Cancelled meetings",
  "edp.cancellations.subtitle": "Afternoons a course did not meet, and what the school does about each: a make-up day or a refund.",
  "edp.cancellations.empty": "No meeting has been cancelled this round.",
  "edp.cancellations.cancel_action": "Cancel a meeting",
  "edp.cancellations.cancel_title": "Cancel a meeting",
  "edp.cancellations.cancel_description": "The course does not meet that afternoon: the homeroom lists send its children home, and no register is offered for it.",
  "edp.cancellations.cancel_submit": "Cancel the meeting",
  "edp.cancellations.col_course": "Course",
  "edp.cancellations.col_afternoon": "Afternoon",
  "edp.cancellations.col_reason": "Reason",
  "edp.cancellations.col_settlement": "Settlement",
  "edp.cancellations.course_label": "Course",
  "edp.cancellations.course_placeholder": "Choose a course",
  "edp.cancellations.course_required": "Choose the course.",
  "edp.cancellations.block_label": "Block",
  "edp.cancellations.reason_label": "Reason",
  "edp.cancellations.reason_placeholder": "e.g. Coach off sick",
  "edp.cancellations.reason_required": "Say why the meeting was cancelled.",
  "edp.cancellations.cancelled": "Meeting cancelled.",
  "edp.cancellations.settle_action": "Settle",
  "edp.cancellations.settle_title": "Settle a cancelled meeting",
  "edp.cancellations.settle_description": "{{course}}, {{afternoon}}: made up on another day, or refunded.",
  "edp.cancellations.settlement_label": "Settlement",
  "edp.cancellations.settlement_to_decide": "To be decided",
  "edp.cancellations.settlement_make_up": "Make up on another day",
  "edp.cancellations.settlement_refund": "Refund",
  "edp.cancellations.make_up_date_label": "Make-up day",
  "edp.cancellations.make_up_date_required": "Choose the day it is made up on.",
  "edp.cancellations.make_up_block_label": "Make-up block",
  "edp.cancellations.make_up_block_same": "Same block as the cancelled meeting",
  "edp.cancellations.made_up_on": "Made up on {{date}}",
  "edp.cancellations.note_label": "Note",
  "edp.cancellations.note_placeholder": "e.g. Refunded ฿5,000 by transfer on 20 Sep",
  "edp.cancellations.settled": "Cancellation updated.",
  "edp.cancellations.remove_action": "Remove",
  "edp.cancellations.remove_title": "Put the meeting back?",
  "edp.cancellations.remove_description": "This removes the cancellation of {{course}} on {{afternoon}}, as if it had never been struck out.",
  "edp.cancellations.removed": "Cancellation removed.",
  "edp.register.cancelled_notice": "Cancelled: {{reason}}",
  "edp.register.cancelled_make_up": "Made up on {{date}}.",
  "edp.register.cancelled_refund": "To be refunded.",
  "edp.register.cancelled_to_decide": "Make-up or refund still to be decided.",
  "edp.payments.heading": "EDP payments",
  "edp.payments.subtitle": "Review family payments and reconcile balances for each round.",
  "edp.payments.search_placeholder": "Search by family or child…",
  "edp.payments.round_label": "Round",
  "edp.payments.empty": "No payments to show.",
  "edp.payments.round_closed_notice": "Payments are switched off for this round, so families cannot see the payment page or report anything. Turn them on in the round settings.",
  "edp.payments.col_family": "Family",
  "edp.payments.col_amount": "Amount reported",
  "edp.payments.col_reported": "Reported",
  "edp.payments.col_slip": "Slip",
  "edp.payments.col_status": "Status",
  "edp.payments.col_actions": "Actions",
  "edp.payments.view_slip": "Open the slip",
  "edp.payments.no_slip": "None attached",
  "edp.payments.status_declared": "Reported",
  "edp.payments.status_confirmed": "Confirmed",
  "edp.payments.status_rejected": "Rejected",
  "edp.payments.action_confirm": "Confirm",
  "edp.payments.action_reject": "Reject",
  "edp.payments.note_placeholder": "Note to the family (required to reject)",
  "edp.payments.confirm_title": "Confirm this payment?",
  "edp.payments.confirm_description": "This tells {{name}} that their payment of {{amount}} has been matched against the bank. They will not be able to change it afterwards.",
  "edp.payments.confirmed": "Payment confirmed.",
  "edp.payments.rejected": "Payment rejected — the family can report it again.",
  "edp.payments.notices_action": "Send payment notices",
  "edp.payments.notices_title": "Write to every family who owes?",
  "edp.payments.notices_description": "Each household with something outstanding gets one email naming their children, the total, and a link to the payment page. Families whose payment you have already confirmed are left out.",
  "edp.payments.balances_title": "Balance differences",
  "edp.payments.balances_hint": "Current course fees compared with confirmed payments. Check outstanding amounts or overpayments, then record any adjustment.",
  "edp.payments.col_owed": "Owes now",
  "edp.payments.col_paid": "Confirmed",
  "edp.payments.col_balance": "Difference",
  "edp.payments.family_unknown": "No parent on record",
  "edp.payments.recorded_by_office": "Recorded by the office",
  "edp.my_courses.badge": "EDP",
  "timetable.edp_cell": "EDP",
  "edp.register.unpaid": "Not paid",
  "edp.by_teacher.heading": "Who is running what",
  "edp.by_teacher.subtitle": "Every course this round, grouped by the member of staff who runs it.",
  "edp.by_teacher.col_teacher": "Teacher",
  "edp.by_teacher.col_courses": "Courses",
  "edp.by_teacher.course_count_one": "{{count}} course",
  "edp.by_teacher.course_count_other": "{{count}} courses",
  "edp.by_teacher.confirmed_one": "{{count}} child",
  "edp.by_teacher.confirmed_other": "{{count}} children",
  "edp.by_teacher.visiting": "Visiting",
  "edp.by_teacher.nobody": "Nobody assigned",
  "edp.payments.awaiting_review": "{{count}} reported, not yet checked",
  "edp.payments.balance_short": "{{amount}} still to come",
  "edp.payments.balance_over": "{{amount}} held over",
  "edp.payments.record_action": "Record a payment",
  "edp.payments.record_title": "Record a payment the office received",
  "edp.payments.record_description": "Cash at the desk, or a transfer a family never reported on the portal. It is recorded as confirmed — you are the one who saw the money.",
  "edp.payments.record_student": "Child",
  "edp.payments.record_student_hint": "Any child of the family. The payment settles their whole household bill, not just this child.",
  "edp.payments.record_student_required": "Choose the child whose family paid.",
  "edp.payments.record_amount": "Amount received",
  "edp.payments.record_amount_required": "Enter the amount received, in whole baht.",
  "edp.payments.record_note": "Note",
  "edp.payments.record_note_placeholder": "e.g. cash at the office, receipt 0412",
  "edp.payments.method_label": "Paid by",
  "edp.payments.method_bank_transfer": "Bank transfer",
  "edp.payments.method_cash": "Cash",
  "edp.payments.method_credit_card": "Credit card",
  "edp.payments.method_salary_deduction": "Salary deduction",
  "edp.payments.export": "Export CSV",
  "edp.payments.csv_recorded_by": "Recorded by",
  "edp.payments.csv_children": "Children",
  "edp.payments.csv_courses": "Courses",
  "edp.payments.csv_free_places": "Free places",
  "edp.payments.csv_free_places_used": "{{used}} of {{granted}} used ({{discount}} off)",
  "edp.payments.csv_reviewed": "Checked",
  "edp.payments.csv_recorded_by_office": "Recorded by the office",
  "edp.payments.csv_note": "Note",
  "edp.payments.csv_awaiting_review": "Awaiting review",
  "edp.payments.totals_fees": "Course fees",
  "edp.payments.totals_fees_hint": "{{count}} children with a place",
  "edp.payments.totals_free_places": "Free places used",
  "edp.payments.totals_free_places_hint": "{{amount}} off · {{unused}} unused of {{granted}}",
  "edp.payments.totals_payable": "To pay",
  "edp.payments.totals_payable_hint": "{{count}} households",
  "edp.payments.totals_confirmed": "Confirmed",
  "edp.payments.totals_by_method": "{{amount}} by {{method}}",
  "edp.payments.totals_confirmed_none": "Nothing confirmed yet",
  "edp.payments.totals_still_to_come": "Still to come",
  "edp.payments.totals_still_to_come_hint": "{{count}} households owe",
  "edp.payments.totals_held_over": "Held over",
  "edp.payments.totals_held_over_hint": "{{count}} households overpaid",
  "edp.payments.totals_awaiting": "Awaiting review",
  "edp.payments.totals_awaiting_hint": "{{amount}} reported, not yet checked · {{rejected}} rejected",
  "edp.payments.totals_settled": "Settled",
  "edp.payments.totals_settled_hint": "of {{total}} households",
  "edp.payments.record_slip": "Receipt or slip (optional)",
  "edp.payments.record_slip_hint": "A photo or PDF — including photos straight from an iPhone. Up to 10 MB.",
  "edp.payments.record_slip_too_big": "That file is larger than 10 MB.",
  "edp.payments.record_success": "Payment recorded.",
  "edp.payments.edit_title": "Correct this payment",
  "edp.payments.edit_description": "Change the amount or the note on {{name}}’s payment. To move it to a different family, delete it and record it again.",
  "edp.payments.edit_success": "Payment corrected.",
  "edp.payments.delete_title": "Delete this payment?",
  "edp.payments.delete_description": "This removes {{name}}’s payment of {{amount}} and the slip attached to it. It cannot be undone.",
  "edp.payments.deleted": "Payment deleted.",
  "edp.payments.create_receipt": "Create receipt",
  "edp.payments.create_all_receipts": "Issue all outstanding receipts",
  "edp.payments.receipt_number": "Receipt",
  "edp.payments.create_receipt_success": "Receipt {{number}} issued.",
  "edp.payments.create_all_receipts_success": "{{issued}} issued, {{skipped}} already had one.",
  "edp.payments.filter_not_matching": "Not matching",
  "edp.payments.balances_all_settled": "Every household's money matches.",
  "edp.rounds.field_payment_due": "Payment deadline",
  "edp.rounds.hint_payment_due": "Optional. Families are asked to pay by this date and it appears in their letters and on the portal — a late payment is still accepted.",
  "edp.payments.send_reminder": "Send a reminder",
  "edp.payments.notices_sent_on": "Notices sent {{when}}",
  "edp.payments.reminder_confirm_title": "Send a reminder?",
  "edp.payments.reminder_confirm_body": "Goes to every family who still owes, except those whose transfer you have not checked yet. You can send it again later.",
  "edp.payments.notices_confirm_title": "Announce payment for this round?",
  "edp.payments.notices_confirm_body": "Goes to every family who owes, and can only be done once. Use the reminder afterwards.",
  "edp.payments.reminder_sent": "Reminder queued for {{count}} family(ies).",
  "edp.detail.field_assistants": "Assistants",
  "edp.detail.hint_assistants": "Staff who help run it. They see the course in their own Classes Today and can take its register.",
  "edp.detail.assistants_empty": "No matching staff",
  "edp.detail.assistants_placeholder": "Search staff…",
  "nav.my_work.edp": "EDP",
  "edp.mine.tabs_label": "My EDP",
  "edp.mine.tab_proposals": "Proposals",
  "edp.mine.tab_running": "Running",
  "edp.mine.running_heading": "What I run",
  "edp.mine.running_subtitle": "Your EDP courses this round, and the children in them.",
  "edp.mine.running_empty": "You are not running any EDP courses this round.",
  "edp.mine.students_count": "{{count}} students",
  "edp.mine.take_register": "Take the register",
  "edp.mine.no_students": "Nobody has a place yet.",
  "edp.mine.running_error": "Your courses could not be loaded. Try again in a moment.",
  "edp.register.load_error": "This register could not be loaded. Try again in a moment.",
  "edp.my_courses.open_register": "Open the full register",
  "edp.payments.family_emails": "Family emails",
  "edp.payments.review_action": "Review",
  "edp.payments.review_hint": "Match this payment against the bank statement before confirming.",
  "edp.payments.review_note_label": "Note to the family",
  "edp.payments.review_note_hint": "Required when rejecting a payment. The family can read this note.",
  "nav.logs": "Logs",
  "logs.tab_activity": "Activity",
  "logs.tab_door": "Door access",
  "edp.payments.void_receipt_action": "Void receipt",
  "edp.payments.void_receipt_title": "Void this receipt?",
  "edp.payments.void_receipt_description": "Receipt {{number}} keeps its number but stops counting as issued, and the payment behind it can be edited or deleted again. Only use this when the receipt itself is wrong — a child leaving the course is not a reason to void it.",
  "edp.payments.void_reason_label": "Reason",
  "edp.payments.void_reason_placeholder": "Why this receipt should not have been issued as issued",
  "edp.payments.void_receipt_success": "Receipt voided.",
  "edp.payments.generate_pdf": "Generate PDF",
  "edp.payments.generate_pdf_success": "PDF generated.",
  "edp.payments.create_all_receipts_confirm_title": "Issue all outstanding receipts?",
  "edp.payments.create_all_receipts_confirm_description": "Issues a numbered receipt for every confirmed payment in this round that does not have one yet — {{count}} payment(s) right now. Numbers are gapless and cannot be reused, so check the round first.",
  "growth.height.severely-short": "Severely short for age",
  "growth.height.short": "Short for age",
  "growth.height.typical": "Typical height",
  "growth.height.tall": "Tall for age",
  "growth.bmi.severe-thinness": "Severe thinness",
  "growth.bmi.thinness": "Thinness",
  "growth.bmi.healthy-weight": "Healthy weight",
  "growth.bmi.risk-of-overweight": "Risk of overweight",
  "growth.bmi.overweight": "Overweight",
  "growth.bmi.obesity": "Obesity",
  "growth.weight.severely-underweight": "Severely underweight",
  "growth.weight.underweight": "Underweight",
  "growth.weight.typical": "Not underweight",
  "students.col_ht_who": "Height (WHO)",
  "students.col_wt_who": "Weight (WHO)",
  "students.col_bmi_who": "BMI (WHO)",
  "students.growth_chart_height": "Height for age",
  "students.growth_chart_bmi": "BMI for age",
  "students.growth_chart_weight": "Weight for age",
  "students.growth_chart_band_outer": "3rd–97th percentile",
  "students.growth_chart_band_inner": "15th–85th percentile",
  "students.growth_chart_median": "50th percentile",
  "students.growth_chart_child": "This child",
  "students.growth_chart_age_axis": "Age (years)",
  "students.growth_chart_tooltip_age": "Age {{years}} years",
  "students.growth_chart_no_reference": "WHO publishes no curve at these ages — only this child’s own measurements are drawn. For weight past age ten, read BMI for age instead.",
  "students.growth_chart_not_comparable": "Add a date of birth and sex to this student to compare their measurements with the WHO curves.",
  "nav.medical_hub": "Medical",
  "medical.hub.tab_today": "Today",
  "medical.hub.tab_measurements": "Measurements",
  "medical.hub.tab_temperature": "Temperature",
  "medical.hub.tab_allergies": "Allergies",
  "medical.hub.settings": "Medical settings",
  "medical.hub.measurements_title": "Measurement coverage",
  "medical.hub.temperature_title": "Temperature coverage",
  "medical.hub.allergies_title": "Allergies and dietary notes",
  "medical.hub.today_title": "Today",
  "medical.hub.tabs_label": "Medical hub tabs",
  "medical.hub.measurements_subtitle": "Who has been measured, and how many times each year.",
  "medical.hub.filter_missing_year": "Missing this year",
  "medical.hub.filter_never": "Never measured",
  "medical.hub.filter_all": "All",
  "medical.hub.col_last": "Last measured",
  "medical.hub.never_measured": "Never",
  "medical.hub.measurements_empty": "Nobody matches this filter.",
  "medical.hub.temperature_subtitle": "Temperature is taken up to Kindergarten, usually three times a day.",
  "medical.hub.filter_no_reading": "No reading today",
  "medical.hub.out_today": "Out today",
  "medical.hub.filter_short": "Fewer than {{expected}}",
  "medical.hub.col_class": "Class",
  "medical.hub.col_readings": "Readings",
  "medical.hub.date": "Date",
  "medical.hub.temperature_empty": "Nobody matches this filter.",
  "medical.hub.allergies_subtitle": "Every student's allergies and dietary notes.",
  "medical.hub.filter_any_allergy": "Any allergy",
  "medical.hub.filter_severe": "Severe",
  "medical.hub.filter_no_record": "No record",
  "medical.hub.col_allergies": "Allergies",
  "medical.hub.col_diet": "Dietary note",
  "medical.hub.no_record_note": "Nothing has been filled in for these children. That is not the same as having no allergies.",
  "medical.hub.allergies_empty": "Nobody matches this filter.",
  "medical.hub.today_subtitle": "Who is out sick, how the temperature round stands, and who has been to the infirmary.",
  "medical.hub.total_sick": "Out sick",
  "medical.hub.total_infirmary": "Infirmary visits",
  "medical.hub.total_no_temperature": "No temperature yet",
  "medical.hub.temperature_progress": "{{complete}} / {{students}} done",
  "medical.hub.class_quiet": "Nothing today.",
  "medical.hub.today_empty": "No classes to show.",
  "medical.hub.temperature_none_count": "{{count}} with none yet",
  "students.attendance_missed_while_at_school_one": "1 lesson missed while at school",
  "students.attendance_missed_while_at_school_other": "{{count}} lessons missed while at school",
  "students.attendance_missed_lessons": "Missed {{lessons}}",
  "attendance.arrives_at": "Arrives {{time}}",
  "attendance.col_rate_marked_days": "Attended, of the days that were marked",
  "attendance.subject_rates_view_rate": "Attendance rate",
  "attendance.subject_rates_view_missed": "Missed while at school",
  "lesson_notes.previous_title": "Last time · {{when}}",
  "lesson_notes.editor_label": "What we did",
  "lesson_notes.editor_placeholder": "Optional — only you can see this.",
  "lesson_notes.saved": "Saved to your diary",
  "lesson_notes.cleared": "Entry removed from your diary",
  "lesson_notes.future_hint": "You can write what you did after the lesson.",
  "medical.hub.record_temperature": "Take temperatures",
  "notifications.item.conferences.teacher-digest": "{{count}} PTC change(s) since yesterday",
  "notifications.item.conferences.teacher-final-schedule": "Booking has closed: your PTC schedule has {{count}} talk(s)",
  "notifications.item.early-dismissals.gate-reminder_one": "1 pickup coming up",
  "notifications.item.early-dismissals.gate-reminder_other": "{{count}} pickups coming up",
  "notifications.item.immigration.digest_one": "Immigration compliance digest: 1 item",
  "notifications.item.immigration.digest_other": "Immigration compliance digest: {{count}} items",
  "notifications.item.report-cards.deadline": "{{count}} report card subject(s) still to fill",
  "notifications.mark_read": "Mark as read",
  "notifications.detail.temperature": "{{tempC}} °C",
  "notifications.urgency.urgent": "Urgent",
  "notifications.urgency.action": "Action needed",
  "notifications.open": "Open",
  "notifications.dismiss": "Dismiss",
  "notifications.dismiss_all": "Dismiss all",
  "notifications.more_count": "+{{count}} more",
  "allergy_changes.detail_breadcrumb": "Detail",
  "allergy_changes.not_found": "This allergy change request could not be found.",
  "allergy_changes.request_section": "Request",
  "contact_inquiries.detail_breadcrumb": "Detail",
  "contact_inquiries.not_found": "This inquiry could not be found.",
  "contact_inquiries.message": "Message",
  "tours.detail_breadcrumb": "Detail",
  "tours.detail_title": "Tour Request — {{name}}",
  "tours.not_found": "This tour request could not be found.",
  "tours.request_section": "Request",
  "tours.full_name": "Full Name",
  "tours.phone": "Phone",
  "tours.message": "Message",
  "tours.born": "born",
  "student_absences.detail_breadcrumb": "Absence",
  "student_absences.not_found": "This absence could not be found. It may have been deleted.",
  "student_absences.detail_title": "Absence — {{name}}",
  "allergy_changes.detail_title": "Allergy change — {{name}}",
  "lesson_excusals.detail_breadcrumb": "Lesson excusal",
  "lesson_excusals.not_found": "This lesson excusal could not be found. It may have been deleted.",
  "lesson_excusals.detail_title": "Lesson excusal — {{name}}",
  "early_dismissals.detail_breadcrumb": "Early dismissal",
  "early_dismissals.not_found": "This early dismissal could not be found. It may have been deleted.",
  "early_dismissals.detail_title": "Early dismissal — {{name}}",
  "bookings.detail_breadcrumb": "Booking",
  "bookings.not_found": "This booking could not be found. It may have been cancelled.",
  "leave.not_found": "This leave request could not be found.",
  "leave.decision_message": "Message from the reviewer",
  "contact_inquiries.request_section": "Inquiry",
  "presence.online_count_one": "1 online",
  "presence.online_count_other": "{{count}} online",
  "medical.hub.not_a_school_day": "Not a school day",
  "medical.hub.tab_growth": "Growth",
  "medical.hub.growth_title": "Growth findings",
  "medical.hub.growth_subtitle": "Each child's latest measurement read against the WHO curves.",
  "medical.hub.growth_measured": "Children measured",
  "medical.hub.growth_attention": "Worth a look",
  "medical.hub.growth_attention_hint": "The bands WHO marks most strongly.",
  "medical.hub.growth_monitor": "Worth watching",
  "medical.hub.growth_monitor_hint": "Outside the expected range, but not the band WHO marks most strongly.",
  "medical.hub.growth_unreadable": "Cannot be read",
  "medical.hub.growth_unreadable_hint": "A missing or impossible date of birth does not leave a child unscored — it scores them against the wrong curves, which can read as reassuring. Fix these first.",
  "medical.hub.growth_empty": "Nothing to show yet.",
  "medical.hub.growth_measurement": "Measurement",
  "medical.hub.growth_findings": "What the curves say",
  "medical.hub.growth_issue": "What is missing",
  "medical.hub.growth_issue_no_date_of_birth": "No date of birth on file",
  "medical.hub.growth_issue_no_sex": "No sex on file",
  "medical.hub.growth_issue_age_implausible": "The date of birth does not fit the class",
  "medical.hub.growth_age_recorded": "recorded as {{years}} years old",
  "medical.hub.growth_percentile": "{{value}}th centile",
  "medical.hub.growth_wh": "{{weight}} kg · {{height}} cm",
  "medical.hub.growth_bmi": "BMI {{bmi}}",
  "medical.hub.growth_indicator.height-for-age": "height for age",
  "medical.hub.growth_indicator.weight-for-age": "weight for age",
  "medical.hub.growth_indicator.bmi-for-age": "BMI for age",
  "students.attendance_late_count_one": "Late once",
  "students.attendance_late_count_other": "Late {{count}} times",
  "students.attendance_late_minutes": "{{total}} minutes in total, {{average}} on average",
  "students.attendance_late_worst": "worst {{minutes}} min on {{date}}",
  "students.attendance_late_excused_one": "{{count}} more with a late arrival on file (excused)",
  "students.attendance_late_excused_other": "{{count}} more with a late arrival on file (excused)",
  "students.attendance_by_subject": "By subject, this year",
  "report_cards.tab_entry": "My entries",
  "report_cards.tab_ptc": "PTC",
  "report_cards.tab_periods": "Periods",
  "report_cards.tab_completeness": "Completeness",
  "report_cards.tabs_label": "Report card sections",
  "report_cards.heading": "Report periods",
  "report_cards.periods.subtitle": "Open a quarter to build its subject matrix and every student's draft report card, then correct the details below.",
  "report_cards.periods.new_period": "New Period",
  "report_cards.periods.select_school_year_placeholder": "Select a school year",
  "report_cards.periods.empty": "No report periods yet for this school year.",
  "report_cards.periods.col_sequence": "#",
  "report_cards.periods.col_name": "Name",
  "report_cards.periods.col_start_date": "Start Date",
  "report_cards.periods.col_end_date": "End Date",
  "report_cards.periods.col_due_at": "Deadline",
  "report_cards.periods.status_draft": "Draft",
  "report_cards.periods.status_open": "Open",
  "report_cards.periods.status_closed": "Closed",
  "report_cards.periods.status_published": "Published",
  "report_cards.periods.open_action": "Open",
  "report_cards.periods.open_confirm_title": "Open \"{{name}}\"?",
  "report_cards.periods.open_confirm_description": "This will create the subject matrix for every grade — cloned from the last period, or read from the timetable if there is none — plus a draft report card for every enrolled student. This cannot be undone.",
  "report_cards.periods.close_action": "Close",
  "report_cards.periods.close_confirm_title": "Close \"{{name}}\"?",
  "report_cards.periods.close_confirm_description": "Teachers will no longer be able to change marks or comments for this period. The subject matrix becomes read-only.",
  "report_cards.periods.matrix_action": "Matrix",
  "report_cards.periods.edit_title": "Edit Report Period",
  "report_cards.periods.new_title": "New Report Period",
  "report_cards.periods.field_number": "Number",
  "report_cards.periods.field_entry_opens_at": "Entry opens (optional)",
  "report_cards.periods.field_issue_date": "Date of report (optional)",
  "report_cards.periods.error_sequence_required": "Enter a period number.",
  "report_cards.periods.error_name_required": "Name is required.",
  "report_cards.periods.error_start_date_required": "Start date is required.",
  "report_cards.periods.error_end_date_required": "End date is required.",
  "report_cards.periods.error_end_before_start": "End date must be on or after the start date.",
  "report_cards.periods.error_entry_opens_at_out_of_span": "Entry opening date must fall between the start and end dates.",
  "report_cards.periods.error_due_at_required": "Deadline is required.",
  "report_cards.periods.error_due_at_out_of_span": "Deadline cannot be before the start date or the day entry opens.",
  "report_cards.periods.open_success_cloned": "Opened: {{lines}} subject lines and {{cards}} report cards created, cloned from the last period.",
  "report_cards.periods.open_success_timetable": "Opened: {{lines}} subject lines and {{cards}} report cards created from the timetable.",
  "report_cards.periods.close_success": "Period closed.",
  "report_cards.matrix.title": "Subject matrix — {{name}}",
  "report_cards.matrix.read_only_notice": "This period is closed. The subject matrix is read-only.",
  "report_cards.matrix.add_line": "Add Subject",
  "report_cards.matrix.col_label": "Subject",
  "report_cards.matrix.col_scale": "Scale",
  "report_cards.matrix.col_kind": "Kind",
  "report_cards.matrix.col_teachers": "Teachers",
  "report_cards.matrix.kind_grade": "Grade",
  "report_cards.matrix.kind_standards": "Standards",
  "report_cards.matrix.kind_narrative": "Narrative",
  "report_cards.matrix.move_up": "Move up",
  "report_cards.matrix.move_down": "Move down",
  "report_cards.matrix.empty": "No subject lines yet for this grade level.",
  "report_cards.matrix.edit_line_title": "Edit Subject Line",
  "report_cards.matrix.new_line_title": "New Subject Line",
  "report_cards.matrix.field_key": "Key",
  "report_cards.matrix.field_label": "Printed Label",
  "report_cards.matrix.field_group_label": "Group Label",
  "report_cards.matrix.field_scale": "Grading Scale",
  "report_cards.matrix.no_scale": "No scale",
  "report_cards.matrix.field_kind": "Kind",
  "report_cards.matrix.field_description": "Description",
  "report_cards.matrix.field_comment_enabled": "Comment enabled",
  "report_cards.matrix.error_key_required": "Key is required.",
  "report_cards.matrix.error_label_required": "Label is required.",
  "report_cards.entry.heading": "Grade entry",
  "report_cards.entry.due": "Due {{date}}",
  "report_cards.entry.overdue": "Overdue",
  "report_cards.entry.outstanding_badge": "{{count}} to fill",
  "report_cards.entry.no_open_period": "There is no report period open for entry right now.",
  "report_cards.entry.nothing_to_submit": "Nothing to submit this quarter — no subject lines are assigned to you.",
  "report_cards.entry.scope_label": "Whose classes to show",
  "report_cards.entry.scope_mine": "My classes · {{count}} to fill",
  "report_cards.entry.scope_all": "All classes · {{count}} to fill",
  "report_cards.entry.mine_empty": "You don't teach any class in this quarter — switch to All classes to fill in for others.",
  "report_cards.entry.grid_empty": "No students on this line yet.",
  "report_cards.entry.col_grade": "Grade",
  "report_cards.entry.col_comment": "Comment",
  "report_cards.entry.grade_label": "Grade for {{name}}",
  "report_cards.entry.comment_label": "Comment for {{name}}",
  "report_cards.entry.comment_saved": "Saved",
  "report_cards.entry.copy_comment": "Copy last quarter's comment",
  "report_cards.entry.comment_only": "Comment only",
  "report_cards.entry.comment_only_hint": "This child gets no letter grade this period — the comment is the assessment.",
  "report_cards.entry.movement_up": "Improved since {{period}}",
  "report_cards.entry.movement_down": "Declined since {{period}}",
  "report_cards.entry.movement_level": "No change since {{period}}",
  "report_cards.completeness.col_subject": "Subject",
  "report_cards.completeness.col_teachers": "Teachers",
  "report_cards.completeness.col_progress": "Filled / Total",
  "report_cards.completeness.unassigned": "Unassigned",
  "report_cards.completeness.empty": "No subject lines yet for this period.",
  "students.detail_tab_map": "MAP",
  "students.report_card.tab": "Report card",
  "students.report_card.quarter": "Quarter",
  "students.report_card.empty": "You don't teach this student, so their report cards aren't shown.",
  "students.report_card.load_error": "The report cards could not be loaded. Please try again.",
  "students.report_card.draft": "Draft",
  "students.report_card.published": "Published",
  "students.report_card.pdf": "PDF",
  "students.report_card.specialists_only_note": "The indicators and homeroom comments are shared with the homeroom team only.",
  "students.report_card.class": "Class",
  "students.report_card.homeroom_teacher": "Homeroom teacher",
  "students.report_card.subjects": "Subject grades",
  "students.report_card.comment_only_note": "This period, this child is assessed through teacher comments rather than letter grades.",
  "students.report_card.homeroom_comment": "Homeroom teacher's comment",
  "students.report_card.attendance": "Attendance",
  "students.report_card.attendance_none": "No attendance was recorded for this reporting period.",
  "students.report_card.attendance_school_days": "School days",
  "students.report_card.attendance_present": "Present",
  "students.report_card.attendance_late": "Late",
  "students.report_card.attendance_absent": "Absent",
  "students.report_card.attendance_excused": "Excused",
  "students.report_card.attendance_suspended": "Suspended",
  "students.report_card.attendance_rate": "Attendance rate",
  "students.report_card.lesson_summaries": "Lesson summaries",
  "students.report_card.indicators": "Indicators",
  "students.report_card.specialists": "Specialist subjects",
  "students.report_card.strengths": "Strengths & celebrated moments",
  "students.report_card.growth": "Areas for continued growth",
  "students.report_card.home_support": "How to support learning at home",
  "map.title": "MAP test results",
  "map.none_for_student": "No MAP results have been imported for this student yet.",
  "map.term": "Term",
  "map.grade": "Grade",
  "map.rit_score": "RIT score (+/- std err)",
  "map.growth": "Growth",
  "map.projection": "Projection",
  "map.percentile": "Percentile",
  "map.goals_performance": "Goals performance — {{term}}",
  "map.lexile_range": "Lexile® range",
  "map.quantile_range": "Quantile® range",
  "map.import_file_label": "MAP results file",
  "map.step_export_title": "Export from MAP Growth",
  "map.step_export_body": "Run a Comprehensive data export in MAP Growth and unzip it. You need the AssessmentResults.csv inside. Each term is a separate export, and they can be uploaded in any order.",
  "map.step_upload_title": "Upload AssessmentResults.csv",
  "map.step_review_title": "Check and import",
  "map.step_review_waiting": "You will see which students the file matches before anything is saved.",
  "map.import_another": "Import another file",
  "map.import_action": "Import",
  "map.import_preview_done": "Nothing has been saved yet.",
  "map.import_done": "Imported.",
  "map.import_counts": "{{parsed}} rows read, {{matched}} matched to a student, {{created}} new and {{updated}} updated.",
  "map.import_terms": "Terms in this file: {{terms}}",
  "map.import_unmatched": "{{count}} rows could not be matched to a student:",
  "map.import_no_id": "(no student ID)",
  "common.reset": "Reset",
  "map.download_pdf": "Download PDF",
  "map.import_roster_label": "StudentBySchool.csv (optional, adds the grade each student was in)",
  "map.import_grades": "Grade found for {{count}} rows.",
  "map.import_no_grades": "No grades found. Without StudentBySchool.csv the percentile, school average and national average cannot be shown for these results.",
  "map.school_average": "School",
  "map.national_average": "National",
  "map.rit_score_help": "The score itself, with the test's margin of error either side. MAP reports a range because no single sitting pins a child to one number.",
  "map.growth_help": "Points gained since the last sitting NWEA compared this one against. Blank where there is no earlier sitting to compare.",
  "map.projection_help": "The growth NWEA expected over that same period, for a child who started where this one did. Compare it with Growth.",
  "map.percentile_help": "Out of 100 children in the same grade nationally, how many scored at or below this child. Shown as the range the score's margin of error allows, with NWEA's own figure in the middle.",
  "map.school_average_help": "The average score of RIS Phuket children in the same grade that term. The number in brackets is how many children that average is taken over — a small group moves a long way on one result.",
  "map.national_average_help": "The average score for that grade and term in NWEA's 2025 national norms.",
  "map.step_reports_title": "Upload the NWEA reports (optional)",
  "map.step_reports_body": "The PDF NWEA produces for each child, one file per student. Files are matched to students by the ID in the filename, and only the most recent report is kept, so uploading again replaces the last one.",
  "map.reports_file_label": "Student report PDFs",
  "map.reports_counts": "{{files}} files, {{matched}} matched to a student.",
  "map.reports_replacing": "{{count}} of these replace a report already on file.",
  "map.reports_unmatched": "{{count}} files were not attached to anyone:",
  "map.reports_matched_heading": "Matched:",
  "map.reports_action": "Attach these reports",
  "map.reports_done": "Reports attached.",
  "map.reports_preview_done": "Nothing has been saved yet.",
  "map.reports_another": "Upload more reports",
  "map.download_report": "Download NWEA report",
  "map.step_notify_title": "Tell families the report is ready",
  "map.step_notify_body": "Sends one email per child to that child's own parents, linking them to the report in the parent portal. Only families whose child has a report are written to, and nobody is written to twice. You can do this now or come back to it days later.",
  "map.notify_pending": "{{count}} children have a report their family has not been told about.",
  "map.notify_none": "Every family with a report has already been told.",
  "map.notify_action": "Send the emails",
  "map.notify_sending": "Sending…",
  "map.notify_done": "Sent {{emails}} emails for {{count}} children.",
  "map.notify_no_recipients": "{{count}} children were skipped because no parent has an email address on file:",
  "map.import_needs_results": "Include the AssessmentResults.csv — that is the file with the scores in it.",
  "edp.students.col_actions": "",
  "edp.students.discount_action": "Discount",
  "edp.students.office_discount": "office −{{amount}}",
  "edp.adjustments.title": "Discounts",
  "edp.adjustments.description": "What the office has taken off {{name}}'s bill this round, and why.",
  "edp.adjustments.amount": "Amount off (THB)",
  "edp.adjustments.amount_required": "Enter a whole number of baht, more than nothing.",
  "edp.adjustments.reason": "Reason",
  "edp.adjustments.reason_required": "Say why this discount was given.",
  "edp.adjustments.reason_placeholder": "Moved from Yoga to Cooking after 1 lesson",
  "edp.adjustments.grant": "Give discount",
  "edp.adjustments.granted": "Discount given.",
  "edp.adjustments.withdraw": "Withdraw",
  "edp.adjustments.withdrawn": "Discount withdrawn.",
  "conferences.title": "PTCs",
  "conferences.new": "New PTC",
  "conferences.empty": "No PTCs yet.",
  "conferences.col_title": "Title",
  "conferences.col_dates": "Dates",
  "conferences.col_grades": "Grades",
  "conferences.col_status": "Status",
  "conferences.col_booked": "Booked",
  "conferences.col_families": "Parents booked",
  "conferences.status.draft": "Draft",
  "conferences.status.open": "Open",
  "conferences.status.closed": "Closed",
  "conferences.status.cancelled": "Cancelled",
  "conferences.back": "Back",
  "conferences.tab_teachers": "Teachers",
  "conferences.tab_schedule": "Schedule",
  "conferences.tab_students": "Students",
  "conferences.students.search": "Search a child or the parent who booked",
  "conferences.students.filter_label": "Filter children",
  "conferences.students.filter_all": "All",
  "conferences.students.filter_booked": "With talks",
  "conferences.students.filter_none": "No talks yet",
  "conferences.students.no_talks": "No talks booked yet",
  "conferences.students.booked_by": "Booked by {{name}}",
  "conferences.students.booked_by_office": "Booked by the office",
  "conferences.students.with": "With {{names}}",
  "conferences.students.empty": "No child matches this search.",
  "conferences.tab_families": "Families",
  "conferences.detail.families_booked": "{{booked}} of {{invited}} parents booked",
  "conferences.invite_title": "Invite families",
  "conferences.invite_body": "This opens booking and emails {{count}} parents in these grades their PTC invitation.",
  "conferences.invite_action": "Send invitation",
  "conferences.invite_confirm": "Send this invitation to {{count}} parents?",
  "conferences.invite_sent": "Invitation sent to {{count}} parents.",
  "conferences.invite_scheduled": "Booking opens automatically on {{date}}, and {{count}} parents get the invitation then. You can still send it now.",
  "conferences.remind_title": "{{count}} parents have not booked yet",
  "conferences.remind_all_title": "Remind all {{count}} invited parents",
  "conferences.remind_last": "Last reminder: {{date}}",
  "conferences.remind_never": "never",
  "conferences.remind_action": "Send reminder",
  "conferences.remind_confirm": "Send a reminder to {{count}} parents?",
  "conferences.remind_sent": "Reminder sent to {{count}} parents.",
  "conferences.remind_too_late": "The last day has come, so it is too late to send a reminder.",
  "conferences.cancel_action": "Cancel this PTC",
  "conferences.cancel_confirm": "Families with a booking will be emailed that it is cancelled.",
  "conferences.cancel_confirm_button": "Cancel PTC",
  "conferences.closed_note": "Booking closed on {{date}}. You can still change bookings on the Schedule tab.",
  "conferences.mine_title": "My PTC schedule",
  "conferences.mine_empty": "No PTC is scheduled for you.",
  "conferences.mine_parents": "Parents: {{names}}",
  "conferences.mine_comments": "My comments ({{period}})",
  "conferences.mine_note_add": "Add note",
  "conferences.mine_note_edit": "Edit note",
  "conferences.mine_note_label": "Private note",
  "conferences.mine_note_hint": "Only you can see this note.",
  "conferences.mine_note_saved": "Note saved",
  "conferences.mine_report_card_of": "Report card: {{name}}",
  "conferences.mine_free": "Free",
  "conferences.mine_break": "Break",
  "conferences.mine_print": "Print my schedule",
  "conferences.mine_calendar": "Download this PTC (.ics)",
  "conferences.mine_session": "Whole-school session: {{title}}",
  "conferences.calendar_card.title": "Your PTC calendar",
  "conferences.calendar_card.explanation": "Your calendar updates by itself as families book, move or cancel — you don't need to add it again, and it stays for future PTCs. Apple Calendar and Outlook refresh within minutes; Google Calendar can take up to a day. Each conference reminds you 10 minutes before.",
  "conferences.calendar_card.add": "Add to my calendar",
  "conferences.calendar_card.copy": "Copy link",
  "conferences.calendar_card.copied": "Link copied.",
  "conferences.calendar_card.copy_error": "Couldn't copy the link.",
  "conferences.calendar_card.google_hint": "In Google Calendar: Other calendars → + → From URL, then paste.",
  "conferences.calendar_card.reset": "Reset link",
  "conferences.calendar_card.reset_confirm_title": "Reset your calendar link?",
  "conferences.calendar_card.reset_confirm_description": "Calendars using the old link stop updating. You will need to add the new one.",
  "conferences.calendar_card.reset_success": "Calendar link reset.",
  "conferences.form.new_title": "New PTC",
  "conferences.form.edit_title": "Edit PTC",
  "conferences.form.title": "Title",
  "conferences.form.grades": "Grades",
  "conferences.form.slot_minutes": "Slot length",
  "conferences.form.closes_at": "Booking closes",
  "conferences.form.opens_at": "Booking opens",
  "conferences.form.opens_at_time": "Booking opens time",
  "conferences.form.opens_at_hint": "Optional. At this time booking opens and families get the invitation by email, without anyone clicking Send. Leave empty to send it yourself.",
  "conferences.form.days": "Days",
  "conferences.form.day_n": "Day {{n}}",
  "conferences.form.add_day": "Add day",
  "conferences.form.add_block": "Add block",
  "conferences.form.remove_day": "Remove day",
  "conferences.form.remove_block": "Remove block",
  "conferences.form.block_start": "Start",
  "conferences.form.block_end": "End",
  "conferences.form.open_only_note": "This PTC is open — only the title and booking deadline can still be changed.",
  "conferences.form.error_title_required": "Title is required.",
  "conferences.form.error_grades_required": "Choose at least one grade.",
  "conferences.form.error_closes_required": "Choose when booking closes.",
  "conferences.form.error_closes": "Booking must close before the first talk.",
  "conferences.form.error_opens_future": "Booking must open in the future.",
  "conferences.form.error_opens_before_close": "Booking must open before it closes.",
  "conferences.form.error_days_required": "Add at least one day.",
  "conferences.form.error_day_date_required": "Choose a date for every day.",
  "conferences.form.error_day_duplicate": "Each day can only be listed once.",
  "conferences.form.error_block_required": "Each day needs at least one block.",
  "conferences.form.error_block_time": "Block times must be in HH:mm form.",
  "conferences.form.error_block_order": "A block must end after it starts.",
  "conferences.form.error_block_overlap": "Blocks on the same day must not overlap.",
  "conferences.form.error_slots": "Each block must divide evenly into a whole number of slots.",
  "conferences.form.block_kind": "Block kind",
  "conferences.form.kind_appointments": "Appointments",
  "conferences.form.kind_session": "Session",
  "conferences.form.session_title": "Programme title",
  "conferences.form.item_time": "Time",
  "conferences.form.item_title": "Item title",
  "conferences.form.item_description": "Description",
  "conferences.form.add_item": "Add item",
  "conferences.form.remove_item": "Remove item",
  "conferences.form.error_session_title": "Give this session a title.",
  "conferences.form.error_session_items": "A session needs at least one programme item.",
  "conferences.form.error_session_item_title": "Each programme item needs a title.",
  "conferences.form.error_session_item_time": "A programme item's time must fall inside its block.",
  "conferences.teachers.add": "Add teacher",
  "conferences.teachers.add_title": "Add a teacher",
  "conferences.teachers.col_teacher": "Teacher",
  "conferences.teachers.col_subject": "Subject",
  "conferences.teachers.col_room": "Room",
  "conferences.teachers.col_grades": "Grades",
  "conferences.teachers.col_breaks": "Breaks",
  "conferences.teachers.col_bookings": "Bookings",
  "conferences.teachers.empty": "No teachers on this PTC yet.",
  "conferences.teachers.remove_title": "Remove teacher",
  "conferences.teachers.remove_description": "Remove {{name}} from this PTC? Their room and subject label go with them.",
  "conferences.teachers.remove_blocked": "This teacher already has bookings — cancel or move them first.",
  "conferences.teachers.resync": "Re-sync from timetable",
  "conferences.teachers.resync_title": "Re-sync from timetable",
  "conferences.teachers.resync_description": "This replaces the teacher list with whoever the timetable now has teaching these grades. Rooms and subject labels already set are kept for any teacher who stays.",
  "conferences.grid.col_time": "Time",
  "conferences.grid.jump_to_teacher": "Jump to a teacher",
  "conferences.grid.free": "Free",
  "conferences.grid.break": "Break",
  "conferences.grid.book_for_family": "Book for a family",
  "conferences.grid.mark_as_break": "Mark as break",
  "conferences.grid.free_aria": "Free slot, {{teacher}}, {{time}}",
  "conferences.grid.break_aria": "Break, {{teacher}}, {{time}} — remove break",
  "conferences.grid.block_break_on_aria": "Mark {{teacher}} on break for {{block}}",
  "conferences.grid.block_break_off_aria": "Remove {{teacher}}'s break for {{block}}",
  "conferences.grid.booked_aria": "{{students}} with {{teacher}} at {{time}}",
  "conferences.grid.booked_by_office": "by the office",
  "conferences.grid.booked_by_name": "by {{name}}",
  "conferences.grid.booked_by_family": "the family",
  "conferences.grid.move_to": "Move to…",
  "conferences.grid.move": "Move",
  "conferences.grid.cancel_talk": "Cancel talk",
  "conferences.grid.cancel_talk_title": "Cancel this talk?",
  "conferences.grid.cancel_talk_description": "This frees the slot booked for {{names}}.",
  "conferences.grid.cancel_talk_confirm": "Cancel talk",
  "conferences.grid.nothing_to_book": "Nothing to book — this PTC has no appointment slots, only the programme above.",
  "conferences.book.title": "Book for a family",
  "conferences.book.student": "Child",
  "conferences.book.students_label": "Who's coming",
  "conferences.book.teacher_does_not_teach": "This teacher does not teach {{name}}.",
  "conferences.book.this_child": "this child",
  "conferences.book.error_no_students": "Choose at least one student.",
  "conferences.print.button": "Print",
  "conferences.print.all_teachers": "All teachers",
  "conferences.print.this_teacher": "This teacher",
  "conferences.print.door_signs": "Door signs",
  "conferences.print.door_sign_this_teacher": "Door sign — this teacher",
  "conferences.print.file_door_sign": "Door sign – {{name}}",
  "conferences.print.file_teachers": "Teacher schedules",
  "conferences.print.by_family": "By student",
  "conferences.print.programme": "Programme",
  "conferences.print.block": "Block {{n}}",
  "conferences.print.col_family": "Student",
  "conferences.print.col_teacher": "Teacher",
  "conferences.print.col_room": "Room",
  "report_cards.early_years.heading": "{{name}} — Early Years report",
  "report_cards.early_years.level_select_label": "Level",
  "report_cards.early_years.banner_unset": "The office has not set this quarter's title, focus and purpose yet.",
  "report_cards.early_years.banner_focus": "Focus",
  "report_cards.early_years.banner_purpose": "Purpose",
  "report_cards.early_years.tabs_label": "Early Years report sections",
  "report_cards.early_years.tab_summaries": "Lesson summaries",
  "report_cards.early_years.tab_indicators": "Indicators",
  "report_cards.early_years.tab_grades": "Grades",
  "report_cards.early_years.tab_comments": "Comments",
  "report_cards.early_years.read_only": "This quarter is closed; everything here is read-only.",
  "report_cards.early_years.read_only_assistant": "You can read this report; only the homeroom teacher can change it.",
  "report_cards.early_years.summaries.intro": "What the class covered this quarter. It prints on every child's report under “What is covered”.",
  "report_cards.early_years.summaries.add": "Add summary",
  "report_cards.early_years.summaries.title": "Title",
  "report_cards.early_years.summaries.body": "What the class did",
  "report_cards.early_years.summaries.move_up": "Move up",
  "report_cards.early_years.summaries.move_down": "Move down",
  "report_cards.early_years.summaries.remove": "Remove",
  "report_cards.early_years.summaries.empty": "No summaries yet.",
  "report_cards.early_years.summaries.saved": "Summaries saved",
  "report_cards.early_years.summaries.error_title_required": "Give this summary a title",
  "report_cards.early_years.summaries.error_body_required": "Write what the class did",
  "report_cards.early_years.indicators.intro": "Pick this quarter's indicators from the {{level}} library and put them in the order they should print.",
  "report_cards.early_years.indicators.add": "Add indicators",
  "report_cards.early_years.indicators.new": "New indicator",
  "report_cards.early_years.indicators.import": "Import from spreadsheet",
  "report_cards.early_years.indicators.empty": "No indicators picked for this quarter yet.",
  "report_cards.early_years.indicators.move_up": "Move {{code}} up",
  "report_cards.early_years.indicators.move_down": "Move {{code}} down",
  "report_cards.early_years.indicators.remove": "Remove {{code}}",
  "report_cards.early_years.indicators.remove_graded_title": "Remove a graded indicator?",
  "report_cards.early_years.indicators.remove_graded_body": "Some children already have a grade for {{codes}}. It will be hidden from this quarter and the grades kept — adding it back restores them.",
  "report_cards.early_years.indicators.remove_confirm": "Remove",
  "report_cards.early_years.indicators.picker_title": "Choose this quarter's indicators",
  "report_cards.early_years.indicators.picker_description": "Ticked indicators appear on this quarter's report. “Suggested” follows the school's quarter plan.",
  "report_cards.early_years.indicators.suggested": "Suggested for Q{{quarter}}",
  "report_cards.early_years.indicators.select_suggested": "Tick all suggested",
  "report_cards.early_years.indicators.all_domains": "All categories",
  "report_cards.early_years.indicators.filter_domain": "Category",
  "report_cards.early_years.indicators.library_empty": "This level's library is empty. Import the school's spreadsheet or add an indicator.",
  "report_cards.early_years.indicators.edit": "Edit {{code}}",
  "report_cards.early_years.indicators.retire": "Retire {{code}}",
  "report_cards.early_years.indicators.retire_title": "Retire this indicator?",
  "report_cards.early_years.indicators.retire_body": "{{code}} will no longer be offered for new quarters. Quarters already using it keep it.",
  "report_cards.early_years.indicators.apply": "Apply",
  "report_cards.early_years.indicator.new_title": "New indicator",
  "report_cards.early_years.indicator.edit_title": "Edit indicator",
  "report_cards.early_years.indicator.domain": "Category",
  "report_cards.early_years.indicator.code": "Code",
  "report_cards.early_years.indicator.label": "Standard (parent-facing label)",
  "report_cards.early_years.indicator.description": "What this means",
  "report_cards.early_years.indicator.example": "Observed example",
  "report_cards.early_years.indicator.practice": "Supportive practice",
  "report_cards.early_years.indicator.quarters": "Suggested quarters",
  "report_cards.early_years.indicator.teacher_only": "The observed example and supportive practice are for teachers only; they never print.",
  "report_cards.early_years.indicator.error_required": "Required",
  "report_cards.early_years.import.title": "Import indicators from the spreadsheet",
  "report_cards.early_years.import.description": "In the spreadsheet, select columns A to F (Code to Qtrs) including the domain heading rows, copy, and paste them here. Existing codes are updated; new ones are added.",
  "report_cards.early_years.import.paste_label": "Pasted rows",
  "report_cards.early_years.import.preview": "{{count}} indicators in {{domains}} domains",
  "report_cards.early_years.import.skipped": "{{count}} rows have a code but no wording and were skipped.",
  "report_cards.early_years.import.submit": "Import",
  "report_cards.early_years.import.done": "{{created}} added, {{updated}} updated",
  "report_cards.early_years.grades.col_indicator": "Indicator",
  "report_cards.early_years.grades.teacher_notes": "Example and practice",
  "report_cards.early_years.grades.no_indicators": "Pick this quarter's indicators first.",
  "report_cards.early_years.grades.choose_indicators": "Choose indicators",
  "report_cards.early_years.grades.all_graded": "Every child has a grade for every indicator.",
  "report_cards.early_years.grades.still_to_grade_one": "{{count}} child still to grade:",
  "report_cards.early_years.grades.still_to_grade_other": "{{count}} children still to grade:",
  "report_cards.early_years.grades.child_missing": "{{name}} ({{count}})",
  "report_cards.early_years.grades.left_one": "{{count}} left",
  "report_cards.early_years.grades.left_other": "{{count}} left",
  "report_cards.early_years.grades.complete": "Done",
  "report_cards.early_years.grades.only_missing": "Show only children still to grade",
  "report_cards.early_years.reflection.strengths": "Strengths & celebrated moments",
  "report_cards.early_years.reflection.growth": "Areas for continued growth",
  "report_cards.early_years.reflection.home": "How to support learning at home",
  "report_cards.early_years.reflection.only_missing": "Only children with missing comments",
  "report_cards.early_years.reflection.previous": "Last quarter ({{period}})",
  "report_cards.early_years.reflection.copy": "Use last quarter's text",
  "report_cards.early_years.reflection.all_done": "Every child has all three comments.",
  "report_cards.early_years.reflection.field_label": "{{field}} — {{name}}",
  "report_cards.early_years.banner.title": "Early Years quarter heading",
  "report_cards.early_years.banner.hint": "Printed under the quarter heading on every {{level}} report.",
  "report_cards.early_years.banner.field_title": "Title",
  "report_cards.early_years.banner.field_focus": "Focus",
  "report_cards.early_years.banner.field_purpose": "Purpose",
  "report_cards.early_years.banner.saved": "Saved",
  "report_cards.periods.publish_action": "Publish",
  "report_cards.periods.publish_confirm_title": "Publish {{name}}?",
  "report_cards.periods.publish_confirm_description": "Every child's report card is rendered as a PDF and becomes visible to their family in the parent portal. The period is closed first, so teachers can no longer change entries, and the cards are dated today unless a date of report is set. Families are not emailed until you choose Notify families.",
  "report_cards.periods.publish_incomplete_title": "Some entries are still missing",
  "report_cards.periods.publish_anyway": "Publish anyway",
  "report_cards.periods.publish_success": "{{count}} report cards published",
  "report_cards.periods.unpublish_action": "Unpublish",
  "report_cards.periods.unpublish_confirm_title": "Unpublish {{name}}?",
  "report_cards.periods.unpublish_confirm_description": "Families will no longer see these report cards until you publish them again. Families already emailed are not emailed again when you republish.",
  "report_cards.periods.unpublish_success": "Report cards taken back from families",
  "report_cards.periods.notify_action": "Notify families",
  "report_cards.periods.notify_title": "Email families?",
  "report_cards.periods.notify_description": "{{cards}} children, {{parents}} parents will be emailed a link to the portal — no grades, no attachment. {{withoutRecipients}} of the children have no parent email on file.",
  "report_cards.periods.notify_send": "Send",
  "report_cards.periods.notify_success": "{{count}} emails sent",
  "report_cards.periods.notify_failed": "{{count}} emails could not be sent; notify again to retry them",
  "report_cards.periods.notify_nothing": "Every published report card has already been notified.",
  "report_cards.early_years.reflection.preview_pdf": "Preview PDF",
  "report_cards.periods.publish_progress": "Publishing report cards… {{done}} of {{total}}",
  "report_cards.periods.notify_progress": "Emailing families… {{done}} of {{total}} children",
  "report_cards.periods.remind_action_one": "Remind 1 family who has not opened it",
  "report_cards.periods.remind_action_other": "Remind {{count}} families who have not opened it",
  "report_cards.periods.remind_title": "Remind families who have not opened it?",
  "report_cards.periods.remind_description": "{{parents}} parents of {{cards}} children whose card no parent has opened yet will get a reminder email with a link to the portal. Families where a parent already opened it get nothing. {{withoutRecipients}} of the children have no parent email on file.",
  "report_cards.periods.remind_send": "Send reminder",
  "report_cards.periods.remind_success": "{{count}} reminders sent",
  "report_cards.periods.remind_failed": "{{count}} reminders could not be sent; remind again to retry them",
  "report_cards.periods.remind_nothing": "Every family who was notified has opened their card.",
  "report_cards.periods.remind_progress": "Reminding families… {{done}} of {{total}} children",
  "report_cards.periods.preview_action": "Children’s cards",
  "report_cards.periods.preview_title": "Children’s cards — {{name}}",
  "report_cards.periods.preview_description": "Choose a grade, then open any child’s PDF as it would be published now. Switch a child to comment only to leave out letter grades for this period; it carries into the next period until switched off.",
  "report_cards.periods.preview_grade": "Grade",
  "report_cards.periods.preview_empty": "No report cards in this grade for this period.",
  "report_cards.periods.preview_open": "Open {{name}}",
  "report_cards.periods.comment_only_for": "Comment only for {{name}}",
  "report_cards.early_years.indicators.add_to_category": "Add to {{domain}}",
  "report_cards.early_years.indicators.add_here": "Add indicator",
  "report_cards.early_years.indicator.code_optional": "Optional — leave empty for your own indicator",
  "report_cards.early_years.indicator.rubric": "What each level looks like (optional)",
  "report_cards.early_years.indicator.rubric_hint": "Shown to teachers beside the grade picker. E Emerging · D Developing · P Proficient · Ex Exemplary.",
  "report_cards.early_years.indicator.retire": "Retire",
  "report_cards.early_years.indicator.restore": "Restore",
  "report_cards.early_years.indicator.retire_hint": "Retiring removes it from the library for new quarters. Quarters already using it keep it.",
  "report_cards.early_years.indicator.retired_hint": "This indicator is retired.",
  "report_cards.early_years.grades.rubric": "What each level looks like",
  "pdf_preview.download": "Download the PDF",
  "pdf_preview.failed": "The PDF could not be made.",
  "pdf_preview.not_opened": "If the PDF did not open here:",
  "report_cards.preview_title": "Report card PDF",
  "report_cards.preview_preparing": "Preparing the report card PDF…",
  "my_classes.tabs_label": "My classes views",
  "my_classes.tab_today": "Today",
  "my_classes.tab_diary": "Diary",
  "my_classes.tab_tests": "Tests",
  "diary.title": "Teaching diary",
  "diary.subtitle": "Your private notes on what you did in class. Only you can see them.",
  "diary.new_entry": "New entry",
  "diary.edit_entry": "Edit entry",
  "diary.all_classes": "All classes",
  "diary.all_subjects": "All subjects",
  "diary.my_classes_group": "My classes",
  "diary.other_classes_group": "Other classes",
  "diary.field_class": "Class",
  "diary.field_subject": "Subject",
  "diary.field_date": "Date",
  "diary.field_from": "From",
  "diary.field_to": "To",
  "diary.field_body": "What we did",
  "diary.class_required": "Choose a class",
  "diary.subject_required": "Choose a subject",
  "diary.body_required": "Write something first",
  "diary.date_future": "Pick today or an earlier day",
  "diary.lesson_entry_hint": "Written from a lesson — only the text can change.",
  "diary.created": "Entry added",
  "diary.updated": "Entry updated",
  "diary.deleted": "Entry deleted",
  "diary.delete_title": "Delete this entry?",
  "diary.delete_description": "This cannot be undone.",
  "diary.empty_title": "No entries yet",
  "diary.empty_description": "Write what you did from a lesson on the Today tab, or add an entry here.",
  "diary.page_of": "Page {{page}} of {{pages}}",
  "diary.open_day": "Open this day",
  "class_tests.title": "Tests",
  "class_tests.subtitle": "Tests you have placed for your classes. Families see them in the parent portal.",
  "class_tests.place_test": "Place a test",
  "class_tests.edit_test": "Edit test",
  "class_tests.upcoming": "Upcoming",
  "class_tests.past": "Past",
  "class_tests.empty_title": "No tests yet",
  "class_tests.empty_description": "Place a test so your classes and their families know when it is.",
  "class_tests.mark": "Mark",
  "class_tests.results_published": "Results published",
  "class_tests.status_to_mark": "To mark",
  "class_tests.status_marking": "Marking {{marked}}/{{students}}",
  "class_tests.status_ready": "Ready to publish",
  "class_tests.out_of": "out of {{max}}",
  "class_tests.out_of_extra": "out of {{max}} + {{extra}} extra credit",
  "class_tests.cancelled": "Cancelled",
  "class_tests.cancel_test": "Cancel test",
  "class_tests.keep_test": "Keep test",
  "class_tests.cancel_title": "Cancel this test?",
  "class_tests.cancel_description": "Families who were told about it will be emailed that it is cancelled.",
  "class_tests.cancel_description_published": "Families who were told about it will be emailed that it is cancelled, and will no longer see its published results.",
  "class_tests.cancelled_toast": "Test cancelled",
  "class_tests.placed": "Test placed",
  "class_tests.updated": "Test updated",
  "class_tests.field_subject": "Subject",
  "class_tests.field_classes": "Grades",
  "class_tests.field_date": "Date",
  "class_tests.field_period": "Period",
  "class_tests.field_title": "Title",
  "class_tests.field_revise_note": "What to revise",
  "class_tests.revise_note_placeholder": "For example: chapters 2 and 3, the vocabulary list",
  "class_tests.field_remind": "Send a reminder the day before",
  "class_tests.no_period": "No period",
  "class_tests.pick_subject_first": "Choose a subject to see its grades.",
  "class_tests.subject_required": "Choose a subject",
  "class_tests.classes_required": "Tick at least one grade",
  "class_tests.date_required": "Choose a date",
  "class_tests.date_weekday": "A test must be on a school day (Monday to Friday)",
  "class_tests.title_required": "Give the test a title",
  "class_tests.past_date_hint": "Families won't be emailed about a test in the past.",
  "class_tests.emailed_hint": "Families will be emailed when you save.",
  "class_tests.week_label": "Tests that week",
  "class_tests.week_free": "No tests",
  "class_tests.week_pick_classes": "Tick a grade to see its other tests that week.",
  "class_tests.same_day_warning": "These grades already have a test that day:",
  "class_tests.marking": "Marking",
  "class_tests.marking_locked": "The results are published. Unpublish them on the mark sheet to change the marking.",
  "class_tests.mode_none": "Not graded",
  "class_tests.mode_total": "Total",
  "class_tests.mode_sections": "By section",
  "class_tests.mode_questions": "By question",
  "class_tests.field_max": "Maximum score",
  "class_tests.field_extra_max": "Extra-credit maximum (optional)",
  "class_tests.max_required": "Give a maximum score",
  "class_tests.max_invalid": "Enter a number above 0",
  "class_tests.part_label": "Name",
  "class_tests.part_question": "Question",
  "class_tests.part_section": "Section",
  "class_tests.part_max": "Out of",
  "class_tests.part_extra_credit": "Extra credit",
  "class_tests.part_label_required": "Give every part a name",
  "class_tests.parts_required": "Add at least one section or question",
  "class_tests.parts_need_scored": "At least one part must count towards the score",
  "class_tests.add_section": "Add section",
  "class_tests.add_question": "Add question",
  "class_tests.section_n": "Section {{n}}",
  "class_tests.question_n": "Question {{n}}",
  "class_tests.marks.title": "Mark sheet",
  "class_tests.marks.score": "Score",
  "class_tests.marks.extra_credit": "Extra credit",
  "class_tests.marks.extra": "Extra",
  "class_tests.marks.student": "Student",
  "class_tests.marks.status": "Status",
  "class_tests.marks.status_marked": "Marked",
  "class_tests.marks.status_absent": "Absent",
  "class_tests.marks.status_excused": "Excused",
  "class_tests.marks.comment": "Comment",
  "class_tests.marks.total": "Total",
  "class_tests.marks.letter": "Letter",
  "class_tests.marks.out_of": "Out of {{max}}",
  "class_tests.marks.out_of_extra": "Out of {{max}} + {{extra}} extra credit",
  "class_tests.marks.average": "Class average",
  "class_tests.marks.highest": "Highest",
  "class_tests.marks.lowest": "Lowest",
  "class_tests.marks.letters": "Letters",
  "class_tests.marks.left_class": "No longer in this grade",
  "class_tests.marks.needs_result": "Needs a score, or mark absent or excused",
  "class_tests.marks.missing": "Missing",
  "class_tests.marks.missing_banner_one": "{{count}} student still needs a result: enter a score, or mark them absent or excused.",
  "class_tests.marks.missing_banner_other": "{{count}} students still need a result: enter a score, or mark them absent or excused.",
  "class_tests.marks.comment_needs_status": "Choose a status before saving a comment",
  "class_tests.marks.err_number": "Enter a number",
  "class_tests.marks.err_negative": "Score cannot be negative",
  "class_tests.marks.err_over_max": "Score cannot be more than {{max}}",
  "class_tests.marks.err_decimals": "Use at most one decimal place",
  "class_tests.marks.fix_errors": "Some scores need fixing before they can be saved",
  "class_tests.marks.save_draft": "Save draft",
  "class_tests.marks.save": "Save",
  "class_tests.marks.saved_toast": "Draft saved",
  "class_tests.marks.saved_published_toast": "Saved. Families of students whose results changed will be emailed.",
  "class_tests.marks.nothing_changed": "Nothing has changed since the last save",
  "class_tests.marks.unsaved": "Unsaved changes",
  "class_tests.marks.publish": "Publish results",
  "class_tests.marks.publish_title": "Publish these results?",
  "class_tests.marks.publish_description": "Each family will be emailed their child's result and can see it in the parent portal.",
  "class_tests.marks.published_toast": "Results published",
  "class_tests.marks.publish_missing_one": "{{count}} student still needs a result",
  "class_tests.marks.publish_missing_other": "{{count}} students still need a result",
  "class_tests.marks.unpublish": "Unpublish",
  "class_tests.marks.unpublish_title": "Unpublish these results?",
  "class_tests.marks.unpublish_description": "Families will no longer see these results until you publish them again.",
  "class_tests.marks.unpublished_toast": "Results unpublished",
  "class_tests.view_label": "Which tests",
  "class_tests.view_mine": "My tests",
  "class_tests.view_history": "Subject history",
  "class_tests.mode_online": "Online",
  "class_tests.online.title": "Online questions",
  "class_tests.online.questions": "Questions",
  "class_tests.online.build_questions": "Build questions",
  "class_tests.online.build_hint": "Students take this test on a computer. Its questions are built on their own page.",
  "class_tests.online.build_hint_new": "Students take this test on a computer. Save the test and its question builder opens.",
  "class_tests.online.switch_away_title": "Delete the online questions?",
  "class_tests.online.switch_away_description": "Changing the marking from Online deletes this test's questions. This cannot be undone.",
  "class_tests.online.switch_away_confirm": "Delete questions",
  "class_tests.online.not_online": "This test is not marked online. Edit the test and set its marking to Online to build questions.",
  "class_tests.online.locked_title": "Students have started",
  "class_tests.online.locked_description": "Questions can no longer be added, deleted or change type. You can still fix the answer key, the question and option text and the points, or remove a question from scoring. Each change re-marks every student for that question.",
  "class_tests.online.add_section": "Add section",
  "class_tests.online.add_question": "Add question",
  "class_tests.online.add_option": "Add option",
  "class_tests.online.remove_option": "Remove option {{n}}",
  "class_tests.online.section_name": "Section name",
  "class_tests.online.section_n": "Section {{n}}",
  "class_tests.online.section_empty": "No questions in this section yet.",
  "class_tests.online.question_n": "Question {{n}}",
  "class_tests.online.question_type": "Question type",
  "class_tests.online.question_text": "Question",
  "class_tests.online.question_placeholder": "Write the question. Lines indented by four spaces, or fenced with ```, show as code.",
  "class_tests.online.option_n": "Option {{n}}",
  "class_tests.online.mark_correct": "Correct: {{option}}",
  "class_tests.online.mark_eliminate": "Eliminate: {{option}}",
  "class_tests.online.drag_option": "Drag to reorder: {{option}}",
  "class_tests.online.points": "Points",
  "class_tests.online.extra_credit": "Extra credit",
  "class_tests.online.model_answer": "Model answer (only markers see it)",
  "class_tests.online.type_single": "Single choice",
  "class_tests.online.type_multiple": "Multiple choice",
  "class_tests.online.type_order": "Order",
  "class_tests.online.type_subtraction": "Subtraction",
  "class_tests.online.type_text": "Free text",
  "class_tests.online.hint_single": "Pick the one correct option.",
  "class_tests.online.hint_multiple": "Tick every correct option. Wrong ticks cost marks.",
  "class_tests.online.hint_order": "List the items in the correct order; drag to rearrange. Each student starts with them scrambled.",
  "class_tests.online.hint_subtraction": "Tick the wrong options, which students should eliminate. Leave at least one standing.",
  "class_tests.online.hint_text": "Students type an answer, which you mark by hand.",
  "class_tests.online.student_hint_multiple": "Tick every correct answer.",
  "class_tests.online.student_hint_order": "Drag the items into the right order.",
  "class_tests.online.student_hint_subtraction": "Tick the options to eliminate.",
  "class_tests.online.move_up": "Move question up",
  "class_tests.online.move_down": "Move question down",
  "class_tests.online.move_section_up": "Move section up",
  "class_tests.online.move_section_down": "Move section down",
  "class_tests.online.duplicate": "Duplicate question",
  "class_tests.online.delete_question": "Delete question",
  "class_tests.online.delete_section": "Delete section",
  "class_tests.online.empty": "No questions yet. Add a section, or import a CSV.",
  "class_tests.online.out_of": "Out of {{max}}",
  "class_tests.online.out_of_extra": "Out of {{max}} + {{extra}} extra credit",
  "class_tests.online.save": "Save questions",
  "class_tests.online.saved_toast": "Questions saved",
  "class_tests.online.unsaved": "Unsaved changes",
  "class_tests.online.save_errors": "The questions were not saved. Fix these and try again:",
  "class_tests.online.reload": "Reload the questions",
  "class_tests.online.err_section_name": "Give every section a name",
  "class_tests.online.err_section_name_long": "Section names can be at most {{max}} characters",
  "class_tests.online.err_text_required": "Write the question",
  "class_tests.online.err_points": "Points must be above 0, with at most one decimal",
  "class_tests.online.err_option_text": "Options cannot be empty",
  "class_tests.online.err_min_options": "At least 2 options are required",
  "class_tests.online.err_order_min": "Order questions need at least 3 items",
  "class_tests.online.err_single": "Mark exactly one correct option",
  "class_tests.online.err_multiple": "Mark at least one correct option",
  "class_tests.online.err_subtraction_none": "Mark at least one option to eliminate",
  "class_tests.online.err_subtraction_all": "Leave at least one option standing",
  "class_tests.online.unsaved_change": "This question has changes that are not saved.",
  "class_tests.online.undo_change": "Undo",
  "class_tests.online.save_change": "Save change",
  "class_tests.online.remark_title": "Re-mark this question?",
  "class_tests.online.remark_description": "Everyone's marks for this question will be recalculated.",
  "class_tests.online.remark_confirm": "Save and re-mark",
  "class_tests.online.remarked_toast": "Saved, and everyone re-marked",
  "class_tests.online.removed": "Removed from scoring",
  "class_tests.online.remove_from_scoring": "Remove from scoring",
  "class_tests.online.remove_title": "Remove this question from scoring?",
  "class_tests.online.remove_description": "Students still see it, marked as removed, but it no longer counts towards any score or the maximum. Everyone's marks will be recalculated.",
  "class_tests.online.restore": "Restore",
  "class_tests.online.restore_title": "Count this question again?",
  "class_tests.online.copy_ai": "Copy AI instructions",
  "class_tests.online.copied_ai": "AI instructions copied. Paste them into any AI with your notes, then import the CSV it gives you.",
  "class_tests.online.import_csv": "Import CSV",
  "class_tests.online.import_title": "Import questions from a CSV",
  "class_tests.online.import_description": "One row per question, in the format \"Copy AI instructions\" describes. Nothing is imported unless every row is valid.",
  "class_tests.online.import_file": "CSV file",
  "class_tests.online.import_pick_file": "Choose a CSV file",
  "class_tests.online.import_mode": "What to do with the questions already here",
  "class_tests.online.import_mode_append": "Add to the questions already here",
  "class_tests.online.import_mode_replace": "Replace all the questions",
  "class_tests.online.import_submit": "Import",
  "class_tests.online.import_replace_title": "Replace all the questions?",
  "class_tests.online.import_replace_description_one": "The {{count}} question in this test is replaced by the file's.",
  "class_tests.online.import_replace_description_other": "The {{count}} questions in this test are replaced by the file's.",
  "class_tests.online.import_unsaved_title": "Import and lose your changes?",
  "class_tests.online.import_unsaved_description": "Your unsaved changes in the editor will be lost.",
  "class_tests.online.import_errors": "Nothing was imported. Fix these and try again:",
  "class_tests.online.import_error_row": "Row {{row}}: {{message}}",
  "class_tests.online.import_error_row_column": "Row {{row}} · {{column}}: {{message}}",
  "class_tests.online.import_error_question": "Section {{section}} · question {{question}}: {{message}}",
  "class_tests.online.import_error_section": "Section {{section}}: {{message}}",
  "class_tests.online.imported_toast": "Questions imported",
  "class_tests.online.preview": "Preview as student",
  "class_tests.online.preview_title": "Preview as a student",
  "class_tests.online.preview_description": "Every student gets their own order: questions shuffle within each section, and options shuffle too.",
  "class_tests.online.preview_empty": "There are no questions to preview yet.",
  "class_tests.online.preview_points_one": "{{count}} point",
  "class_tests.online.preview_points_other": "{{count}} points",
  "class_tests.online.shuffle_again": "Shuffle again",
  "class_tests.online.run": "Live",
  "class_tests.online.open_from": "A test can be opened from the day before its date",
  "class_tests.online.open_test": "Open test",
  "class_tests.online.close_test": "Close test",
  "class_tests.online.reopen_test": "Reopen test",
  "class_tests.online.open_title": "Open this test?",
  "class_tests.online.open_description": "Students in the test's classes can start it as soon as it is open. It closes by itself at midnight after the test date.",
  "class_tests.online.close_title": "Close this test?",
  "class_tests.online.close_description": "Students still working are stopped, and their unfinished answers will be submitted as they are.",
  "class_tests.online.reopen_title": "Reopen this test?",
  "class_tests.online.reopen_description": "Students who have not started can start. Before results are published, students stopped by the close can carry on.",
  "class_tests.online.opened_toast": "The test is open",
  "class_tests.online.closed_toast": "The test is closed and every answer is submitted",
  "class_tests.online.reopened_toast": "The test is open again",
  "class_tests.online.status_not_open": "Not open yet",
  "class_tests.online.status_open": "Open",
  "class_tests.online.status_closed": "Closed",
  "class_tests.online.tabs_label": "Online test",
  "class_tests.online.tab_live": "Live",
  "class_tests.online.tab_mark": "Mark answers",
  "class_tests.online.tab_students": "Students",
  "class_tests.online.mark_sheet": "Mark sheet",
  "class_tests.online.col_student": "Student",
  "class_tests.online.col_state": "State",
  "class_tests.online.col_answered": "Answered",
  "class_tests.online.col_left": "Left the test",
  "class_tests.online.col_score": "Score",
  "class_tests.online.state_not_started": "Not started",
  "class_tests.online.state_in_progress": "In progress",
  "class_tests.online.state_submitted": "Submitted",
  "class_tests.online.state_to_mark": "Submitted",
  "class_tests.online.state_complete": "Complete",
  "class_tests.online.to_mark": "{{n}} to mark",
  "class_tests.online.left_count": "Left the test {{times}}×",
  "class_tests.online.event_left": "Left",
  "class_tests.online.event_returned": "Came back",
  "class_tests.online.event_fullscreen_exit": "Left full screen",
  "class_tests.online.reopen_student": "Reopen for this student",
  "class_tests.online.reopen_student_title": "Reopen the test for {{name}}?",
  "class_tests.online.reopen_student_description": "{{name}} can carry on from the answers saved so far, and submits again when they finish or the test closes.",
  "class_tests.online.reopened_student_toast": "{{name}} can carry on",
  "class_tests.online.live_refresh": "Updates every 10 seconds",
  "class_tests.online.live_not_open": "Students can start once you open the test.",
  "class_tests.online.live_empty": "There are no students in this test's classes.",
  "class_tests.online.mark_empty": "No free-text answers to mark yet. They appear here once students submit.",
  "class_tests.online.mark_no_answers": "No one has answered this question yet.",
  "class_tests.online.mark_progress": "{{marked}} of {{total}} marked",
  "class_tests.online.mark_hint": "Each mark saves when you leave its box. Marks go from 0 to the question's points, in steps of 0.5.",
  "class_tests.online.model_answer_label": "Model answer",
  "class_tests.online.mark_input": "{{name}}, {{question}}",
  "class_tests.online.out_of_points": "/ {{max}}",
  "class_tests.online.saving": "Saving…",
  "class_tests.online.saved": "Saved",
  "class_tests.online.err_mark_number": "Enter a number",
  "class_tests.online.err_mark_negative": "Marks cannot be negative",
  "class_tests.online.err_mark_over": "At most {{max}}",
  "class_tests.online.err_mark_step": "Marks go in steps of 0.5",
  "class_tests.online.review_answers": "Review answers",
  "class_tests.online.review_title": "{{name}}'s answers",
  "class_tests.online.review_description": "In the order the student saw them. An override replaces the automatic mark; clear it to go back to the automatic mark.",
  "class_tests.online.review_not_submitted": "This student has not submitted yet. Marks can be changed once they do.",
  "class_tests.online.review_removed": "Removed by the teacher",
  "class_tests.online.review_auto": "Automatic mark: {{points}} / {{max}}",
  "class_tests.online.review_teacher": "Teacher's mark: {{points}} / {{max}}",
  "class_tests.online.review_overridden": "Overridden",
  "class_tests.online.review_picked": "Chosen",
  "class_tests.online.review_eliminated": "Eliminated",
  "class_tests.online.review_correct": "Correct answer",
  "class_tests.online.review_should_eliminate": "Should be eliminated",
  "class_tests.online.review_in_place": "In the right place",
  "class_tests.online.review_belongs_at": "Belongs at {{n}}",
  "class_tests.online.review_no_answer": "No answer",
  "class_tests.online.review_events": "Left the test",
  "class_tests.online.override": "Override",
  "class_tests.online.override_label": "Override, question {{n}}",
  "class_tests.online.mark": "Mark",
  "class_tests.online.mark_label": "Mark, question {{n}}",
  "class_tests.online.review_save": "Save marks",
  "class_tests.online.review_saved_toast": "Marks saved",
  "class_tests.online.review_nothing_changed": "Nothing changed",
  "class_tests.online.explain_correct": "Correct",
  "class_tests.online.explain_incorrect": "Incorrect",
  "class_tests.online.explain_no_answer": "No answer",
  "class_tests.online.explain_picks": "{{right}} right, {{wrong}} wrong",
  "class_tests.online.explain_eliminations": "{{right}} right, {{wrong}} wrongly eliminated",
  "class_tests.online.explain_order": "{{inPlace}} of {{total}} items in place",
  "class_tests.online.explain_not_marked": "Not marked yet",
  "class_tests.online.explain_teacher": "Marked by the teacher",
  "class_tests.history.title": "Test history",
  "class_tests.history.subtitle": "Past tests and tests with published results in the subjects you teach, whoever set them.",
  "class_tests.history.sst_subtitle": "Past tests and tests with published results across the school, with each student's published marks.",
  "class_tests.history.school_year": "School year",
  "class_tests.history.all_subjects": "All subjects",
  "class_tests.history.student": "Student",
  "class_tests.history.all_students": "All students",
  "class_tests.history.search_student": "Search students",
  "class_tests.history.not_published": "Results not published",
  "class_tests.history.show_results": "Student results",
  "class_tests.history.empty_title": "No past or published tests yet",
  "class_tests.history.empty_description": "A test appears here once its date has passed or its results are published.",
  "class_tests.history.item_label": "tests",
  "students.aides.class_assistants": "Class assistants: {{names}}",
  "timetable.class_aides": "1:1: {{list}}",
  "timetable.class_aide_pair": "{{student}} ({{aide}})",
  "dashboard.widget.my_aide_students": "My 1:1 students",
  "nav.section.tuition": "Tuition",
  "nav.tuition": "Tuition",
  "tuition.title": "Tuition",
  "tuition.subtitle": "Fees, discounts and semester invoices",
  "tuition.year": "School year",
  "tuition.grade_label": "Grade",
  "tuition.all_grades": "All grades",
  "tuition.no_year": "Create a school year first.",
  "tuition.tabs.label": "Tuition sections",
  "tuition.tab_fees": "Fees",
  "tuition.tab_students": "Students",
  "tuition.tab_charges": "Invoices",
  "tuition.semester_both": "Both semesters",
  "tuition.semester_n": "Semester {{n}}",
  "tuition.component.tuition": "Tuition Fee",
  "tuition.component.campus_development": "Campus Development",
  "tuition.component.technology": "Technology",
  "tuition.component.lunch": "Set Lunch, Snack & Milk",
  "tuition.component.graduation": "Graduation Fee",
  "tuition.component.english_language_development": "English Language Development",
  "tuition.component.learning_support": "Learning Support",
  "tuition.component.one_to_one_support": "1:1 Support",
  "tuition.component.custom": "Other",
  "tuition.fee_types.title": "Fee types",
  "tuition.fee_types.hint": "Every fee an invoice can carry, in printing order. A student's discount only reduces the fees marked below. To add a new fee type, ask for it to be added.",
  "tuition.fee_types.printed_as": "Printed on the invoice as",
  "tuition.fee_types.charged": "Charged",
  "tuition.fee_types.charged_by_grade": "By grade, from the table above",
  "tuition.fee_types.charged_per_student": "Per student, added with Edit on a draft",
  "tuition.fee_types.discount": "Discount applies",
  "tuition.fee_types.discount_yes": "Yes",
  "tuition.fee_types.discount_no": "No, always in full",
  "tuition.fee_types.default_amount": "Default amount",
  "tuition.fees.empty": "This school year has no fees yet.",
  "tuition.fees.fill_published": "Fill with the published 2026–2027 fees",
  "tuition.fees.start_empty": "Start from an empty table",
  "tuition.fees.hint": "What each grade band pays per semester, fee by fee. A fee that does not apply to a band has no row. Changes reach the next drafts generated, never an issued invoice.",
  "tuition.fees.fee": "Fee",
  "tuition.fees.from": "From",
  "tuition.fees.to": "To",
  "tuition.fees.semester": "Semester",
  "tuition.fees.amount": "Amount (฿)",
  "tuition.fees.add": "Add row",
  "tuition.fees.remove": "Remove row",
  "tuition.fees.save": "Save fees",
  "tuition.fees.saved": "Fees saved.",
  "tuition.fees.grades_backwards": "The first grade comes after the last.",
  "tuition.fees.amount_invalid": "Whole baht, 0 or more.",
  "tuition.students.filter_label": "Show",
  "tuition.students.filter_all": "All",
  "tuition.students.filter_discount": "With discount",
  "tuition.students.filter_none": "Without discount",
  "tuition.students.search": "Search students",
  "tuition.roster.projected": "No one is enrolled in {{year}} yet. These are {{source}}'s students one grade up. New pupils are added once they are in the system.",
  "tuition.roster.empty": "No students to bill in this year yet.",
  "tuition.students.student": "Student",
  "tuition.students.grade": "Grade",
  "tuition.students.discount": "Tuition discount",
  "tuition.students.note": "Invoice note",
  "tuition.students.note_hint": "Printed under Note on every invoice this year, e.g. Credit Salary.",
  "tuition.students.save_note": "Save note",
  "tuition.students.note_saved": "Note saved.",
  "tuition.students.discount_title": "Tuition discount",
  "tuition.students.tuition_only": "Applies to the Tuition Fee only. Campus Development, Technology and Lunch are always charged in full.",
  "tuition.students.percent": "Discount percent",
  "tuition.students.percent_invalid": "A whole percentage from 1 to 100.",
  "tuition.students.reason": "Reason",
  "tuition.students.reason_required": "Give a reason for the discount.",
  "tuition.students.reason_first_50": "First 50 families",
  "tuition.students.reason_staff": "Staff child",
  "tuition.students.grant": "Grant discount",
  "tuition.students.granted": "Discount granted.",
  "tuition.students.withdraw": "Withdraw",
  "tuition.students.withdrawn": "Discount withdrawn.",
  "tuition.students.granted_by": "Granted by {{name}} on {{date}}",
  "tuition.students.next_generation": "Changes apply the next time drafts are generated. A draft someone edited keeps its own lines until it is reset, and issued invoices never change.",
  "tuition.students.copy_discounts": "Copy {{count}} discounts from {{year}}",
  "tuition.students.copy_discounts_confirm": "Copy last year’s discounts onto this year? Each keeps its percentage and reason. Notes are not copied.",
  "tuition.students.discounts_copied": "{{count}} discounts copied",
  "tuition.students.discounts_not_copied": "Not copied, no longer on the list: {{names}}",
  "tuition.students.filter_prepaid": "Prepaid",
  "tuition.students.prepaid_badge": "Prepaid Sem {{fromSemester}} {{fromYears}} \u2013 Sem {{untilSemester}} {{untilYears}}",
  "tuition.students.prepaid_title": "Paid in advance",
  "tuition.students.prepaid_hint": "Semester invoices from the first semester through the last, both included, are generated with the fees shown and \u0e3f0 due. Anything extra is billed separately. Drafts already generated are not changed until they are generated or reset again.",
  "tuition.students.prepaid_from_year": "Paid from the start of",
  "tuition.students.prepaid_from_semester": "First semester",
  "tuition.students.prepaid_year": "Paid up to the end of",
  "tuition.students.prepaid_semester": "Last semester",
  "tuition.students.prepaid_semester_option": "Semester {{semester}}",
  "tuition.students.prepaid_note": "How it was paid",
  "tuition.students.prepaid_note_hint": "Receipt number or payment method",
  "tuition.students.prepaid_note_required": "Say how it was paid, e.g. the receipt number.",
  "tuition.students.prepaid_save": "Save prepayment",
  "tuition.students.prepaid_saved": "Prepayment saved.",
  "tuition.students.prepaid_remove": "Remove",
  "tuition.students.prepaid_removed": "Prepayment removed.",
  "tuition.students.prepaid_remove_confirm": "Remove this prepayment? Semester invoices will bill the family again.",
  "tuition.charges.prepaid": "Prepaid",
  "tuition.charges.for_semester": "For Semester {{n}}",
  "tuition.charges.billing_for_1": "These invoices are the fees for Semester 1 of {{year}}. Families pay in advance, so they are sent during Semester 2 of the year before.",
  "tuition.charges.billing_for_2": "These invoices are the fees for Semester 2 of {{year}}. Families pay in advance, so they are sent during Semester 1.",
  "tuition.charges.generate": "Generate drafts",
  "tuition.charges.generated": "{{created}} drafts generated · {{kept}} kept as they were",
  "tuition.charges.add_draft": "Add a student's draft",
  "tuition.charges.add_draft_hint": "For a student added after the drafts were generated. The draft is priced like the others, with their discount and note.",
  "tuition.charges.add_draft_student": "Student",
  "tuition.charges.add_draft_choose": "Choose a student",
  "tuition.charges.add_draft_required": "Choose a student.",
  "tuition.charges.add_draft_none": "Every student on the billing list already has an invoice or draft this semester.",
  "tuition.charges.add_draft_confirm": "Make draft",
  "tuition.charges.draft_added": "Draft made for {{name}}.",
  "tuition.charges.issue_all": "Issue all drafts",
  "tuition.charges.issue_all_hint": "{{count}} drafts get invoice numbers and can no longer be edited.",
  "tuition.charges.issue_one_hint": "This draft gets an invoice number and can no longer be edited.",
  "tuition.charges.issue_hint": "Printed on the invoice as the payment due date.",
  "tuition.charges.issue_confirm": "Issue",
  "tuition.charges.issue": "Issue",
  "tuition.charges.issued_count": "{{count}} invoices issued.",
  "tuition.charges.due_date": "Payment due date",
  "tuition.charges.make_pdfs": "Make invoice PDFs",
  "tuition.charges.pdf_progress": "Invoice PDFs: {{done}} of {{total}}",
  "tuition.charges.export": "Export CSV",
  "tuition.charges.skipped_title": "{{count}} students got no draft",
  "tuition.charges.filter_label": "Status",
  "tuition.charges.filter_unpaid": "Unpaid",
  "tuition.charges.filter_all": "All",
  "tuition.charges.search": "Search a child or an invoice",
  "tuition.charges.kind_label": "Kind",
  "tuition.charges.kind_all": "All kinds",
  "tuition.charges.kind_semester": "Semester invoices",
  "tuition.charges.kind_extra": "Extra invoices",
  "tuition.charges.more": "More",
  "tuition.charges.summary": "Total {{total}} · {{missing}} issued without a PDF",
  "tuition.charges.empty": "No invoices for this semester yet. Generate drafts to start.",
  "tuition.charges.status_col": "Status",
  "tuition.charges.invoice": "Invoice",
  "tuition.charges.net": "Net",
  "tuition.charges.actions": "Actions",
  "tuition.charges.status.draft": "Draft",
  "tuition.charges.status.issued": "Issued",
  "tuition.charges.status.settled": "Paid",
  "tuition.charges.status.cancelled": "Cancelled",
  "tuition.charges.edited": "Edited",
  "tuition.charges.extra": "Extra",
  "tuition.charges.extra_invoice": "Extra invoice",
  "tuition.charges.discounted": "after {{amount}} off",
  "tuition.charges.edit": "Edit",
  "tuition.charges.pdf": "PDF",
  "tuition.charges.preview": "Preview",
  "tuition.charges.preview_title": "Invoice preview",
  "tuition.charges.preview_preparing": "Preparing the invoice preview…",
  "tuition.charges.cancel": "Cancel",
  "tuition.charges.cancel_reason": "Reason",
  "tuition.charges.cancel_reason_required": "Give a reason for cancelling.",
  "tuition.charges.cancel_draft_hint": "The draft is removed. Generate again to make a new one.",
  "tuition.charges.cancel_extra_draft_hint": "The extra invoice draft is removed.",
  "tuition.charges.cancel_issued_hint": "The invoice is cancelled and its number stays retired. Generate again to make a new draft for this student.",
  "tuition.charges.cancel_confirm": "Cancel invoice",
  "tuition.charges.cancelled": "Cancelled.",
  "tuition.editor.description": "edit this draft before issuing",
  "tuition.editor.description_col": "Description",
  "tuition.editor.line_label": "Line description",
  "tuition.editor.amount": "Amount",
  "tuition.editor.discount_col": "Discount",
  "tuition.editor.discount": "Discount amount",
  "tuition.editor.discount_label": "Discount wording",
  "tuition.editor.discount_label_placeholder": "e.g. Discount 50% Tuition Fee",
  "tuition.editor.percent": "Discount percent of this line",
  "tuition.editor.apply_percent": "Apply %",
  "tuition.editor.remove": "Remove line",
  "tuition.editor.add": "Add line",
  "tuition.editor.add_one_to_one_support": "1:1 Support",
  "tuition.editor.add_english_language_development": "ELD",
  "tuition.editor.add_learning_support": "Learning Support",
  "tuition.editor.add_custom": "Other",
  "tuition.editor.note": "Note on the invoice",
  "tuition.editor.title": "Title",
  "tuition.editor.title_placeholder": "e.g. Field trip to Bangkok",
  "tuition.editor.title_hint": "Printed as the heading of the invoice and shown to the family.",
  "tuition.editor.title_required": "Give the invoice a title.",
  "tuition.editor.total": "Total",
  "tuition.editor.kept_note": "An edited draft is kept when drafts are generated again, until you reset it.",
  "tuition.editor.reset": "Reset to fee matrix",
  "tuition.editor.reset_confirm": "Throw away the changes and price this draft from the fee matrix again?",
  "tuition.editor.reset_done": "Draft reset.",
  "tuition.editor.save": "Save draft",
  "tuition.editor.saved": "Draft saved.",
  "tuition.editor.extra_description": "an extra invoice, separate from the semester invoice",
  "tuition.editor.create": "Create extra invoice",
  "tuition.editor.created": "Extra invoice drafted.",
  "tuition.editor.label_required": "Describe the line.",
  "tuition.editor.amount_invalid": "Whole baht, 0 or more.",
  "tuition.editor.discount_too_big": "The discount is larger than the amount.",
  "tuition.editor.discount_label_required": "Say what the discount is.",
  "tuition.editor.no_lines": "An invoice needs at least one line.",
  "tuition.charges.stale_title": "{{count}} edited drafts no longer match — check them before issuing",
  "tuition.charges.due_date_required": "Choose the due date.",
  "tuition.charges.due_date_past": "The due date cannot be in the past.",
  "tuition.charges.remove_draft": "Remove draft",
  "tuition.charges.remake_pdfs": "Re-make all PDFs",
  "tuition.charges.remake_confirm": "Make every issued invoice's PDF again? Use this after a change to the invoice layout.",
  "tuition.students.withdraw_confirm": "Withdraw this discount? Drafts generated from now on charge full tuition.",
  "tuition.tab_payments": "Payments",
  "tuition.charges.paid_of": "{{paid}} paid · {{balance}} to go",
  "tuition.payments.empty": "No issued invoices for this semester yet.",
  "tuition.payments.amount": "Amount (฿)",
  "tuition.payments.amount_invalid": "Whole baht, 1 or more.",
  "tuition.payments.reported": "Reported",
  "tuition.payments.status.declared": "To check",
  "tuition.payments.status.confirmed": "Confirmed",
  "tuition.payments.status.rejected": "Rejected",
  "tuition.payments.methods.bank_transfer": "Bank transfer",
  "tuition.payments.methods.cheque": "Cheque",
  "tuition.payments.methods.cash": "Cash",
  "tuition.payments.methods.credit_card": "Credit card",
  "tuition.payments.methods.salary_deduction": "Salary deduction",
  "tuition.payments.method": "How it was paid",
  "tuition.payments.received_on": "Received on",
  "tuition.payments.received_on_required": "Choose the day the money arrived.",
  "tuition.payments.note": "Note",
  "tuition.payments.slip": "Slip",
  "tuition.payments.confirmed": "Payment confirmed.",
  "tuition.payments.reject": "Reject…",
  "tuition.payments.reject_hint": "The family reads this note in the portal and can report again.",
  "tuition.payments.reject_note": "Why it could not be matched",
  "tuition.payments.reject_note_required": "Tell the family why.",
  "tuition.payments.reject_save": "Reject payment",
  "tuition.payments.rejected": "Payment rejected.",
  "tuition.payments.create_receipt": "Create receipt",
  "tuition.payments.receipt_created": "Receipt {{number}} issued.",
  "tuition.payments.receipt_pdf": "Receipt PDF",
  "tuition.payments.void_receipt": "Void receipt",
  "tuition.payments.void_hint": "The number stays retired. Issue a new receipt afterwards if needed.",
  "tuition.payments.void_reason": "Reason",
  "tuition.payments.void_reason_required": "Give a reason for voiding.",
  "tuition.payments.receipt_voided": "Receipt voided.",
  "tuition.payments.record": "Record payment",
  "tuition.payments.record_save": "Record payment",
  "tuition.payments.recorded": "Payment recorded.",
  "tuition.payments.record_waiting": "The family has reported {{amount}} on these invoices and it is waiting to be checked. If this is that money, confirm their report instead of recording it again.",
  "tuition.payments.totals_to_collect": "To collect",
  "tuition.payments.totals_confirmed": "Confirmed",
  "tuition.payments.totals_waiting": "Waiting for you to check",
  "tuition.payments.totals_still_to_come": "Still to come",
  "tuition.payments.families_count_one": "{{count}} family",
  "tuition.payments.families_count_other": "{{count}} families",
  "tuition.payments.paid_in_full_one": "{{count}} family paid in full",
  "tuition.payments.paid_in_full_other": "{{count}} families paid in full",
  "tuition.payments.reports_count_one": "{{count}} report",
  "tuition.payments.reports_count_other": "{{count}} reports",
  "tuition.payments.filter_label": "Status",
  "tuition.payments.filter_all": "All",
  "tuition.payments.family_status.to_check": "To check",
  "tuition.payments.family_status.owing": "Owing",
  "tuition.payments.family_status.paid": "Paid",
  "tuition.payments.search": "Search a parent, a child or an invoice",
  "tuition.payments.export": "Export",
  "tuition.payments.last_reported": "Reported a transfer on {{when}}",
  "tuition.payments.nothing_reported": "Nothing reported yet",
  "tuition.payments.invoices_count_one": "{{count}} invoice",
  "tuition.payments.invoices_count_other": "{{count}} invoices",
  "tuition.payments.confirmed_label": "confirmed",
  "tuition.payments.still_to_pay": "still to pay",
  "tuition.payments.invoices_for": "Invoices for Semester {{n}}, {{year}}",
  "tuition.payments.due_on": "due {{date}}",
  "tuition.payments.no_transfers": "No transfer reported for these invoices yet.",
  "tuition.payments.match_exact": "Matches the invoices",
  "tuition.payments.match_less": "{{amount}} less than the invoices",
  "tuition.payments.match_more": "{{amount}} more than the invoices",
  "tuition.payments.match_other_semester": "Also pays invoices not shown here",
  "tuition.payments.also_pays": "Also pays {{invoice}} for Semester {{n}}, {{year}} · {{amount}}",
  "tuition.payments.confirm_amount": "Confirm {{amount}}",
  "tuition.payments.confirm_transfer_hint": "Check the amount against the bank statement, then share it over the invoices. The shares must add up to the amount confirmed; a share of 0 leaves that invoice out.",
  "tuition.payments.reported_amount": "The family reported {{amount}}.",
  "tuition.payments.split_title": "Shared over",
  "tuition.payments.split_sum": "Shares add up to {{sum}} of {{amount}}",
  "tuition.payments.shares_mismatch": "The shares must add up to {{amount}}.",
  "tuition.payments.share_over": "Only {{amount}} is still owed on this invoice.",
  "tuition.payments.share_invalid": "Whole baht, 0 or more.",
  "tuition.payments.outstanding": "{{amount}} still to pay",
  "tuition.payments.other_semester_share": "Semester {{n}}, {{year}}",
  "tuition.payments.record_family": "Record a payment",
  "tuition.payments.record_family_hint": "Money the office took itself — cash, card, cheque, a salary deduction or a transfer seen on the statement. Tick the invoices it pays; it is confirmed as it is recorded.",
  "tuition.payments.record_pays_for": "This payment pays for",
  "tuition.payments.record_pick_one": "Tick at least one invoice.",
  "tuition.payments.record_total": "Total {{amount}}",
  "tuition.notices.email_invoices": "Email invoices ({{count}})",
  "tuition.notices.send_reminders": "Send reminders ({{count}} unpaid)",
  "tuition.notices.email_confirm": "Email {{parents}} parents that {{count}} invoices are ready? Each email links to the portal. Invoices still waiting for their PDF are not included.",
  "tuition.notices.email_confirm_without": "{{count}} invoices have no parent email on file and will not be sent.",
  "tuition.notices.remind_confirm": "Send a gentle reminder to {{parents}} parents about {{count}} unpaid invoices? Families reminded in the last 7 days are skipped.",
  "tuition.notices.progress": "Sending: {{done}} of {{total}}",
  "tuition.notices.done_invoices": "Invoice emails sent to {{emails}} parents.",
  "tuition.notices.done_reminders": "Reminders sent to {{emails}} parents.",
  "tuition.notices.failed": "{{count}} emails could not be sent — run it again to retry them.",
  "tuition.notices.without": "{{count}} invoices have no parent email on file.",
  "tuition.notices.emailed_on": "Emailed {{date}}",
  "tuition.notices.reminded_on": "Reminded {{date}}",
  "tuition.copies.title": "Stamped originals requested",
  "tuition.copies.hint": "Families asked for the stamped paper receipt. Print and stamp it, mark it ready (the family is emailed), then mark it collected.",
  "tuition.copies.requested_by": "Requested by {{name}} on {{date}}",
  "tuition.copies.status.requested": "Requested",
  "tuition.copies.status.ready": "Ready to collect",
  "tuition.copies.status.collected": "Collected",
  "tuition.copies.mark_ready": "Mark ready",
  "tuition.copies.mark_collected": "Mark collected",
  "tuition.copies.marked_ready": "Marked ready — the family has been emailed.",
  "tuition.copies.marked_collected": "Marked collected.",
  "report_cards.periods.download_action": "Download all",
  "report_cards.periods.views_summary": "Opened by families for {{opened}} of {{cards}}",
  "report_cards.periods.views_title": "Who opened {{name}}",
  "report_cards.periods.views_description": "Opens on the parent and student portals. A parent who only read the notice email is not counted.",
  "report_cards.periods.views_opened_by_parent": "Opened by a parent",
  "report_cards.periods.views_parents": "Parents who opened one",
  "report_cards.periods.views_pdf": "PDF downloaded by a parent",
  "report_cards.periods.views_student": "Opened by the student",
  "report_cards.periods.views_of": "{{value}} of {{total}}",
  "report_cards.periods.views_show": "Show",
  "report_cards.periods.views_show_all": "All children",
  "report_cards.periods.views_show_unopened": "Not opened yet",
  "report_cards.periods.views_empty": "Every family in this list has opened their card.",
  "report_cards.periods.views_col_student": "Student",
  "report_cards.periods.views_col_parents": "Parents opened",
  "report_cards.periods.views_col_pdf": "PDF",
  "report_cards.periods.views_col_student_opened": "Student opened",
  "report_cards.periods.views_col_first": "First opened",
  "report_cards.periods.views_no_parent": "No parent linked",
  "report_cards.periods.download_title": "Download {{name}} report cards",
  "report_cards.periods.download_description": "The published PDFs exactly as families receive them, to keep on file or to print.",
  "report_cards.periods.download_all_grades": "All grades",
  "report_cards.periods.download_formats": "ZIP keeps one PDF per child, in a folder per grade. Print joins them into a single PDF.",
  "report_cards.periods.download_zip": "Download ZIP",
  "report_cards.periods.download_pdf": "Download for printing",
  "report_cards.periods.download_preparing": "Preparing…",
  "report_cards.periods.download_filename": "Report cards {{name}} - {{scope}}",
  "report_cards.entry.section_label": "Which part of the school",
  "report_cards.entry.section_early_years": "Early Years",
  "report_cards.entry.section_grades": "Grade 1 and up",
  "report_cards.entry.class_label": "Class",
  "report_cards.entry.subjects_label": "Subjects",
  "report_cards.entry.tab_homeroom": "Early Years report",
  "common.showing_last_received": "Showing the last results received.",
  "common.try_again": "Try again",
  "common.through": "Through",
  "common.all_history": "All recorded history",
  "common.date_range_invalid_one": "Choose a date range of up to {{count}} day, ending on or after the start date.",
  "common.date_range_invalid_other": "Choose a date range of up to {{count}} days, ending on or after the start date.",
  "sparky.duration.hours": "{{hours}}h {{minutes}}m",
  "sparky.duration.minutes": "{{minutes}}m {{seconds}}s",
  "sparky.signal.needs_practice": "Needs practice",
  "sparky.signal.review": "Review with student",
  "sparky.signal.excellent": "Excellent",
  "sparky.signal.progressing": "Progressing",
  "sparky.signal.getting_started": "Getting started",
  "sparky.signal.no_play": "No recorded play",
  "sparky.live_status.playing": "Playing",
  "sparky.live_status.idle": "Idle",
  "sparky.live_status.paused": "Paused",
  "sparky.live_status.disconnected": "Disconnected",
  "sparky.live_status.offline": "Offline",
  "sparky.live_status.unavailable": "Update unavailable",
  "sparky.live_status.finished": "Not playing",
  "sparky.live_status.recorded": "Earlier today",
  "sparky.evidence.mistakes_one": "{{count}} mistake",
  "sparky.evidence.mistakes_other": "{{count}} mistakes",
  "sparky.evidence.successes_one": "{{count}} correct step",
  "sparky.evidence.successes_other": "{{count}} correct steps",
  "sparky.evidence.hints_one": "{{count}} hint",
  "sparky.evidence.hints_other": "{{count}} hints",
  "sparky.evidence.retries_one": "{{count}} retry",
  "sparky.evidence.retries_other": "{{count}} retries",
  "sparky.evidence.skips_one": "{{count}} skip",
  "sparky.evidence.skips_other": "{{count}} skips",
  "sparky.evidence.low_stars_one": "{{count}} completion under 3 stars",
  "sparky.evidence.low_stars_other": "{{count}} completions under 3 stars",
  "sparky.evidence.none": "No recorded mistakes or help",
  "sparky.interaction.rapid_bursts_one": "{{count}} rapid-click burst",
  "sparky.interaction.rapid_bursts_other": "{{count}} rapid-click bursts",
  "sparky.interaction.blocked_presses_one": "{{count}} press while busy",
  "sparky.interaction.blocked_presses_other": "{{count}} presses while busy",
  "sparky.interaction.rapid_answers_one": "{{count}} rapid-answer pattern",
  "sparky.interaction.rapid_answers_other": "{{count}} rapid-answer patterns",
  "sparky.stars.tier_1": "1 star",
  "sparky.stars.tier_2": "2 stars",
  "sparky.stars.tier_3": "3 stars",
  "sparky.stars.unfinished": "Unfinished",
  "sparky.stars.not_visited": "Not visited",
  "sparky.stars.of_max_one": "{{count}} of {{max}} stars",
  "sparky.stars.of_max_other": "{{count}} of {{max}} stars",
  "sparky.topic.of_completed": "/ {{total}} completed",
  "sparky.topic.unfinished_count_one": "{{count}} unfinished",
  "sparky.topic.unfinished_count_other": "{{count}} unfinished",
  "sparky.control.solution_next": "Solution · Next step",
  "sparky.control.review_next": "Mistake review · Next step",
  "sparky.control.trace_next": "Code trace · Next step",
  "sparky.control.tutorial_next": "Coding tutorial · Next step",
  "sparky.control.code_run": "Run code",
  "sparky.control.code_step": "Step through code",
  "sparky.control.code_reset": "Reset code",
  "sparky.control.multiple_choice": "Multiple-choice answer",
  "sparky.interaction_event.correct": "Correct",
  "sparky.interaction_event.incorrect": "Incorrect",
  "sparky.interaction_event.answer": "{{result}} · {{seconds}}s response · {{choices}} choices",
  "sparky.interaction_event.rapid_answers": "{{wrong}} of 5 rapid answers incorrect · each within {{seconds}}s · very fast answers, mostly wrong",
  "sparky.interaction_event.activated": "Action accepted",
  "sparky.interaction_event.rapid_clicks": "5 presses within {{seconds}}s",
  "sparky.interaction_event.blocked_disabled": "Ignored: the game was still busy",
  "sparky.interaction_event.blocked_pending": "Waiting for the displayed step to update",
  "sparky.interaction_event.advanced": "Advanced from step {{step}} to {{next}} of {{total}}",
  "sparky.mistake.incorrect_answer": "Incorrect answer",
  "sparky.mistake.math_counting": "Counting / matching answer",
  "sparky.mistake.math_sequence": "Sequence answer",
  "sparky.mistake.math_strategy": "Calculation strategy",
  "sparky.mistake.math_place_value": "Decimal / place value answer",
  "sparky.mistake.math_calculation": "Calculation answer",
  "sparky.mistake.math_geometry": "Shape / angle answer",
  "sparky.mistake.math_shape": "Shapes answer",
  "sparky.mistake.math_fraction": "Fraction answer",
  "sparky.mistake.math_measurement": "Measurement / units answer",
  "sparky.mistake.checkup_answer": "Check-up answer",
  "sparky.mistake.checkup_concept": "Concept / idea answer",
  "sparky.mistake.checkup_vocabulary": "Word meaning answer",
  "sparky.mistake.checkup_code_reading": "Reading code answer",
  "sparky.mistake.checkup_debugging": "Finding the bug answer",
  "sparky.mistake.coding_obstacle": "Program hit an obstacle",
  "sparky.mistake.coding_incomplete": "Program ended before the goal",
  "sparky.mistake.coding_required_block": "Required coding block missing",
  "sparky.mistake.coding_program_error": "Program could not run",
  "sparky.mistake.coding_stuck_loop": "Loop stopped making progress",
  "sparky.mistake.coding_message": "Incorrect message to another robot",
  "sparky.mistake.coding_interaction": "Incorrect switch or interaction",
  "sparky.mistake.coding_repeat_count": "Repeat count",
  "sparky.mistake.coding_condition": "Condition",
  "sparky.mistake.coding_direction": "Direction",
  "sparky.mistake.coding_variable": "Variable",
  "sparky.mistake.coding_function": "Function",
  "sparky.mistake.coding_event": "Event",
  "sparky.mistake.coding_block_order": "Block order",
  "sparky.mistake.illegal_move": "Move not allowed",
  "sparky.mistake.task_failed": "Task not completed",
  "sparky.mistake.other": "Other recorded mistake",
  "sparky.mistake.student_response": "Student response:",
  "sparky.mistake.observed_result": "What happened:",
  "sparky.mistake.missing_block": "The program has no {{block}}.",
  "sparky.mistake.block.repeat": "REPEAT block",
  "sparky.mistake.block.nested_repeat": "REPEAT block inside another REPEAT",
  "sparky.mistake.block.condition": "IF block",
  "sparky.mistake.block.variable": "variable",
  "sparky.mistake.block.function": "DEFINE block",
  "sparky.mistake.block.event": "WHEN script",
  "sparky.mistake.run_error.invalid": "Sparky could not run this program.",
  "sparky.mistake.run_error.stuck": "Sparky got stuck in a loop: nothing changed inside it, so it would never stop.",
  "sparky.mistake.run_error.wrong_tell": "TELL gave the gate the wrong number.",
  "sparky.mistake.run_error.gate": "A gate was still closed.",
  "sparky.mistake.run_error.press": "PRESS was used while Sparky was not on a switch.",
  "sparky.mistake.expected": "Expected:",
  "sparky.mistake.none": "No recorded mistakes.",
  "sparky.mistake.fixed": "Fixed {{date}}",
  "sparky.mistake.unclassified_one": "{{count}} mistake without recorded details.",
  "sparky.mistake.unclassified_other": "{{count}} mistakes without recorded details.",
  "sparky.mistake.latest_example": "Last recorded example",
  "sparky.mistake.examples_in_order": "What was answered, in order",
  "sparky.story.result_completed": "Finished with {{stars}} of 3 stars",
  "sparky.story.result_skipped": "Skipped",
  "sparky.story.result_unfinished": "Left unfinished",
  "sparky.story.result_playing": "Still playing",
  "sparky.story.no_mistakes": "No mistakes recorded",
  "sparky.story.mistake_count": "{{label}} ×{{count}}",
  "sparky.story.answered": "Answered “{{actual}}”",
  "sparky.story.observed": "What happened: {{actual}}",
  "sparky.story.answered_expected": "Answered “{{actual}}”; the answer was “{{expected}}”",
  "sparky.story.expected_only": "The answer was “{{expected}}”",
  "sparky.story.answers_in_order": "Answers in order: {{answers}}",
  "sparky.story.answer_right": "right ({{seconds}} s)",
  "sparky.story.answer_wrong": "wrong ({{seconds}} s)",
  "sparky.story.hints_one": "Asked for a hint {{count}} time",
  "sparky.story.hints_other": "Asked for a hint {{count}} times",
  "sparky.story.retries_one": "Restarted {{count}} time",
  "sparky.story.retries_other": "Restarted {{count}} times",
  "sparky.story.example_unrecorded": "This game did not record what was answered",
  "sparky.story.unrecorded_examples_one": "{{count}} more without a recorded example",
  "sparky.story.unrecorded_examples_other": "{{count}} more without a recorded example",
  "sparky.mistake.no_example": "This game did not record what was answered. Recovery & improvement and Activity history show which level it was.",
  "sparky.mistake.answers_given": "Wrong answers and how many children gave each",
  "sparky.checkup.self_not_yet": "Not yet",
  "sparky.checkup.self_getting_there": "Getting there",
  "sparky.checkup.self_can_do": "I can do it",
  "sparky.report.level_target": "level {{level}}",
  "sparky.report.suggest_practise": "Practise {{target}} together, then ask the student to try independently.",
  "sparky.report.suggest_review": "Ask how they solved {{target}}; review the part where they needed help.",
  "sparky.report.suggest_next": "Offer the next exercise in this skill.",
  "sparky.report.suggest_finish": "Give the student time to finish the current exercise.",
  "sparky.report.result_skipped": "Skipped",
  "sparky.report.result_left_unfinished": "Left unfinished",
  "sparky.course_level": "{{course}} · Level {{level}}",
  "sparky.level": "Level {{level}}",
  "sparky.score.none": "No completed levels",
  "sparky.score.stars": "{{earned}}/{{possible}} stars",
  "sparky.assignment.complete": "Complete",
  "sparky.assignment.target_achieved": "Lesson target achieved",
  "sparky.assignment.target_achieved_free": "Lesson target achieved · free choice",
  "sparky.assignment.in_progress": "In progress",
  "sparky.assignment.not_started": "Not started",
  "sparky.assignment.incomplete": "Incomplete",
  "sparky.assignment.not_completed_count_one": "{{count}} exercise not completed",
  "sparky.assignment.not_completed_count_other": "{{count}} exercises not completed",
  "sparky.assignment.remaining_count_one": "{{count}} exercise remaining",
  "sparky.assignment.remaining_count_other": "{{count}} exercises remaining",
  "sparky.assignment.of": "of {{required}}",
  "sparky.assignment.progress_value": "{{completed}} of {{required}} exercises completed",
  "sparky.assignment.of_exercises": "of {{required}} exercises",
  "sparky.assignment.all_done": "All exercises done",
  "sparky.checkup.title": "{{name}} · Topic feedback",
  "sparky.checkup.description": "{{grade}} check-up: coverage, recorded mistakes and help, the child’s own rating, and questions to revisit.",
  "sparky.checkup.no_measured": "No measured questions in this selection",
  "sparky.checkup.completed_of": "{{completed}}/{{total}} completed",
  "sparky.checkup.measured_line": "{{clean}}/{{completed}} completed cleanly · {{completed}}/{{total}} completed",
  "sparky.checkup.self_rating": "Self: {{rating}}",
  "sparky.checkup.rated": "Rated",
  "sparky.checkup.rated_as": "Rated: {{rating}}",
  "sparky.checkup.not_rated": "Not rated",
  "sparky.checkup.mismatch_overconfident": "Says “I can do it”, but fewer than half of the first answers were correct",
  "sparky.checkup.mismatch_underconfident": "Says “Not yet”, but every first answer was correct",
  "sparky.checkup.coverage": "{{name}} coverage",
  "sparky.checkup.clean_count_one": "{{count}} completed without recorded mistakes, help or retries",
  "sparky.checkup.clean_count_other": "{{count}} completed without recorded mistakes, help or retries",
  "sparky.checkup.unfinished_unvisited": "{{unfinished}} unfinished · {{unvisited}} not attempted",
  "sparky.checkup.next": "Next: {{next}}",
  "sparky.checkup.band_secure": "Secure",
  "sparky.checkup.band_developing": "Developing",
  "sparky.checkup.band_not_yet": "Not yet",
  "sparky.checkup.band_insufficient": "Not enough evidence",
  "sparky.checkup.band_basis": "Band from {{secure}}/{{evidence}} right first time (first answers and three stars on a practical’s first completion)",
  "sparky.checkup.band_insufficient_basis_one": "Only {{count}} first-time result so far; a band needs at least 3",
  "sparky.checkup.band_insufficient_basis_other": "Only {{count}} first-time results so far; a band needs at least 3",
  "sparky.checkup.secure_early": "Secure early",
  "sparky.checkup.secure_early_hint": "The first three core questions were right first time, so the rest of the core questions were skipped",
  "sparky.checkup.stopped_early": "Stopped early",
  "sparky.checkup.stopped_early_hint": "The first two core questions were wrong first time, so the rest of the topic was skipped",
  "sparky.checkup.skipped_by_rule_one": "· {{count}} skipped when the topic stopped early",
  "sparky.checkup.skipped_by_rule_other": "· {{count}} skipped when the topic stopped early",
  "sparky.checkup.band_next_secure": "Move on: offer the extension questions or a harder task.",
  "sparky.checkup.band_next_developing": "Practise: go over the review questions together, then try a fresh question.",
  "sparky.checkup.band_next_not_yet": "Reteach: work through the idea again in a small group with concrete examples before checking again.",
  "sparky.checkup.band_next_insufficient": "Gather more evidence: ask a few more questions on this topic before deciding.",
  "sparky.checkup.review_heading": "Review these questions:",
  "sparky.checkup.footnote": "These questions are a starting point, not a mastery judgement or exam mark. Replays can raise stars; recorded mistakes and help remain visible. Self-ratings are the child’s own view and are never scored. Ask for working and try a fresh problem before deciding next steps. Adult help given outside Sparky is not automatically recorded.",
  "sparky.checkup.measured": "Measured: {{line}}",
  "sparky.checkup.self_title": "Self-assessment",
  "sparky.checkup.self_description": "What the child said they can do, beside what Sparky measured for the same topic.",
  "sparky.interactions.not_recorded": "Interaction tracking was not recorded for this visit.",
  "sparky.interactions.steps_advanced_one": "{{count}} step advanced",
  "sparky.interactions.steps_advanced_other": "{{count}} steps advanced",
  "sparky.interactions.code_actions_one": "{{count}} code action",
  "sparky.interactions.code_actions_other": "{{count}} code actions",
  "sparky.interactions.timed_answers_one": "{{count}} timed answer",
  "sparky.interactions.timed_answers_other": "{{count}} timed answers",
  "sparky.interactions.timeline": "Interaction timeline",
  "sparky.interactions.rapid_clicks": "Rapid clicks",
  "sparky.interactions.review_answers": "Review answers",
  "sparky.interactions.no_presses": "No recorded presses on the tracked controls.",
  "sparky.interactions.showing_events": "Showing {{shown}} of {{total}} events for this visit (latest 60 retained). Times are elapsed since opening the level.",
  "sparky.interactions.title": "Answer patterns & interactions",
  "sparky.interactions.description": "Review answer timing, repeated requests and the evidence behind each observation.",
  "sparky.interactions.export": "Export interaction timeline",
  "sparky.interactions.tile_steps": "Steps advanced",
  "sparky.interactions.tile_code_actions": "Code actions accepted",
  "sparky.interactions.tile_blocked": "Repeated presses while busy",
  "sparky.interactions.tile_bursts": "Rapid-click bursts",
  "sparky.interactions.tile_answers": "Multiple-choice answers timed",
  "sparky.interactions.tile_rapid_answers": "Rapid-answer patterns",
  "sparky.interactions.coverage": "Tracking covers {{tracked}} of {{visits}} visits. Rapid clicking does not prove frustration and never affects scores. Answer timing covers {{answerVisits}} visits; earlier answer times were not recorded.",
  "sparky.interactions.how_to_read": "How to interpret these signals",
  "sparky.interactions.how_bursts": "A burst means at least 5 presses on the same control within 2 seconds, separated by 2 seconds of quiet. Compare steps that advanced with disabled or pending requests to see whether the student moved through content quickly or kept pressing an unavailable control.",
  "sparky.interactions.how_controls": "Tracks solution, review and coding Next step controls, plus block-code Run, Step and Reset. Board taps and typing are excluded from click detection. Accepted multiple-choice answers are timed separately.",
  "sparky.interactions.how_rapid_answers": "A rapid-answer pattern means 5 consecutive answers within 1 second each, at least 3 incorrect, within 90 seconds in the same activity and skill. Help, pauses and slower answers break the pattern. Fast correct answers are never flagged. This suggests very fast answers, mostly wrong, not proof: ask the student to explain their approach before deciding on support. Scores are unaffected.",
  "sparky.interactions.visit_debug": "Visit {{id}} · {{status}} · Last update {{updated}}",
  "sparky.interactions.none_flagged": "No interaction patterns to review in the recent visits shown here.",
  "sparky.interactions.tracking_starts": "Interaction tracking starts with new visits after this update.",
  "sparky.interactions.flagged_from_one": "Flagged visits above come from the latest {{count}} visit in this period. Open Activity history for every available visit timeline; totals above include the whole period.",
  "sparky.interactions.flagged_from_other": "Flagged visits above come from the latest {{count}} visits in this period. Open Activity history for every available visit timeline; totals above include the whole period.",
  "sparky.preview.open": "Preview level {{level}}",
  "sparky.preview.button": "Preview",
  "sparky.preview.title": "Exercise preview · Level {{level}}",
  "sparky.preview.description": "{{grade}} · Try the exercise or review its teaching solution",
  "sparky.preview.tab_play": "Play exercise",
  "sparky.preview.tab_guide": "Teaching guide",
  "sparky.preview.tabs_label": "Exercise preview views",
  "sparky.preview.loading": "Loading exercise…",
  "sparky.preview.unavailable": "Exercise preview unavailable.",
  "sparky.preview.preparing": "Preparing playable preview…",
  "sparky.preview.frame_title": "Playable {{course}} exercise · Level {{level}}",
  "sparky.preview.playable_unavailable": "Playable preview unavailable. Close and reopen this preview to try again.",
  "sparky.preview.footer_note": "Preview only · student progress and reports are unaffected.",
  "sparky.preview.close": "Close preview",
  "sparky.preview.played_board": "The board this student played",
  "sparky.preview.support_board": "Support check: an easier version of level {{level}}",
  "sparky.preview.stretch_board": "Stretch challenge: a harder version of level {{level}}",
  "sparky.preview.example_board": "Example board: this visit was recorded before boards were saved, so the layout may differ from the student's.",
  "sparky.preview.guide_example": "The teaching guide and model solution describe the example board for this level, so they may not match the student's board.",
  "sparky.guide.row_clues": "Row clues",
  "sparky.guide.column_clue": "Column {{column}} clue: {{clue}}",
  "sparky.guide.row_clue": "Row {{row}} clue: {{clue}}",
  "sparky.guide.cell_filled": "filled",
  "sparky.guide.cell_empty": "empty",
  "sparky.guide.cell": "Row {{row}}, column {{column}}: {{label}}",
  "sparky.guide.goal": "Learning goal",
  "sparky.guide.readiness": "Before assigning",
  "sparky.guide.task": "What the student does",
  "sparky.guide.dot_intro": "The student sees this numeral and these dot cards",
  "sparky.guide.numeral": "Numeral {{value}}",
  "sparky.guide.dot_option_one": "Option {{option}}: {{count}} dot",
  "sparky.guide.dot_option_other": "Option {{option}}: {{count}} dots",
  "sparky.guide.card": "Card {{card}}",
  "sparky.guide.solution": "Walk through the solution",
  "sparky.guide.correct_solution": "Correct solution",
  "sparky.guide.look_for": "What to look for",
  "sparky.guide.support": "Support if they get stuck",
  "sparky.guide.extension": "When they are ready for more",
  "sparky.guide.footnote": "This guide describes the exercise shown in the playable preview. Adaptive practice may vary the numbers or layout during play.",
  "sparky.active_time": "{{time}} active",
  "sparky.open_learning_report": "Open learning report",
  "sparky.lesson_form.title_heading": "Prepare a lesson",
  "sparky.lesson_form.description": "Save a draft today and start it when class begins. Students complete different assigned levels during the lesson before choosing other activities. Replays and skips do not add to the target.",
  "sparky.lesson_form.title": "Lesson title",
  "sparky.lesson_form.target": "Levels each student must finish",
  "sparky.lesson_form.target_choices": "Quick target choices",
  "sparky.lesson_form.target_all": "All",
  "sparky.lesson_form.target_percent": "{{percent}}%",
  "sparky.lesson_form.target_half": "Half",
  "sparky.lesson_form.target_exact": "Exact",
  "sparky.lesson_form.target_summary_one": "{{target}} of {{count}} exercise ({{percent}}%)",
  "sparky.lesson_form.target_summary_other": "{{target}} of {{count}} exercises ({{percent}}%)",
  "sparky.lesson_form.target_hint_one": "Students finish the one exercise. Replays and skips don't count.",
  "sparky.lesson_form.target_hint_other": "Students finish at least {{target}} of the {{count}} exercises. Replays and skips don't count.",
  "sparky.lesson_form.target_unknown": "Choose a course and exercises to see how many are available.",
  "sparky.lesson_form.target_varies": "Exercises differ by grade: {{count}} is the fewest any chosen student has, so everyone can reach the target.",
  "sparky.lesson_form.target_cap": "A lesson can require at most {{max}} exercises, so the larger quick choices are unavailable.",
  "sparky.lesson_form.target_over_one": "At most {{count}} exercise can be required here. Add exercises or lower the target.",
  "sparky.lesson_form.target_over_other": "At most {{count}} exercises can be required here. Add exercises or lower the target.",
  "sparky.lesson_form.target_lowered_one": "The target was lowered to {{count}} exercise, the most this lesson can require now.",
  "sparky.lesson_form.target_lowered_other": "The target was lowered to {{count}} exercises, the most this lesson can require now.",
  "sparky.lesson_form.checkup_all_exercises_one": "Everyone does the {{count}} exercise",
  "sparky.lesson_form.checkup_all_exercises_other": "Everyone does all {{count}} exercises",
  "sparky.lesson_form.checkup_all_exercises_grades": "Everyone does all the exercises for their grade",
  "sparky.lesson_form.students_legend_one": "Students ({{count}} selected)",
  "sparky.lesson_form.students_legend_other": "Students ({{count}} selected)",
  "sparky.lesson_form.class": "Class",
  "sparky.lesson_form.individual_students": "Choose individual students",
  "sparky.lesson_form.loading_students": "Loading students…",
  "sparky.lesson_form.select_all": "Select all shown",
  "sparky.lesson_form.clear_selection": "Clear selection",
  "sparky.lesson_form.exercises_legend": "Activity and exercises",
  "sparky.lesson_form.grade": "Exercise grade",
  "sparky.lesson_form.grade_auto": "Each student's school grade",
  "sparky.lesson_form.course": "Activity / course",
  "sparky.lesson_form.exercises": "Exercises",
  "sparky.lesson_form.exercises_any": "Any different exercises in this course",
  "sparky.lesson_form.exercises_selected": "Choose specific exercises",
  "sparky.lesson_form.catalog_error": "Activities could not load.",
  "sparky.lesson_form.explore": "Explore exercises before assigning",
  "sparky.lesson_form.choose_exercise": "Choose an exercise",
  "sparky.lesson_form.level_in_chapter": "Level {{level}} · {{chapter}}",
  "sparky.lesson_form.preview_grade": "Preview grade",
  "sparky.lesson_form.preview_grade_note": "Preview grade does not change each student's assigned school grade.",
  "sparky.lesson_form.assigned_legend_one": "Assigned exercises ({{count}} selected)",
  "sparky.lesson_form.assigned_legend_other": "Assigned exercises ({{count}} selected)",
  "sparky.lesson_form.assigned_hint_one": "Choose chapters or individual levels. Students complete at least {{count}} different selected level, at any star result.",
  "sparky.lesson_form.assigned_hint_other": "Choose chapters or individual levels. Students complete at least {{count}} different selected levels, at any star result.",
  "sparky.lesson_form.not_valid": "Choose an available course and enough exercises for the required target.",
  "sparky.lesson_form.save": "Save lesson draft",
  "sparky.lesson_form.new": "New lesson",
  "sparky.lesson_form.edit_heading": "Change lesson",
  "sparky.lesson_form.edit_description": "This lesson has not started, so you can still change its title, students, exercises and target.",
  "sparky.lesson_form.save_changes": "Save changes",
  "sparky.lesson_form.loading_lesson": "Loading lesson…",
  "sparky.lesson_form.removed_students_one": "{{count}} student is no longer on the student list and was taken off this lesson.",
  "sparky.lesson_form.removed_students_other": "{{count}} students are no longer on the student list and were taken off this lesson.",
  "sparky.assign.to_student": "Assign to {{name}}",
  "sparky.assign.to_class": "Assign to class",
  "sparky.assign.student_aria": "Assign to {{name}} · Level {{level}}",
  "sparky.assign.class_aria": "Assign to class · Level {{level}}",
  "sparky.assign.title": "{{course}} · Level {{level}} · {{name}}",
  "sparky.assign.heading": "Assign this level",
  "sparky.assign.description": "The lesson starts as soon as you save it. Students finish this level once, then choose other activities.",
  "sparky.assign.summary_one": "Level {{level}} ({{grade}}) for {{count}} student.",
  "sparky.assign.summary_other": "Level {{level}} ({{grade}}) for {{count}} students.",
  "sparky.assign.show_details": "Show all lesson settings",
  "sparky.assign.save": "Assign and start",
  "sparky.lesson_form.error_title_required": "Enter a lesson title",
  "sparky.lesson_form.error_title_length": "Use 160 characters or fewer",
  "sparky.lesson_form.error_target_required": "Enter how many different exercises are required",
  "sparky.lesson_form.error_target_whole": "Use a whole number of exercises",
  "sparky.lesson_form.error_target_min": "Require at least 1 exercise",
  "sparky.lesson_form.error_target_max": "Require no more than 30 exercises",
  "sparky.lesson_form.error_target_available": "Require no more exercises than are available",
  "sparky.lesson_form.error_grade_specific": "Choose an exercise grade to assign specific exercises",
  "sparky.lesson_form.sitting_screen": "Screen (about {{minutes}} minutes): self-ratings and the first core questions in each topic",
  "sparky.lesson_form.sitting_extension": "Extension sitting: the remaining core and harder questions",
  "sparky.lesson_form.sitting_full": "Full check-up: every question",
  "sparky.lesson_form.sitting_estimate_one": "{{count}} item · about {{minutes}} minutes",
  "sparky.lesson_form.sitting_estimate_other": "{{count}} items · about {{minutes}} minutes",
  "sparky.lesson_form.stop_early": "Stop a topic early when the answers are clear",
  "sparky.lesson_form.stop_early_hint": "After three right first answers the rest of a topic's core questions are skipped; after two wrong ones the topic stops. Full sittings keep this off so the question analysis sees every item.",
  "sparky.lesson_form.wrong_answer_cost": "Wrong answer costs",
  "sparky.lesson_form.wrong_cost_none": "Nothing",
  "sparky.lesson_form.wrong_cost_half": "0.5 point",
  "sparky.lesson_form.wrong_cost_one": "1 point",
  "sparky.test.score": "{{points}} / {{questions}} ({{percent}}%)",
  "sparky.test.whole_score": "{{points}} out of {{total}} points ({{percent}}%)",
  "sparky.test.answered_score": "{{points}} points on the {{answered}} questions answered ({{percent}}%)",
  "sparky.test.right": "{{n}} right",
  "sparky.test.wrong": "{{n}} wrong",
  "sparky.test.wrong_deduction": "{{n}} wrong (−{{deduction}})",
  "sparky.test.dont_know_count": "{{n}} I don't know",
  "sparky.test.not_answered": "{{n}} not answered",
  "sparky.test.dont_know": "{{n}} × I don't know",
  "sparky.test.guessing": "Score no better than guessing",
  "sparky.test.raw": "Score {{raw}}%",
  "sparky.test.raw_chance": "Score {{raw}}%: random clicking gets about {{chance}}%",
  "sparky.test.fast": "{{n}} answers in under 3 seconds",
  "sparky.test.code_runs_one": "{{count}} rushed or repeated code run",
  "sparky.test.code_runs_other": "{{count}} rushed or repeated code runs",
  "sparky.test.review_skipped": "Explanations in the review skipped",
  "sparky.test.student_score": "Test score",
  "sparky.test.class_score": "Class test score",
  "sparky.test.class_hint": "{{points}} / {{questions}} points · students tested: {{students}}",
  "sparky.test.class_hint_whole": "{{points}} out of {{total}} points · {{points}} points on the {{questions}} questions answered ({{percent}}%) · students tested: {{students}}",
  "sparky.test.score_note": "Every child is marked out of all the questions in the test they were given, so everyone has the same total; a question they never reached earns 0 points and costs nothing. The answered figure is the same points out of the questions the child reached. Points are earned after any wrong-answer cost the lesson sets. \"I don't know\" earns 0 points and costs nothing. The class test score adds every tested student's points and totals together. \"Score no better than guessing\" marks a score of 40% or less on the answered questions (before deductions) where at least 3 answers, and at least a third of all answers, came within 3 seconds, or where the child ran unchanged code again or rushed a failed run with a tiny change at least 3 times on the test's coding exercises.",
  "sparky.test.topic_score": "{{topic}} {{points}}/{{questions}}",
  "sparky.test.pace_one": "{{time}} · {{count}} fast answer",
  "sparky.test.pace_other": "{{time}} · {{count}} fast answers",
  "sparky.class_test.region": "Class test results",
  "sparky.class_test.title": "Class test results",
  "sparky.class_test.description": "Scores out of the whole test, for the {{tested}} of {{total}} students who took it.",
  "sparky.class_test.average": "Average score",
  "sparky.class_test.median": "Median {{percent}}%",
  "sparky.class_test.highest": "Highest score",
  "sparky.class_test.lowest": "Lowest score",
  "sparky.class_test.finished": "Finished all exercises",
  "sparky.class_test.finished_hint": "Students who finished every exercise in the test",
  "sparky.class_test.guessing_hint_one": "{{count}} student flagged",
  "sparky.class_test.guessing_hint_other": "{{count}} students flagged",
  "sparky.class_test.topics_title": "Accuracy by topic",
  "sparky.class_test.topic_points": "{{points}} of {{questions}} points",
  "sparky.class_test.weakest": "Weakest topic",
  "sparky.class_test.most_missed_title": "Most missed questions",
  "sparky.class_test.most_missed_hint": "The three questions with the lowest first-answer accuracy, among questions at least two students answered.",
  "sparky.practice.guess_pauses": "Slowed down for guessing: {{n}} times",
  "sparky.practice.run_pauses": "Slowed down for rushed or repeated runs: {{n}} times",
  "sparky.practice.explanation_locks": "Rushed explanations: {{n}} times (+{{seconds}} s)",
  "sparky.practice.runs": "{{partial}} partial runs, {{failed}} failed runs",
  "sparky.practice.repeat_runs_one": "Ran unchanged code: {{count}} time",
  "sparky.practice.repeat_runs_other": "Ran unchanged code: {{count}} times",
  "sparky.practice.rushed_runs_one": "Rushed runs: {{count}}",
  "sparky.practice.rushed_runs_other": "Rushed runs: {{count}}",
  "sparky.practice.refused_moves_one": "Refused moves: {{count}} (kept trying moves that aren't allowed)",
  "sparky.practice.refused_moves_other": "Refused moves: {{count}} (kept trying moves that aren't allowed)",
  "sparky.practice.level_runs": "{{partial}}, {{failed}}",
  "sparky.practice.level_partial_one": "{{count}} partial run",
  "sparky.practice.level_partial_other": "{{count}} partial runs",
  "sparky.practice.level_failed_one": "{{count}} failed run",
  "sparky.practice.level_failed_other": "{{count}} failed runs",
  "sparky.interaction_event.explanation_lock": "Explanation skipped ahead: locked for {{seconds}}s",
  "sparky.interaction_event.guess_pause": "Slowed down for guessing: {{seconds}}s pause",
  "sparky.interaction_event.run_pause": "Slowed down for repeated or rushed code runs: {{seconds}}s pause",
  "sparky.interaction_event.run_refused": "Run refused: the code had not changed",
  "sparky.interaction_event.blocked_locked": "Ignored: the explanation was still locked",
  "sparky.lesson_form.error_sitting_grade": "A check-up sitting needs one exercise grade: choose a grade or students from one grade",
  "sparky.lesson_form.error_grade_students": "Choose an exercise grade for these students",
  "sparky.lesson_form.error_students_min": "Choose at least one student",
  "sparky.lesson_form.error_students_max": "Choose no more than 500 students",
  "sparky.lesson_form.error_course_required": "Choose an activity",
  "sparky.lesson_form.error_course_available": "Choose an available activity for these students",
  "sparky.lesson_form.error_levels_min": "Choose at least one exercise",
  "sparky.lesson_form.add_part": "+ Add another course",
  "sparky.lesson_form.part_legend": "Course {{number}}",
  "sparky.lesson_form.remove_part": "Remove this course",
  "sparky.lesson_form.parts_hint": "Different levels completed in any of these courses count towards the one target. Replays and skips do not.",
  "sparky.lesson_form.error_part_course_available": "Choose another activity these students can play; check-ups and courses already in the lesson cannot be added",
  "sparky.lesson.status_draft": "Prepared",
  "sparky.lesson.status_active": "In progress",
  "sparky.lesson.status_ended": "Ended",
  "sparky.lesson.results_caption": "Lesson results by student",
  "sparky.lesson.col_progress": "Assignment progress",
  "sparky.lesson.col_score": "Score",
  "sparky.lesson.col_activity": "Activity & time",
  "sparky.lesson.col_evidence": "Learning evidence",
  "sparky.lesson.progress_label": "{{name}} assignment progress",
  "sparky.lesson.on_level": "{{time}} on level",
  "sparky.lesson.active_visits_one": "{{time}} active · {{count}} visit",
  "sparky.lesson.active_visits_other": "{{time}} active · {{count}} visits",
  "sparky.lesson.selected_students": "Selected students",
  "sparky.lesson.required_count_one": "{{count}} different exercise required",
  "sparky.lesson.required_count_other": "{{count}} different exercises required",
  "sparky.lesson.all_exercises": "All exercises",
  "sparky.lesson.no_answers_yet": "No answers yet",
  "sparky.lesson.started_at": "Started {{date}}",
  "sparky.lesson.draft_hint": "Draft · start the lesson when your class is ready",
  "sparky.lesson.ended_at": "Ended {{date}}",
  "sparky.lesson.export": "Export lesson report CSV",
  "sparky.lesson.any_exercises": "Any exercises in this course",
  "sparky.lesson.updating": "Updating…",
  "sparky.lesson.start": "Start lesson",
  "sparky.lesson.end": "End lesson",
  "sparky.lesson.edit": "Edit lesson",
  "sparky.lesson.delete": "Delete lesson",
  "sparky.lesson.delete_title": "Delete this lesson?",
  "sparky.lesson.delete_description": "“{{title}}” has not started. Deleting it removes the draft and its student list. This cannot be undone.",
  "sparky.lesson.deleted": "Lesson deleted",
  "sparky.lesson.showing_students": "Showing {{shown}} of {{total}} students.",
  "sparky.lesson.no_group_students": "No students match this group.",
  "sparky.lesson.stat_target": "Assignment target",
  "sparky.lesson.of_students": "{{met}} of {{total}}",
  "sparky.lesson.stat_target_hint": "{{done}} of {{total}} required completions",
  "sparky.lesson.stat_exercise_score": "Exercise score",
  "sparky.lesson.stat_class_score": "Class score",
  "sparky.lesson.stat_score_hint": "Best stars on completed assigned exercises",
  "sparky.lesson.stat_active": "Active time",
  "sparky.lesson.stat_active_hint": "Recorded play during this lesson",
  "sparky.lesson.stat_improved": "Exercises improved",
  "sparky.lesson.stat_improved_hint": "Higher stars on a later completion",
  "sparky.lesson.student_results": "Student results",
  "sparky.lesson.how_calculated": "Completion counts each different assigned level once, at any star result. Score uses the best stars for each completed assigned level (3 possible stars per level). Other activities do not add to the target or score. Active time excludes pauses and hidden tabs. Ended lesson results stay fixed. Recorded mistakes describe game outcomes, rather than a diagnosis.",
  "sparky.lesson.loading_report": "Loading lesson report…",
  "sparky.lesson.report_unavailable": "Lesson report unavailable.",
  "sparky.lesson.updates_unavailable": "Live report updates unavailable.",
  "sparky.lesson.report_region": "Lesson report",
  "sparky.lesson.first_to_best": "First try {{first}} stars, best {{best}} stars after a replay",
  "sparky.lesson.level_results": "Level results & progression",
  "sparky.lesson.details_title": "{{name}} · Lesson exercise results",
  "sparky.lesson.details_description": "{{lesson}} · What was recorded during this lesson, exercise by exercise",
  "sparky.lesson.target_label": "{{name}} lesson target",
  "sparky.lesson.assignment_score": "Assignment score",
  "sparky.lesson.assigned_exercises": "Assigned exercises",
  "sparky.lesson.none_attempted": "No assigned exercises have been attempted yet.",
  "sparky.lesson.other_activities": "Other activities",
  "sparky.lesson.other_not_counted": "These do not count towards the assignment target or score.",
  "sparky.lesson.attempts": "Attempts, in order",
  "sparky.lesson.attempt_n": "Attempt {{n}}",
  "sparky.lesson.attempts_loading": "Loading attempts…",
  "sparky.lesson.attempts_unavailable": "Attempt details are unavailable right now.",
  "sparky.lesson.attempts_none": "No attempt recorded in this lesson.",
  "sparky.lesson.open_history": "Full activity history",
  "sparky.lesson.assigned_levels": "Assigned levels: {{levels}}",
  "sparky.lessons.list_hint": "Running lessons are all shown; other views show up to 100 lessons, running lessons first. Select a lesson to see every student’s results.",
  "sparky.lessons.loading": "Loading lessons…",
  "sparky.lessons.refresh_failed": "Lessons could not refresh.",
  "sparky.lessons.caption": "Lessons",
  "sparky.lessons.col_lesson": "Lesson",
  "sparky.lessons.col_activity": "Activity",
  "sparky.lessons.col_target": "Target",
  "sparky.lessons.empty": "No lessons in this view.",
  "sparky.lessons.status_filter": "Lessons",
  "sparky.lessons.status_active": "Running",
  "sparky.lessons.status_draft": "Prepared",
  "sparky.lessons.status_ended": "Ended",
  "sparky.lessons.status_all": "All",
  "sparky.lessons.running_long_one": "Running for {{count}} day — end it?",
  "sparky.lessons.running_long_other": "Running for {{count}} days — end it?",
  "sparky.cohort.not_started": "Not started",
  "sparky.cohort.below_target": "Below target",
  "sparky.cohort.working": "Working towards target",
  "sparky.cohort.met_target": "Target met",
  "sparky.cohort.improved": "Improved on replay",
  "sparky.cohort.region": "Class lesson insights",
  "sparky.cohort.empty": "No students in this group",
  "sparky.cohort.results_description": "See who is ready to move on and who needs a check-in. Select a group above to focus the report.",
  "sparky.cohort.all_count_one": "All students ({{count}})",
  "sparky.cohort.all_count_other": "All students ({{count}})",
  "sparky.cohort.review_title": "Exercises to review with the class",
  "sparky.cohort.review_description": "Start with the exercises fewest students got right on their first answer, then those with the most mistakes. Only assigned exercises are included.",
  "sparky.cohort.to_review_one": "{{count}} to review",
  "sparky.cohort.to_review_other": "{{count}} to review",
  "sparky.cohort.review_caption": "Assigned exercises to review",
  "sparky.cohort.col_exercise": "Exercise",
  "sparky.cohort.col_students": "Students & mistakes",
  "sparky.cohort.col_results": "Results",
  "sparky.cohort.col_error_types": "Error types",
  "sparky.cohort.affected": "{{affected}} of {{tried}} students who tried it",
  "sparky.cohort.completed_of": "{{completed}} of {{tried}} completed",
  "sparky.cohort.students_improved_one": "{{count}} student improved",
  "sparky.cohort.students_improved_other": "{{count}} students improved",
  "sparky.cohort.none_flagged": "No exercises flagged for review",
  "sparky.cohort.none_flagged_hint": "No recorded mistakes, help or retries on assigned exercises yet.",
  "sparky.items.none": "No check-up questions were answered in this window.",
  "sparky.items.title": "Question analysis",
  "sparky.items.description": "Every check-up question across the class, hardest first: how many first answers were right, and which wrong options children chose. Start reteaching with the questions most children missed.",
  "sparky.items.caption": "Check-up questions by first-answer accuracy",
  "sparky.items.export": "Export questions",
  "sparky.items.col_question": "Question",
  "sparky.items.col_first": "First answers right",
  "sparky.items.col_wrong": "Wrong answers chosen",
  "sparky.items.first_of": "{{correct}} of {{answered}} children",
  "sparky.items.assisted_one": "{{count}} answered after help or a reset",
  "sparky.items.assisted_other": "{{count}} answered after help or a reset",
  "sparky.items.chosen_by_one": "chosen by {{count}} child",
  "sparky.items.chosen_by_other": "chosen by {{count}} children",
  "sparky.items.unrecorded_one": "{{count}} wrong answer without the option recorded",
  "sparky.items.unrecorded_other": "{{count}} wrong answers without the option recorded",
  "sparky.items.no_wrong": "No wrong first answers",
  "sparky.items.flag_everyone": "Everyone gets this",
  "sparky.items.flag_most_miss": "Most miss this",
  "sparky.items.flag_hint": "Questions are flagged only once at least 5 children have answered them. “Everyone gets this” means more than 95% right first time; “Most miss this” means under 20%.",
  "sparky.items.csv_answered": "First answers",
  "sparky.items.csv_assisted": "First answers after help",
  "sparky.items.csv_percent": "First-answer accuracy %",
  "sparky.items.csv_flag": "Flag",
  "sparky.window.school_year": "{{name}} school year",
  "sparky.window.range": "{{from}} – {{to}}",
  "sparky.window.since": "since {{from}}",
  "sparky.window.until": "until {{to}}",
  "sparky.window.all": "all recorded history",
  "sparky.window.counted": "First answers counted: {{window}}.",
  "sparky.window.picker_label": "Evidence window",
  "sparky.window.custom": "Custom dates",
  "sparky.window.apply": "Apply dates",
  "sparky.window.reset": "Reset to default",
  "sparky.window.from_required": "Choose a start date.",
  "sparky.window.to_required": "Choose an end date.",
  "sparky.window.order": "The start date must be on or before the end date.",
  "sparky.window.invalid_link": "The dates in this link are not valid, so the default window is shown.",
  "sparky.window.unavailable": "These dates could not be used: {{message}}",
  "sparky.growth.title": "Check-up growth",
  "sparky.growth.description": "First-answer accuracy per topic: the first school year it was measured beside the current window ({{window}}). Each school year counts its own first answers, so a question met last year is a fresh first answer this year.",
  "sparky.growth.caption": "Check-up topics, baseline and latest",
  "sparky.growth.col_topic": "Topic",
  "sparky.growth.col_baseline": "Baseline",
  "sparky.growth.col_latest": "Latest",
  "sparky.growth.col_change": "Change",
  "sparky.growth.measure": "{{correct}}/{{answered}} right first time · {{score}}%",
  "sparky.growth.change": "{{change}} points",
  "sparky.growth.note": "Topics are measured by only a few questions, so results can swing a lot. Compare with classwork before drawing conclusions.",
  "sparky.snapshot.remaining_one": "{{count}} more different exercise to complete",
  "sparky.snapshot.remaining_other": "{{count}} more different exercises to complete",
  "sparky.snapshot.not_met_one": "Target not met · {{count}} required exercise remaining",
  "sparky.snapshot.not_met_other": "Target not met · {{count}} required exercises remaining",
  "sparky.snapshot.met": "Target met",
  "sparky.snapshot.current": "Current class assignment",
  "sparky.snapshot.latest": "Latest lesson",
  "sparky.snapshot.loading": "Loading lesson results…",
  "sparky.snapshot.unavailable": "Lesson updates unavailable.",
  "sparky.snapshot.course_only": "{{course}} · results for this lesson only",
  "sparky.snapshot.required": "Required exercises",
  "sparky.snapshot.score": "Score",
  "sparky.snapshot.progress_label": "Lesson completion progress",
  "sparky.snapshot.none": "No started lesson yet. Prepare one on the Lessons tab.",
  "sparky.snapshot.open": "View lesson results & history",
  "sparky.student_lessons.title": "Assignments & lesson history",
  "sparky.student_lessons.description": "Lesson reports cover their assigned exercises, regardless of the learning report date filter.",
  "sparky.student_lessons.select_label": "Student lesson",
  "sparky.student_lessons.empty": "No lesson assignments yet.",
  "sparky.recovery.title": "Recovery & improvement",
  "sparky.recovery.description": "Recognise what changed after a difficult attempt. Comparisons use visits within the selected period.",
  "sparky.recovery.export": "Export recovery",
  "sparky.recovery.finished_after_mistakes": "Finished after mistakes",
  "sparky.recovery.finished_after_mistakes_hint": "Completed visits with an earlier incorrect answer",
  "sparky.recovery.independent_after_help": "Independent after help",
  "sparky.recovery.independent_after_help_hint": "Different levels completed without mistakes, help or retries after an earlier helped visit",
  "sparky.recovery.improved_on_replay": "Improved on replay",
  "sparky.recovery.improved_on_replay_hint": "Different levels with a higher star result than their first completion",
  "sparky.recovery.stars_change": "{{first}} → {{best}} stars",
  "sparky.recovery.empty": "Recovery highlights appear when a student finishes after mistakes or improves on a later attempt.",
  "sparky.recovery.more_one": "{{count}} more level improved; see Skills & exercises for every level.",
  "sparky.recovery.more_other": "{{count}} more levels improved; see Skills & exercises for every level.",
  "sparky.chart.title": "Progress over time",
  "sparky.chart.description": "Daily results by school day",
  "sparky.chart.metric": "Progress chart metric",
  "sparky.chart.option_completed_levels": "Completed levels",
  "sparky.chart.option_score": "Scores",
  "sparky.chart.option_minutes": "Active time",
  "sparky.chart.label_completed_levels": "Different levels completed",
  "sparky.chart.label_score": "Completion score (%)",
  "sparky.chart.label_minutes": "Active minutes",
  "sparky.chart.hint_completed_levels": "Each different level counts once per day. A replay on another day can appear again.",
  "sparky.chart.hint_score": "Scores include every completion that day, including replays; days without a completion have no score.",
  "sparky.chart.hint_minutes": "Active time excludes hidden tabs, pauses and inactivity.",
  "sparky.chart.aria": "{{label}} by school day",
  "sparky.chart.days_played_one": "{{count}} day with recorded play.",
  "sparky.chart.days_played_other": "{{count}} days with recorded play.",
  "sparky.chart.empty": "Daily progress will appear after recorded play.",
  "sparky.skills.levels_active_one": "{{count}} level completed · {{time}} active",
  "sparky.skills.levels_active_other": "{{count}} levels completed · {{time}} active",
  "sparky.skills.exercises_title": "Exercises & scores",
  "sparky.skills.exercises_description": "Every visited level in this period. Select a level to see its results and learning evidence.",
  "sparky.skills.course_totals": "{{completed}}/{{visited}} visited levels completed · {{earned}}/{{possible}} stars",
  "sparky.skills.level_button": "{{course}} {{grade}} level {{level}}: {{result}}",
  "sparky.skills.empty": "No visited exercises in this period.",
  "sparky.skills.selected_region": "Selected exercise details",
  "sparky.skills.best_result": "Best result",
  "sparky.skills.no_completion": "No completion yet",
  "sparky.skills.first_completion": "First completion: {{stars}}/3 stars",
  "sparky.skills.level_visits_one": "{{count}} level visit",
  "sparky.skills.level_visits_other": "{{count}} level visits",
  "sparky.skills.completions": "Completions",
  "sparky.skills.skipped_visits_one": "{{count}} skipped visit",
  "sparky.skills.skipped_visits_other": "{{count}} skipped visits",
  "sparky.history.title": "Activity history",
  "sparky.history.description": "Latest {{limit}} visits in this period. Overview and daily totals include all {{count}} visits.",
  "sparky.history.result": "Result",
  "sparky.history.all_results": "All results",
  "sparky.history.outcome_completed": "Completed",
  "sparky.history.outcome_skipped": "Skipped",
  "sparky.history.outcome_unfinished": "Unfinished",
  "sparky.history.caption": "Recent student activity history",
  "sparky.history.col_started": "Started",
  "sparky.history.col_exercise": "Exercise",
  "sparky.history.col_evidence": "Evidence",
  "sparky.history.error_details": "Error details",
  "sparky.history.empty": "No visits match these filters.",
  "sparky.overview.next_title": "What to work on next",
  "sparky.overview.review_together": "Review together",
  "sparky.overview.keep_going": "Keep going",
  "sparky.overview.across_visits_one": "across {{count}} visit",
  "sparky.overview.across_visits_other": "across {{count}} visits",
  "sparky.overview.no_signals": "No recorded practice signals in this period. Offer the next exercise and observe how they solve it.",
  "sparky.overview.start_lesson": "Start a lesson to see achievements and suggested practice here.",
  "sparky.overview.more_skills_one": "{{count}} more skill to review.",
  "sparky.overview.more_skills_other": "{{count}} more skills to review.",
  "sparky.overview.explore_skills": "Explore skills & exercises",
  "sparky.overview.achievements_title": "Achievements by activity",
  "sparky.overview.completed_count_one": "{{count}} completed",
  "sparky.overview.completed_count_other": "{{count}} completed",
  "sparky.overview.no_score": "No score yet",
  "sparky.overview.score_percent": "{{score}}% score",
  "sparky.overview.visited_completed_label": "{{course}}: visited levels completed",
  "sparky.overview.visited_completed": "{{completed}} of {{total}} visited levels completed",
  "sparky.overview.course_line": "{{threeStars}} three-star results · {{improved}} levels improved · {{visited}} visited levels",
  "sparky.overview.no_play": "No recorded play in this date range.",
  "sparky.overview.mistakes_title": "Types of mistakes",
  "sparky.overview.checkups_title": "Check-up results",
  "sparky.overview.mistakes_description": "Recorded game outcomes and answers in this period. Examples show the latest occurrence of each type.",
  "sparky.overview.footnote": "Practice suggestions use recorded mistakes, help, retries and star results. “Needs practice” requires repeated evidence across at least two visits. Time alone does not indicate difficulty. Exercise scores use completed levels only; unfinished levels appear under Skills & exercises.",
  "sparky.report.region": "Student learning report",
  "sparky.report.eyebrow": "Sparky learning report",
  "sparky.report.loading": "Loading report…",
  "sparky.report.unavailable": "Report updates are unavailable.",
  "sparky.report.stat_completed": "Exercises completed",
  "sparky.report.stat_completed_hint": "{{threeStars}} with 3 stars · {{improved}} improved after replay",
  "sparky.report.stat_score_hint": "{{earned}}/{{possible}} stars · best result per completed level",
  "sparky.report.stat_score_empty": "Complete a level to earn a score",
  "sparky.report.stat_active_hint": "{{visits}} visits · {{days}} days played",
  "sparky.report.stat_review": "Skills to review",
  "sparky.report.stat_review_hint_one": "{{count}} with repeated practice signals",
  "sparky.report.stat_review_hint_other": "{{count}} with repeated practice signals",
  "sparky.report.tab_overview": "Overview",
  "sparky.report.tab_skills": "Skills & exercises",
  "sparky.report.tab_lessons": "Lessons",
  "sparky.report.tab_history": "Activity history",
  "sparky.report.tabs_label": "Student report views",
  "sparky.mastery.caption": "Student results by topic · {{course}} · {{grade}}",
  "sparky.mastery.chapter_levels_one": "{{count}} level · {{topic}}",
  "sparky.mastery.chapter_levels_other": "{{count}} levels · {{topic}}",
  "sparky.mastery.cell_label": "{{name}}: {{topic}}, {{completed}} of {{total}} completed",
  "sparky.mastery.active_view": "{{time}} active · View exercises",
  "sparky.mastery.not_started_view": "Not started · View exercises",
  "sparky.mastery.unavailable_cell": "Results unavailable",
  "sparky.mastery.topic_progress": "Topic progress",
  "sparky.mastery.level_visits_one": "{{count}} visit · {{time}} active",
  "sparky.mastery.level_visits_other": "{{count}} visits · {{time}} active",
  "sparky.mastery.close_topic": "Close topic",
  "sparky.mastery.title": "Class topic mastery",
  "sparky.mastery.description": "Compare what students have completed, their best star results, and where to offer practice. Each different level counts once in the selected period.",
  "sparky.mastery.loading": "Loading topic results…",
  "sparky.mastery.unavailable": "Topic results unavailable.",
  "sparky.mastery.stat_started": "Students who started",
  "sparky.mastery.stat_three_stars": "Levels with 3 stars",
  "sparky.mastery.stat_needs_practice": "Topics needing practice",
  "sparky.mastery.show_not_started_one": "Show {{count}} student who has not started",
  "sparky.mastery.show_not_started_other": "Show {{count}} students who have not started",
  "sparky.mastery.hide_not_started": "Only students who started",
  "sparky.mastery.nobody_started": "Nobody has played this activity in this period.",
  "sparky.mastery.export": "Export topic CSV",
  "sparky.mastery.footer": "Select a topic cell to see its exercises. Stars show recorded results; “Needs practice” requires difficulty evidence on at least two visits.",
  "sparky.behavior.title": "How the rule works",
  "sparky.behavior.description": "Compare observations by exercise grade and activity, then use teacher reviews to check whether a signal is helpful.",
  "sparky.behavior.current_rule": "Current rule",
  "sparky.behavior.rule": "{{answers}} consecutive answers within {{seconds}}s each, at least {{wrong}} incorrect, within {{window}}s in the same activity, skill and grade.",
  "sparky.behavior.rule_note": "Fast correct answers are never flagged. Help, pauses and slower responses break the pattern. Reviews never change student scores or automatically change these thresholds.",
  "sparky.behavior.loading": "Loading threshold evidence…",
  "sparky.behavior.unavailable": "Unable to load threshold evidence.",
  "sparky.behavior.groups_count_one": "{{count}} activity and skill",
  "sparky.behavior.groups_count_other": "{{count}} activities and skills",
  "sparky.behavior.export": "Export threshold evidence",
  "sparky.behavior.caption": "Rapid-answer evidence by activity, skill and exercise grade",
  "sparky.behavior.col_activity": "Activity / exercise grade",
  "sparky.behavior.col_timed": "Timed answers",
  "sparky.behavior.col_patterns": "Rapid-answer patterns",
  "sparky.behavior.col_median": "Median response",
  "sparky.behavior.col_reviews": "Your reviews",
  "sparky.behavior.timed_visits": "{{timed}} timed visits / {{visits}} visits",
  "sparky.behavior.patterns_hint": "Review the evidence before inferring guessing",
  "sparky.behavior.seconds": "{{value}}s",
  "sparky.behavior.sampled_one": "{{count}} retained answer sampled",
  "sparky.behavior.sampled_other": "{{count}} retained answers sampled",
  "sparky.behavior.reviews": "{{support}} need support · {{fine}} not concerning",
  "sparky.behavior.acknowledged_one": "{{count}} acknowledged · current rapid-answer observations only",
  "sparky.behavior.acknowledged_other": "{{count}} acknowledged · current rapid-answer observations only",
  "sparky.behavior.empty": "Play a lesson to collect classroom evidence. Earlier answer times cannot be reconstructed.",
  "sparky.behavior.sample_note": "Answer and pattern totals cover the full selected period. Response medians use retained answer events from the latest {{sampled}} timed visits (up to {{limit}}); each visit retains its latest 60 interaction events. This sample may omit earlier answers. A zero review count means no current observation has been reviewed by you.",
  "sparky.behavior.how_to_use": "During a lesson, ask flagged students to explain an answer. Use “Needs support” or “Not concerning” in Teacher attention. Compare several lessons before deciding whether a grade or activity needs a different threshold.",
  "sparky.attention.title": "Teacher attention",
  "sparky.attention.description": "One card per student and topic: what happened, why it is here and what to try next. Open follow-ups stay at the top, then students playing now. Done, Follow up and Not concerning apply to every attempt on the card. These observations suggest a conversation; they do not change scores.",
  "sparky.attention.open_count_one": "{{count}} open observation",
  "sparky.attention.open_count_other": "{{count}} open observations",
  "sparky.attention.hide_reviewed": "Hide reviewed",
  "sparky.attention.show_reviewed": "Show reviewed",
  "sparky.attention.export": "Export observations",
  "sparky.attention.loading": "Loading observations…",
  "sparky.attention.unavailable": "Unable to load observations.",
  "sparky.attention.try_next": "Try next:",
  "sparky.attention.see_evidence": "See interaction evidence",
  "sparky.attention.student_report": "Student report",
  "sparky.attention.assignment": "Lesson",
  "sparky.attention.review_support": "Follow up",
  "sparky.attention.review_fine": "Not concerning",
  "sparky.attention.review_done": "Done",
  "sparky.attention.review_acknowledged": "Seen",
  "sparky.attention.review_open": "Open",
  "sparky.attention.empty": "No open observations for these students in the loaded visits.",
  "sparky.attention.view_all": "View all observations",
  "sparky.attention.footer_one": "Reviews are kept; new evidence re-opens an item. Showing observations from {{count}} matching visit in this period.",
  "sparky.attention.footer_other": "Reviews are kept; new evidence re-opens an item. Showing observations from {{count}} matching visits in this period.",
  "sparky.attention.loading_earlier": "Loading earlier visits…",
  "sparky.attention.load_earlier": "Load earlier observations",
  "sparky.attention.rapid_answers_title": "Answering faster than the questions can be read",
  "sparky.attention.rapid_answers_evidence_one": "{{count}} run of five answers each given in under a second, mostly wrong.",
  "sparky.attention.rapid_answers_evidence_other": "{{count}} runs of five answers each given in under a second, mostly wrong.",
  "sparky.attention.rapid_answers_next": "Ask {{name}} to read the next question aloud and explain the answer before choosing it.",
  "sparky.attention.blocked_title": "Kept pressing while the game was busy",
  "sparky.attention.blocked_evidence_one": "{{count}} press while the game was still busy (for example while the program was running).",
  "sparky.attention.blocked_evidence_other": "{{count}} presses while the game was still busy (for example while the program was running).",
  "sparky.attention.blocked_next": "Watch {{name}} run a program once and point out when the next step becomes available.",
  "sparky.attention.rapid_clicks_title": "Tapping rapidly through the steps",
  "sparky.attention.rapid_clicks_evidence_one": "{{count}} burst of five taps within two seconds on the same control.",
  "sparky.attention.rapid_clicks_evidence_other": "{{count}} bursts of five taps within two seconds on the same control.",
  "sparky.attention.rapid_clicks_next": "Ask {{name}} what the last explanation said; if they cannot say, go through it together.",
  "sparky.attention.difficulty_title": "Review this exercise",
  "sparky.attention.difficulty_next_done": "Ask {{name}} which part was hardest, then offer the same level again without help.",
  "sparky.attention.difficulty_next": "Sit with {{name}} for the first step of this level, then let them finish it alone.",
  "sparky.attention.difficulty_title_stuck": "Stuck on {{skill}}",
  "sparky.attention.difficulty_title_struggled": "Struggled through {{skill}}",
  "sparky.attention.difficulty_title_helped": "Needed help with {{skill}}",
  "sparky.attention.why": "Why it is here:",
  "sparky.attention.why_sentence": "In the latest attempt {{name}} {{facts}}.",
  "sparky.attention.why_join": ", ",
  "sparky.attention.why_mistakes_one": "made {{count}} mistake",
  "sparky.attention.why_mistakes_other": "made {{count}} mistakes",
  "sparky.attention.why_hints_one": "asked for help {{count}} time",
  "sparky.attention.why_hints_other": "asked for help {{count}} times",
  "sparky.attention.why_retries_one": "restarted {{count}} time",
  "sparky.attention.why_retries_other": "restarted {{count}} times",
  "sparky.attention.why_low_stars": "finished with {{stars}} of 3 stars",
  "sparky.attention.why_unfinished": "left the level unfinished",
  "sparky.attention.why_skipped": "skipped the level",
  "sparky.attention.why_repeated_one": "{{count}} attempt at this topic looked like this.",
  "sparky.attention.why_repeated_other": "{{count}} attempts at this topic looked like this.",
  "sparky.attention.what_happened": "What happened",
  "sparky.attention.attempts_one": "{{count}} attempt",
  "sparky.attention.attempts_other": "{{count}} attempts",
  "sparky.attention.next_counting": "Count or match one set out loud with {{name}}, pointing at each item, then watch them do the next one alone.",
  "sparky.attention.next_sequence": "Say the pattern out loud together, what comes next and why, then let {{name}} continue one more.",
  "sparky.attention.next_calculation": "Ask {{name}} to show the working for one sum like “{{expected}}” on paper, then try a similar one.",
  "sparky.attention.next_place_value": "Build one number with place-value columns or blocks with {{name}}, then ask them to read it back.",
  "sparky.attention.next_geometry": "Put two shapes or angles side by side with {{name}} and name the difference, then try one more.",
  "sparky.attention.next_fraction": "Draw or fold one fraction with {{name}}, then ask them to show another one.",
  "sparky.attention.next_measurement": "Measure one real object with {{name}} and check the unit, then let them do the next.",
  "sparky.attention.next_checkup": "Ask {{name}} to explain their answer in their own words, then ask the same idea with a new example.",
  "sparky.attention.next_trace": "Trace the program one block at a time on the board with {{name}} and ask where Sparky turns, before running it.",
  "sparky.attention.next_goal": "Ask {{name}} what the goal is and which step is still missing, then let them add it.",
  "sparky.attention.next_block": "Show {{name}} the block this level asks for and build one tiny example with it together.",
  "sparky.attention.next_error": "Read the error message with {{name}} and ask what would have to change inside the loop.",
  "sparky.attention.next_predict": "Ask {{name}} to say what the program will do before each run, then run it once.",
  "sparky.attention.next_act_out": "Act out the message or switch with two people, then let {{name}} build it.",
  "sparky.attention.next_answer": "Do one question out loud with {{name}}, then watch them try the next one alone.",
  "sparky.attention.next_hints": "Try the next level with {{name}} with hints closed; ask what they would try first.",
  "students.detail_tab_sparky": "Sparky",
  "sparky.page.subtitle": "Live classroom activity and learning history",
  "sparky.page.open_sparky": "Open Sparky",
  "sparky.tabs.label": "Sparky views",
  "sparky.tabs.live": "Live",
  "sparky.tabs.classroom": "History",
  "sparky.tabs.mastery": "Topic mastery",
  "sparky.tabs.lessons": "Lessons",
  "sparky.tabs.attention": "Attention",
  "sparky.filters.search": "Find student",
  "sparky.filters.search_placeholder": "Search by name or nickname…",
  "sparky.filters.school_day": "School day",
  "sparky.filters.recent_days_one": "Last {{count}} school day",
  "sparky.filters.recent_days_other": "Last {{count}} school days",
  "sparky.filters.class": "Class",
  "sparky.filters.all_classes": "All classes",
  "sparky.filters.my_classes": "My classes",
  "sparky.filters.grade_all_sections": "{{grade}} (all sections)",
  "sparky.filters.period": "Period",
  "sparky.filters.period_today": "Today",
  "sparky.filters.period_range": "Date range",
  "sparky.filters.period_all": "All time",
  "sparky.filters.exercise_grade": "Exercise grade",
  "sparky.filters.all_exercise_grades": "All exercise grades",
  "sparky.filters.activity": "Activity",
  "sparky.filters.all_activities": "All activities",
  "sparky.filters.live_activity": "Live activity",
  "sparky.filters.review_only": "Needs a look",
  "sparky.filters.interaction_only": "Fast clicking or guessing",
  "sparky.filters.no_students": "No students match these filters.",
  "sparky.classroom.loading": "Loading classroom…",
  "sparky.classroom.loading_roster": "Loading classroom roster…",
  "sparky.classroom.roster_unavailable": "Unable to load the classroom roster.",
  "sparky.classroom.updates_unavailable": "Updates are unavailable. Last received data may be out of date.",
  "sparky.classroom.stat_played": "Students who played",
  "sparky.classroom.stat_played_hint_one": "Of {{count}} student in these filters",
  "sparky.classroom.stat_played_hint_other": "Of {{count}} students in these filters",
  "sparky.classroom.show_not_played_one": "Show {{count}} student who did not play",
  "sparky.classroom.show_not_played_other": "Show {{count}} students who did not play",
  "sparky.classroom.hide_not_played": "Only students who played",
  "sparky.classroom.nobody_played": "Nobody played in this period.",
  "sparky.classroom.stat_levels": "Levels completed",
  "sparky.classroom.stat_active_hint": "Excludes hidden tabs and pauses",
  "sparky.classroom.stat_practice": "Need practice",
  "sparky.classroom.stat_practice_hint": "Repeated difficulty across at least two visits",
  "sparky.classroom.activities_title": "Activities in this period",
  "sparky.classroom.activity_hint": "{{students}} students · {{levels}} levels completed",
  "sparky.classroom.export": "Export view CSV",
  "sparky.classroom.help_summary": "How these numbers update",
  "sparky.classroom.help_details": "Totals reload whenever a student opens or finishes a level or answers, and when the connection comes back. Active time excludes hidden tabs and pauses after 1 minute without input.",
  "sparky.classroom.history_summary_one": "{{count}} student",
  "sparky.classroom.history_summary_other": "{{count}} students",
  "sparky.live.summary_one": "{{count}} student with Sparky open",
  "sparky.live.summary_other": "{{count}} students with Sparky open",
  "sparky.live.nobody_playing": "Nobody is playing right now.",
  "sparky.live.caption": "Students playing Sparky right now",
  "sparky.live.connected": "Updates live as students play",
  "sparky.live.reconnecting": "Live updates paused, reconnecting…",
  "sparky.live.help_details": "Each game reports every 5 seconds and this board updates as soon as it does. Active time excludes hidden tabs and pauses after 1 minute without input. A student shows as disconnected after 30 seconds without an update and leaves the board after 2 minutes. Earlier play and totals are in History.",
  "sparky.classroom.caption": "Students, live activity, and progress",
  "sparky.classroom.col_status": "Live status",
  "sparky.classroom.col_last_played": "Last played",
  "sparky.classroom.col_level": "Current level",
  "sparky.classroom.col_time": "Time on level",
  "sparky.classroom.col_progress": "Progress in date range",
  "sparky.classroom.updated_ago_one": "Updated {{count}}s ago",
  "sparky.classroom.updated_ago_other": "Updated {{count}}s ago",
  "sparky.classroom.last_played": "Last played {{date}}",
  "sparky.classroom.no_play": "No recorded play",
  "sparky.classroom.last_action": "Last action: {{control}} · {{detail}}",
  "sparky.classroom.since_opening": "{{time}} since opening",
  "sparky.classroom.progress_line": "{{levels}} levels completed · {{completions}} completions · {{skipped}} skipped",
  "sparky.classroom.view_report": "View {{name}}’s report",
  "sparky.summary.title": "Sparky · last 30 days",
  "sparky.summary.open": "Open Sparky report",
  "sparky.summary.loading": "Loading learning summary…",
  "sparky.summary.unavailable": "Learning summary unavailable.",
  "sparky.summary.levels": "Different levels completed",
  "sparky.csv.visit_id": "Visit ID",
  "sparky.csv.visit": "Visit",
  "sparky.csv.started": "Started",
  "sparky.csv.course": "Course",
  "sparky.csv.activity": "Activity",
  "sparky.csv.grade": "Grade",
  "sparky.csv.school_grade": "School grade",
  "sparky.csv.exercise_grade": "Exercise grade",
  "sparky.csv.level": "Level",
  "sparky.csv.skill": "Skill",
  "sparky.csv.topic": "Topic",
  "sparky.csv.topic_levels": "Topic levels",
  "sparky.csv.elapsed_ms": "Elapsed ms",
  "sparky.csv.control": "Control",
  "sparky.csv.event": "Event",
  "sparky.csv.step": "Step",
  "sparky.csv.total_steps": "Total steps",
  "sparky.csv.detail": "Detail",
  "sparky.csv.student": "Student",
  "sparky.csv.lesson": "Lesson",
  "sparky.csv.assigned_levels": "Assigned levels",
  "sparky.csv.target": "Target",
  "sparky.csv.different_levels_completed": "Different levels completed",
  "sparky.csv.target_met": "Target met",
  "sparky.csv.stars_earned": "Stars earned",
  "sparky.csv.possible_stars": "Possible stars",
  "sparky.csv.score_percent": "Score percent",
  "sparky.csv.test_points": "Test points",
  "sparky.csv.test_questions": "Test questions answered",
  "sparky.csv.test_percent": "Test score percent of answered",
  "sparky.csv.test_total": "Questions in the whole test",
  "sparky.csv.test_whole_percent": "Test score percent of the whole test",
  "sparky.csv.test_right": "Test right",
  "sparky.csv.test_wrong": "Test wrong",
  "sparky.csv.test_deduction": "Points taken off for wrong answers",
  "sparky.csv.test_dont_know": "Test I don't know",
  "sparky.csv.test_not_answered": "Test questions not answered",
  "sparky.csv.test_guessing": "Score no better than guessing",
  "sparky.csv.topic_points": "{{topic}}: points",
  "sparky.csv.topic_questions": "{{topic}}: questions",
  "sparky.csv.test_seconds": "Time on test (seconds)",
  "sparky.csv.test_fast": "Test answers in under 3 seconds",
  "sparky.csv.active_seconds": "Active seconds",
  "sparky.csv.mistakes": "Mistakes",
  "sparky.csv.successes": "Correct steps",
  "sparky.csv.refused_moves": "Refused moves",
  "sparky.csv.hints": "Hints",
  "sparky.csv.retries": "Retries",
  "sparky.csv.skipped": "Skipped",
  "sparky.csv.error_details": "Recorded error details",
  "sparky.csv.result": "Result",
  "sparky.csv.stars": "Stars",
  "sparky.csv.completed_after_mistakes": "Completed after mistakes",
  "sparky.csv.independent_after_help": "Independent after help",
  "sparky.csv.first_stars": "First stars",
  "sparky.csv.best_stars": "Best stars",
  "sparky.csv.completed_levels": "Completed levels",
  "sparky.csv.completions": "Completions",
  "sparky.csv.one_star_levels": "1-star levels",
  "sparky.csv.two_star_levels": "2-star levels",
  "sparky.csv.three_star_levels": "3-star levels",
  "sparky.csv.signal": "Learning signal",
  "sparky.csv.interaction_visits": "Visits with interaction tracking",
  "sparky.csv.steps_advanced": "Steps advanced",
  "sparky.csv.code_actions": "Code actions accepted",
  "sparky.csv.blocked_presses": "Repeated presses while busy",
  "sparky.csv.rapid_bursts": "Rapid-click bursts",
  "sparky.csv.answer_visits": "Answer-tracked visits",
  "sparky.csv.answers": "Multiple-choice answers",
  "sparky.csv.rapid_answers": "Rapid-answer patterns",
  "sparky.csv.timed_answers": "Timed answers",
  "sparky.csv.patterns": "Patterns",
  "sparky.csv.median_response_ms": "Median response ms (sample)",
  "sparky.csv.sampled_answers": "Sampled answers",
  "sparky.csv.needs_support_reviews": "Needs support (your reviews)",
  "sparky.csv.not_concerning_reviews": "Not concerning (your reviews)",
  "sparky.csv.acknowledged_reviews": "Acknowledged (your reviews)",
  "sparky.csv.observation": "Observation",
  "sparky.csv.evidence": "Evidence",
  "sparky.csv.what_happened": "What happened",
  "sparky.csv.next_step": "Next step",
  "sparky.csv.your_review": "Your review",
  "sparky.checkup.first_accuracy": "First-attempt accuracy",
  "sparky.checkup.first_count": "{{correct}}/{{answered}} correct on the first answer",
  "sparky.checkup.guided": "Guided corrections after an explanation: {{count}}",
  "sparky.checkup.repeated": "{{count}} questions answered correctly on a replay",
  "sparky.checkup.assisted": "{{count}} first answers with recorded help or a reset",
  "sparky.checkup.unknown": "{{count}} questions whose first answer was not recorded (older game version)",
  "sparky.checkup.answer_correct": "First answer: correct",
  "sparky.checkup.answer_incorrect": "First answer: incorrect",
  "sparky.checkup.answer_assisted": "First answer: recorded help or reset used",
  "sparky.checkup.answer_unknown": "First answer not recorded (older game version)",
  "sparky.checkup.guided_answer": "Corrected after the explanation · guided practice",
  "sparky.checkup.repeated_answer": "Correct on a replay · the original first answer is unchanged",
  "sparky.checkup.first_correct": "First answers correct",
  "sparky.checkup.answers_recorded": "Questions with first answers recorded",
  "sparky.checkup.guided_label": "Guided corrections",
  "sparky.checkup.guided_hint": "Correct answers entered after the explanation; excluded from first-attempt accuracy",
  "sparky.checkup.assessment_note": "Check-up accuracy uses the earliest recorded answer to each question. Correct answers after an explanation or on a replay do not raise it. Recorded help or resets are shown separately. Missing first-answer evidence is excluded, rather than inferred from stars. New check-ups explain a mistake, then move to a different question. Stars describe completion, not assessment accuracy.",
  "sparky.checkup.prepare_fresh": "Prepare fresh check-up",
  "sparky.checkup.fresh_title": "Fresh check-up · {{name}}",
  "sparky.checkup.fresh_description": "These questions have never been visited by this student and cover topics needing review. Difficulty and the specific skill may vary: preview each question before saving the draft. Starting the draft is a separate step.",
  "sparky.checkup.save_fresh": "Save fresh check-up draft",
  "sparky.checkup.no_fresh": "No unvisited questions remain in the topics needing review. Add different questions before assessing them again.",
  "sparky.checkup.fresh_levels_required": "Choose at least one question.",
  "sparky.checkup.group_heading": "Group follow-up",
  "sparky.checkup.group_section_description": "Draft one follow-up lesson for the children who are developing or not yet secure in chosen topics.",
  "sparky.checkup.group_grade": "Exercise grade",
  "sparky.checkup.group_prepare": "Prepare a group follow-up",
  "sparky.checkup.group_none": "No child is developing or not yet secure in a topic with enough evidence.",
  "sparky.checkup.group_description": "{{grade}}: choose topics, check the children and pick the questions. Questions no child in the group has seen come first, follow-ups before the rest. Starting the draft is a separate step.",
  "sparky.checkup.group_title": "Follow-up · {{topics}}",
  "sparky.checkup.group_topics": "Topics",
  "sparky.checkup.group_topic_count_one": "{{count}} child developing or not yet",
  "sparky.checkup.group_topic_count_other": "{{count}} children developing or not yet",
  "sparky.checkup.group_topics_required": "Choose at least one topic.",
  "sparky.checkup.group_questions_one": "Questions ({{count}} selected)",
  "sparky.checkup.group_questions_other": "Questions ({{count}} selected)",
  "sparky.checkup.group_loading": "Finding questions the group has not seen…",
  "sparky.checkup.group_error": "Questions could not be loaded.",
  "sparky.checkup.group_no_questions": "Most of this group has already seen every question in these topics.",
  "sparky.checkup.group_unseen_all": "New to everyone",
  "sparky.checkup.group_unseen_some": "New to {{unseen}} of {{total}}",
  "sparky.checkup.group_save": "Save group follow-up draft",
  "sparky.checkup.followup": "Follow-up",
  "timetable.tab_timetable": "Timetable",
  "timetable.tab_tests": "Tests",
  "timetable.tabs_label": "Timetable views",
  "tests_calendar.subtitle": "Every class test in the school, week by week.",
  "tests_calendar.grade_filter": "Grade",
  "tests_calendar.all_grades": "All grades",
  "tests_calendar.previous_week": "Previous week",
  "tests_calendar.next_week": "Next week",
  "tests_calendar.this_week": "This week",
  "tests_calendar.week_of": "Week of {{date}}",
  "tests_calendar.col_class": "Class",
  "tests_calendar.legend_yours": "Your tests",
  "tests_calendar.legend_others": "Other teachers' tests",
  "tests_calendar.legend_crowded": "Two or more tests in a day",
  "edp.tab_registers": "Registers",
  "edp.registers.heading": "Registers",
  "edp.registers.subtitle": "Every EDP lesson, whether its register was taken, and who runs it. Cancelled lessons are never counted as not taken.",
  "edp.registers.empty": "No EDP lessons in this period.",
  "edp.registers.empty_owed": "Every register in this period has been taken.",
  "edp.registers.show_all": "All lessons",
  "edp.registers.show_owed": "Not taken",
  "edp.registers.range_label": "Period",
  "edp.registers.range_week": "One week",
  "edp.registers.range_term": "Whole term so far",
  "edp.registers.col_lesson": "Lesson",
  "edp.registers.col_course": "Course",
  "edp.registers.col_teacher": "Teacher",
  "edp.registers.col_register": "Register",
  "edp.registers.with_assistants": "with {{names}}",
  "edp.lessons.came": "{{attended}} of {{total}} came",
  "edp.lessons.part_done": "{{marked}} of {{total}} marked",
  "edp.lessons.state.today": "Today",
  "edp.lessons.state.upcoming": "Upcoming",
  "edp.lessons.state.taken": "Taken",
  "edp.lessons.state.partial": "Part done",
  "edp.lessons.state.not_taken": "Not taken",
  "edp.lessons.state.no_children": "No children",
  "edp.lessons.state.cancelled": "Cancelled",
  "edp.lessons.state.moved": "Moved",
  "edp.lessons.make_up_for": "Make-up for {{date}}",
  "edp.lessons.overview_held": "{{held}} of {{total}} lessons held",
  "edp.lessons.overview_not_taken": "{{count}} not taken",
  "edp.lessons.overview_partial": "{{count}} part done",
  "edp.lessons.overview_cancelled": "{{count}} cancelled",
  "edp.register.crumb": "Register",
  "edp.register.tabs_label": "Course register",
  "edp.register.tab_lessons": "Lessons",
  "edp.register.tab_summary": "Term summary",
  "edp.register.lessons_title": "Lessons this term",
  "edp.register.no_lessons": "This course has no lessons this term.",
  "edp.register.cancel_lesson": "Cancel this lesson",
  "edp.register.moved_notice": "The course no longer meets on this day, so this register can be read but not changed."
}
